import { type CompositionVideoShortsPropsType, Presets } from "@repo/types";

export const testV2: CompositionVideoShortsPropsType = {
	target: 0,
	options: Presets.VIRAL,
	resolution: {
		width: 720,
		height: 1280
      // width: 1080,
      // height: 1920
	},
  video: {
    "files": {
    "isInS3": false,
    "target": "https://sieve-prod-us-central1-persistent-bucket.storage.googleapis.com/ac9870b3-4a83-42e2-8250-6223186567f3/0a979a23-aefc-4df6-aec4-f2234f5d5499/e0e3f2f3-ed3b-440f-bca4-7a7beeb69086/tmpy4rbudjq.mp4?X-Goog-Algorithm=GOOG4-RSA-SHA256&X-Goog-Credential=abhi-admin%40sieve-grapefruit.iam.gserviceaccount.com%2F20250722%2Fauto%2Fstorage%2Fgoog4_request&X-Goog-Date=20250722T162943Z&X-Goog-Expires=172800&X-Goog-SignedHeaders=host&x-goog-signature=88a4725e529ce604fec9ece668c75c4a6e2b3ec248a6373712e1d584d47618ec11b3a3c2cd5b3a8d0a0ce383e6f58dc711069f7e0244d6f56c7a31574f523b47e7fa7d35689c97de04f404ec3ae9ecac90cf73a9da43850a9d03d5d29ed817ec24d4eaedbf62193f0c0f3753e0d53d22cfdc8484932483e7bf4321839c71485c63adbad3543e5cd5b35fe24ef657f58ffdaedd29676c6cc38c781ed09a0b7bac32de8307d90072244a044ee56bdaa867bcd7d31d8149dca0caa8f831d484a7459ae7c2fc7c31396e0d0a96af6bf89aeef06619dd060fafdfcf193081fcc09ee5afdd997cbf36e6dbe1ffb4a85bfc3dab6569d139742ad3c98c5358243e0a9a9f",
    "targetFPS": null,
    "preview": null,
    "previewFPS": null
    },
    "options": null,
    "transcription": {
    "prediction": [
      {
      "words": [
        {
        "word": "When",
        "time_begin": 12.625,
        "time_end": 12.865,
        "confidence": 0.83080304
        },
        {
        "word": "I",
        "time_begin": 12.865,
        "time_end": 12.945,
        "confidence": 0.99988854
        },
        {
        "word": "was",
        "time_begin": 12.945,
        "time_end": 13.1050005,
        "confidence": 0.9993561
        },
        {
        "word": "first",
        "time_begin": 13.1050005,
        "time_end": 13.345,
        "confidence": 0.9993425
        },
        {
        "word": "learning",
        "time_begin": 13.345,
        "time_end": 13.665,
        "confidence": 0.99983084
        },
        {
        "word": "to",
        "time_begin": 13.665,
        "time_end": 13.905,
        "confidence": 0.99962795
        },
        {
        "word": "meditate,",
        "time_begin": 13.905,
        "time_end": 14.405,
        "confidence": 0.997132
        },
        {
        "word": "the",
        "time_begin": 14.545,
        "time_end": 14.785,
        "confidence": 0.99978465
        },
        {
        "word": "instruction",
        "time_begin": 14.785,
        "time_end": 15.285,
        "confidence": 0.9992872
        },
        {
        "word": "was",
        "time_begin": 15.425,
        "time_end": 15.665,
        "confidence": 0.99985564
        },
        {
        "word": "to",
        "time_begin": 15.665,
        "time_end": 15.825,
        "confidence": 0.99652547
        },
        {
        "word": "simply",
        "time_begin": 15.825,
        "time_end": 16.145,
        "confidence": 0.9998785
        },
        {
        "word": "pay",
        "time_begin": 16.145,
        "time_end": 16.305,
        "confidence": 0.9988079
        },
        {
        "word": "attention",
        "time_begin": 16.305,
        "time_end": 16.705,
        "confidence": 0.99998164
        },
        {
        "word": "to",
        "time_begin": 16.705,
        "time_end": 16.865,
        "confidence": 0.99966395
        },
        {
        "word": "my",
        "time_begin": 16.865,
        "time_end": 17.025,
        "confidence": 0.9999254
        },
        {
        "word": "breath,",
        "time_begin": 17.025,
        "time_end": 17.425,
        "confidence": 0.7980448
        },
        {
        "word": "and",
        "time_begin": 17.425,
        "time_end": 17.665,
        "confidence": 0.99796665
        },
        {
        "word": "when",
        "time_begin": 17.665,
        "time_end": 17.905,
        "confidence": 0.98251855
        },
        {
        "word": "my",
        "time_begin": 17.905,
        "time_end": 18.065,
        "confidence": 0.9994685
        },
        {
        "word": "mind",
        "time_begin": 18.065,
        "time_end": 18.305,
        "confidence": 0.9999572
        },
        {
        "word": "wandered,",
        "time_begin": 18.305,
        "time_end": 18.625,
        "confidence": 0.9569824
        },
        {
        "word": "to",
        "time_begin": 18.625,
        "time_end": 18.705,
        "confidence": 0.997006
        },
        {
        "word": "bring",
        "time_begin": 18.705,
        "time_end": 18.945,
        "confidence": 0.999969
        },
        {
        "word": "it",
        "time_begin": 18.945,
        "time_end": 19.105,
        "confidence": 0.99992716
        },
        {
        "word": "back.",
        "time_begin": 19.105,
        "time_end": 19.605,
        "confidence": 0.99912834
        }
      ],
      "language": "en",
      "transcription": "When I was first learning to meditate, the instruction was to simply pay attention to my breath, and when my mind wandered, to bring it back.",
      "confidence": -1,
      "time_begin": 12.625,
      "time_end": 19.605,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Sounded",
        "time_begin": 20.625,
        "time_end": 21.025,
        "confidence": 0.8216753
        },
        {
        "word": "simple",
        "time_begin": 21.025,
        "time_end": 21.345001,
        "confidence": 0.99982905
        },
        {
        "word": "enough.",
        "time_begin": 21.345001,
        "time_end": 21.845001,
        "confidence": 0.78879476
        }
      ],
      "language": "en",
      "transcription": "Sounded simple enough.",
      "confidence": -1,
      "time_begin": 20.625,
      "time_end": 21.845001,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Yet",
        "time_begin": 22.625,
        "time_end": 22.945,
        "confidence": 0.9984114
        },
        {
        "word": "I'd",
        "time_begin": 22.945,
        "time_end": 23.425,
        "confidence": 0.8520715
        },
        {
        "word": "sit",
        "time_begin": 23.425,
        "time_end": 23.825,
        "confidence": 0.9998958
        },
        {
        "word": "on",
        "time_begin": 23.825,
        "time_end": 24.064999,
        "confidence": 0.9998579
        },
        {
        "word": "these",
        "time_begin": 24.064999,
        "time_end": 24.385,
        "confidence": 0.9985958
        },
        {
        "word": "silent",
        "time_begin": 24.385,
        "time_end": 24.865,
        "confidence": 0.99993825
        },
        {
        "word": "retreats,",
        "time_begin": 24.865,
        "time_end": 25.365,
        "confidence": 0.92677003
        },
        {
        "word": "sweating",
        "time_begin": 26.25,
        "time_end": 26.49,
        "confidence": 0.99995446
        },
        {
        "word": "through",
        "time_begin": 26.49,
        "time_end": 26.89,
        "confidence": 0.99977714
        },
        {
        "word": "T",
        "time_begin": 26.89,
        "time_end": 27.05,
        "confidence": 0.6133041
        },
        {
        "word": "shirts",
        "time_begin": 27.05,
        "time_end": 27.29,
        "confidence": 0.9982674
        },
        {
        "word": "in",
        "time_begin": 27.29,
        "time_end": 27.53,
        "confidence": 0.98003083
        },
        {
        "word": "the",
        "time_begin": 27.53,
        "time_end": 27.69,
        "confidence": 0.9998864
        },
        {
        "word": "middle",
        "time_begin": 27.69,
        "time_end": 27.85,
        "confidence": 0.999941
        },
        {
        "word": "of",
        "time_begin": 27.85,
        "time_end": 27.93,
        "confidence": 0.99977773
        },
        {
        "word": "winter.",
        "time_begin": 27.93,
        "time_end": 28.43,
        "confidence": 0.99687487
        }
      ],
      "language": "en",
      "transcription": "Yet I'd sit on these silent retreats, sweating through T shirts in the middle of winter.",
      "confidence": -1,
      "time_begin": 22.625,
      "time_end": 28.43,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "I'd",
        "time_begin": 29.130001,
        "time_end": 29.37,
        "confidence": 0.9865426
        },
        {
        "word": "take",
        "time_begin": 29.37,
        "time_end": 29.61,
        "confidence": 0.9998006
        },
        {
        "word": "naps",
        "time_begin": 29.61,
        "time_end": 29.93,
        "confidence": 0.99997294
        },
        {
        "word": "every",
        "time_begin": 29.93,
        "time_end": 30.17,
        "confidence": 0.99813557
        },
        {
        "word": "chance",
        "time_begin": 30.17,
        "time_end": 30.41,
        "confidence": 0.9999794
        },
        {
        "word": "I",
        "time_begin": 30.41,
        "time_end": 30.57,
        "confidence": 0.99948657
        },
        {
        "word": "got",
        "time_begin": 30.57,
        "time_end": 30.89,
        "confidence": 0.9945102
        },
        {
        "word": "because",
        "time_begin": 30.89,
        "time_end": 31.130001,
        "confidence": 0.89113134
        },
        {
        "word": "it",
        "time_begin": 31.130001,
        "time_end": 31.21,
        "confidence": 0.99991643
        },
        {
        "word": "was",
        "time_begin": 31.21,
        "time_end": 31.45,
        "confidence": 0.99981827
        },
        {
        "word": "really",
        "time_begin": 31.45,
        "time_end": 31.69,
        "confidence": 0.9984366
        },
        {
        "word": "hard",
        "time_begin": 31.69,
        "time_end": 31.93,
        "confidence": 0.99994993
        },
        {
        "word": "work.",
        "time_begin": 31.93,
        "time_end": 32.43,
        "confidence": 0.9970436
        }
      ],
      "language": "en",
      "transcription": "I'd take naps every chance I got because it was really hard work.",
      "confidence": -1,
      "time_begin": 29.130001,
      "time_end": 32.43,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Actually,",
        "time_begin": 32.73,
        "time_end": 33.23,
        "confidence": 0.9931545
        },
        {
        "word": "it",
        "time_begin": 33.29,
        "time_end": 33.45,
        "confidence": 0.9998184
        },
        {
        "word": "was",
        "time_begin": 33.45,
        "time_end": 33.77,
        "confidence": 0.9999602
        },
        {
        "word": "exhausting.",
        "time_begin": 33.77,
        "time_end": 34.27,
        "confidence": 0.9969231
        }
      ],
      "language": "en",
      "transcription": "Actually, it was exhausting.",
      "confidence": -1,
      "time_begin": 32.73,
      "time_end": 34.27,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "The",
        "time_begin": 35.29,
        "time_end": 35.53,
        "confidence": 0.99493635
        },
        {
        "word": "instruction",
        "time_begin": 35.53,
        "time_end": 36.010002,
        "confidence": 0.9991731
        },
        {
        "word": "was",
        "time_begin": 36.010002,
        "time_end": 36.17,
        "confidence": 0.9998933
        },
        {
        "word": "simple",
        "time_begin": 36.17,
        "time_end": 36.489998,
        "confidence": 0.99982965
        },
        {
        "word": "enough,",
        "time_begin": 36.489998,
        "time_end": 36.97,
        "confidence": 0.98714817
        },
        {
        "word": "but",
        "time_begin": 36.97,
        "time_end": 37.21,
        "confidence": 0.99988735
        },
        {
        "word": "I",
        "time_begin": 37.21,
        "time_end": 37.29,
        "confidence": 0.9998708
        },
        {
        "word": "was",
        "time_begin": 37.29,
        "time_end": 37.45,
        "confidence": 0.9999193
        },
        {
        "word": "missing",
        "time_begin": 37.45,
        "time_end": 37.77,
        "confidence": 0.99998343
        },
        {
        "word": "something",
        "time_begin": 37.77,
        "time_end": 38.17,
        "confidence": 0.99996376
        },
        {
        "word": "really",
        "time_begin": 38.17,
        "time_end": 38.489998,
        "confidence": 0.99954456
        },
        {
        "word": "important.",
        "time_begin": 38.489998,
        "time_end": 38.989998,
        "confidence": 0.999964
        }
      ],
      "language": "en",
      "transcription": "The instruction was simple enough, but I was missing something really important.",
      "confidence": -1,
      "time_begin": 35.29,
      "time_end": 38.989998,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "So",
        "time_begin": 40.205,
        "time_end": 40.525,
        "confidence": 0.9866649
        },
        {
        "word": "why",
        "time_begin": 40.525,
        "time_end": 40.765,
        "confidence": 0.9256013
        },
        {
        "word": "is",
        "time_begin": 40.765,
        "time_end": 40.925,
        "confidence": 0.9993376
        },
        {
        "word": "it",
        "time_begin": 40.925,
        "time_end": 41.165,
        "confidence": 0.9993979
        },
        {
        "word": "so",
        "time_begin": 41.165,
        "time_end": 41.325,
        "confidence": 0.9995339
        },
        {
        "word": "hard",
        "time_begin": 41.325,
        "time_end": 41.485,
        "confidence": 0.99991083
        },
        {
        "word": "to",
        "time_begin": 41.485,
        "time_end": 41.645,
        "confidence": 0.9998958
        },
        {
        "word": "pay",
        "time_begin": 41.645,
        "time_end": 41.805,
        "confidence": 0.99988174
        },
        {
        "word": "attention?",
        "time_begin": 41.805,
        "time_end": 42.305,
        "confidence": 0.9995624
        }
      ],
      "language": "en",
      "transcription": "So why is it so hard to pay attention?",
      "confidence": -1,
      "time_begin": 40.205,
      "time_end": 42.305,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Well,",
        "time_begin": 43.005,
        "time_end": 43.325,
        "confidence": 0.97222155
        },
        {
        "word": "studies",
        "time_begin": 43.325,
        "time_end": 43.645,
        "confidence": 0.99900717
        },
        {
        "word": "show",
        "time_begin": 43.645,
        "time_end": 44.145,
        "confidence": 0.9997589
        },
        {
        "word": "that",
        "time_begin": 44.525,
        "time_end": 44.765,
        "confidence": 0.99345374
        },
        {
        "word": "even",
        "time_begin": 44.765,
        "time_end": 45.005,
        "confidence": 0.96631205
        },
        {
        "word": "when",
        "time_begin": 45.005,
        "time_end": 45.245,
        "confidence": 0.99958986
        },
        {
        "word": "we're",
        "time_begin": 45.245,
        "time_end": 45.485,
        "confidence": 0.9943136
        },
        {
        "word": "really",
        "time_begin": 45.485,
        "time_end": 45.805,
        "confidence": 0.9985946
        },
        {
        "word": "trying",
        "time_begin": 45.805,
        "time_end": 46.045,
        "confidence": 0.9996742
        },
        {
        "word": "to",
        "time_begin": 46.045,
        "time_end": 46.125,
        "confidence": 0.9997352
        },
        {
        "word": "pay",
        "time_begin": 46.125,
        "time_end": 46.285,
        "confidence": 0.999539
        },
        {
        "word": "attention",
        "time_begin": 46.285,
        "time_end": 46.685,
        "confidence": 0.9999682
        },
        {
        "word": "to",
        "time_begin": 46.685,
        "time_end": 46.845,
        "confidence": 0.99943954
        },
        {
        "word": "something,",
        "time_begin": 46.845,
        "time_end": 47.345,
        "confidence": 0.92998123
        },
        {
        "word": "like",
        "time_begin": 47.405,
        "time_end": 47.725,
        "confidence": 0.9994667
        },
        {
        "word": "maybe",
        "time_begin": 47.725,
        "time_end": 48.045,
        "confidence": 0.85257405
        },
        {
        "word": "this",
        "time_begin": 48.045,
        "time_end": 48.285,
        "confidence": 0.9903257
        },
        {
        "word": "talk,",
        "time_begin": 48.285,
        "time_end": 48.785,
        "confidence": 0.9965228
        },
        {
        "word": "at",
        "time_begin": 49.325,
        "time_end": 49.565002,
        "confidence": 0.99938965
        },
        {
        "word": "some",
        "time_begin": 49.565002,
        "time_end": 49.725,
        "confidence": 0.99983454
        },
        {
        "word": "point,",
        "time_begin": 49.725,
        "time_end": 49.965,
        "confidence": 0.78983676
        },
        {
        "word": "about",
        "time_begin": 49.965,
        "time_end": 50.285,
        "confidence": 0.99924797
        },
        {
        "word": "half",
        "time_begin": 50.285,
        "time_end": 50.445,
        "confidence": 0.9996774
        },
        {
        "word": "of",
        "time_begin": 50.445,
        "time_end": 50.605,
        "confidence": 0.99760973
        },
        {
        "word": "us",
        "time_begin": 50.605,
        "time_end": 50.765,
        "confidence": 0.99982136
        },
        {
        "word": "will",
        "time_begin": 50.765,
        "time_end": 51.005,
        "confidence": 0.9976737
        },
        {
        "word": "drift",
        "time_begin": 51.005,
        "time_end": 51.245,
        "confidence": 0.9999578
        },
        {
        "word": "off",
        "time_begin": 51.245,
        "time_end": 51.405,
        "confidence": 0.9988507
        },
        {
        "word": "into",
        "time_begin": 51.405,
        "time_end": 51.645,
        "confidence": 0.9985424
        },
        {
        "word": "a",
        "time_begin": 51.645,
        "time_end": 51.805,
        "confidence": 0.99978095
        },
        {
        "word": "daydream",
        "time_begin": 51.805,
        "time_end": 52.305,
        "confidence": 0.97535497
        },
        {
        "word": "or",
        "time_begin": 52.845,
        "time_end": 53.165,
        "confidence": 0.902323
        },
        {
        "word": "have",
        "time_begin": 53.165,
        "time_end": 53.325,
        "confidence": 0.9994419
        },
        {
        "word": "this",
        "time_begin": 53.325,
        "time_end": 53.565002,
        "confidence": 0.99962187
        },
        {
        "word": "urge",
        "time_begin": 53.565002,
        "time_end": 53.725,
        "confidence": 0.99989104
        },
        {
        "word": "to",
        "time_begin": 53.725,
        "time_end": 53.885002,
        "confidence": 0.99979204
        },
        {
        "word": "check",
        "time_begin": 53.885002,
        "time_end": 54.125,
        "confidence": 0.99991894
        },
        {
        "word": "our",
        "time_begin": 54.125,
        "time_end": 54.285,
        "confidence": 0.99686795
        },
        {
        "word": "Twitter",
        "time_begin": 54.285,
        "time_end": 54.685,
        "confidence": 0.99692106
        },
        {
        "word": "feed.",
        "time_begin": 54.685,
        "time_end": 55.185,
        "confidence": 0.99913186
        }
      ],
      "language": "en",
      "transcription": "Well, studies show that even when we're really trying to pay attention to something, like maybe this talk, at some point, about half of us will drift off into a daydream or have this urge to check our Twitter feed.",
      "confidence": -1,
      "time_begin": 43.005,
      "time_end": 55.185,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "So",
        "time_begin": 56.27,
        "time_end": 56.43,
        "confidence": 0.98902696
        },
        {
        "word": "what's",
        "time_begin": 56.43,
        "time_end": 56.75,
        "confidence": 0.9730902
        },
        {
        "word": "going",
        "time_begin": 56.75,
        "time_end": 56.99,
        "confidence": 0.9999522
        },
        {
        "word": "on",
        "time_begin": 56.99,
        "time_end": 57.23,
        "confidence": 0.9998374
        },
        {
        "word": "here?",
        "time_begin": 57.23,
        "time_end": 57.73,
        "confidence": 0.99898934
        }
      ],
      "language": "en",
      "transcription": "So what's going on here?",
      "confidence": -1,
      "time_begin": 56.27,
      "time_end": 57.73,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "It",
        "time_begin": 58.91,
        "time_end": 59.15,
        "confidence": 0.99864477
        },
        {
        "word": "turns",
        "time_begin": 59.15,
        "time_end": 59.31,
        "confidence": 0.9997869
        },
        {
        "word": "out",
        "time_begin": 59.31,
        "time_end": 59.550003,
        "confidence": 0.99955827
        },
        {
        "word": "that",
        "time_begin": 59.550003,
        "time_end": 59.71,
        "confidence": 0.96351916
        },
        {
        "word": "we're",
        "time_begin": 59.71,
        "time_end": 60.030003,
        "confidence": 0.991107
        },
        {
        "word": "fighting",
        "time_begin": 60.030003,
        "time_end": 60.43,
        "confidence": 0.9998441
        },
        {
        "word": "one",
        "time_begin": 60.43,
        "time_end": 60.59,
        "confidence": 0.9998141
        },
        {
        "word": "of",
        "time_begin": 60.59,
        "time_end": 60.75,
        "confidence": 0.9996456
        },
        {
        "word": "the",
        "time_begin": 60.75,
        "time_end": 60.83,
        "confidence": 0.999835
        },
        {
        "word": "most",
        "time_begin": 60.83,
        "time_end": 61.23,
        "confidence": 0.9966839
        },
        {
        "word": "evolutionarily",
        "time_begin": 61.23,
        "time_end": 61.73,
        "confidence": 0.99987125
        },
        {
        "word": "conserved",
        "time_begin": 62.030003,
        "time_end": 62.510002,
        "confidence": 0.9999865
        },
        {
        "word": "learning",
        "time_begin": 62.510002,
        "time_end": 62.91,
        "confidence": 0.9996797
        },
        {
        "word": "processes",
        "time_begin": 62.91,
        "time_end": 63.41,
        "confidence": 0.9992804
        },
        {
        "word": "currently",
        "time_begin": 63.550003,
        "time_end": 64.03,
        "confidence": 0.9903178
        },
        {
        "word": "known",
        "time_begin": 64.03,
        "time_end": 64.270004,
        "confidence": 0.9993932
        },
        {
        "word": "in",
        "time_begin": 64.270004,
        "time_end": 64.51,
        "confidence": 0.999757
        },
        {
        "word": "science,",
        "time_begin": 64.51,
        "time_end": 65.01,
        "confidence": 0.89507926
        },
        {
        "word": "one",
        "time_begin": 65.23,
        "time_end": 65.39,
        "confidence": 0.9995703
        },
        {
        "word": "that's",
        "time_begin": 65.39,
        "time_end": 65.71,
        "confidence": 0.99642825
        },
        {
        "word": "conserved",
        "time_begin": 65.71,
        "time_end": 66.11,
        "confidence": 0.99845684
        },
        {
        "word": "back",
        "time_begin": 66.11,
        "time_end": 66.270004,
        "confidence": 0.9996482
        },
        {
        "word": "to",
        "time_begin": 66.270004,
        "time_end": 66.43,
        "confidence": 0.9990453
        },
        {
        "word": "the",
        "time_begin": 66.43,
        "time_end": 66.51,
        "confidence": 0.99918157
        },
        {
        "word": "most",
        "time_begin": 66.51,
        "time_end": 66.83,
        "confidence": 0.9994363
        },
        {
        "word": "basic",
        "time_begin": 66.83,
        "time_end": 67.23,
        "confidence": 0.9999274
        },
        {
        "word": "nervous",
        "time_begin": 67.23,
        "time_end": 67.55,
        "confidence": 0.9998584
        },
        {
        "word": "systems",
        "time_begin": 67.55,
        "time_end": 68.03,
        "confidence": 0.9980849
        },
        {
        "word": "known",
        "time_begin": 68.03,
        "time_end": 68.19,
        "confidence": 0.99893886
        },
        {
        "word": "to",
        "time_begin": 68.19,
        "time_end": 68.43,
        "confidence": 0.9998203
        },
        {
        "word": "man.",
        "time_begin": 68.43,
        "time_end": 68.93,
        "confidence": 0.9993819
        }
      ],
      "language": "en",
      "transcription": "It turns out that we're fighting one of the most evolutionarily conserved learning processes currently known in science, one that's conserved back to the most basic nervous systems known to man.",
      "confidence": -1,
      "time_begin": 58.91,
      "time_end": 68.93,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "This",
        "time_begin": 69.795,
        "time_end": 70.034996,
        "confidence": 0.9996835
        },
        {
        "word": "reward",
        "time_begin": 70.034996,
        "time_end": 70.354996,
        "confidence": 0.99838495
        },
        {
        "word": "based",
        "time_begin": 70.354996,
        "time_end": 70.59499,
        "confidence": 0.9988238
        },
        {
        "word": "learning",
        "time_begin": 70.59499,
        "time_end": 70.91499,
        "confidence": 0.9979837
        },
        {
        "word": "process",
        "time_begin": 70.91499,
        "time_end": 71.235,
        "confidence": 0.99655956
        },
        {
        "word": "is",
        "time_begin": 71.235,
        "time_end": 71.395,
        "confidence": 0.9957022
        },
        {
        "word": "called",
        "time_begin": 71.395,
        "time_end": 71.634995,
        "confidence": 0.9995827
        },
        {
        "word": "positive",
        "time_begin": 71.634995,
        "time_end": 72.034996,
        "confidence": 0.9977755
        },
        {
        "word": "and",
        "time_begin": 72.034996,
        "time_end": 72.195,
        "confidence": 0.99949586
        },
        {
        "word": "negative",
        "time_begin": 72.195,
        "time_end": 72.59499,
        "confidence": 0.9999895
        },
        {
        "word": "reinforcement",
        "time_begin": 72.59499,
        "time_end": 73.09499,
        "confidence": 0.9997671
        },
        {
        "word": "and",
        "time_begin": 73.314995,
        "time_end": 73.555,
        "confidence": 0.58434963
        },
        {
        "word": "basically",
        "time_begin": 73.555,
        "time_end": 74.034996,
        "confidence": 0.9652514
        },
        {
        "word": "goes",
        "time_begin": 74.034996,
        "time_end": 74.354996,
        "confidence": 0.9874126
        },
        {
        "word": "like",
        "time_begin": 74.354996,
        "time_end": 74.59499,
        "confidence": 0.99952686
        },
        {
        "word": "this.",
        "time_begin": 74.59499,
        "time_end": 75.09499,
        "confidence": 0.8264936
        }
      ],
      "language": "en",
      "transcription": "This reward based learning process is called positive and negative reinforcement and basically goes like this.",
      "confidence": -1,
      "time_begin": 69.795,
      "time_end": 75.09499,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "We",
        "time_begin": 76.034996,
        "time_end": 76.274994,
        "confidence": 0.9985959
        },
        {
        "word": "see",
        "time_begin": 76.274994,
        "time_end": 76.515,
        "confidence": 0.99944144
        },
        {
        "word": "some",
        "time_begin": 76.515,
        "time_end": 76.674995,
        "confidence": 0.99620926
        },
        {
        "word": "food",
        "time_begin": 76.674995,
        "time_end": 76.91499,
        "confidence": 0.999342
        },
        {
        "word": "that",
        "time_begin": 76.91499,
        "time_end": 77.075,
        "confidence": 0.99878913
        },
        {
        "word": "looks",
        "time_begin": 77.075,
        "time_end": 77.314995,
        "confidence": 0.9996407
        },
        {
        "word": "good.",
        "time_begin": 77.314995,
        "time_end": 77.795,
        "confidence": 0.7805743
        }
      ],
      "language": "en",
      "transcription": "We see some food that looks good.",
      "confidence": -1,
      "time_begin": 76.034996,
      "time_end": 77.795,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Our",
        "time_begin": 77.795,
        "time_end": 77.954994,
        "confidence": 0.99832493
        },
        {
        "word": "brain",
        "time_begin": 77.954994,
        "time_end": 78.274994,
        "confidence": 0.9935741
        },
        {
        "word": "says,",
        "time_begin": 78.274994,
        "time_end": 78.674995,
        "confidence": 0.83007765
        },
        {
        "word": "calories,",
        "time_begin": 78.674995,
        "time_end": 79.174995,
        "confidence": 0.67734617
        },
        {
        "word": "survival.",
        "time_begin": 79.395,
        "time_end": 79.895,
        "confidence": 0.94619966
        }
      ],
      "language": "en",
      "transcription": "Our brain says, calories, survival.",
      "confidence": -1,
      "time_begin": 77.795,
      "time_end": 79.895,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "We",
        "time_begin": 80.515,
        "time_end": 80.755,
        "confidence": 0.9986601
        },
        {
        "word": "eat",
        "time_begin": 80.755,
        "time_end": 80.91499,
        "confidence": 0.99986947
        },
        {
        "word": "the",
        "time_begin": 80.91499,
        "time_end": 81.075,
        "confidence": 0.9987908
        },
        {
        "word": "food,",
        "time_begin": 81.075,
        "time_end": 81.395,
        "confidence": 0.9028946
        },
        {
        "word": "we",
        "time_begin": 81.395,
        "time_end": 81.55499,
        "confidence": 0.99580705
        },
        {
        "word": "taste",
        "time_begin": 81.55499,
        "time_end": 81.875,
        "confidence": 0.9995963
        },
        {
        "word": "it,",
        "time_begin": 81.875,
        "time_end": 82.115,
        "confidence": 0.9270532
        },
        {
        "word": "it",
        "time_begin": 82.115,
        "time_end": 82.274994,
        "confidence": 0.9877916
        },
        {
        "word": "tastes",
        "time_begin": 82.274994,
        "time_end": 82.59499,
        "confidence": 0.9943837
        },
        {
        "word": "good.",
        "time_begin": 82.59499,
        "time_end": 83.09499,
        "confidence": 0.97247756
        }
      ],
      "language": "en",
      "transcription": "We eat the food, we taste it, it tastes good.",
      "confidence": -1,
      "time_begin": 80.515,
      "time_end": 83.09499,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "And",
        "time_begin": 83.32001,
        "time_end": 83.560005,
        "confidence": 0.98053175
        },
        {
        "word": "especially",
        "time_begin": 83.560005,
        "time_end": 83.880005,
        "confidence": 0.957799
        },
        {
        "word": "with",
        "time_begin": 83.880005,
        "time_end": 84.200005,
        "confidence": 0.99339116
        },
        {
        "word": "sugar,",
        "time_begin": 84.200005,
        "time_end": 84.700005,
        "confidence": 0.9981801
        },
        {
        "word": "our",
        "time_begin": 84.840004,
        "time_end": 85,
        "confidence": 0.999632
        },
        {
        "word": "bodies",
        "time_begin": 85,
        "time_end": 85.240005,
        "confidence": 0.9885111
        },
        {
        "word": "send",
        "time_begin": 85.240005,
        "time_end": 85.48,
        "confidence": 0.9980617
        },
        {
        "word": "a",
        "time_begin": 85.48,
        "time_end": 85.560005,
        "confidence": 0.9980775
        },
        {
        "word": "signal",
        "time_begin": 85.560005,
        "time_end": 85.880005,
        "confidence": 0.99997747
        },
        {
        "word": "to",
        "time_begin": 85.880005,
        "time_end": 85.96001,
        "confidence": 0.9997502
        },
        {
        "word": "our",
        "time_begin": 85.96001,
        "time_end": 86.12,
        "confidence": 0.99958724
        },
        {
        "word": "brain",
        "time_begin": 86.12,
        "time_end": 86.44,
        "confidence": 0.99411654
        },
        {
        "word": "that",
        "time_begin": 86.44,
        "time_end": 86.520004,
        "confidence": 0.9911738
        },
        {
        "word": "says,",
        "time_begin": 86.520004,
        "time_end": 87.020004,
        "confidence": 0.9359658
        },
        {
        "word": "remember",
        "time_begin": 87.08,
        "time_end": 87.560005,
        "confidence": 0.9128093
        },
        {
        "word": "what",
        "time_begin": 87.560005,
        "time_end": 87.72,
        "confidence": 0.9997807
        },
        {
        "word": "you're",
        "time_begin": 87.72,
        "time_end": 87.96001,
        "confidence": 0.99781007
        },
        {
        "word": "eating",
        "time_begin": 87.96001,
        "time_end": 88.44,
        "confidence": 0.9999579
        },
        {
        "word": "and",
        "time_begin": 88.44,
        "time_end": 88.68,
        "confidence": 0.9530442
        },
        {
        "word": "where",
        "time_begin": 88.68,
        "time_end": 88.840004,
        "confidence": 0.9999374
        },
        {
        "word": "you",
        "time_begin": 88.840004,
        "time_end": 89.08,
        "confidence": 0.9998234
        },
        {
        "word": "found",
        "time_begin": 89.08,
        "time_end": 89.32001,
        "confidence": 0.99176735
        },
        {
        "word": "it.",
        "time_begin": 89.32001,
        "time_end": 89.82001,
        "confidence": 0.9994017
        }
      ],
      "language": "en",
      "transcription": "And especially with sugar, our bodies send a signal to our brain that says, remember what you're eating and where you found it.",
      "confidence": -1,
      "time_begin": 83.32001,
      "time_end": 89.82001,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "We",
        "time_begin": 91.240005,
        "time_end": 91.48,
        "confidence": 0.99697125
        },
        {
        "word": "lay",
        "time_begin": 91.48,
        "time_end": 91.72,
        "confidence": 0.99893934
        },
        {
        "word": "down",
        "time_begin": 91.72,
        "time_end": 91.880005,
        "confidence": 0.9998542
        },
        {
        "word": "this",
        "time_begin": 91.880005,
        "time_end": 92.200005,
        "confidence": 0.9995394
        },
        {
        "word": "context",
        "time_begin": 92.200005,
        "time_end": 92.600006,
        "confidence": 0.99978966
        },
        {
        "word": "dependent",
        "time_begin": 92.600006,
        "time_end": 93.08,
        "confidence": 0.9965634
        },
        {
        "word": "memory",
        "time_begin": 93.08,
        "time_end": 93.58,
        "confidence": 0.9999224
        },
        {
        "word": "and",
        "time_begin": 93.880005,
        "time_end": 94.12,
        "confidence": 0.94615304
        },
        {
        "word": "learn",
        "time_begin": 94.12,
        "time_end": 94.36,
        "confidence": 0.99896145
        },
        {
        "word": "to",
        "time_begin": 94.36,
        "time_end": 94.520004,
        "confidence": 0.99980706
        },
        {
        "word": "repeat",
        "time_begin": 94.520004,
        "time_end": 94.840004,
        "confidence": 0.99998283
        },
        {
        "word": "the",
        "time_begin": 94.840004,
        "time_end": 95,
        "confidence": 0.99934083
        },
        {
        "word": "process",
        "time_begin": 95,
        "time_end": 95.4,
        "confidence": 0.9999206
        },
        {
        "word": "next",
        "time_begin": 95.4,
        "time_end": 95.72,
        "confidence": 0.9974152
        },
        {
        "word": "time.",
        "time_begin": 95.72,
        "time_end": 96.165,
        "confidence": 0.9377509
        }
      ],
      "language": "en",
      "transcription": "We lay down this context dependent memory and learn to repeat the process next time.",
      "confidence": -1,
      "time_begin": 91.240005,
      "time_end": 96.165,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "See",
        "time_begin": 96.565,
        "time_end": 96.885,
        "confidence": 0.9989986
        },
        {
        "word": "food,",
        "time_begin": 96.885,
        "time_end": 97.385,
        "confidence": 0.7860919
        },
        {
        "word": "eat",
        "time_begin": 97.605,
        "time_end": 97.925,
        "confidence": 0.9996891
        },
        {
        "word": "food,",
        "time_begin": 97.925,
        "time_end": 98.425,
        "confidence": 0.99962676
        },
        {
        "word": "feel",
        "time_begin": 98.565,
        "time_end": 98.885,
        "confidence": 0.9998883
        },
        {
        "word": "good,",
        "time_begin": 98.885,
        "time_end": 99.385,
        "confidence": 0.99157834
        },
        {
        "word": "repeat.",
        "time_begin": 99.525,
        "time_end": 100.025,
        "confidence": 0.99670297
        }
      ],
      "language": "en",
      "transcription": "See food, eat food, feel good, repeat.",
      "confidence": -1,
      "time_begin": 96.565,
      "time_end": 100.025,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Trigger,",
        "time_begin": 100.965004,
        "time_end": 101.465004,
        "confidence": 0.8615187
        },
        {
        "word": "behavior,",
        "time_begin": 101.845,
        "time_end": 102.345,
        "confidence": 0.98946774
        },
        {
        "word": "reward.",
        "time_begin": 102.645004,
        "time_end": 103.145004,
        "confidence": 0.99762535
        }
      ],
      "language": "en",
      "transcription": "Trigger, behavior, reward.",
      "confidence": -1,
      "time_begin": 100.965004,
      "time_end": 103.145004,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Simple,",
        "time_begin": 103.525,
        "time_end": 103.925,
        "confidence": 0.86848235
        },
        {
        "word": "right?",
        "time_begin": 103.925,
        "time_end": 104.425,
        "confidence": 0.99852663
        }
      ],
      "language": "en",
      "transcription": "Simple, right?",
      "confidence": -1,
      "time_begin": 103.525,
      "time_end": 104.425,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Well,",
        "time_begin": 105.765,
        "time_end": 106.005005,
        "confidence": 0.97170985
        },
        {
        "word": "after",
        "time_begin": 106.005005,
        "time_end": 106.165,
        "confidence": 0.99980515
        },
        {
        "word": "a",
        "time_begin": 106.165,
        "time_end": 106.325,
        "confidence": 0.96482074
        },
        {
        "word": "while,",
        "time_begin": 106.325,
        "time_end": 106.645004,
        "confidence": 0.85279584
        },
        {
        "word": "our",
        "time_begin": 106.645004,
        "time_end": 106.805,
        "confidence": 0.99968374
        },
        {
        "word": "creative",
        "time_begin": 106.805,
        "time_end": 107.205,
        "confidence": 0.9996624
        },
        {
        "word": "brains",
        "time_begin": 107.205,
        "time_end": 107.605,
        "confidence": 0.98652285
        },
        {
        "word": "say,",
        "time_begin": 107.605,
        "time_end": 107.925,
        "confidence": 0.9835595
        },
        {
        "word": "you",
        "time_begin": 107.925,
        "time_end": 108.165,
        "confidence": 0.96358603
        },
        {
        "word": "know",
        "time_begin": 108.165,
        "time_end": 108.325,
        "confidence": 0.9994979
        },
        {
        "word": "what?",
        "time_begin": 108.325,
        "time_end": 108.825,
        "confidence": 0.91206837
        }
      ],
      "language": "en",
      "transcription": "Well, after a while, our creative brains say, you know what?",
      "confidence": -1,
      "time_begin": 105.765,
      "time_end": 108.825,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "You",
        "time_begin": 109.18,
        "time_end": 109.42,
        "confidence": 0.9952093
        },
        {
        "word": "can",
        "time_begin": 109.42,
        "time_end": 109.5,
        "confidence": 0.9996903
        },
        {
        "word": "use",
        "time_begin": 109.5,
        "time_end": 109.74,
        "confidence": 0.9998622
        },
        {
        "word": "this",
        "time_begin": 109.74,
        "time_end": 109.979996,
        "confidence": 0.9992065
        },
        {
        "word": "for",
        "time_begin": 109.979996,
        "time_end": 110.14,
        "confidence": 0.9961647
        },
        {
        "word": "more",
        "time_begin": 110.14,
        "time_end": 110.38,
        "confidence": 0.99978966
        },
        {
        "word": "than",
        "time_begin": 110.38,
        "time_end": 110.53999,
        "confidence": 0.99956363
        },
        {
        "word": "just",
        "time_begin": 110.53999,
        "time_end": 110.78,
        "confidence": 0.9871904
        },
        {
        "word": "remembering",
        "time_begin": 110.78,
        "time_end": 111.259995,
        "confidence": 0.9998317
        },
        {
        "word": "where",
        "time_begin": 111.259995,
        "time_end": 111.5,
        "confidence": 0.999328
        },
        {
        "word": "food",
        "time_begin": 111.5,
        "time_end": 111.82,
        "confidence": 0.9995603
        },
        {
        "word": "is.",
        "time_begin": 111.82,
        "time_end": 112.32,
        "confidence": 0.99691486
        }
      ],
      "language": "en",
      "transcription": "You can use this for more than just remembering where food is.",
      "confidence": -1,
      "time_begin": 109.18,
      "time_end": 112.32,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "You",
        "time_begin": 112.78,
        "time_end": 112.85999,
        "confidence": 0.88758963
        },
        {
        "word": "know,",
        "time_begin": 112.85999,
        "time_end": 113.1,
        "confidence": 0.9969182
        },
        {
        "word": "next",
        "time_begin": 113.1,
        "time_end": 113.42,
        "confidence": 0.99389535
        },
        {
        "word": "time",
        "time_begin": 113.42,
        "time_end": 113.579994,
        "confidence": 0.99991775
        },
        {
        "word": "you",
        "time_begin": 113.579994,
        "time_end": 113.82,
        "confidence": 0.98926824
        },
        {
        "word": "feel",
        "time_begin": 113.82,
        "time_end": 114.21999,
        "confidence": 0.99988997
        },
        {
        "word": "bad,",
        "time_begin": 114.21999,
        "time_end": 114.71999,
        "confidence": 0.9963115
        },
        {
        "word": "why",
        "time_begin": 115.02,
        "time_end": 115.259995,
        "confidence": 0.999567
        },
        {
        "word": "don't",
        "time_begin": 115.259995,
        "time_end": 115.42,
        "confidence": 0.99993825
        },
        {
        "word": "you",
        "time_begin": 115.42,
        "time_end": 115.659996,
        "confidence": 0.9992505
        },
        {
        "word": "try",
        "time_begin": 115.659996,
        "time_end": 115.899994,
        "confidence": 0.99983907
        },
        {
        "word": "eating",
        "time_begin": 115.899994,
        "time_end": 116.21999,
        "confidence": 0.9999268
        },
        {
        "word": "something",
        "time_begin": 116.21999,
        "time_end": 116.71999,
        "confidence": 0.99976593
        },
        {
        "word": "good",
        "time_begin": 116.78,
        "time_end": 117.28,
        "confidence": 0.99981874
        },
        {
        "word": "so",
        "time_begin": 117.42,
        "time_end": 117.659996,
        "confidence": 0.8066112
        },
        {
        "word": "you'll",
        "time_begin": 117.659996,
        "time_end": 117.899994,
        "confidence": 0.99802446
        },
        {
        "word": "feel",
        "time_begin": 117.899994,
        "time_end": 118.14,
        "confidence": 0.99990547
        },
        {
        "word": "better?",
        "time_begin": 118.14,
        "time_end": 118.64,
        "confidence": 0.96538234
        }
      ],
      "language": "en",
      "transcription": "You know, next time you feel bad, why don't you try eating something good so you'll feel better?",
      "confidence": -1,
      "time_begin": 112.78,
      "time_end": 118.64,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "We",
        "time_begin": 119.579994,
        "time_end": 119.82,
        "confidence": 0.99935204
        },
        {
        "word": "thank",
        "time_begin": 119.82,
        "time_end": 119.979996,
        "confidence": 0.9973731
        },
        {
        "word": "our",
        "time_begin": 119.979996,
        "time_end": 120.14,
        "confidence": 0.99979216
        },
        {
        "word": "brains",
        "time_begin": 120.14,
        "time_end": 120.46,
        "confidence": 0.99994886
        },
        {
        "word": "for",
        "time_begin": 120.46,
        "time_end": 120.619995,
        "confidence": 0.99978966
        },
        {
        "word": "the",
        "time_begin": 120.619995,
        "time_end": 120.7,
        "confidence": 0.99883324
        },
        {
        "word": "great",
        "time_begin": 120.7,
        "time_end": 121.02,
        "confidence": 0.997982
        },
        {
        "word": "idea.",
        "time_begin": 121.02,
        "time_end": 121.52,
        "confidence": 0.8263759
        }
      ],
      "language": "en",
      "transcription": "We thank our brains for the great idea.",
      "confidence": -1,
      "time_begin": 119.579994,
      "time_end": 121.52,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Try",
        "time_begin": 121.814995,
        "time_end": 122.055,
        "confidence": 0.99983823
        },
        {
        "word": "this",
        "time_begin": 122.055,
        "time_end": 122.375,
        "confidence": 0.9999039
        },
        {
        "word": "and",
        "time_begin": 122.375,
        "time_end": 122.615,
        "confidence": 0.8431818
        },
        {
        "word": "quickly",
        "time_begin": 122.615,
        "time_end": 123.015,
        "confidence": 0.9995826
        },
        {
        "word": "learn",
        "time_begin": 123.015,
        "time_end": 123.255,
        "confidence": 0.9976419
        },
        {
        "word": "that",
        "time_begin": 123.255,
        "time_end": 123.41499,
        "confidence": 0.996012
        },
        {
        "word": "if",
        "time_begin": 123.41499,
        "time_end": 123.655,
        "confidence": 0.9931948
        },
        {
        "word": "we",
        "time_begin": 123.655,
        "time_end": 123.814995,
        "confidence": 0.9996251
        },
        {
        "word": "eat",
        "time_begin": 123.814995,
        "time_end": 124.055,
        "confidence": 0.9999217
        },
        {
        "word": "chocolate",
        "time_begin": 124.055,
        "time_end": 124.555,
        "confidence": 0.9997787
        },
        {
        "word": "or",
        "time_begin": 124.854996,
        "time_end": 125.09499,
        "confidence": 0.9864775
        },
        {
        "word": "ice",
        "time_begin": 125.09499,
        "time_end": 125.41499,
        "confidence": 0.99997497
        },
        {
        "word": "cream",
        "time_begin": 125.41499,
        "time_end": 125.655,
        "confidence": 0.999946
        },
        {
        "word": "when",
        "time_begin": 125.655,
        "time_end": 125.895,
        "confidence": 0.9770995
        },
        {
        "word": "we're",
        "time_begin": 125.895,
        "time_end": 126.055,
        "confidence": 0.9983458
        },
        {
        "word": "mad",
        "time_begin": 126.055,
        "time_end": 126.295,
        "confidence": 0.9970848
        },
        {
        "word": "or",
        "time_begin": 126.295,
        "time_end": 126.454994,
        "confidence": 0.99852544
        },
        {
        "word": "sad,",
        "time_begin": 126.454994,
        "time_end": 126.695,
        "confidence": 0.9782078
        },
        {
        "word": "we",
        "time_begin": 126.695,
        "time_end": 126.854996,
        "confidence": 0.99982303
        },
        {
        "word": "feel",
        "time_begin": 126.854996,
        "time_end": 127.09499,
        "confidence": 0.9988298
        },
        {
        "word": "better.",
        "time_begin": 127.09499,
        "time_end": 127.59499,
        "confidence": 0.99859273
        }
      ],
      "language": "en",
      "transcription": "Try this and quickly learn that if we eat chocolate or ice cream when we're mad or sad, we feel better.",
      "confidence": -1,
      "time_begin": 121.814995,
      "time_end": 127.59499,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Same",
        "time_begin": 128.69499,
        "time_end": 129.095,
        "confidence": 0.9892496
        },
        {
        "word": "process,",
        "time_begin": 129.095,
        "time_end": 129.595,
        "confidence": 0.97719467
        },
        {
        "word": "just",
        "time_begin": 129.97499,
        "time_end": 130.295,
        "confidence": 0.9989868
        },
        {
        "word": "a",
        "time_begin": 130.295,
        "time_end": 130.375,
        "confidence": 0.9997025
        },
        {
        "word": "different",
        "time_begin": 130.375,
        "time_end": 130.775,
        "confidence": 0.99997914
        },
        {
        "word": "trigger.",
        "time_begin": 130.775,
        "time_end": 131.275,
        "confidence": 0.9962675
        }
      ],
      "language": "en",
      "transcription": "Same process, just a different trigger.",
      "confidence": -1,
      "time_begin": 128.69499,
      "time_end": 131.275,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Instead",
        "time_begin": 131.735,
        "time_end": 132.135,
        "confidence": 0.99984515
        },
        {
        "word": "of",
        "time_begin": 132.135,
        "time_end": 132.295,
        "confidence": 0.9999162
        },
        {
        "word": "this",
        "time_begin": 132.295,
        "time_end": 132.455,
        "confidence": 0.99941885
        },
        {
        "word": "hunger",
        "time_begin": 132.455,
        "time_end": 132.855,
        "confidence": 0.99994695
        },
        {
        "word": "signal",
        "time_begin": 132.855,
        "time_end": 133.175,
        "confidence": 0.99993
        },
        {
        "word": "coming",
        "time_begin": 133.175,
        "time_end": 133.495,
        "confidence": 0.9997148
        },
        {
        "word": "from",
        "time_begin": 133.495,
        "time_end": 133.735,
        "confidence": 0.99962986
        },
        {
        "word": "our",
        "time_begin": 133.735,
        "time_end": 133.97499,
        "confidence": 0.99973005
        },
        {
        "word": "stomach,",
        "time_begin": 133.97499,
        "time_end": 134.47499,
        "confidence": 0.9989203
        },
        {
        "word": "this",
        "time_begin": 134.91,
        "time_end": 135.15,
        "confidence": 0.999833
        },
        {
        "word": "emotional",
        "time_begin": 135.15,
        "time_end": 135.65,
        "confidence": 0.99934703
        },
        {
        "word": "signal,",
        "time_begin": 135.70999,
        "time_end": 136.19,
        "confidence": 0.8374903
        },
        {
        "word": "feeling",
        "time_begin": 136.19,
        "time_end": 136.59,
        "confidence": 0.99902153
        },
        {
        "word": "sad,",
        "time_begin": 136.59,
        "time_end": 136.91,
        "confidence": 0.8162522
        },
        {
        "word": "triggers",
        "time_begin": 136.91,
        "time_end": 137.23,
        "confidence": 0.99993384
        },
        {
        "word": "that",
        "time_begin": 137.23,
        "time_end": 137.47,
        "confidence": 0.99404114
        },
        {
        "word": "urge",
        "time_begin": 137.47,
        "time_end": 137.70999,
        "confidence": 0.9999995
        },
        {
        "word": "to",
        "time_begin": 137.70999,
        "time_end": 137.87,
        "confidence": 0.9998944
        },
        {
        "word": "eat.",
        "time_begin": 137.87,
        "time_end": 138.37,
        "confidence": 0.99888
        }
      ],
      "language": "en",
      "transcription": "Instead of this hunger signal coming from our stomach, this emotional signal, feeling sad, triggers that urge to eat.",
      "confidence": -1,
      "time_begin": 131.735,
      "time_end": 138.37,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Maybe",
        "time_begin": 138.98999,
        "time_end": 139.31,
        "confidence": 0.9996308
        },
        {
        "word": "in",
        "time_begin": 139.31,
        "time_end": 139.47,
        "confidence": 0.96801615
        },
        {
        "word": "our",
        "time_begin": 139.47,
        "time_end": 139.63,
        "confidence": 0.99977773
        },
        {
        "word": "teenage",
        "time_begin": 139.63,
        "time_end": 140.11,
        "confidence": 0.99710244
        },
        {
        "word": "years,",
        "time_begin": 140.11,
        "time_end": 140.61,
        "confidence": 0.92152125
        },
        {
        "word": "we",
        "time_begin": 141.06999,
        "time_end": 141.23,
        "confidence": 0.97882366
        },
        {
        "word": "were",
        "time_begin": 141.23,
        "time_end": 141.47,
        "confidence": 0.8841619
        },
        {
        "word": "a",
        "time_begin": 141.47,
        "time_end": 141.55,
        "confidence": 0.997106
        },
        {
        "word": "nerd",
        "time_begin": 141.55,
        "time_end": 141.79,
        "confidence": 0.99992657
        },
        {
        "word": "at",
        "time_begin": 141.79,
        "time_end": 141.95,
        "confidence": 0.9981927
        },
        {
        "word": "school,",
        "time_begin": 141.95,
        "time_end": 142.45,
        "confidence": 0.7192628
        },
        {
        "word": "and",
        "time_begin": 143.47,
        "time_end": 143.63,
        "confidence": 0.99636394
        },
        {
        "word": "we",
        "time_begin": 143.63,
        "time_end": 143.87,
        "confidence": 0.99653876
        },
        {
        "word": "see",
        "time_begin": 143.87,
        "time_end": 144.03,
        "confidence": 0.99747807
        },
        {
        "word": "those",
        "time_begin": 144.03,
        "time_end": 144.27,
        "confidence": 0.99790895
        },
        {
        "word": "rebel",
        "time_begin": 144.27,
        "time_end": 144.59,
        "confidence": 0.99968004
        },
        {
        "word": "kids",
        "time_begin": 144.59,
        "time_end": 144.83,
        "confidence": 0.99983203
        },
        {
        "word": "outside",
        "time_begin": 144.83,
        "time_end": 145.31,
        "confidence": 0.9972601
        },
        {
        "word": "smoking,",
        "time_begin": 145.31,
        "time_end": 145.63,
        "confidence": 0.74626684
        },
        {
        "word": "and",
        "time_begin": 145.63,
        "time_end": 145.79,
        "confidence": 0.681569
        },
        {
        "word": "we",
        "time_begin": 145.79,
        "time_end": 145.87,
        "confidence": 0.9989593
        },
        {
        "word": "think,",
        "time_begin": 145.87,
        "time_end": 146.27,
        "confidence": 0.98496234
        },
        {
        "word": "hey,",
        "time_begin": 146.27,
        "time_end": 146.59,
        "confidence": 0.89484084
        },
        {
        "word": "I",
        "time_begin": 146.59,
        "time_end": 146.75,
        "confidence": 0.99982846
        },
        {
        "word": "want",
        "time_begin": 146.75,
        "time_end": 146.91,
        "confidence": 0.84843916
        },
        {
        "word": "to",
        "time_begin": 146.91,
        "time_end": 147.06999,
        "confidence": 0.9995134
        },
        {
        "word": "be",
        "time_begin": 147.06999,
        "time_end": 147.23,
        "confidence": 0.9998336
        },
        {
        "word": "cool,",
        "time_begin": 147.23,
        "time_end": 147.47,
        "confidence": 0.7748253
        },
        {
        "word": "so",
        "time_begin": 147.47,
        "time_end": 147.70999,
        "confidence": 0.9975988
        },
        {
        "word": "we",
        "time_begin": 147.70999,
        "time_end": 147.87,
        "confidence": 0.9996277
        },
        {
        "word": "start",
        "time_begin": 147.87,
        "time_end": 148.19,
        "confidence": 0.9961383
        },
        {
        "word": "smoking.",
        "time_begin": 148.19,
        "time_end": 148.69,
        "confidence": 0.99973786
        }
      ],
      "language": "en",
      "transcription": "Maybe in our teenage years, we were a nerd at school, and we see those rebel kids outside smoking, and we think, hey, I want to be cool, so we start smoking.",
      "confidence": -1,
      "time_begin": 138.98999,
      "time_end": 148.69,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "The",
        "time_begin": 149.665,
        "time_end": 149.825,
        "confidence": 0.9986833
        },
        {
        "word": "Marlboro",
        "time_begin": 149.825,
        "time_end": 150.325,
        "confidence": 0.9844346
        },
        {
        "word": "man",
        "time_begin": 150.385,
        "time_end": 150.625,
        "confidence": 0.62832594
        },
        {
        "word": "wasn't",
        "time_begin": 150.625,
        "time_end": 150.94499,
        "confidence": 0.99977505
        },
        {
        "word": "a",
        "time_begin": 150.94499,
        "time_end": 151.105,
        "confidence": 0.9996489
        },
        {
        "word": "dork,",
        "time_begin": 151.105,
        "time_end": 151.425,
        "confidence": 0.90925384
        },
        {
        "word": "and",
        "time_begin": 151.425,
        "time_end": 151.665,
        "confidence": 0.9996729
        },
        {
        "word": "that",
        "time_begin": 151.665,
        "time_end": 151.905,
        "confidence": 0.99973816
        },
        {
        "word": "was",
        "time_begin": 151.905,
        "time_end": 152.065,
        "confidence": 0.99991596
        },
        {
        "word": "no",
        "time_begin": 152.065,
        "time_end": 152.385,
        "confidence": 0.999253
        },
        {
        "word": "accident.",
        "time_begin": 152.385,
        "time_end": 152.885,
        "confidence": 0.9974681
        }
      ],
      "language": "en",
      "transcription": "The Marlboro man wasn't a dork, and that was no accident.",
      "confidence": -1,
      "time_begin": 149.665,
      "time_end": 152.885,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "See",
        "time_begin": 153.665,
        "time_end": 153.905,
        "confidence": 0.99070704
        },
        {
        "word": "cool,",
        "time_begin": 153.905,
        "time_end": 154.405,
        "confidence": 0.87045527
        },
        {
        "word": "smoke",
        "time_begin": 154.785,
        "time_end": 155.105,
        "confidence": 0.9988752
        },
        {
        "word": "to",
        "time_begin": 155.105,
        "time_end": 155.265,
        "confidence": 0.9998437
        },
        {
        "word": "be",
        "time_begin": 155.265,
        "time_end": 155.505,
        "confidence": 0.9999043
        },
        {
        "word": "cool,",
        "time_begin": 155.505,
        "time_end": 156.005,
        "confidence": 0.9956387
        },
        {
        "word": "feel",
        "time_begin": 156.145,
        "time_end": 156.465,
        "confidence": 0.9994717
        },
        {
        "word": "good.",
        "time_begin": 156.465,
        "time_end": 156.965,
        "confidence": 0.93106204
        }
      ],
      "language": "en",
      "transcription": "See cool, smoke to be cool, feel good.",
      "confidence": -1,
      "time_begin": 153.665,
      "time_end": 156.965,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Repeat.",
        "time_begin": 157.265,
        "time_end": 157.765,
        "confidence": 0.92910415
        }
      ],
      "language": "en",
      "transcription": "Repeat.",
      "confidence": -1,
      "time_begin": 157.265,
      "time_end": 157.765,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Trigger,",
        "time_begin": 157.905,
        "time_end": 158.405,
        "confidence": 0.7927822
        },
        {
        "word": "behavior,",
        "time_begin": 158.545,
        "time_end": 159.045,
        "confidence": 0.9952446
        },
        {
        "word": "reward.",
        "time_begin": 159.265,
        "time_end": 159.765,
        "confidence": 0.99869305
        }
      ],
      "language": "en",
      "transcription": "Trigger, behavior, reward.",
      "confidence": -1,
      "time_begin": 157.905,
      "time_end": 159.765,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "And",
        "time_begin": 160.545,
        "time_end": 160.785,
        "confidence": 0.9086396
        },
        {
        "word": "each",
        "time_begin": 160.785,
        "time_end": 160.94499,
        "confidence": 0.998382
        },
        {
        "word": "time",
        "time_begin": 160.94499,
        "time_end": 161.185,
        "confidence": 0.9997936
        },
        {
        "word": "we",
        "time_begin": 161.185,
        "time_end": 161.345,
        "confidence": 0.9994759
        },
        {
        "word": "do",
        "time_begin": 161.345,
        "time_end": 161.505,
        "confidence": 0.9998952
        },
        {
        "word": "this,",
        "time_begin": 161.505,
        "time_end": 161.745,
        "confidence": 0.98639035
        },
        {
        "word": "we",
        "time_begin": 161.745,
        "time_end": 161.905,
        "confidence": 0.9998678
        },
        {
        "word": "learn",
        "time_begin": 161.905,
        "time_end": 162.225,
        "confidence": 0.99903524
        },
        {
        "word": "to",
        "time_begin": 162.225,
        "time_end": 162.385,
        "confidence": 0.99946076
        },
        {
        "word": "repeat",
        "time_begin": 162.385,
        "time_end": 162.785,
        "confidence": 0.9999654
        },
        {
        "word": "the",
        "time_begin": 162.785,
        "time_end": 162.94499,
        "confidence": 0.9980946
        },
        {
        "word": "process,",
        "time_begin": 162.94499,
        "time_end": 163.44499,
        "confidence": 0.78789234
        },
        {
        "word": "and",
        "time_begin": 163.825,
        "time_end": 163.985,
        "confidence": 0.9995433
        },
        {
        "word": "it",
        "time_begin": 163.985,
        "time_end": 164.145,
        "confidence": 0.9999006
        },
        {
        "word": "becomes",
        "time_begin": 164.145,
        "time_end": 164.545,
        "confidence": 0.999931
        },
        {
        "word": "a",
        "time_begin": 164.545,
        "time_end": 164.625,
        "confidence": 0.9998443
        },
        {
        "word": "habit.",
        "time_begin": 164.625,
        "time_end": 165.125,
        "confidence": 0.9998772
        }
      ],
      "language": "en",
      "transcription": "And each time we do this, we learn to repeat the process, and it becomes a habit.",
      "confidence": -1,
      "time_begin": 160.545,
      "time_end": 165.125,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "So",
        "time_begin": 165.98,
        "time_end": 166.21999,
        "confidence": 0.9865578
        },
        {
        "word": "later,",
        "time_begin": 166.21999,
        "time_end": 166.71999,
        "confidence": 0.9664948
        },
        {
        "word": "feeling",
        "time_begin": 167.26,
        "time_end": 167.73999,
        "confidence": 0.9994711
        },
        {
        "word": "stressed",
        "time_begin": 167.73999,
        "time_end": 168.14,
        "confidence": 0.99982697
        },
        {
        "word": "out",
        "time_begin": 168.14,
        "time_end": 168.45999,
        "confidence": 0.99327636
        },
        {
        "word": "triggers",
        "time_begin": 168.45999,
        "time_end": 168.78,
        "confidence": 0.9997234
        },
        {
        "word": "that",
        "time_begin": 168.78,
        "time_end": 169.01999,
        "confidence": 0.99681383
        },
        {
        "word": "urge",
        "time_begin": 169.01999,
        "time_end": 169.26,
        "confidence": 0.9999558
        },
        {
        "word": "to",
        "time_begin": 169.26,
        "time_end": 169.42,
        "confidence": 0.99995244
        },
        {
        "word": "smoke",
        "time_begin": 169.42,
        "time_end": 169.65999,
        "confidence": 0.9999083
        },
        {
        "word": "a",
        "time_begin": 169.65999,
        "time_end": 169.81999,
        "confidence": 0.9998373
        },
        {
        "word": "cigarette",
        "time_begin": 169.81999,
        "time_end": 170.31999,
        "confidence": 0.99992335
        },
        {
        "word": "or",
        "time_begin": 170.78,
        "time_end": 171.01999,
        "confidence": 0.9672619
        },
        {
        "word": "to",
        "time_begin": 171.01999,
        "time_end": 171.09999,
        "confidence": 0.97489136
        },
        {
        "word": "eat",
        "time_begin": 171.09999,
        "time_end": 171.34,
        "confidence": 0.9999143
        },
        {
        "word": "something",
        "time_begin": 171.34,
        "time_end": 171.73999,
        "confidence": 0.9999118
        },
        {
        "word": "sweet.",
        "time_begin": 171.73999,
        "time_end": 172.23999,
        "confidence": 0.9999268
        }
      ],
      "language": "en",
      "transcription": "So later, feeling stressed out triggers that urge to smoke a cigarette or to eat something sweet.",
      "confidence": -1,
      "time_begin": 165.98,
      "time_end": 172.23999,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Now,",
        "time_begin": 173.18,
        "time_end": 173.5,
        "confidence": 0.76452684
        },
        {
        "word": "with",
        "time_begin": 173.5,
        "time_end": 173.73999,
        "confidence": 0.9997849
        },
        {
        "word": "these",
        "time_begin": 173.73999,
        "time_end": 174.06,
        "confidence": 0.9861953
        },
        {
        "word": "same",
        "time_begin": 174.06,
        "time_end": 174.56,
        "confidence": 0.9989643
        },
        {
        "word": "brain",
        "time_begin": 174.62,
        "time_end": 175.12,
        "confidence": 0.9495899
        },
        {
        "word": "processes,",
        "time_begin": 175.26,
        "time_end": 175.76,
        "confidence": 0.9940996
        },
        {
        "word": "we've",
        "time_begin": 175.98,
        "time_end": 176.21999,
        "confidence": 0.9980103
        },
        {
        "word": "gone",
        "time_begin": 176.21999,
        "time_end": 176.45999,
        "confidence": 0.99979323
        },
        {
        "word": "from",
        "time_begin": 176.45999,
        "time_end": 176.7,
        "confidence": 0.99969876
        },
        {
        "word": "learning",
        "time_begin": 176.7,
        "time_end": 177.01999,
        "confidence": 0.9998528
        },
        {
        "word": "to",
        "time_begin": 177.01999,
        "time_end": 177.18,
        "confidence": 0.99986184
        },
        {
        "word": "survive",
        "time_begin": 177.18,
        "time_end": 177.68,
        "confidence": 0.9998623
        },
        {
        "word": "to",
        "time_begin": 177.98,
        "time_end": 178.21999,
        "confidence": 0.97274965
        },
        {
        "word": "literally",
        "time_begin": 178.21999,
        "time_end": 178.7,
        "confidence": 0.9986615
        },
        {
        "word": "killing",
        "time_begin": 178.7,
        "time_end": 179.01999,
        "confidence": 0.9998202
        },
        {
        "word": "ourselves",
        "time_begin": 179.01999,
        "time_end": 179.5,
        "confidence": 0.9997812
        },
        {
        "word": "with",
        "time_begin": 179.5,
        "time_end": 179.73999,
        "confidence": 0.99976593
        },
        {
        "word": "these",
        "time_begin": 179.73999,
        "time_end": 179.98,
        "confidence": 0.9995747
        },
        {
        "word": "habits.",
        "time_begin": 179.98,
        "time_end": 180.48,
        "confidence": 0.99991
        }
      ],
      "language": "en",
      "transcription": "Now, with these same brain processes, we've gone from learning to survive to literally killing ourselves with these habits.",
      "confidence": -1,
      "time_begin": 173.18,
      "time_end": 180.48,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Obesity",
        "time_begin": 181.065,
        "time_end": 181.305,
        "confidence": 0.99999607
        },
        {
        "word": "and",
        "time_begin": 181.305,
        "time_end": 181.625,
        "confidence": 0.9998573
        },
        {
        "word": "smoking",
        "time_begin": 181.625,
        "time_end": 182.025,
        "confidence": 0.9999455
        },
        {
        "word": "are",
        "time_begin": 182.025,
        "time_end": 182.265,
        "confidence": 0.9971348
        },
        {
        "word": "among",
        "time_begin": 182.265,
        "time_end": 182.665,
        "confidence": 0.86970013
        },
        {
        "word": "the",
        "time_begin": 182.665,
        "time_end": 182.825,
        "confidence": 0.9998313
        },
        {
        "word": "leading",
        "time_begin": 182.825,
        "time_end": 183.325,
        "confidence": 0.9775015
        },
        {
        "word": "preventable",
        "time_begin": 183.385,
        "time_end": 183.785,
        "confidence": 0.99880517
        },
        {
        "word": "causes",
        "time_begin": 183.785,
        "time_end": 184.185,
        "confidence": 0.9990939
        },
        {
        "word": "of",
        "time_begin": 184.185,
        "time_end": 184.345,
        "confidence": 0.99913126
        },
        {
        "word": "morbidity",
        "time_begin": 184.345,
        "time_end": 184.845,
        "confidence": 0.99976885
        },
        {
        "word": "and",
        "time_begin": 184.905,
        "time_end": 185.065,
        "confidence": 0.96569353
        },
        {
        "word": "mortality",
        "time_begin": 185.065,
        "time_end": 185.565,
        "confidence": 0.9998573
        },
        {
        "word": "in",
        "time_begin": 185.625,
        "time_end": 185.705,
        "confidence": 0.9998807
        },
        {
        "word": "the",
        "time_begin": 185.705,
        "time_end": 185.86499,
        "confidence": 0.9999418
        },
        {
        "word": "world.",
        "time_begin": 185.86499,
        "time_end": 186.36499,
        "confidence": 0.99976385
        }
      ],
      "language": "en",
      "transcription": "Obesity and smoking are among the leading preventable causes of morbidity and mortality in the world.",
      "confidence": -1,
      "time_begin": 181.065,
      "time_end": 186.36499,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "So",
        "time_begin": 187.385,
        "time_end": 187.705,
        "confidence": 0.99471223
        },
        {
        "word": "back",
        "time_begin": 187.705,
        "time_end": 187.86499,
        "confidence": 0.9412823
        },
        {
        "word": "to",
        "time_begin": 187.86499,
        "time_end": 188.025,
        "confidence": 0.9998965
        },
        {
        "word": "my",
        "time_begin": 188.025,
        "time_end": 188.265,
        "confidence": 0.99996233
        },
        {
        "word": "breath.",
        "time_begin": 188.265,
        "time_end": 188.765,
        "confidence": 0.8815098
        }
      ],
      "language": "en",
      "transcription": "So back to my breath.",
      "confidence": -1,
      "time_begin": 187.385,
      "time_end": 188.765,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "What",
        "time_begin": 189.705,
        "time_end": 189.86499,
        "confidence": 0.99951434
        },
        {
        "word": "if",
        "time_begin": 189.86499,
        "time_end": 190.185,
        "confidence": 0.99980134
        },
        {
        "word": "instead",
        "time_begin": 190.185,
        "time_end": 190.58499,
        "confidence": 0.8424741
        },
        {
        "word": "of",
        "time_begin": 190.58499,
        "time_end": 191.08499,
        "confidence": 0.9997403
        },
        {
        "word": "fighting",
        "time_begin": 191.22499,
        "time_end": 191.545,
        "confidence": 0.9998317
        },
        {
        "word": "our",
        "time_begin": 191.545,
        "time_end": 191.785,
        "confidence": 0.9997236
        },
        {
        "word": "brains",
        "time_begin": 191.785,
        "time_end": 192.105,
        "confidence": 0.99991846
        },
        {
        "word": "or",
        "time_begin": 192.105,
        "time_end": 192.265,
        "confidence": 0.9596879
        },
        {
        "word": "trying",
        "time_begin": 192.265,
        "time_end": 192.50499,
        "confidence": 0.99936026
        },
        {
        "word": "to",
        "time_begin": 192.50499,
        "time_end": 192.745,
        "confidence": 0.9997509
        },
        {
        "word": "force",
        "time_begin": 192.745,
        "time_end": 193.065,
        "confidence": 0.9999393
        },
        {
        "word": "ourselves",
        "time_begin": 193.065,
        "time_end": 193.545,
        "confidence": 0.999006
        },
        {
        "word": "to",
        "time_begin": 193.545,
        "time_end": 193.705,
        "confidence": 0.999863
        },
        {
        "word": "pay",
        "time_begin": 193.705,
        "time_end": 193.86499,
        "confidence": 0.99989057
        },
        {
        "word": "attention,",
        "time_begin": 193.86499,
        "time_end": 194.36499,
        "confidence": 0.9895004
        },
        {
        "word": "we",
        "time_begin": 194.63,
        "time_end": 194.87001,
        "confidence": 0.9997228
        },
        {
        "word": "instead",
        "time_begin": 194.87001,
        "time_end": 195.27,
        "confidence": 0.99197125
        },
        {
        "word": "tapped",
        "time_begin": 195.27,
        "time_end": 195.59,
        "confidence": 0.999033
        },
        {
        "word": "into",
        "time_begin": 195.59,
        "time_end": 195.83,
        "confidence": 0.9956917
        },
        {
        "word": "this",
        "time_begin": 195.83,
        "time_end": 195.99,
        "confidence": 0.99916816
        },
        {
        "word": "natural",
        "time_begin": 195.99,
        "time_end": 196.39,
        "confidence": 0.9996582
        },
        {
        "word": "reward",
        "time_begin": 196.39,
        "time_end": 196.71,
        "confidence": 0.8349664
        },
        {
        "word": "based",
        "time_begin": 196.71,
        "time_end": 196.95,
        "confidence": 0.99905866
        },
        {
        "word": "learning",
        "time_begin": 196.95,
        "time_end": 197.27,
        "confidence": 0.99970335
        },
        {
        "word": "process,",
        "time_begin": 197.27,
        "time_end": 197.77,
        "confidence": 0.834992
        },
        {
        "word": "but",
        "time_begin": 198.63,
        "time_end": 198.79001,
        "confidence": 0.92051774
        },
        {
        "word": "added",
        "time_begin": 198.79001,
        "time_end": 199.11,
        "confidence": 0.99803716
        },
        {
        "word": "a",
        "time_begin": 199.11,
        "time_end": 199.27,
        "confidence": 0.99961865
        },
        {
        "word": "twist.",
        "time_begin": 199.27,
        "time_end": 199.77,
        "confidence": 0.79941916
        }
      ],
      "language": "en",
      "transcription": "What if instead of fighting our brains or trying to force ourselves to pay attention, we instead tapped into this natural reward based learning process, but added a twist.",
      "confidence": -1,
      "time_begin": 189.705,
      "time_end": 199.77,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "What",
        "time_begin": 200.39,
        "time_end": 200.63,
        "confidence": 0.9997503
        },
        {
        "word": "if",
        "time_begin": 200.63,
        "time_end": 200.79001,
        "confidence": 0.99965703
        },
        {
        "word": "instead",
        "time_begin": 200.79001,
        "time_end": 201.11,
        "confidence": 0.76603264
        },
        {
        "word": "we",
        "time_begin": 201.11,
        "time_end": 201.35,
        "confidence": 0.68252444
        },
        {
        "word": "just",
        "time_begin": 201.35,
        "time_end": 201.43001,
        "confidence": 0.9728448
        },
        {
        "word": "got",
        "time_begin": 201.43001,
        "time_end": 201.67,
        "confidence": 0.99966323
        },
        {
        "word": "really",
        "time_begin": 201.67,
        "time_end": 201.91,
        "confidence": 0.9968178
        },
        {
        "word": "curious",
        "time_begin": 201.91,
        "time_end": 202.23,
        "confidence": 0.99997246
        },
        {
        "word": "about",
        "time_begin": 202.23,
        "time_end": 202.47,
        "confidence": 0.9995473
        },
        {
        "word": "what",
        "time_begin": 202.47,
        "time_end": 202.63,
        "confidence": 0.9998832
        },
        {
        "word": "was",
        "time_begin": 202.63,
        "time_end": 202.79001,
        "confidence": 0.9989907
        },
        {
        "word": "happening",
        "time_begin": 202.79001,
        "time_end": 203.19,
        "confidence": 0.9999604
        },
        {
        "word": "in",
        "time_begin": 203.19,
        "time_end": 203.35,
        "confidence": 0.9997522
        },
        {
        "word": "our",
        "time_begin": 203.35,
        "time_end": 203.51001,
        "confidence": 0.998582
        },
        {
        "word": "momentary",
        "time_begin": 203.51001,
        "time_end": 204.01001,
        "confidence": 0.9997686
        },
        {
        "word": "experience?",
        "time_begin": 204.07,
        "time_end": 204.57,
        "confidence": 0.97071767
        }
      ],
      "language": "en",
      "transcription": "What if instead we just got really curious about what was happening in our momentary experience?",
      "confidence": -1,
      "time_begin": 200.39,
      "time_end": 204.57,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "I'll",
        "time_begin": 204.63,
        "time_end": 204.79001,
        "confidence": 0.99907315
        },
        {
        "word": "give",
        "time_begin": 204.79001,
        "time_end": 204.95,
        "confidence": 0.99993837
        },
        {
        "word": "you",
        "time_begin": 204.95,
        "time_end": 205.11,
        "confidence": 0.9994648
        },
        {
        "word": "an",
        "time_begin": 205.11,
        "time_end": 205.35,
        "confidence": 0.9998418
        },
        {
        "word": "example.",
        "time_begin": 205.35,
        "time_end": 205.85,
        "confidence": 0.99942136
        }
      ],
      "language": "en",
      "transcription": "I'll give you an example.",
      "confidence": -1,
      "time_begin": 204.63,
      "time_end": 205.85,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "In",
        "time_begin": 206.565,
        "time_end": 206.80501,
        "confidence": 0.9997737
        },
        {
        "word": "my",
        "time_begin": 206.80501,
        "time_end": 206.965,
        "confidence": 0.9998926
        },
        {
        "word": "lab,",
        "time_begin": 206.965,
        "time_end": 207.045,
        "confidence": 0.9557879
        },
        {
        "word": "we",
        "time_begin": 207.045,
        "time_end": 207.285,
        "confidence": 0.99989974
        },
        {
        "word": "studied",
        "time_begin": 207.285,
        "time_end": 207.605,
        "confidence": 0.99561346
        },
        {
        "word": "whether",
        "time_begin": 207.605,
        "time_end": 207.845,
        "confidence": 0.99907196
        },
        {
        "word": "mindfulness",
        "time_begin": 207.845,
        "time_end": 208.345,
        "confidence": 0.99942327
        },
        {
        "word": "training",
        "time_begin": 208.405,
        "time_end": 208.725,
        "confidence": 0.99921405
        },
        {
        "word": "could",
        "time_begin": 208.725,
        "time_end": 208.88501,
        "confidence": 0.99816173
        },
        {
        "word": "help",
        "time_begin": 208.88501,
        "time_end": 209.125,
        "confidence": 0.9999374
        },
        {
        "word": "people",
        "time_begin": 209.125,
        "time_end": 209.365,
        "confidence": 0.9999143
        },
        {
        "word": "quit",
        "time_begin": 209.365,
        "time_end": 209.685,
        "confidence": 0.9983144
        },
        {
        "word": "smoking.",
        "time_begin": 209.685,
        "time_end": 210.185,
        "confidence": 0.9998015
        }
      ],
      "language": "en",
      "transcription": "In my lab, we studied whether mindfulness training could help people quit smoking.",
      "confidence": -1,
      "time_begin": 206.565,
      "time_end": 210.185,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Now,",
        "time_begin": 211.205,
        "time_end": 211.685,
        "confidence": 0.91436005
        },
        {
        "word": "just",
        "time_begin": 211.685,
        "time_end": 212.005,
        "confidence": 0.99955314
        },
        {
        "word": "like",
        "time_begin": 212.005,
        "time_end": 212.245,
        "confidence": 0.9996414
        },
        {
        "word": "trying",
        "time_begin": 212.245,
        "time_end": 212.485,
        "confidence": 0.9987833
        },
        {
        "word": "to",
        "time_begin": 212.485,
        "time_end": 212.645,
        "confidence": 0.9998286
        },
        {
        "word": "force",
        "time_begin": 212.645,
        "time_end": 212.965,
        "confidence": 0.9998369
        },
        {
        "word": "myself",
        "time_begin": 212.965,
        "time_end": 213.365,
        "confidence": 0.9992455
        },
        {
        "word": "to",
        "time_begin": 213.365,
        "time_end": 213.445,
        "confidence": 0.9969343
        },
        {
        "word": "pay",
        "time_begin": 213.445,
        "time_end": 213.685,
        "confidence": 0.9980001
        },
        {
        "word": "attention",
        "time_begin": 213.685,
        "time_end": 214.005,
        "confidence": 0.9999671
        },
        {
        "word": "on",
        "time_begin": 214.005,
        "time_end": 214.085,
        "confidence": 0.54893094
        },
        {
        "word": "my",
        "time_begin": 214.085,
        "time_end": 214.325,
        "confidence": 0.9997793
        },
        {
        "word": "breath,",
        "time_begin": 214.325,
        "time_end": 214.825,
        "confidence": 0.9965496
        },
        {
        "word": "they",
        "time_begin": 214.965,
        "time_end": 215.205,
        "confidence": 0.9996537
        },
        {
        "word": "could",
        "time_begin": 215.205,
        "time_end": 215.52501,
        "confidence": 0.99984574
        },
        {
        "word": "try",
        "time_begin": 215.52501,
        "time_end": 215.765,
        "confidence": 0.9997731
        },
        {
        "word": "to",
        "time_begin": 215.765,
        "time_end": 215.925,
        "confidence": 0.99902105
        },
        {
        "word": "force",
        "time_begin": 215.925,
        "time_end": 216.245,
        "confidence": 0.9999229
        },
        {
        "word": "themselves",
        "time_begin": 216.245,
        "time_end": 216.745,
        "confidence": 0.9997032
        },
        {
        "word": "to",
        "time_begin": 216.80501,
        "time_end": 216.965,
        "confidence": 0.9997211
        },
        {
        "word": "quit",
        "time_begin": 216.965,
        "time_end": 217.205,
        "confidence": 0.99991
        },
        {
        "word": "smoking.",
        "time_begin": 217.205,
        "time_end": 217.705,
        "confidence": 0.8154226
        }
      ],
      "language": "en",
      "transcription": "Now, just like trying to force myself to pay attention on my breath, they could try to force themselves to quit smoking.",
      "confidence": -1,
      "time_begin": 211.205,
      "time_end": 217.705,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "And",
        "time_begin": 218.085,
        "time_end": 218.325,
        "confidence": 0.9775544
        },
        {
        "word": "the",
        "time_begin": 218.325,
        "time_end": 218.485,
        "confidence": 0.9973041
        },
        {
        "word": "majority",
        "time_begin": 218.485,
        "time_end": 218.88501,
        "confidence": 0.99996376
        },
        {
        "word": "of",
        "time_begin": 218.88501,
        "time_end": 219.045,
        "confidence": 0.99432147
        },
        {
        "word": "them",
        "time_begin": 219.045,
        "time_end": 219.285,
        "confidence": 0.999701
        },
        {
        "word": "had",
        "time_begin": 219.285,
        "time_end": 219.52501,
        "confidence": 0.99918586
        },
        {
        "word": "tried",
        "time_begin": 219.52501,
        "time_end": 219.765,
        "confidence": 0.99990785
        },
        {
        "word": "this",
        "time_begin": 219.765,
        "time_end": 219.925,
        "confidence": 0.99968314
        },
        {
        "word": "before",
        "time_begin": 219.925,
        "time_end": 220.245,
        "confidence": 0.99971193
        },
        {
        "word": "and",
        "time_begin": 220.245,
        "time_end": 220.485,
        "confidence": 0.97610927
        },
        {
        "word": "failed,",
        "time_begin": 220.485,
        "time_end": 220.95,
        "confidence": 0.8284328
        },
        {
        "word": "on",
        "time_begin": 221.19,
        "time_end": 221.43,
        "confidence": 0.9994753
        },
        {
        "word": "average,",
        "time_begin": 221.43,
        "time_end": 221.93,
        "confidence": 0.7814095
        },
        {
        "word": "six",
        "time_begin": 222.06999,
        "time_end": 222.47,
        "confidence": 0.99968445
        },
        {
        "word": "times.",
        "time_begin": 222.47,
        "time_end": 222.97,
        "confidence": 0.999841
        }
      ],
      "language": "en",
      "transcription": "And the majority of them had tried this before and failed, on average, six times.",
      "confidence": -1,
      "time_begin": 218.085,
      "time_end": 222.97,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Now,",
        "time_begin": 223.83,
        "time_end": 223.98999,
        "confidence": 0.70204383
        },
        {
        "word": "with",
        "time_begin": 223.98999,
        "time_end": 224.23,
        "confidence": 0.99958986
        },
        {
        "word": "mindfulness",
        "time_begin": 224.23,
        "time_end": 224.70999,
        "confidence": 0.9973687
        },
        {
        "word": "training,",
        "time_begin": 224.70999,
        "time_end": 225.03,
        "confidence": 0.9722637
        },
        {
        "word": "we",
        "time_begin": 225.03,
        "time_end": 225.19,
        "confidence": 0.99991024
        },
        {
        "word": "dropped",
        "time_begin": 225.19,
        "time_end": 225.43,
        "confidence": 0.9941267
        },
        {
        "word": "a",
        "time_begin": 225.43,
        "time_end": 225.51,
        "confidence": 0.8504573
        },
        {
        "word": "bit",
        "time_begin": 225.51,
        "time_end": 225.75,
        "confidence": 0.99709845
        },
        {
        "word": "about",
        "time_begin": 225.75,
        "time_end": 225.98999,
        "confidence": 0.9969568
        },
        {
        "word": "forcing",
        "time_begin": 225.98999,
        "time_end": 226.48999,
        "confidence": 0.99851817
        },
        {
        "word": "and",
        "time_begin": 226.62999,
        "time_end": 226.87,
        "confidence": 0.8911858
        },
        {
        "word": "instead",
        "time_begin": 226.87,
        "time_end": 227.34999,
        "confidence": 0.9811911
        },
        {
        "word": "focused",
        "time_begin": 227.34999,
        "time_end": 227.75,
        "confidence": 0.99340373
        },
        {
        "word": "on",
        "time_begin": 227.75,
        "time_end": 227.91,
        "confidence": 0.9998166
        },
        {
        "word": "being",
        "time_begin": 227.91,
        "time_end": 228.23,
        "confidence": 0.9999006
        },
        {
        "word": "curious.",
        "time_begin": 228.23,
        "time_end": 228.73,
        "confidence": 0.9998776
        }
      ],
      "language": "en",
      "transcription": "Now, with mindfulness training, we dropped a bit about forcing and instead focused on being curious.",
      "confidence": -1,
      "time_begin": 223.83,
      "time_end": 228.73,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "In",
        "time_begin": 229.59,
        "time_end": 229.83,
        "confidence": 0.9991672
        },
        {
        "word": "fact,",
        "time_begin": 229.83,
        "time_end": 230.33,
        "confidence": 0.99708164
        },
        {
        "word": "we",
        "time_begin": 230.47,
        "time_end": 230.79,
        "confidence": 0.9998853
        },
        {
        "word": "even",
        "time_begin": 230.79,
        "time_end": 231.11,
        "confidence": 0.9999008
        },
        {
        "word": "told",
        "time_begin": 231.11,
        "time_end": 231.43,
        "confidence": 0.99967766
        },
        {
        "word": "them",
        "time_begin": 231.43,
        "time_end": 231.67,
        "confidence": 0.9998977
        },
        {
        "word": "to",
        "time_begin": 231.67,
        "time_end": 231.83,
        "confidence": 0.9999201
        },
        {
        "word": "smoke.",
        "time_begin": 231.83,
        "time_end": 232.33,
        "confidence": 0.99953675
        }
      ],
      "language": "en",
      "transcription": "In fact, we even told them to smoke.",
      "confidence": -1,
      "time_begin": 229.59,
      "time_end": 232.33,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "What?",
        "time_begin": 232.70999,
        "time_end": 233.03,
        "confidence": 0.9954307
        }
      ],
      "language": "en",
      "transcription": "What?",
      "confidence": -1,
      "time_begin": 232.70999,
      "time_end": 233.03,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Yeah.",
        "time_begin": 233.03,
        "time_end": 233.19,
        "confidence": 0.77929187
        }
      ],
      "language": "en",
      "transcription": "Yeah.",
      "confidence": -1,
      "time_begin": 233.03,
      "time_end": 233.19,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "We",
        "time_begin": 233.19,
        "time_end": 233.34999,
        "confidence": 0.9978193
        },
        {
        "word": "said,",
        "time_begin": 233.34999,
        "time_end": 233.59,
        "confidence": 0.8510114
        },
        {
        "word": "go",
        "time_begin": 233.59,
        "time_end": 233.67,
        "confidence": 0.9696163
        },
        {
        "word": "ahead",
        "time_begin": 233.67,
        "time_end": 233.91,
        "confidence": 0.9994679
        },
        {
        "word": "and",
        "time_begin": 233.91,
        "time_end": 234.06999,
        "confidence": 0.996372
        },
        {
        "word": "smoke.",
        "time_begin": 234.06999,
        "time_end": 234.56999,
        "confidence": 0.9050592
        }
      ],
      "language": "en",
      "transcription": "We said, go ahead and smoke.",
      "confidence": -1,
      "time_begin": 233.19,
      "time_end": 234.56999,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Just",
        "time_begin": 234.82501,
        "time_end": 234.945,
        "confidence": 0.99925226
        },
        {
        "word": "be",
        "time_begin": 234.945,
        "time_end": 235.065,
        "confidence": 0.99954873
        },
        {
        "word": "really",
        "time_begin": 235.065,
        "time_end": 235.54501,
        "confidence": 0.9949184
        },
        {
        "word": "curious",
        "time_begin": 235.54501,
        "time_end": 235.945,
        "confidence": 0.99986136
        },
        {
        "word": "about",
        "time_begin": 235.945,
        "time_end": 236.345,
        "confidence": 0.9982229
        },
        {
        "word": "what",
        "time_begin": 236.345,
        "time_end": 236.505,
        "confidence": 0.9997819
        },
        {
        "word": "it's",
        "time_begin": 236.505,
        "time_end": 236.74501,
        "confidence": 0.9978711
        },
        {
        "word": "like",
        "time_begin": 236.74501,
        "time_end": 236.90501,
        "confidence": 0.99988806
        },
        {
        "word": "when",
        "time_begin": 236.90501,
        "time_end": 237.145,
        "confidence": 0.9998184
        },
        {
        "word": "you",
        "time_begin": 237.145,
        "time_end": 237.225,
        "confidence": 0.9998692
        },
        {
        "word": "do.",
        "time_begin": 237.225,
        "time_end": 237.725,
        "confidence": 0.99905556
        }
      ],
      "language": "en",
      "transcription": "Just be really curious about what it's like when you do.",
      "confidence": -1,
      "time_begin": 234.82501,
      "time_end": 237.725,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "And",
        "time_begin": 238.265,
        "time_end": 238.425,
        "confidence": 0.9598319
        },
        {
        "word": "what",
        "time_begin": 238.425,
        "time_end": 238.585,
        "confidence": 0.9960312
        },
        {
        "word": "did",
        "time_begin": 238.585,
        "time_end": 238.74501,
        "confidence": 0.99942005
        },
        {
        "word": "they",
        "time_begin": 238.74501,
        "time_end": 238.905,
        "confidence": 0.99989486
        },
        {
        "word": "notice?",
        "time_begin": 238.905,
        "time_end": 239.405,
        "confidence": 0.99857336
        }
      ],
      "language": "en",
      "transcription": "And what did they notice?",
      "confidence": -1,
      "time_begin": 238.265,
      "time_end": 239.405,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Well,",
        "time_begin": 239.945,
        "time_end": 240.18501,
        "confidence": 0.8258536
        },
        {
        "word": "here's",
        "time_begin": 240.18501,
        "time_end": 240.505,
        "confidence": 0.9849413
        },
        {
        "word": "an",
        "time_begin": 240.505,
        "time_end": 240.585,
        "confidence": 0.9995974
        },
        {
        "word": "example",
        "time_begin": 240.585,
        "time_end": 240.985,
        "confidence": 0.999974
        },
        {
        "word": "from",
        "time_begin": 240.985,
        "time_end": 241.225,
        "confidence": 0.996628
        },
        {
        "word": "one",
        "time_begin": 241.225,
        "time_end": 241.38501,
        "confidence": 0.9986828
        },
        {
        "word": "of",
        "time_begin": 241.38501,
        "time_end": 241.46501,
        "confidence": 0.99892634
        },
        {
        "word": "our",
        "time_begin": 241.46501,
        "time_end": 241.785,
        "confidence": 0.9998275
        },
        {
        "word": "smokers.",
        "time_begin": 241.785,
        "time_end": 242.285,
        "confidence": 0.9972791
        }
      ],
      "language": "en",
      "transcription": "Well, here's an example from one of our smokers.",
      "confidence": -1,
      "time_begin": 239.945,
      "time_end": 242.285,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "She",
        "time_begin": 242.74501,
        "time_end": 242.985,
        "confidence": 0.99946207
        },
        {
        "word": "said,",
        "time_begin": 242.985,
        "time_end": 243.30501,
        "confidence": 0.80075175
        },
        {
        "word": "mindful",
        "time_begin": 243.30501,
        "time_end": 243.785,
        "confidence": 0.9086071
        },
        {
        "word": "smoking",
        "time_begin": 243.785,
        "time_end": 244.285,
        "confidence": 0.9985102
        },
        {
        "word": "smells",
        "time_begin": 244.82501,
        "time_end": 245.225,
        "confidence": 0.9650019
        },
        {
        "word": "like",
        "time_begin": 245.225,
        "time_end": 245.46501,
        "confidence": 0.99955314
        },
        {
        "word": "stinky",
        "time_begin": 245.46501,
        "time_end": 245.945,
        "confidence": 0.9996523
        },
        {
        "word": "cheese",
        "time_begin": 245.945,
        "time_end": 246.18501,
        "confidence": 0.9984059
        },
        {
        "word": "and",
        "time_begin": 246.18501,
        "time_end": 246.505,
        "confidence": 0.9926978
        },
        {
        "word": "tastes",
        "time_begin": 246.505,
        "time_end": 246.82501,
        "confidence": 0.9966731
        },
        {
        "word": "like",
        "time_begin": 246.82501,
        "time_end": 247.065,
        "confidence": 0.99916625
        },
        {
        "word": "chemicals.",
        "time_begin": 247.065,
        "time_end": 247.565,
        "confidence": 0.9979075
        }
      ],
      "language": "en",
      "transcription": "She said, mindful smoking smells like stinky cheese and tastes like chemicals.",
      "confidence": -1,
      "time_begin": 242.74501,
      "time_end": 247.565,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Yuck.",
        "time_begin": 247.945,
        "time_end": 248.445,
        "confidence": 0.91593313
        }
      ],
      "language": "en",
      "transcription": "Yuck.",
      "confidence": -1,
      "time_begin": 247.945,
      "time_end": 248.445,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Now,",
        "time_begin": 249.73999,
        "time_end": 249.98,
        "confidence": 0.8277691
        },
        {
        "word": "she",
        "time_begin": 249.98,
        "time_end": 250.21999,
        "confidence": 0.9996542
        },
        {
        "word": "knew",
        "time_begin": 250.21999,
        "time_end": 250.7,
        "confidence": 0.9996935
        },
        {
        "word": "cognitively",
        "time_begin": 250.7,
        "time_end": 251.2,
        "confidence": 0.8825916
        },
        {
        "word": "that",
        "time_begin": 251.34,
        "time_end": 251.57999,
        "confidence": 0.99137574
        },
        {
        "word": "smoking",
        "time_begin": 251.57999,
        "time_end": 251.98,
        "confidence": 0.9999193
        },
        {
        "word": "was",
        "time_begin": 251.98,
        "time_end": 252.14,
        "confidence": 0.99931574
        },
        {
        "word": "bad",
        "time_begin": 252.14,
        "time_end": 252.37999,
        "confidence": 0.99998784
        },
        {
        "word": "for",
        "time_begin": 252.37999,
        "time_end": 252.54,
        "confidence": 0.99995494
        },
        {
        "word": "her.",
        "time_begin": 252.54,
        "time_end": 253.04,
        "confidence": 0.9643626
        }
      ],
      "language": "en",
      "transcription": "Now, she knew cognitively that smoking was bad for her.",
      "confidence": -1,
      "time_begin": 249.73999,
      "time_end": 253.04,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "That's",
        "time_begin": 253.18,
        "time_end": 253.42,
        "confidence": 0.9991708
        },
        {
        "word": "why",
        "time_begin": 253.42,
        "time_end": 253.65999,
        "confidence": 0.9995908
        },
        {
        "word": "she",
        "time_begin": 253.65999,
        "time_end": 253.73999,
        "confidence": 0.99962294
        },
        {
        "word": "joined",
        "time_begin": 253.73999,
        "time_end": 254.14,
        "confidence": 0.99912816
        },
        {
        "word": "our",
        "time_begin": 254.14,
        "time_end": 254.37999,
        "confidence": 0.9998739
        },
        {
        "word": "program.",
        "time_begin": 254.37999,
        "time_end": 254.87999,
        "confidence": 0.9997163
        }
      ],
      "language": "en",
      "transcription": "That's why she joined our program.",
      "confidence": -1,
      "time_begin": 253.18,
      "time_end": 254.87999,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "What",
        "time_begin": 255.65999,
        "time_end": 255.9,
        "confidence": 0.9995977
        },
        {
        "word": "she",
        "time_begin": 255.9,
        "time_end": 256.22,
        "confidence": 0.999864
        },
        {
        "word": "discovered,",
        "time_begin": 256.22,
        "time_end": 256.72,
        "confidence": 0.7843217
        },
        {
        "word": "just",
        "time_begin": 257.02,
        "time_end": 257.34,
        "confidence": 0.99977404
        },
        {
        "word": "by",
        "time_begin": 257.34,
        "time_end": 257.58,
        "confidence": 0.9991411
        },
        {
        "word": "being",
        "time_begin": 257.58,
        "time_end": 257.82,
        "confidence": 0.9998938
        },
        {
        "word": "curiously",
        "time_begin": 257.82,
        "time_end": 258.32,
        "confidence": 0.9949168
        },
        {
        "word": "aware",
        "time_begin": 258.38,
        "time_end": 258.69998,
        "confidence": 0.9998654
        },
        {
        "word": "when",
        "time_begin": 258.69998,
        "time_end": 258.94,
        "confidence": 0.9468747
        },
        {
        "word": "she",
        "time_begin": 258.94,
        "time_end": 259.18,
        "confidence": 0.9998179
        },
        {
        "word": "smoked,",
        "time_begin": 259.18,
        "time_end": 259.68,
        "confidence": 0.9836316
        },
        {
        "word": "was",
        "time_begin": 260.13998,
        "time_end": 260.38,
        "confidence": 0.99940896
        },
        {
        "word": "that",
        "time_begin": 260.38,
        "time_end": 260.69998,
        "confidence": 0.99807596
        },
        {
        "word": "smoking",
        "time_begin": 260.69998,
        "time_end": 261.19998,
        "confidence": 0.9996717
        },
        {
        "word": "tastes",
        "time_begin": 261.5,
        "time_end": 262,
        "confidence": 0.9978352
        },
        {
        "word": "like",
        "time_begin": 262.06,
        "time_end": 262.56,
        "confidence": 0.9996536
        },
        {
        "word": "shit.",
        "time_begin": 262.69998,
        "time_end": 263.19998,
        "confidence": 0.999612
        }
      ],
      "language": "en",
      "transcription": "What she discovered, just by being curiously aware when she smoked, was that smoking tastes like shit.",
      "confidence": -1,
      "time_begin": 255.65999,
      "time_end": 263.19998,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Now,",
        "time_begin": 266.535,
        "time_end": 267.035,
        "confidence": 0.9152694
        },
        {
        "word": "she",
        "time_begin": 267.175,
        "time_end": 267.495,
        "confidence": 0.9987733
        },
        {
        "word": "moved",
        "time_begin": 267.495,
        "time_end": 267.995,
        "confidence": 0.99929404
        },
        {
        "word": "from",
        "time_begin": 268.13498,
        "time_end": 268.63498,
        "confidence": 0.99978536
        },
        {
        "word": "knowledge",
        "time_begin": 269.095,
        "time_end": 269.495,
        "confidence": 0.9999001
        },
        {
        "word": "to",
        "time_begin": 269.495,
        "time_end": 269.815,
        "confidence": 0.99996233
        },
        {
        "word": "wisdom.",
        "time_begin": 269.815,
        "time_end": 270.315,
        "confidence": 0.9907191
        }
      ],
      "language": "en",
      "transcription": "Now, she moved from knowledge to wisdom.",
      "confidence": -1,
      "time_begin": 266.535,
      "time_end": 270.315,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "She",
        "time_begin": 270.375,
        "time_end": 270.69498,
        "confidence": 0.99964285
        },
        {
        "word": "moved",
        "time_begin": 270.69498,
        "time_end": 270.935,
        "confidence": 0.99930096
        },
        {
        "word": "from",
        "time_begin": 270.935,
        "time_end": 271.175,
        "confidence": 0.9998222
        },
        {
        "word": "knowing",
        "time_begin": 271.175,
        "time_end": 271.495,
        "confidence": 0.99989974
        },
        {
        "word": "in",
        "time_begin": 271.495,
        "time_end": 271.57498,
        "confidence": 0.9925557
        },
        {
        "word": "her",
        "time_begin": 271.57498,
        "time_end": 271.735,
        "confidence": 0.99922025
        },
        {
        "word": "head",
        "time_begin": 271.735,
        "time_end": 271.97498,
        "confidence": 0.9999536
        },
        {
        "word": "that",
        "time_begin": 271.97498,
        "time_end": 272.13498,
        "confidence": 0.99612695
        },
        {
        "word": "smoking",
        "time_begin": 272.13498,
        "time_end": 272.535,
        "confidence": 0.99940884
        },
        {
        "word": "was",
        "time_begin": 272.535,
        "time_end": 272.69498,
        "confidence": 0.8288816
        },
        {
        "word": "bad",
        "time_begin": 272.69498,
        "time_end": 272.935,
        "confidence": 0.9999676
        },
        {
        "word": "for",
        "time_begin": 272.935,
        "time_end": 273.095,
        "confidence": 0.9998361
        },
        {
        "word": "her",
        "time_begin": 273.095,
        "time_end": 273.495,
        "confidence": 0.9999058
        },
        {
        "word": "to",
        "time_begin": 273.495,
        "time_end": 273.815,
        "confidence": 0.9433081
        },
        {
        "word": "knowing",
        "time_begin": 273.815,
        "time_end": 274.13498,
        "confidence": 0.9998171
        },
        {
        "word": "it",
        "time_begin": 274.13498,
        "time_end": 274.375,
        "confidence": 0.99855524
        },
        {
        "word": "in",
        "time_begin": 274.375,
        "time_end": 274.535,
        "confidence": 0.9992229
        },
        {
        "word": "her",
        "time_begin": 274.535,
        "time_end": 274.775,
        "confidence": 0.99989367
        },
        {
        "word": "bones.",
        "time_begin": 274.775,
        "time_end": 275.275,
        "confidence": 0.8848374
        }
      ],
      "language": "en",
      "transcription": "She moved from knowing in her head that smoking was bad for her to knowing it in her bones.",
      "confidence": -1,
      "time_begin": 270.375,
      "time_end": 275.275,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "And",
        "time_begin": 275.895,
        "time_end": 276.13498,
        "confidence": 0.9964478
        },
        {
        "word": "this",
        "time_begin": 276.13498,
        "time_end": 276.535,
        "confidence": 0.617704
        },
        {
        "word": "spell",
        "time_begin": 276.535,
        "time_end": 276.775,
        "confidence": 0.99963105
        },
        {
        "word": "of",
        "time_begin": 276.775,
        "time_end": 277.01498,
        "confidence": 0.9998155
        },
        {
        "word": "smoking",
        "time_begin": 277.01498,
        "time_end": 277.41498,
        "confidence": 0.9998559
        },
        {
        "word": "was",
        "time_begin": 277.41498,
        "time_end": 277.57498,
        "confidence": 0.99995196
        },
        {
        "word": "broken.",
        "time_begin": 277.57498,
        "time_end": 278.07498,
        "confidence": 0.9987813
        }
      ],
      "language": "en",
      "transcription": "And this spell of smoking was broken.",
      "confidence": -1,
      "time_begin": 275.895,
      "time_end": 278.07498,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "She",
        "time_begin": 278.25,
        "time_end": 278.41,
        "confidence": 0.9998708
        },
        {
        "word": "started",
        "time_begin": 278.41,
        "time_end": 278.73,
        "confidence": 0.99919945
        },
        {
        "word": "to",
        "time_begin": 278.73,
        "time_end": 278.89,
        "confidence": 0.9995952
        },
        {
        "word": "become",
        "time_begin": 278.89,
        "time_end": 279.39,
        "confidence": 0.9998863
        },
        {
        "word": "disenchanted",
        "time_begin": 279.45,
        "time_end": 279.95,
        "confidence": 0.99996156
        },
        {
        "word": "with",
        "time_begin": 280.33,
        "time_end": 280.57,
        "confidence": 0.9998741
        },
        {
        "word": "her",
        "time_begin": 280.57,
        "time_end": 280.81,
        "confidence": 0.9998673
        },
        {
        "word": "behavior.",
        "time_begin": 280.81,
        "time_end": 281.31,
        "confidence": 0.9998001
        }
      ],
      "language": "en",
      "transcription": "She started to become disenchanted with her behavior.",
      "confidence": -1,
      "time_begin": 278.25,
      "time_end": 281.31,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Now,",
        "time_begin": 282.97,
        "time_end": 283.47,
        "confidence": 0.9068758
        },
        {
        "word": "the",
        "time_begin": 283.69,
        "time_end": 283.93,
        "confidence": 0.9997484
        },
        {
        "word": "prefrontal",
        "time_begin": 283.93,
        "time_end": 284.43,
        "confidence": 0.99979526
        },
        {
        "word": "cortex,",
        "time_begin": 284.57,
        "time_end": 285.05,
        "confidence": 0.9925961
        },
        {
        "word": "that",
        "time_begin": 285.05,
        "time_end": 285.37,
        "confidence": 0.97838175
        },
        {
        "word": "youngest",
        "time_begin": 285.37,
        "time_end": 285.85,
        "confidence": 0.9998123
        },
        {
        "word": "part",
        "time_begin": 285.85,
        "time_end": 286.01,
        "confidence": 0.9998449
        },
        {
        "word": "of",
        "time_begin": 286.01,
        "time_end": 286.17,
        "confidence": 0.9996228
        },
        {
        "word": "our",
        "time_begin": 286.17,
        "time_end": 286.25,
        "confidence": 0.99948263
        },
        {
        "word": "brain",
        "time_begin": 286.25,
        "time_end": 286.49,
        "confidence": 0.998733
        },
        {
        "word": "from",
        "time_begin": 286.49,
        "time_end": 286.73,
        "confidence": 0.96322644
        },
        {
        "word": "an",
        "time_begin": 286.73,
        "time_end": 286.89,
        "confidence": 0.99971455
        },
        {
        "word": "evolutionary",
        "time_begin": 286.89,
        "time_end": 287.39,
        "confidence": 0.9999335
        },
        {
        "word": "perspective,",
        "time_begin": 287.61,
        "time_end": 288.11,
        "confidence": 0.99191225
        },
        {
        "word": "it",
        "time_begin": 288.65,
        "time_end": 288.97,
        "confidence": 0.97589535
        },
        {
        "word": "understands",
        "time_begin": 288.97,
        "time_end": 289.47,
        "confidence": 0.99977833
        },
        {
        "word": "on",
        "time_begin": 289.69,
        "time_end": 289.93,
        "confidence": 0.8888342
        },
        {
        "word": "an",
        "time_begin": 289.93,
        "time_end": 290.09,
        "confidence": 0.9997577
        },
        {
        "word": "intellectual",
        "time_begin": 290.09,
        "time_end": 290.59,
        "confidence": 0.9999505
        },
        {
        "word": "level",
        "time_begin": 290.73,
        "time_end": 291.23,
        "confidence": 0.9999616
        },
        {
        "word": "that",
        "time_begin": 291.29,
        "time_end": 291.53,
        "confidence": 0.9984731
        },
        {
        "word": "we",
        "time_begin": 291.53,
        "time_end": 291.69,
        "confidence": 0.99995077
        },
        {
        "word": "shouldn't",
        "time_begin": 291.69,
        "time_end": 292.09,
        "confidence": 0.9999766
        },
        {
        "word": "smoke,",
        "time_begin": 292.09,
        "time_end": 292.59,
        "confidence": 0.7833358
        },
        {
        "word": "And",
        "time_begin": 292.685,
        "time_end": 292.92502,
        "confidence": 0.9959182
        },
        {
        "word": "it",
        "time_begin": 292.92502,
        "time_end": 293.08502,
        "confidence": 0.99912494
        },
        {
        "word": "tries",
        "time_begin": 293.08502,
        "time_end": 293.48502,
        "confidence": 0.9999479
        },
        {
        "word": "its",
        "time_begin": 293.48502,
        "time_end": 293.80502,
        "confidence": 0.9959913
        },
        {
        "word": "hardest",
        "time_begin": 293.80502,
        "time_end": 294.30502,
        "confidence": 0.99986017
        },
        {
        "word": "to",
        "time_begin": 294.36502,
        "time_end": 294.605,
        "confidence": 0.99984384
        },
        {
        "word": "help",
        "time_begin": 294.605,
        "time_end": 294.845,
        "confidence": 0.9996737
        },
        {
        "word": "us",
        "time_begin": 294.845,
        "time_end": 295.165,
        "confidence": 0.999228
        },
        {
        "word": "change",
        "time_begin": 295.165,
        "time_end": 295.48502,
        "confidence": 0.999388
        },
        {
        "word": "our",
        "time_begin": 295.48502,
        "time_end": 295.725,
        "confidence": 0.9997496
        },
        {
        "word": "behavior,",
        "time_begin": 295.725,
        "time_end": 296.225,
        "confidence": 0.96160865
        },
        {
        "word": "to",
        "time_begin": 296.445,
        "time_end": 296.605,
        "confidence": 0.99929285
        },
        {
        "word": "help",
        "time_begin": 296.605,
        "time_end": 296.845,
        "confidence": 0.99779654
        },
        {
        "word": "us",
        "time_begin": 296.845,
        "time_end": 297.08502,
        "confidence": 0.99682105
        },
        {
        "word": "stop",
        "time_begin": 297.08502,
        "time_end": 297.405,
        "confidence": 0.9993315
        },
        {
        "word": "smoking,",
        "time_begin": 297.405,
        "time_end": 297.885,
        "confidence": 0.9968288
        },
        {
        "word": "to",
        "time_begin": 297.885,
        "time_end": 297.965,
        "confidence": 0.99540555
        },
        {
        "word": "help",
        "time_begin": 297.965,
        "time_end": 298.20502,
        "confidence": 0.98680115
        },
        {
        "word": "us",
        "time_begin": 298.20502,
        "time_end": 298.36502,
        "confidence": 0.9967662
        },
        {
        "word": "stop",
        "time_begin": 298.36502,
        "time_end": 298.685,
        "confidence": 0.99924797
        },
        {
        "word": "eating",
        "time_begin": 298.685,
        "time_end": 299.005,
        "confidence": 0.9998518
        },
        {
        "word": "that",
        "time_begin": 299.005,
        "time_end": 299.325,
        "confidence": 0.99927837
        },
        {
        "word": "second,",
        "time_begin": 299.325,
        "time_end": 299.825,
        "confidence": 0.9968788
        },
        {
        "word": "that",
        "time_begin": 299.885,
        "time_end": 300.125,
        "confidence": 0.8598001
        },
        {
        "word": "third,",
        "time_begin": 300.125,
        "time_end": 300.605,
        "confidence": 0.99855006
        },
        {
        "word": "that",
        "time_begin": 300.605,
        "time_end": 300.92502,
        "confidence": 0.9979506
        },
        {
        "word": "fourth",
        "time_begin": 300.92502,
        "time_end": 301.405,
        "confidence": 0.9996896
        },
        {
        "word": "cookie.",
        "time_begin": 301.405,
        "time_end": 301.905,
        "confidence": 0.99865067
        }
      ],
      "language": "en",
      "transcription": "Now, the prefrontal cortex, that youngest part of our brain from an evolutionary perspective, it understands on an intellectual level that we shouldn't smoke, And it tries its hardest to help us change our behavior, to help us stop smoking, to help us stop eating that second, that third, that fourth cookie.",
      "confidence": -1,
      "time_begin": 282.97,
      "time_end": 301.905,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "We",
        "time_begin": 302.845,
        "time_end": 303.08502,
        "confidence": 0.9998404
        },
        {
        "word": "call",
        "time_begin": 303.08502,
        "time_end": 303.245,
        "confidence": 0.9996213
        },
        {
        "word": "this",
        "time_begin": 303.245,
        "time_end": 303.48502,
        "confidence": 0.9998292
        },
        {
        "word": "cognitive",
        "time_begin": 303.48502,
        "time_end": 303.965,
        "confidence": 0.999073
        },
        {
        "word": "control.",
        "time_begin": 303.965,
        "time_end": 304.285,
        "confidence": 0.9751035
        }
      ],
      "language": "en",
      "transcription": "We call this cognitive control.",
      "confidence": -1,
      "time_begin": 302.845,
      "time_end": 304.285,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "We're",
        "time_begin": 304.285,
        "time_end": 304.52502,
        "confidence": 0.9926367
        },
        {
        "word": "using",
        "time_begin": 304.52502,
        "time_end": 304.92502,
        "confidence": 0.9999678
        },
        {
        "word": "cognition",
        "time_begin": 304.92502,
        "time_end": 305.42502,
        "confidence": 0.9997403
        },
        {
        "word": "to",
        "time_begin": 305.725,
        "time_end": 305.885,
        "confidence": 0.99995375
        },
        {
        "word": "control",
        "time_begin": 305.885,
        "time_end": 306.36502,
        "confidence": 0.9999751
        },
        {
        "word": "our",
        "time_begin": 306.36502,
        "time_end": 306.52502,
        "confidence": 0.9999193
        },
        {
        "word": "behavior.",
        "time_begin": 306.52502,
        "time_end": 307.02502,
        "confidence": 0.99978125
        }
      ],
      "language": "en",
      "transcription": "We're using cognition to control our behavior.",
      "confidence": -1,
      "time_begin": 304.285,
      "time_end": 307.02502,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Unfortunately,",
        "time_begin": 308.11,
        "time_end": 308.61,
        "confidence": 0.99637616
        },
        {
        "word": "this",
        "time_begin": 308.83,
        "time_end": 309.06998,
        "confidence": 0.99988246
        },
        {
        "word": "is",
        "time_begin": 309.06998,
        "time_end": 309.15,
        "confidence": 0.99864954
        },
        {
        "word": "also",
        "time_begin": 309.15,
        "time_end": 309.47,
        "confidence": 0.9986051
        },
        {
        "word": "the",
        "time_begin": 309.47,
        "time_end": 309.63,
        "confidence": 0.99991465
        },
        {
        "word": "first",
        "time_begin": 309.63,
        "time_end": 309.94998,
        "confidence": 0.9998301
        },
        {
        "word": "part",
        "time_begin": 309.94998,
        "time_end": 310.11,
        "confidence": 0.9999422
        },
        {
        "word": "of",
        "time_begin": 310.11,
        "time_end": 310.27,
        "confidence": 0.9997315
        },
        {
        "word": "our",
        "time_begin": 310.27,
        "time_end": 310.35,
        "confidence": 0.9880299
        },
        {
        "word": "brain",
        "time_begin": 310.35,
        "time_end": 310.59,
        "confidence": 0.9997086
        },
        {
        "word": "that",
        "time_begin": 310.59,
        "time_end": 310.66998,
        "confidence": 0.9983912
        },
        {
        "word": "goes",
        "time_begin": 310.66998,
        "time_end": 310.91,
        "confidence": 0.9996947
        },
        {
        "word": "offline",
        "time_begin": 310.91,
        "time_end": 311.31,
        "confidence": 0.99408937
        },
        {
        "word": "when",
        "time_begin": 311.31,
        "time_end": 311.55,
        "confidence": 0.9995486
        },
        {
        "word": "we",
        "time_begin": 311.55,
        "time_end": 311.63,
        "confidence": 0.99971217
        },
        {
        "word": "get",
        "time_begin": 311.63,
        "time_end": 311.78998,
        "confidence": 0.99962234
        },
        {
        "word": "stressed",
        "time_begin": 311.78998,
        "time_end": 312.11,
        "confidence": 0.9999039
        },
        {
        "word": "out,",
        "time_begin": 312.11,
        "time_end": 312.61,
        "confidence": 0.9759761
        },
        {
        "word": "which",
        "time_begin": 312.66998,
        "time_end": 312.83,
        "confidence": 0.9998454
        },
        {
        "word": "isn't",
        "time_begin": 312.83,
        "time_end": 313.22998,
        "confidence": 0.9998821
        },
        {
        "word": "that",
        "time_begin": 313.22998,
        "time_end": 313.38998,
        "confidence": 0.9988739
        },
        {
        "word": "helpful.",
        "time_begin": 313.38998,
        "time_end": 313.88998,
        "confidence": 0.9997426
        }
      ],
      "language": "en",
      "transcription": "Unfortunately, this is also the first part of our brain that goes offline when we get stressed out, which isn't that helpful.",
      "confidence": -1,
      "time_begin": 308.11,
      "time_end": 313.88998,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Now,",
        "time_begin": 314.27,
        "time_end": 314.50998,
        "confidence": 0.82658637
        },
        {
        "word": "we",
        "time_begin": 314.50998,
        "time_end": 314.59,
        "confidence": 0.9995079
        },
        {
        "word": "can",
        "time_begin": 314.59,
        "time_end": 314.83,
        "confidence": 0.9993728
        },
        {
        "word": "all",
        "time_begin": 314.83,
        "time_end": 314.99,
        "confidence": 0.9985348
        },
        {
        "word": "relate",
        "time_begin": 314.99,
        "time_end": 315.31,
        "confidence": 0.9999156
        },
        {
        "word": "to",
        "time_begin": 315.31,
        "time_end": 315.38998,
        "confidence": 0.998367
        },
        {
        "word": "this",
        "time_begin": 315.38998,
        "time_end": 315.63,
        "confidence": 0.999819
        },
        {
        "word": "in",
        "time_begin": 315.63,
        "time_end": 315.71,
        "confidence": 0.9947625
        },
        {
        "word": "our",
        "time_begin": 315.71,
        "time_end": 315.94998,
        "confidence": 0.9993766
        },
        {
        "word": "own",
        "time_begin": 315.94998,
        "time_end": 316.19,
        "confidence": 0.99865854
        },
        {
        "word": "experience.",
        "time_begin": 316.19,
        "time_end": 316.69,
        "confidence": 0.9881569
        }
      ],
      "language": "en",
      "transcription": "Now, we can all relate to this in our own experience.",
      "confidence": -1,
      "time_begin": 314.27,
      "time_end": 316.69,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "We're",
        "time_begin": 316.83,
        "time_end": 317.15,
        "confidence": 0.9962821
        },
        {
        "word": "much",
        "time_begin": 317.15,
        "time_end": 317.38998,
        "confidence": 0.9983694
        },
        {
        "word": "more",
        "time_begin": 317.38998,
        "time_end": 317.55,
        "confidence": 0.9997768
        },
        {
        "word": "likely",
        "time_begin": 317.55,
        "time_end": 317.94998,
        "confidence": 0.9999201
        },
        {
        "word": "to",
        "time_begin": 317.94998,
        "time_end": 318.11,
        "confidence": 0.9996308
        },
        {
        "word": "do",
        "time_begin": 318.11,
        "time_end": 318.27,
        "confidence": 0.99993587
        },
        {
        "word": "things",
        "time_begin": 318.27,
        "time_end": 318.50998,
        "confidence": 0.99987483
        },
        {
        "word": "like",
        "time_begin": 318.50998,
        "time_end": 318.83,
        "confidence": 0.98987806
        },
        {
        "word": "yell",
        "time_begin": 318.83,
        "time_end": 318.99,
        "confidence": 0.9997471
        },
        {
        "word": "at",
        "time_begin": 318.99,
        "time_end": 319.15,
        "confidence": 0.99983084
        },
        {
        "word": "our",
        "time_begin": 319.15,
        "time_end": 319.31,
        "confidence": 0.9987637
        },
        {
        "word": "spouse",
        "time_begin": 319.31,
        "time_end": 319.63,
        "confidence": 0.99944025
        },
        {
        "word": "or",
        "time_begin": 319.63,
        "time_end": 319.78998,
        "confidence": 0.9951232
        },
        {
        "word": "kids",
        "time_begin": 319.78998,
        "time_end": 320.11,
        "confidence": 0.995751
        },
        {
        "word": "when",
        "time_begin": 320.11,
        "time_end": 320.27,
        "confidence": 0.9993217
        },
        {
        "word": "we're",
        "time_begin": 320.27,
        "time_end": 320.43,
        "confidence": 0.99498606
        },
        {
        "word": "stressed",
        "time_begin": 320.43,
        "time_end": 320.75,
        "confidence": 0.9998764
        },
        {
        "word": "out",
        "time_begin": 320.75,
        "time_end": 320.99,
        "confidence": 0.9945292
        },
        {
        "word": "or",
        "time_begin": 320.99,
        "time_end": 321.15,
        "confidence": 0.99738115
        },
        {
        "word": "tired,",
        "time_begin": 321.15,
        "time_end": 321.47,
        "confidence": 0.8665824
        },
        {
        "word": "even",
        "time_begin": 321.47,
        "time_end": 321.71,
        "confidence": 0.99988985
        },
        {
        "word": "though",
        "time_begin": 321.71,
        "time_end": 321.87,
        "confidence": 0.9994985
        },
        {
        "word": "we",
        "time_begin": 321.87,
        "time_end": 322.11,
        "confidence": 0.9992779
        },
        {
        "word": "know",
        "time_begin": 322.11,
        "time_end": 322.27,
        "confidence": 0.9998677
        },
        {
        "word": "it's",
        "time_begin": 322.27,
        "time_end": 322.43,
        "confidence": 0.99914443
        },
        {
        "word": "not",
        "time_begin": 322.43,
        "time_end": 322.66998,
        "confidence": 0.99980205
        },
        {
        "word": "going",
        "time_begin": 322.66998,
        "time_end": 322.91,
        "confidence": 0.8824101
        },
        {
        "word": "to",
        "time_begin": 322.91,
        "time_end": 322.99,
        "confidence": 0.9975068
        },
        {
        "word": "be",
        "time_begin": 322.99,
        "time_end": 323.15,
        "confidence": 0.9996214
        },
        {
        "word": "helpful.",
        "time_begin": 323.15,
        "time_end": 323.65,
        "confidence": 0.993717
        }
      ],
      "language": "en",
      "transcription": "We're much more likely to do things like yell at our spouse or kids when we're stressed out or tired, even though we know it's not going to be helpful.",
      "confidence": -1,
      "time_begin": 316.83,
      "time_end": 323.65,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "We",
        "time_begin": 323.685,
        "time_end": 323.925,
        "confidence": 0.99973994
        },
        {
        "word": "just",
        "time_begin": 323.925,
        "time_end": 324.165,
        "confidence": 0.99598134
        },
        {
        "word": "can't",
        "time_begin": 324.165,
        "time_end": 324.405,
        "confidence": 0.99992365
        },
        {
        "word": "help",
        "time_begin": 324.405,
        "time_end": 324.725,
        "confidence": 0.99995756
        },
        {
        "word": "ourselves.",
        "time_begin": 324.725,
        "time_end": 325.225,
        "confidence": 0.99946535
        }
      ],
      "language": "en",
      "transcription": "We just can't help ourselves.",
      "confidence": -1,
      "time_begin": 323.685,
      "time_end": 325.225,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Now,",
        "time_begin": 327.125,
        "time_end": 327.365,
        "confidence": 0.7771894
        },
        {
        "word": "when",
        "time_begin": 327.365,
        "time_end": 327.525,
        "confidence": 0.999213
        },
        {
        "word": "the",
        "time_begin": 327.525,
        "time_end": 327.685,
        "confidence": 0.99937755
        },
        {
        "word": "prefrontal",
        "time_begin": 327.685,
        "time_end": 328.185,
        "confidence": 0.99868053
        },
        {
        "word": "cortex",
        "time_begin": 328.245,
        "time_end": 328.565,
        "confidence": 0.9999356
        },
        {
        "word": "goes",
        "time_begin": 328.565,
        "time_end": 328.805,
        "confidence": 0.9988714
        },
        {
        "word": "offline,",
        "time_begin": 328.805,
        "time_end": 329.305,
        "confidence": 0.98169786
        },
        {
        "word": "we",
        "time_begin": 329.445,
        "time_end": 329.605,
        "confidence": 0.9987155
        },
        {
        "word": "fall",
        "time_begin": 329.605,
        "time_end": 329.845,
        "confidence": 0.99944407
        },
        {
        "word": "back",
        "time_begin": 329.845,
        "time_end": 330.005,
        "confidence": 0.9997279
        },
        {
        "word": "into",
        "time_begin": 330.005,
        "time_end": 330.325,
        "confidence": 0.99870133
        },
        {
        "word": "our",
        "time_begin": 330.325,
        "time_end": 330.565,
        "confidence": 0.9953478
        },
        {
        "word": "old",
        "time_begin": 330.565,
        "time_end": 330.805,
        "confidence": 0.9770089
        },
        {
        "word": "habits,",
        "time_begin": 330.805,
        "time_end": 331.305,
        "confidence": 0.962786
        },
        {
        "word": "which",
        "time_begin": 331.525,
        "time_end": 331.685,
        "confidence": 0.99977654
        },
        {
        "word": "is",
        "time_begin": 331.685,
        "time_end": 331.845,
        "confidence": 0.99977416
        },
        {
        "word": "why",
        "time_begin": 331.845,
        "time_end": 332.085,
        "confidence": 0.99981934
        },
        {
        "word": "this",
        "time_begin": 332.085,
        "time_end": 332.325,
        "confidence": 0.9986607
        },
        {
        "word": "disenchantment",
        "time_begin": 332.325,
        "time_end": 332.825,
        "confidence": 0.99975634
        },
        {
        "word": "is",
        "time_begin": 333.04498,
        "time_end": 333.285,
        "confidence": 0.99987185
        },
        {
        "word": "so",
        "time_begin": 333.285,
        "time_end": 333.445,
        "confidence": 0.998733
        },
        {
        "word": "important.",
        "time_begin": 333.445,
        "time_end": 333.945,
        "confidence": 0.9995542
        }
      ],
      "language": "en",
      "transcription": "Now, when the prefrontal cortex goes offline, we fall back into our old habits, which is why this disenchantment is so important.",
      "confidence": -1,
      "time_begin": 327.125,
      "time_end": 333.945,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Seeing",
        "time_begin": 334.325,
        "time_end": 334.565,
        "confidence": 0.9996228
        },
        {
        "word": "what",
        "time_begin": 334.565,
        "time_end": 334.805,
        "confidence": 0.9998615
        },
        {
        "word": "we",
        "time_begin": 334.805,
        "time_end": 334.965,
        "confidence": 0.999851
        },
        {
        "word": "get",
        "time_begin": 334.965,
        "time_end": 335.205,
        "confidence": 0.9998171
        },
        {
        "word": "from",
        "time_begin": 335.205,
        "time_end": 335.445,
        "confidence": 0.99941194
        },
        {
        "word": "our",
        "time_begin": 335.445,
        "time_end": 335.525,
        "confidence": 0.9968929
        },
        {
        "word": "habits",
        "time_begin": 335.525,
        "time_end": 335.845,
        "confidence": 0.9997876
        },
        {
        "word": "helps",
        "time_begin": 335.845,
        "time_end": 336.085,
        "confidence": 0.99679095
        },
        {
        "word": "us",
        "time_begin": 336.085,
        "time_end": 336.325,
        "confidence": 0.9989454
        },
        {
        "word": "understand",
        "time_begin": 336.325,
        "time_end": 336.725,
        "confidence": 0.9909869
        },
        {
        "word": "them",
        "time_begin": 336.725,
        "time_end": 336.885,
        "confidence": 0.99837035
        },
        {
        "word": "in",
        "time_begin": 336.885,
        "time_end": 337.04498,
        "confidence": 0.75768656
        },
        {
        "word": "a",
        "time_begin": 337.04498,
        "time_end": 337.125,
        "confidence": 0.99940884
        },
        {
        "word": "deeper",
        "time_begin": 337.125,
        "time_end": 337.525,
        "confidence": 0.9998447
        },
        {
        "word": "level,",
        "time_begin": 337.525,
        "time_end": 338.025,
        "confidence": 0.97999823
        },
        {
        "word": "to",
        "time_begin": 338.27,
        "time_end": 338.51,
        "confidence": 0.99929714
        },
        {
        "word": "know",
        "time_begin": 338.51,
        "time_end": 338.59003,
        "confidence": 0.9958801
        },
        {
        "word": "it",
        "time_begin": 338.59003,
        "time_end": 338.67,
        "confidence": 0.41373822
        },
        {
        "word": "in",
        "time_begin": 338.67,
        "time_end": 338.91,
        "confidence": 0.8479461
        },
        {
        "word": "our",
        "time_begin": 338.91,
        "time_end": 339.07,
        "confidence": 0.99757844
        },
        {
        "word": "own",
        "time_begin": 339.07,
        "time_end": 339.15,
        "confidence": 0.9173459
        },
        {
        "word": "bones,",
        "time_begin": 339.15,
        "time_end": 339.39,
        "confidence": 0.82979625
        },
        {
        "word": "so",
        "time_begin": 339.39,
        "time_end": 339.55,
        "confidence": 0.99960274
        },
        {
        "word": "we",
        "time_begin": 339.55,
        "time_end": 339.63,
        "confidence": 0.99708074
        },
        {
        "word": "don't",
        "time_begin": 339.63,
        "time_end": 339.79,
        "confidence": 0.9998734
        },
        {
        "word": "have",
        "time_begin": 339.79,
        "time_end": 339.95,
        "confidence": 0.9987155
        },
        {
        "word": "to",
        "time_begin": 339.95,
        "time_end": 340.11002,
        "confidence": 0.9995623
        },
        {
        "word": "force",
        "time_begin": 340.11002,
        "time_end": 340.43,
        "confidence": 0.9998227
        },
        {
        "word": "ourselves",
        "time_begin": 340.43,
        "time_end": 340.83002,
        "confidence": 0.9993936
        },
        {
        "word": "to",
        "time_begin": 340.83002,
        "time_end": 340.99,
        "confidence": 0.9995474
        },
        {
        "word": "hold",
        "time_begin": 340.99,
        "time_end": 341.15,
        "confidence": 0.9999815
        },
        {
        "word": "back",
        "time_begin": 341.15,
        "time_end": 341.31,
        "confidence": 0.9996172
        },
        {
        "word": "or",
        "time_begin": 341.31,
        "time_end": 341.47,
        "confidence": 0.9961659
        },
        {
        "word": "restrain",
        "time_begin": 341.47,
        "time_end": 341.87,
        "confidence": 0.9994814
        },
        {
        "word": "ourselves",
        "time_begin": 341.87,
        "time_end": 342.19,
        "confidence": 0.99589694
        },
        {
        "word": "from",
        "time_begin": 342.19,
        "time_end": 342.43,
        "confidence": 0.9991923
        },
        {
        "word": "behavior.",
        "time_begin": 342.43,
        "time_end": 342.91,
        "confidence": 0.9520525
        }
      ],
      "language": "en",
      "transcription": "Seeing what we get from our habits helps us understand them in a deeper level, to know it in our own bones, so we don't have to force ourselves to hold back or restrain ourselves from behavior.",
      "confidence": -1,
      "time_begin": 334.325,
      "time_end": 342.91,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "We're",
        "time_begin": 342.91,
        "time_end": 343.23,
        "confidence": 0.9971361
        },
        {
        "word": "just",
        "time_begin": 343.23,
        "time_end": 343.55,
        "confidence": 0.9983223
        },
        {
        "word": "less",
        "time_begin": 343.55,
        "time_end": 343.79,
        "confidence": 0.9997695
        },
        {
        "word": "interested",
        "time_begin": 343.79,
        "time_end": 344.27,
        "confidence": 0.99989223
        },
        {
        "word": "in",
        "time_begin": 344.27,
        "time_end": 344.35,
        "confidence": 0.9997658
        },
        {
        "word": "doing",
        "time_begin": 344.35,
        "time_end": 344.59,
        "confidence": 0.999951
        },
        {
        "word": "it",
        "time_begin": 344.59,
        "time_end": 344.75,
        "confidence": 0.99885523
        },
        {
        "word": "in",
        "time_begin": 344.75,
        "time_end": 344.91,
        "confidence": 0.9941571
        },
        {
        "word": "the",
        "time_begin": 344.91,
        "time_end": 345.07,
        "confidence": 0.99995816
        },
        {
        "word": "first",
        "time_begin": 345.07,
        "time_end": 345.23,
        "confidence": 0.9999503
        },
        {
        "word": "place.",
        "time_begin": 345.23,
        "time_end": 345.73,
        "confidence": 0.99871004
        }
      ],
      "language": "en",
      "transcription": "We're just less interested in doing it in the first place.",
      "confidence": -1,
      "time_begin": 342.91,
      "time_end": 345.73,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "And",
        "time_begin": 346.35,
        "time_end": 346.51,
        "confidence": 0.8977375
        },
        {
        "word": "this",
        "time_begin": 346.51,
        "time_end": 346.75,
        "confidence": 0.99906605
        },
        {
        "word": "is",
        "time_begin": 346.75,
        "time_end": 346.91,
        "confidence": 0.9985037
        },
        {
        "word": "what",
        "time_begin": 346.91,
        "time_end": 347.15,
        "confidence": 0.99982315
        },
        {
        "word": "mindfulness",
        "time_begin": 347.15,
        "time_end": 347.65,
        "confidence": 0.9997682
        },
        {
        "word": "is",
        "time_begin": 347.71,
        "time_end": 347.87,
        "confidence": 0.9997929
        },
        {
        "word": "all",
        "time_begin": 347.87,
        "time_end": 348.03,
        "confidence": 0.9993451
        },
        {
        "word": "about.",
        "time_begin": 348.03,
        "time_end": 348.53,
        "confidence": 0.67751324
        }
      ],
      "language": "en",
      "transcription": "And this is what mindfulness is all about.",
      "confidence": -1,
      "time_begin": 346.35,
      "time_end": 348.53,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Seeing",
        "time_begin": 348.99,
        "time_end": 349.39,
        "confidence": 0.9898442
        },
        {
        "word": "really",
        "time_begin": 349.39,
        "time_end": 349.63,
        "confidence": 0.9966035
        },
        {
        "word": "clearly",
        "time_begin": 349.63,
        "time_end": 350.11002,
        "confidence": 0.99966586
        },
        {
        "word": "what",
        "time_begin": 350.11002,
        "time_end": 350.35,
        "confidence": 0.9968696
        },
        {
        "word": "we",
        "time_begin": 350.35,
        "time_end": 350.59,
        "confidence": 0.9999311
        },
        {
        "word": "get",
        "time_begin": 350.59,
        "time_end": 350.83002,
        "confidence": 0.9999
        },
        {
        "word": "when",
        "time_begin": 350.83002,
        "time_end": 351.07,
        "confidence": 0.98600256
        },
        {
        "word": "we",
        "time_begin": 351.07,
        "time_end": 351.15,
        "confidence": 0.998776
        },
        {
        "word": "get",
        "time_begin": 351.15,
        "time_end": 351.39,
        "confidence": 0.9988593
        },
        {
        "word": "caught",
        "time_begin": 351.39,
        "time_end": 351.55,
        "confidence": 0.99987876
        },
        {
        "word": "up",
        "time_begin": 351.55,
        "time_end": 351.71,
        "confidence": 0.9991067
        },
        {
        "word": "in",
        "time_begin": 351.71,
        "time_end": 351.87,
        "confidence": 0.9991295
        },
        {
        "word": "our",
        "time_begin": 351.87,
        "time_end": 352.03,
        "confidence": 0.999729
        },
        {
        "word": "behaviors,",
        "time_begin": 352.03,
        "time_end": 352.53,
        "confidence": 0.97076213
        },
        {
        "word": "becoming",
        "time_begin": 353.675,
        "time_end": 354.155,
        "confidence": 0.99701
        },
        {
        "word": "disenchanted",
        "time_begin": 354.155,
        "time_end": 354.655,
        "confidence": 0.9997282
        },
        {
        "word": "on",
        "time_begin": 355.115,
        "time_end": 355.435,
        "confidence": 0.9926414
        },
        {
        "word": "a",
        "time_begin": 355.435,
        "time_end": 355.595,
        "confidence": 0.999843
        },
        {
        "word": "visceral",
        "time_begin": 355.595,
        "time_end": 356.07498,
        "confidence": 0.99998856
        },
        {
        "word": "level,",
        "time_begin": 356.07498,
        "time_end": 356.57498,
        "confidence": 0.9380453
        },
        {
        "word": "and",
        "time_begin": 357.115,
        "time_end": 357.275,
        "confidence": 0.9995253
        },
        {
        "word": "from",
        "time_begin": 357.275,
        "time_end": 357.51498,
        "confidence": 0.92283356
        },
        {
        "word": "this",
        "time_begin": 357.51498,
        "time_end": 357.835,
        "confidence": 0.9995509
        },
        {
        "word": "disenchanted",
        "time_begin": 357.835,
        "time_end": 358.335,
        "confidence": 0.9992067
        },
        {
        "word": "stance,",
        "time_begin": 358.395,
        "time_end": 358.875,
        "confidence": 0.9421097
        },
        {
        "word": "naturally",
        "time_begin": 358.875,
        "time_end": 359.35498,
        "confidence": 0.9992907
        },
        {
        "word": "letting",
        "time_begin": 359.35498,
        "time_end": 359.675,
        "confidence": 0.98861027
        },
        {
        "word": "go.",
        "time_begin": 359.675,
        "time_end": 360.175,
        "confidence": 0.9879421
        }
      ],
      "language": "en",
      "transcription": "Seeing really clearly what we get when we get caught up in our behaviors, becoming disenchanted on a visceral level, and from this disenchanted stance, naturally letting go.",
      "confidence": -1,
      "time_begin": 348.99,
      "time_end": 360.175,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "This",
        "time_begin": 360.875,
        "time_end": 361.115,
        "confidence": 0.9997403
        },
        {
        "word": "isn't",
        "time_begin": 361.115,
        "time_end": 361.435,
        "confidence": 0.9991828
        },
        {
        "word": "to",
        "time_begin": 361.435,
        "time_end": 361.51498,
        "confidence": 0.9996007
        },
        {
        "word": "say",
        "time_begin": 361.51498,
        "time_end": 361.835,
        "confidence": 0.99991274
        },
        {
        "word": "that",
        "time_begin": 361.835,
        "time_end": 362.315,
        "confidence": 0.9650012
        },
        {
        "word": "poof,",
        "time_begin": 362.315,
        "time_end": 362.63498,
        "confidence": 0.73190594
        },
        {
        "word": "magically",
        "time_begin": 362.63498,
        "time_end": 363.13498,
        "confidence": 0.999681
        },
        {
        "word": "we",
        "time_begin": 363.19498,
        "time_end": 363.275,
        "confidence": 0.6012804
        },
        {
        "word": "quit",
        "time_begin": 363.275,
        "time_end": 363.595,
        "confidence": 0.9981352
        },
        {
        "word": "smoking,",
        "time_begin": 363.595,
        "time_end": 364.095,
        "confidence": 0.8680786
        },
        {
        "word": "but",
        "time_begin": 364.315,
        "time_end": 364.555,
        "confidence": 0.99956423
        },
        {
        "word": "over",
        "time_begin": 364.555,
        "time_end": 364.79498,
        "confidence": 0.9665264
        },
        {
        "word": "time,",
        "time_begin": 364.79498,
        "time_end": 364.955,
        "confidence": 0.8515291
        },
        {
        "word": "as",
        "time_begin": 364.955,
        "time_end": 365.115,
        "confidence": 0.9996061
        },
        {
        "word": "we",
        "time_begin": 365.115,
        "time_end": 365.35498,
        "confidence": 0.9997534
        },
        {
        "word": "learn",
        "time_begin": 365.35498,
        "time_end": 365.51498,
        "confidence": 0.9853768
        },
        {
        "word": "to",
        "time_begin": 365.51498,
        "time_end": 365.675,
        "confidence": 0.9993569
        },
        {
        "word": "see",
        "time_begin": 365.675,
        "time_end": 365.835,
        "confidence": 0.9999062
        },
        {
        "word": "more",
        "time_begin": 365.835,
        "time_end": 365.995,
        "confidence": 0.9996101
        },
        {
        "word": "and",
        "time_begin": 365.995,
        "time_end": 366.155,
        "confidence": 0.9934556
        },
        {
        "word": "more",
        "time_begin": 366.155,
        "time_end": 366.395,
        "confidence": 0.9997336
        },
        {
        "word": "clearly",
        "time_begin": 366.395,
        "time_end": 366.79498,
        "confidence": 0.999754
        },
        {
        "word": "the",
        "time_begin": 366.79498,
        "time_end": 366.955,
        "confidence": 0.99926776
        },
        {
        "word": "results",
        "time_begin": 366.955,
        "time_end": 367.275,
        "confidence": 0.99852496
        },
        {
        "word": "of",
        "time_begin": 367.275,
        "time_end": 367.435,
        "confidence": 0.9990005
        },
        {
        "word": "our",
        "time_begin": 367.435,
        "time_end": 367.595,
        "confidence": 0.99954057
        },
        {
        "word": "actions,",
        "time_begin": 367.595,
        "time_end": 368.095,
        "confidence": 0.99706566
        },
        {
        "word": "we",
        "time_begin": 368.3,
        "time_end": 368.38,
        "confidence": 0.999884
        },
        {
        "word": "let",
        "time_begin": 368.38,
        "time_end": 368.54,
        "confidence": 0.9972036
        },
        {
        "word": "go",
        "time_begin": 368.54,
        "time_end": 368.7,
        "confidence": 0.99995327
        },
        {
        "word": "of",
        "time_begin": 368.7,
        "time_end": 368.94,
        "confidence": 0.99898654
        },
        {
        "word": "old",
        "time_begin": 368.94,
        "time_end": 369.18,
        "confidence": 0.999795
        },
        {
        "word": "habits",
        "time_begin": 369.18,
        "time_end": 369.68,
        "confidence": 0.9999893
        },
        {
        "word": "and",
        "time_begin": 369.82,
        "time_end": 370.06,
        "confidence": 0.99620855
        },
        {
        "word": "form",
        "time_begin": 370.06,
        "time_end": 370.38,
        "confidence": 0.99741024
        },
        {
        "word": "new",
        "time_begin": 370.38,
        "time_end": 370.54,
        "confidence": 0.9363433
        },
        {
        "word": "ones.",
        "time_begin": 370.54,
        "time_end": 371.04,
        "confidence": 0.9986139
        }
      ],
      "language": "en",
      "transcription": "This isn't to say that poof, magically we quit smoking, but over time, as we learn to see more and more clearly the results of our actions, we let go of old habits and form new ones.",
      "confidence": -1,
      "time_begin": 360.875,
      "time_end": 371.04,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "The",
        "time_begin": 372.14,
        "time_end": 372.3,
        "confidence": 0.9994697
        },
        {
        "word": "paradox",
        "time_begin": 372.3,
        "time_end": 372.8,
        "confidence": 0.9999647
        },
        {
        "word": "here",
        "time_begin": 372.86002,
        "time_end": 373.26,
        "confidence": 0.9967583
        },
        {
        "word": "is",
        "time_begin": 373.26,
        "time_end": 373.58,
        "confidence": 0.9977539
        },
        {
        "word": "that",
        "time_begin": 373.58,
        "time_end": 373.74,
        "confidence": 0.99353033
        },
        {
        "word": "mindfulness",
        "time_begin": 373.74,
        "time_end": 374.24,
        "confidence": 0.9983382
        },
        {
        "word": "is",
        "time_begin": 374.3,
        "time_end": 374.54,
        "confidence": 0.99971384
        },
        {
        "word": "just",
        "time_begin": 374.54,
        "time_end": 374.78,
        "confidence": 0.9947613
        },
        {
        "word": "about",
        "time_begin": 374.78,
        "time_end": 375.02,
        "confidence": 0.99943715
        },
        {
        "word": "being",
        "time_begin": 375.02,
        "time_end": 375.34,
        "confidence": 0.9996915
        },
        {
        "word": "really",
        "time_begin": 375.34,
        "time_end": 375.74,
        "confidence": 0.99430215
        },
        {
        "word": "interested",
        "time_begin": 375.74,
        "time_end": 376.22,
        "confidence": 0.99980956
        },
        {
        "word": "in",
        "time_begin": 376.22,
        "time_end": 376.38,
        "confidence": 0.7282502
        },
        {
        "word": "getting",
        "time_begin": 376.38,
        "time_end": 376.78,
        "confidence": 0.9999238
        },
        {
        "word": "close",
        "time_begin": 376.78,
        "time_end": 377.02,
        "confidence": 0.99919146
        },
        {
        "word": "and",
        "time_begin": 377.02,
        "time_end": 377.26,
        "confidence": 0.9996965
        },
        {
        "word": "personal",
        "time_begin": 377.26,
        "time_end": 377.66,
        "confidence": 0.9999888
        },
        {
        "word": "with",
        "time_begin": 377.66,
        "time_end": 377.82,
        "confidence": 0.999438
        },
        {
        "word": "what's",
        "time_begin": 377.82,
        "time_end": 378.14,
        "confidence": 0.99703074
        },
        {
        "word": "actually",
        "time_begin": 378.14,
        "time_end": 378.38,
        "confidence": 0.9963697
        },
        {
        "word": "happening",
        "time_begin": 378.38,
        "time_end": 378.86,
        "confidence": 0.99997807
        },
        {
        "word": "in",
        "time_begin": 378.86,
        "time_end": 379.02,
        "confidence": 0.99989223
        },
        {
        "word": "our",
        "time_begin": 379.02,
        "time_end": 379.18,
        "confidence": 0.9998803
        },
        {
        "word": "bodies",
        "time_begin": 379.18,
        "time_end": 379.5,
        "confidence": 0.99981755
        },
        {
        "word": "and",
        "time_begin": 379.5,
        "time_end": 379.66,
        "confidence": 0.998782
        },
        {
        "word": "minds",
        "time_begin": 379.66,
        "time_end": 379.9,
        "confidence": 0.99974483
        },
        {
        "word": "from",
        "time_begin": 379.9,
        "time_end": 380.14,
        "confidence": 0.99199754
        },
        {
        "word": "moment",
        "time_begin": 380.14,
        "time_end": 380.46,
        "confidence": 0.99991775
        },
        {
        "word": "to",
        "time_begin": 380.46,
        "time_end": 380.62,
        "confidence": 0.9997186
        },
        {
        "word": "moment.",
        "time_begin": 380.62,
        "time_end": 381.12,
        "confidence": 0.81508243
        }
      ],
      "language": "en",
      "transcription": "The paradox here is that mindfulness is just about being really interested in getting close and personal with what's actually happening in our bodies and minds from moment to moment.",
      "confidence": -1,
      "time_begin": 372.14,
      "time_end": 381.12,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "This",
        "time_begin": 381.975,
        "time_end": 382.295,
        "confidence": 0.9983612
        },
        {
        "word": "willingness",
        "time_begin": 382.295,
        "time_end": 382.795,
        "confidence": 0.9999746
        },
        {
        "word": "to",
        "time_begin": 382.855,
        "time_end": 383.015,
        "confidence": 0.99977416
        },
        {
        "word": "turn",
        "time_begin": 383.015,
        "time_end": 383.255,
        "confidence": 0.9988839
        },
        {
        "word": "toward",
        "time_begin": 383.255,
        "time_end": 383.655,
        "confidence": 0.99724895
        },
        {
        "word": "our",
        "time_begin": 383.655,
        "time_end": 383.815,
        "confidence": 0.9985852
        },
        {
        "word": "experience",
        "time_begin": 383.815,
        "time_end": 384.295,
        "confidence": 0.9972089
        },
        {
        "word": "rather",
        "time_begin": 384.295,
        "time_end": 384.535,
        "confidence": 0.8627147
        },
        {
        "word": "than",
        "time_begin": 384.535,
        "time_end": 384.695,
        "confidence": 0.9990606
        },
        {
        "word": "trying",
        "time_begin": 384.695,
        "time_end": 384.935,
        "confidence": 0.97952867
        },
        {
        "word": "to",
        "time_begin": 384.935,
        "time_end": 385.015,
        "confidence": 0.99897206
        },
        {
        "word": "make",
        "time_begin": 385.015,
        "time_end": 385.255,
        "confidence": 0.99990773
        },
        {
        "word": "unpleasant",
        "time_begin": 385.255,
        "time_end": 385.73502,
        "confidence": 0.9997601
        },
        {
        "word": "cravings",
        "time_begin": 385.73502,
        "time_end": 386.135,
        "confidence": 0.99986255
        },
        {
        "word": "go",
        "time_begin": 386.135,
        "time_end": 386.295,
        "confidence": 0.99959224
        },
        {
        "word": "away",
        "time_begin": 386.295,
        "time_end": 386.615,
        "confidence": 0.99991524
        },
        {
        "word": "as",
        "time_begin": 386.615,
        "time_end": 386.775,
        "confidence": 0.99760014
        },
        {
        "word": "quickly",
        "time_begin": 386.775,
        "time_end": 387.17502,
        "confidence": 0.9996985
        },
        {
        "word": "as",
        "time_begin": 387.17502,
        "time_end": 387.335,
        "confidence": 0.9997596
        },
        {
        "word": "possible.",
        "time_begin": 387.335,
        "time_end": 387.835,
        "confidence": 0.99544513
        }
      ],
      "language": "en",
      "transcription": "This willingness to turn toward our experience rather than trying to make unpleasant cravings go away as quickly as possible.",
      "confidence": -1,
      "time_begin": 381.975,
      "time_end": 387.835,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "And",
        "time_begin": 388.695,
        "time_end": 388.935,
        "confidence": 0.9303384
        },
        {
        "word": "this",
        "time_begin": 388.935,
        "time_end": 389.17502,
        "confidence": 0.9979919
        },
        {
        "word": "willingness",
        "time_begin": 389.17502,
        "time_end": 389.575,
        "confidence": 0.99998605
        },
        {
        "word": "to",
        "time_begin": 389.575,
        "time_end": 389.73502,
        "confidence": 0.99977714
        },
        {
        "word": "turn",
        "time_begin": 389.73502,
        "time_end": 389.89502,
        "confidence": 0.9996971
        },
        {
        "word": "toward",
        "time_begin": 389.89502,
        "time_end": 390.215,
        "confidence": 0.99624
        },
        {
        "word": "our",
        "time_begin": 390.215,
        "time_end": 390.375,
        "confidence": 0.9992094
        },
        {
        "word": "experience",
        "time_begin": 390.375,
        "time_end": 390.875,
        "confidence": 0.9987686
        },
        {
        "word": "is",
        "time_begin": 391.335,
        "time_end": 391.495,
        "confidence": 0.98332685
        },
        {
        "word": "supported",
        "time_begin": 391.495,
        "time_end": 391.975,
        "confidence": 0.9998698
        },
        {
        "word": "by",
        "time_begin": 391.975,
        "time_end": 392.135,
        "confidence": 0.9998877
        },
        {
        "word": "curiosity,",
        "time_begin": 392.135,
        "time_end": 392.635,
        "confidence": 0.97603625
        },
        {
        "word": "which",
        "time_begin": 393.17502,
        "time_end": 393.415,
        "confidence": 0.9998851
        },
        {
        "word": "is",
        "time_begin": 393.415,
        "time_end": 393.655,
        "confidence": 0.99989665
        },
        {
        "word": "naturally",
        "time_begin": 393.655,
        "time_end": 394.155,
        "confidence": 0.9998447
        },
        {
        "word": "rewarding.",
        "time_begin": 394.215,
        "time_end": 394.715,
        "confidence": 0.999779
        }
      ],
      "language": "en",
      "transcription": "And this willingness to turn toward our experience is supported by curiosity, which is naturally rewarding.",
      "confidence": -1,
      "time_begin": 388.695,
      "time_end": 394.715,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "What",
        "time_begin": 394.855,
        "time_end": 395.015,
        "confidence": 0.99964654
        },
        {
        "word": "does",
        "time_begin": 395.015,
        "time_end": 395.255,
        "confidence": 0.99811625
        },
        {
        "word": "curiosity",
        "time_begin": 395.255,
        "time_end": 395.755,
        "confidence": 0.999579
        },
        {
        "word": "feel",
        "time_begin": 395.815,
        "time_end": 396.055,
        "confidence": 0.9991843
        },
        {
        "word": "like?",
        "time_begin": 396.055,
        "time_end": 396.45,
        "confidence": 0.9997928
        }
      ],
      "language": "en",
      "transcription": "What does curiosity feel like?",
      "confidence": -1,
      "time_begin": 394.855,
      "time_end": 396.45,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "It",
        "time_begin": 396.69,
        "time_end": 396.85,
        "confidence": 0.99958867
        },
        {
        "word": "feels",
        "time_begin": 396.85,
        "time_end": 397.17,
        "confidence": 0.99975806
        },
        {
        "word": "good.",
        "time_begin": 397.17,
        "time_end": 397.67,
        "confidence": 0.9993451
        }
      ],
      "language": "en",
      "transcription": "It feels good.",
      "confidence": -1,
      "time_begin": 396.69,
      "time_end": 397.67,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "And",
        "time_begin": 398.93002,
        "time_end": 399.09003,
        "confidence": 0.8846306
        },
        {
        "word": "what",
        "time_begin": 399.09003,
        "time_end": 399.33002,
        "confidence": 0.9921679
        },
        {
        "word": "happens",
        "time_begin": 399.33002,
        "time_end": 399.65002,
        "confidence": 0.9999405
        },
        {
        "word": "when",
        "time_begin": 399.65002,
        "time_end": 399.81,
        "confidence": 0.9997886
        },
        {
        "word": "we",
        "time_begin": 399.81,
        "time_end": 399.97,
        "confidence": 0.99972683
        },
        {
        "word": "get",
        "time_begin": 399.97,
        "time_end": 400.21002,
        "confidence": 0.9998728
        },
        {
        "word": "curious?",
        "time_begin": 400.21002,
        "time_end": 400.71002,
        "confidence": 0.99909794
        }
      ],
      "language": "en",
      "transcription": "And what happens when we get curious?",
      "confidence": -1,
      "time_begin": 398.93002,
      "time_end": 400.71002,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "We",
        "time_begin": 401.25,
        "time_end": 401.49002,
        "confidence": 0.9993604
        },
        {
        "word": "start",
        "time_begin": 401.49002,
        "time_end": 401.73,
        "confidence": 0.99980325
        },
        {
        "word": "to",
        "time_begin": 401.73,
        "time_end": 401.89,
        "confidence": 0.9997093
        },
        {
        "word": "notice",
        "time_begin": 401.89,
        "time_end": 402.21002,
        "confidence": 0.9998097
        },
        {
        "word": "that",
        "time_begin": 402.21002,
        "time_end": 402.45,
        "confidence": 0.87784815
        },
        {
        "word": "cravings",
        "time_begin": 402.45,
        "time_end": 402.85,
        "confidence": 0.9994731
        },
        {
        "word": "are",
        "time_begin": 402.85,
        "time_end": 402.93002,
        "confidence": 0.99928063
        },
        {
        "word": "simply",
        "time_begin": 402.93002,
        "time_end": 403.25,
        "confidence": 0.9986733
        },
        {
        "word": "made",
        "time_begin": 403.25,
        "time_end": 403.41,
        "confidence": 0.99989843
        },
        {
        "word": "up",
        "time_begin": 403.41,
        "time_end": 403.57,
        "confidence": 0.9961195
        },
        {
        "word": "of",
        "time_begin": 403.57,
        "time_end": 403.73,
        "confidence": 0.99871755
        },
        {
        "word": "body",
        "time_begin": 403.73,
        "time_end": 404.05002,
        "confidence": 0.9997696
        },
        {
        "word": "sensations.",
        "time_begin": 404.05002,
        "time_end": 404.55002,
        "confidence": 0.9686515
        }
      ],
      "language": "en",
      "transcription": "We start to notice that cravings are simply made up of body sensations.",
      "confidence": -1,
      "time_begin": 401.25,
      "time_end": 404.55002,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Oh,",
        "time_begin": 404.77002,
        "time_end": 405.01,
        "confidence": 0.9124563
        },
        {
        "word": "there's",
        "time_begin": 405.01,
        "time_end": 405.41,
        "confidence": 0.99098086
        },
        {
        "word": "tightness,",
        "time_begin": 405.41,
        "time_end": 405.91,
        "confidence": 0.9165998
        },
        {
        "word": "there's",
        "time_begin": 405.97,
        "time_end": 406.37003,
        "confidence": 0.98554844
        },
        {
        "word": "tension,",
        "time_begin": 406.37003,
        "time_end": 406.87003,
        "confidence": 0.99748886
        },
        {
        "word": "there's",
        "time_begin": 407.01,
        "time_end": 407.41,
        "confidence": 0.99875456
        },
        {
        "word": "restlessness,",
        "time_begin": 407.41,
        "time_end": 407.91,
        "confidence": 0.8518534
        },
        {
        "word": "and",
        "time_begin": 408.61002,
        "time_end": 408.85,
        "confidence": 0.9986897
        },
        {
        "word": "that",
        "time_begin": 408.85,
        "time_end": 409.01,
        "confidence": 0.9927093
        },
        {
        "word": "these",
        "time_begin": 409.01,
        "time_end": 409.25,
        "confidence": 0.99882835
        },
        {
        "word": "body",
        "time_begin": 409.25,
        "time_end": 409.57,
        "confidence": 0.99946386
        },
        {
        "word": "sensations",
        "time_begin": 409.57,
        "time_end": 410.07,
        "confidence": 0.9999212
        },
        {
        "word": "come",
        "time_begin": 410.21002,
        "time_end": 410.45,
        "confidence": 0.999752
        },
        {
        "word": "and",
        "time_begin": 410.45,
        "time_end": 410.61002,
        "confidence": 0.9998227
        },
        {
        "word": "go.",
        "time_begin": 410.61002,
        "time_end": 411.11002,
        "confidence": 0.9967321
        }
      ],
      "language": "en",
      "transcription": "Oh, there's tightness, there's tension, there's restlessness, and that these body sensations come and go.",
      "confidence": -1,
      "time_begin": 404.77002,
      "time_end": 411.11002,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "These",
        "time_begin": 411.895,
        "time_end": 411.975,
        "confidence": 0.9997335
        },
        {
        "word": "are",
        "time_begin": 411.975,
        "time_end": 412.375,
        "confidence": 0.99978966
        },
        {
        "word": "bite",
        "time_begin": 412.375,
        "time_end": 412.695,
        "confidence": 0.97642255
        },
        {
        "word": "sized",
        "time_begin": 412.695,
        "time_end": 413.01498,
        "confidence": 0.93507016
        },
        {
        "word": "pieces",
        "time_begin": 413.01498,
        "time_end": 413.335,
        "confidence": 0.9998747
        },
        {
        "word": "of",
        "time_begin": 413.335,
        "time_end": 413.655,
        "confidence": 0.9998982
        },
        {
        "word": "experiences",
        "time_begin": 413.655,
        "time_end": 414.155,
        "confidence": 0.99848074
        },
        {
        "word": "that",
        "time_begin": 414.85498,
        "time_end": 415.01498,
        "confidence": 0.99313605
        },
        {
        "word": "we",
        "time_begin": 415.01498,
        "time_end": 415.175,
        "confidence": 0.99993956
        },
        {
        "word": "can",
        "time_begin": 415.175,
        "time_end": 415.415,
        "confidence": 0.99973637
        },
        {
        "word": "manage",
        "time_begin": 415.415,
        "time_end": 415.815,
        "confidence": 0.99992204
        },
        {
        "word": "from",
        "time_begin": 415.815,
        "time_end": 415.975,
        "confidence": 0.99520904
        },
        {
        "word": "moment",
        "time_begin": 415.975,
        "time_end": 416.29498,
        "confidence": 0.99971133
        },
        {
        "word": "to",
        "time_begin": 416.29498,
        "time_end": 416.455,
        "confidence": 0.99983394
        },
        {
        "word": "moment",
        "time_begin": 416.455,
        "time_end": 416.85498,
        "confidence": 0.9999373
        },
        {
        "word": "rather",
        "time_begin": 416.85498,
        "time_end": 417.255,
        "confidence": 0.57438725
        },
        {
        "word": "than",
        "time_begin": 417.255,
        "time_end": 417.495,
        "confidence": 0.99699783
        },
        {
        "word": "getting",
        "time_begin": 417.495,
        "time_end": 417.895,
        "confidence": 0.4747178
        },
        {
        "word": "clobbered",
        "time_begin": 417.895,
        "time_end": 418.375,
        "confidence": 0.9998932
        },
        {
        "word": "by",
        "time_begin": 418.375,
        "time_end": 418.615,
        "confidence": 0.9997422
        },
        {
        "word": "this",
        "time_begin": 418.615,
        "time_end": 418.935,
        "confidence": 0.999169
        },
        {
        "word": "huge,",
        "time_begin": 418.935,
        "time_end": 419.435,
        "confidence": 0.7843393
        },
        {
        "word": "scary",
        "time_begin": 419.895,
        "time_end": 420.395,
        "confidence": 0.9999107
        },
        {
        "word": "craving",
        "time_begin": 420.455,
        "time_end": 420.955,
        "confidence": 0.9967643
        },
        {
        "word": "that",
        "time_begin": 421.01498,
        "time_end": 421.175,
        "confidence": 0.9961629
        },
        {
        "word": "we",
        "time_begin": 421.175,
        "time_end": 421.415,
        "confidence": 0.99994385
        },
        {
        "word": "choke",
        "time_begin": 421.415,
        "time_end": 421.735,
        "confidence": 0.99917454
        },
        {
        "word": "on.",
        "time_begin": 421.735,
        "time_end": 422.235,
        "confidence": 0.99972403
        }
      ],
      "language": "en",
      "transcription": "These are bite sized pieces of experiences that we can manage from moment to moment rather than getting clobbered by this huge, scary craving that we choke on.",
      "confidence": -1,
      "time_begin": 411.895,
      "time_end": 422.235,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "In",
        "time_begin": 422.455,
        "time_end": 422.615,
        "confidence": 0.9995485
        },
        {
        "word": "other",
        "time_begin": 422.615,
        "time_end": 422.85498,
        "confidence": 0.99979776
        },
        {
        "word": "words,",
        "time_begin": 422.85498,
        "time_end": 423.35498,
        "confidence": 0.9992221
        },
        {
        "word": "when",
        "time_begin": 423.67,
        "time_end": 423.83002,
        "confidence": 0.9998902
        },
        {
        "word": "we",
        "time_begin": 423.83002,
        "time_end": 423.99002,
        "confidence": 0.9999428
        },
        {
        "word": "get",
        "time_begin": 423.99002,
        "time_end": 424.15002,
        "confidence": 0.9999577
        },
        {
        "word": "curious,",
        "time_begin": 424.15002,
        "time_end": 424.65002,
        "confidence": 0.9947214
        },
        {
        "word": "we",
        "time_begin": 424.95,
        "time_end": 425.35,
        "confidence": 0.9999062
        },
        {
        "word": "step",
        "time_begin": 425.35,
        "time_end": 425.67,
        "confidence": 0.9999707
        },
        {
        "word": "out",
        "time_begin": 425.67,
        "time_end": 425.83002,
        "confidence": 0.9997607
        },
        {
        "word": "of",
        "time_begin": 425.83002,
        "time_end": 426.07,
        "confidence": 0.9990281
        },
        {
        "word": "our",
        "time_begin": 426.07,
        "time_end": 426.15002,
        "confidence": 0.9995116
        },
        {
        "word": "old",
        "time_begin": 426.15002,
        "time_end": 426.65002,
        "confidence": 0.99990404
        },
        {
        "word": "fear",
        "time_begin": 427.19,
        "time_end": 427.51,
        "confidence": 0.900476
        },
        {
        "word": "based",
        "time_begin": 427.51,
        "time_end": 427.91,
        "confidence": 0.99961865
        },
        {
        "word": "reactive",
        "time_begin": 427.91,
        "time_end": 428.39,
        "confidence": 0.6858193
        },
        {
        "word": "habit",
        "time_begin": 428.39,
        "time_end": 428.71002,
        "confidence": 0.9984908
        },
        {
        "word": "patterns",
        "time_begin": 428.71002,
        "time_end": 429.21002,
        "confidence": 0.9998764
        },
        {
        "word": "and",
        "time_begin": 429.59,
        "time_end": 429.91,
        "confidence": 0.60450923
        },
        {
        "word": "we",
        "time_begin": 429.91,
        "time_end": 430.23,
        "confidence": 0.99921477
        },
        {
        "word": "step",
        "time_begin": 430.23,
        "time_end": 430.55002,
        "confidence": 0.99993086
        },
        {
        "word": "into",
        "time_begin": 430.55002,
        "time_end": 430.95,
        "confidence": 0.99903464
        },
        {
        "word": "being.",
        "time_begin": 430.95,
        "time_end": 431.45,
        "confidence": 0.996768
        }
      ],
      "language": "en",
      "transcription": "In other words, when we get curious, we step out of our old fear based reactive habit patterns and we step into being.",
      "confidence": -1,
      "time_begin": 422.455,
      "time_end": 431.45,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "We",
        "time_begin": 431.91,
        "time_end": 432.23,
        "confidence": 0.999798
        },
        {
        "word": "become",
        "time_begin": 432.23,
        "time_end": 432.71002,
        "confidence": 0.86405635
        },
        {
        "word": "this",
        "time_begin": 432.71002,
        "time_end": 433.21002,
        "confidence": 0.9995078
        },
        {
        "word": "inner",
        "time_begin": 433.35,
        "time_end": 433.75,
        "confidence": 0.9998647
        },
        {
        "word": "scientist",
        "time_begin": 433.75,
        "time_end": 434.25,
        "confidence": 0.99980825
        },
        {
        "word": "where",
        "time_begin": 434.79,
        "time_end": 434.95,
        "confidence": 0.65462464
        },
        {
        "word": "we're",
        "time_begin": 434.95,
        "time_end": 435.35,
        "confidence": 0.99562085
        },
        {
        "word": "eagerly",
        "time_begin": 435.35,
        "time_end": 435.75,
        "confidence": 0.99995756
        },
        {
        "word": "awaiting",
        "time_begin": 435.75,
        "time_end": 436.15002,
        "confidence": 0.9995858
        },
        {
        "word": "that",
        "time_begin": 436.15002,
        "time_end": 436.39,
        "confidence": 0.9996081
        },
        {
        "word": "next",
        "time_begin": 436.39,
        "time_end": 436.71002,
        "confidence": 0.9998735
        },
        {
        "word": "data",
        "time_begin": 436.71002,
        "time_end": 437.03,
        "confidence": 0.9915189
        },
        {
        "word": "point.",
        "time_begin": 437.03,
        "time_end": 437.53,
        "confidence": 0.9998664
        }
      ],
      "language": "en",
      "transcription": "We become this inner scientist where we're eagerly awaiting that next data point.",
      "confidence": -1,
      "time_begin": 431.91,
      "time_end": 437.53,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Now,",
        "time_begin": 438.215,
        "time_end": 438.715,
        "confidence": 0.9394272
        },
        {
        "word": "this",
        "time_begin": 439.495,
        "time_end": 439.655,
        "confidence": 0.9993156
        },
        {
        "word": "might",
        "time_begin": 439.655,
        "time_end": 439.975,
        "confidence": 0.99949324
        },
        {
        "word": "sound",
        "time_begin": 439.975,
        "time_end": 440.295,
        "confidence": 0.9998932
        },
        {
        "word": "too",
        "time_begin": 440.295,
        "time_end": 440.615,
        "confidence": 0.99953747
        },
        {
        "word": "simplistic",
        "time_begin": 440.615,
        "time_end": 441.095,
        "confidence": 0.99994886
        },
        {
        "word": "to",
        "time_begin": 441.095,
        "time_end": 441.175,
        "confidence": 0.9998356
        },
        {
        "word": "affect",
        "time_begin": 441.175,
        "time_end": 441.575,
        "confidence": 0.99255824
        },
        {
        "word": "behavior,",
        "time_begin": 441.575,
        "time_end": 442.075,
        "confidence": 0.89417017
        },
        {
        "word": "but",
        "time_begin": 442.535,
        "time_end": 442.775,
        "confidence": 0.9989779
        },
        {
        "word": "in",
        "time_begin": 442.775,
        "time_end": 442.935,
        "confidence": 0.9657159
        },
        {
        "word": "one",
        "time_begin": 442.935,
        "time_end": 443.175,
        "confidence": 0.99986064
        },
        {
        "word": "study,",
        "time_begin": 443.175,
        "time_end": 443.415,
        "confidence": 0.794845
        },
        {
        "word": "we",
        "time_begin": 443.415,
        "time_end": 443.575,
        "confidence": 0.999841
        },
        {
        "word": "found",
        "time_begin": 443.575,
        "time_end": 443.815,
        "confidence": 0.99717003
        },
        {
        "word": "that",
        "time_begin": 443.815,
        "time_end": 443.975,
        "confidence": 0.97205794
        },
        {
        "word": "mindfulness",
        "time_begin": 443.975,
        "time_end": 444.455,
        "confidence": 0.9986449
        },
        {
        "word": "training",
        "time_begin": 444.455,
        "time_end": 444.855,
        "confidence": 0.99920243
        },
        {
        "word": "was",
        "time_begin": 444.855,
        "time_end": 445.095,
        "confidence": 0.99991417
        },
        {
        "word": "twice",
        "time_begin": 445.095,
        "time_end": 445.495,
        "confidence": 0.99993885
        },
        {
        "word": "as",
        "time_begin": 445.495,
        "time_end": 445.575,
        "confidence": 0.9988739
        },
        {
        "word": "good",
        "time_begin": 445.575,
        "time_end": 445.815,
        "confidence": 0.99996924
        },
        {
        "word": "as",
        "time_begin": 445.815,
        "time_end": 445.975,
        "confidence": 0.9985067
        },
        {
        "word": "gold",
        "time_begin": 445.975,
        "time_end": 446.215,
        "confidence": 0.99120784
        },
        {
        "word": "standard",
        "time_begin": 446.215,
        "time_end": 446.615,
        "confidence": 0.99981624
        },
        {
        "word": "therapy",
        "time_begin": 446.615,
        "time_end": 446.935,
        "confidence": 0.9994092
        },
        {
        "word": "at",
        "time_begin": 446.935,
        "time_end": 447.095,
        "confidence": 0.9884282
        },
        {
        "word": "helping",
        "time_begin": 447.095,
        "time_end": 447.335,
        "confidence": 0.99998343
        },
        {
        "word": "people",
        "time_begin": 447.335,
        "time_end": 447.655,
        "confidence": 0.99994063
        },
        {
        "word": "quit",
        "time_begin": 447.655,
        "time_end": 447.975,
        "confidence": 0.99893683
        },
        {
        "word": "smoking.",
        "time_begin": 447.975,
        "time_end": 448.475,
        "confidence": 0.9718342
        }
      ],
      "language": "en",
      "transcription": "Now, this might sound too simplistic to affect behavior, but in one study, we found that mindfulness training was twice as good as gold standard therapy at helping people quit smoking.",
      "confidence": -1,
      "time_begin": 438.215,
      "time_end": 448.475,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "So",
        "time_begin": 449.01498,
        "time_end": 449.255,
        "confidence": 0.99905866
        },
        {
        "word": "it",
        "time_begin": 449.255,
        "time_end": 449.415,
        "confidence": 0.9459514
        },
        {
        "word": "actually",
        "time_begin": 449.415,
        "time_end": 449.895,
        "confidence": 0.9998772
        },
        {
        "word": "works.",
        "time_begin": 449.895,
        "time_end": 450.395,
        "confidence": 0.998113
        }
      ],
      "language": "en",
      "transcription": "So it actually works.",
      "confidence": -1,
      "time_begin": 449.01498,
      "time_end": 450.395,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "And",
        "time_begin": 451.71,
        "time_end": 451.87,
        "confidence": 0.9633354
        },
        {
        "word": "when",
        "time_begin": 451.87,
        "time_end": 452.03,
        "confidence": 0.9895237
        },
        {
        "word": "we",
        "time_begin": 452.03,
        "time_end": 452.19,
        "confidence": 0.99957496
        },
        {
        "word": "studied",
        "time_begin": 452.19,
        "time_end": 452.59,
        "confidence": 0.972475
        },
        {
        "word": "the",
        "time_begin": 452.59,
        "time_end": 452.75,
        "confidence": 0.99962723
        },
        {
        "word": "brains",
        "time_begin": 452.75,
        "time_end": 452.99,
        "confidence": 0.99986243
        },
        {
        "word": "of",
        "time_begin": 452.99,
        "time_end": 453.23,
        "confidence": 0.99978226
        },
        {
        "word": "experienced",
        "time_begin": 453.23,
        "time_end": 453.73,
        "confidence": 0.99901533
        },
        {
        "word": "meditators,",
        "time_begin": 453.79,
        "time_end": 454.29,
        "confidence": 0.9957689
        },
        {
        "word": "we",
        "time_begin": 454.59,
        "time_end": 454.75,
        "confidence": 0.99946636
        },
        {
        "word": "found",
        "time_begin": 454.75,
        "time_end": 455.15,
        "confidence": 0.99522626
        },
        {
        "word": "that",
        "time_begin": 455.15,
        "time_end": 455.39,
        "confidence": 0.9455898
        },
        {
        "word": "parts",
        "time_begin": 455.39,
        "time_end": 455.71,
        "confidence": 0.9987668
        },
        {
        "word": "of",
        "time_begin": 455.71,
        "time_end": 455.95,
        "confidence": 0.99934965
        },
        {
        "word": "a",
        "time_begin": 455.95,
        "time_end": 456.11002,
        "confidence": 0.98124
        },
        {
        "word": "neural",
        "time_begin": 456.11002,
        "time_end": 456.35,
        "confidence": 0.9949309
        },
        {
        "word": "network",
        "time_begin": 456.35,
        "time_end": 456.83,
        "confidence": 0.99836105
        },
        {
        "word": "of",
        "time_begin": 456.83,
        "time_end": 457.15,
        "confidence": 0.865662
        },
        {
        "word": "self",
        "time_begin": 457.15,
        "time_end": 457.39,
        "confidence": 0.7586813
        },
        {
        "word": "referential",
        "time_begin": 457.39,
        "time_end": 457.89,
        "confidence": 0.999732
        },
        {
        "word": "processing",
        "time_begin": 457.95,
        "time_end": 458.43,
        "confidence": 0.9993544
        },
        {
        "word": "called",
        "time_begin": 458.43,
        "time_end": 458.67,
        "confidence": 0.8581202
        },
        {
        "word": "the",
        "time_begin": 458.67,
        "time_end": 458.83,
        "confidence": 0.99634427
        },
        {
        "word": "default",
        "time_begin": 458.83,
        "time_end": 459.15,
        "confidence": 0.9667507
        },
        {
        "word": "mode",
        "time_begin": 459.15,
        "time_end": 459.39,
        "confidence": 0.99881506
        },
        {
        "word": "network",
        "time_begin": 459.39,
        "time_end": 459.79,
        "confidence": 0.99933404
        },
        {
        "word": "were",
        "time_begin": 459.79,
        "time_end": 459.95,
        "confidence": 0.9583847
        },
        {
        "word": "at",
        "time_begin": 459.95,
        "time_end": 460.11,
        "confidence": 0.99860966
        },
        {
        "word": "play.",
        "time_begin": 460.11,
        "time_end": 460.61,
        "confidence": 0.99979556
        }
      ],
      "language": "en",
      "transcription": "And when we studied the brains of experienced meditators, we found that parts of a neural network of self referential processing called the default mode network were at play.",
      "confidence": -1,
      "time_begin": 451.71,
      "time_end": 460.61,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Now,",
        "time_begin": 461.07,
        "time_end": 461.31,
        "confidence": 0.7274705
        },
        {
        "word": "one",
        "time_begin": 461.31,
        "time_end": 461.63,
        "confidence": 0.9995435
        },
        {
        "word": "current",
        "time_begin": 461.63,
        "time_end": 461.95,
        "confidence": 0.9992262
        },
        {
        "word": "hypothesis",
        "time_begin": 461.95,
        "time_end": 462.45,
        "confidence": 0.99975914
        },
        {
        "word": "is",
        "time_begin": 462.75,
        "time_end": 462.91,
        "confidence": 0.9928063
        },
        {
        "word": "that",
        "time_begin": 462.91,
        "time_end": 463.07,
        "confidence": 0.955696
        },
        {
        "word": "a",
        "time_begin": 463.07,
        "time_end": 463.23,
        "confidence": 0.97642183
        },
        {
        "word": "region",
        "time_begin": 463.23,
        "time_end": 463.55,
        "confidence": 0.99987936
        },
        {
        "word": "of",
        "time_begin": 463.55,
        "time_end": 463.63,
        "confidence": 0.99957246
        },
        {
        "word": "this",
        "time_begin": 463.63,
        "time_end": 463.87,
        "confidence": 0.998784
        },
        {
        "word": "network",
        "time_begin": 463.87,
        "time_end": 464.19,
        "confidence": 0.99973637
        },
        {
        "word": "called",
        "time_begin": 464.19,
        "time_end": 464.43,
        "confidence": 0.61166877
        },
        {
        "word": "the",
        "time_begin": 464.43,
        "time_end": 464.51,
        "confidence": 0.99596065
        },
        {
        "word": "posterior",
        "time_begin": 464.51,
        "time_end": 465.01,
        "confidence": 0.99929905
        },
        {
        "word": "cingulate",
        "time_begin": 465.15,
        "time_end": 465.55,
        "confidence": 0.99861234
        },
        {
        "word": "cortex",
        "time_begin": 465.55,
        "time_end": 466.05,
        "confidence": 0.99962056
        },
        {
        "word": "is",
        "time_begin": 466.455,
        "time_end": 466.695,
        "confidence": 0.9997197
        },
        {
        "word": "activated",
        "time_begin": 466.695,
        "time_end": 467.175,
        "confidence": 0.99967945
        },
        {
        "word": "not",
        "time_begin": 467.175,
        "time_end": 467.415,
        "confidence": 0.7766877
        },
        {
        "word": "necessarily",
        "time_begin": 467.415,
        "time_end": 467.895,
        "confidence": 0.9986286
        },
        {
        "word": "by",
        "time_begin": 467.895,
        "time_end": 468.135,
        "confidence": 0.9997547
        },
        {
        "word": "craving",
        "time_begin": 468.135,
        "time_end": 468.455,
        "confidence": 0.9944437
        },
        {
        "word": "itself,",
        "time_begin": 468.455,
        "time_end": 468.955,
        "confidence": 0.9627348
        },
        {
        "word": "but",
        "time_begin": 469.175,
        "time_end": 469.335,
        "confidence": 0.9998871
        },
        {
        "word": "when",
        "time_begin": 469.335,
        "time_end": 469.495,
        "confidence": 0.9971878
        },
        {
        "word": "we",
        "time_begin": 469.495,
        "time_end": 469.655,
        "confidence": 0.99957365
        },
        {
        "word": "get",
        "time_begin": 469.655,
        "time_end": 469.895,
        "confidence": 0.9981325
        },
        {
        "word": "caught",
        "time_begin": 469.895,
        "time_end": 470.055,
        "confidence": 0.99990916
        },
        {
        "word": "up",
        "time_begin": 470.055,
        "time_end": 470.215,
        "confidence": 0.99875057
        },
        {
        "word": "in",
        "time_begin": 470.215,
        "time_end": 470.29498,
        "confidence": 0.9980876
        },
        {
        "word": "it,",
        "time_begin": 470.29498,
        "time_end": 470.535,
        "confidence": 0.95364743
        },
        {
        "word": "when",
        "time_begin": 470.535,
        "time_end": 470.695,
        "confidence": 0.9835175
        },
        {
        "word": "we",
        "time_begin": 470.695,
        "time_end": 470.855,
        "confidence": 0.9987546
        },
        {
        "word": "get",
        "time_begin": 470.855,
        "time_end": 471.095,
        "confidence": 0.99910235
        },
        {
        "word": "sucked",
        "time_begin": 471.095,
        "time_end": 471.335,
        "confidence": 0.99979335
        },
        {
        "word": "in",
        "time_begin": 471.335,
        "time_end": 471.57498,
        "confidence": 0.9985733
        },
        {
        "word": "and",
        "time_begin": 471.57498,
        "time_end": 471.735,
        "confidence": 0.6904779
        },
        {
        "word": "it",
        "time_begin": 471.735,
        "time_end": 471.895,
        "confidence": 0.98684675
        },
        {
        "word": "takes",
        "time_begin": 471.895,
        "time_end": 472.135,
        "confidence": 0.9998641
        },
        {
        "word": "us",
        "time_begin": 472.135,
        "time_end": 472.29498,
        "confidence": 0.99922144
        },
        {
        "word": "for",
        "time_begin": 472.29498,
        "time_end": 472.455,
        "confidence": 0.99905676
        },
        {
        "word": "a",
        "time_begin": 472.455,
        "time_end": 472.535,
        "confidence": 0.9993895
        },
        {
        "word": "ride.",
        "time_begin": 472.535,
        "time_end": 473.035,
        "confidence": 0.9984546
        }
      ],
      "language": "en",
      "transcription": "Now, one current hypothesis is that a region of this network called the posterior cingulate cortex is activated not necessarily by craving itself, but when we get caught up in it, when we get sucked in and it takes us for a ride.",
      "confidence": -1,
      "time_begin": 461.07,
      "time_end": 473.035,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "In",
        "time_begin": 473.655,
        "time_end": 473.815,
        "confidence": 0.9995721
        },
        {
        "word": "contrast,",
        "time_begin": 473.815,
        "time_end": 474.29498,
        "confidence": 0.9960964
        },
        {
        "word": "when",
        "time_begin": 474.29498,
        "time_end": 474.535,
        "confidence": 0.99974376
        },
        {
        "word": "we",
        "time_begin": 474.535,
        "time_end": 474.695,
        "confidence": 0.9999062
        },
        {
        "word": "let",
        "time_begin": 474.695,
        "time_end": 474.935,
        "confidence": 0.99958724
        },
        {
        "word": "go,",
        "time_begin": 474.935,
        "time_end": 475.435,
        "confidence": 0.96444577
        },
        {
        "word": "step",
        "time_begin": 475.735,
        "time_end": 476.055,
        "confidence": 0.9979243
        },
        {
        "word": "out",
        "time_begin": 476.055,
        "time_end": 476.215,
        "confidence": 0.99979454
        },
        {
        "word": "of",
        "time_begin": 476.215,
        "time_end": 476.375,
        "confidence": 0.99897563
        },
        {
        "word": "the",
        "time_begin": 476.375,
        "time_end": 476.535,
        "confidence": 0.9994506
        },
        {
        "word": "process",
        "time_begin": 476.535,
        "time_end": 477.035,
        "confidence": 0.9998253
        },
        {
        "word": "just",
        "time_begin": 477.095,
        "time_end": 477.335,
        "confidence": 0.8151003
        },
        {
        "word": "by",
        "time_begin": 477.335,
        "time_end": 477.57498,
        "confidence": 0.99952567
        },
        {
        "word": "being",
        "time_begin": 477.57498,
        "time_end": 477.815,
        "confidence": 0.99983096
        },
        {
        "word": "curiously",
        "time_begin": 477.815,
        "time_end": 478.29498,
        "confidence": 0.98686326
        },
        {
        "word": "aware",
        "time_begin": 478.29498,
        "time_end": 478.615,
        "confidence": 0.9997441
        },
        {
        "word": "of",
        "time_begin": 478.615,
        "time_end": 478.695,
        "confidence": 0.99934834
        },
        {
        "word": "what's",
        "time_begin": 478.695,
        "time_end": 478.935,
        "confidence": 0.9958768
        },
        {
        "word": "happening,",
        "time_begin": 478.935,
        "time_end": 479.435,
        "confidence": 0.99749875
        },
        {
        "word": "this",
        "time_begin": 479.57498,
        "time_end": 479.815,
        "confidence": 0.9367401
        },
        {
        "word": "same",
        "time_begin": 479.815,
        "time_end": 480.055,
        "confidence": 0.99835676
        },
        {
        "word": "brain",
        "time_begin": 480.055,
        "time_end": 480.29498,
        "confidence": 0.9880788
        },
        {
        "word": "region",
        "time_begin": 480.29498,
        "time_end": 480.695,
        "confidence": 0.9986964
        },
        {
        "word": "quiets",
        "time_begin": 480.695,
        "time_end": 481.175,
        "confidence": 0.99962497
        },
        {
        "word": "down.",
        "time_begin": 481.175,
        "time_end": 481.675,
        "confidence": 0.99980474
        }
      ],
      "language": "en",
      "transcription": "In contrast, when we let go, step out of the process just by being curiously aware of what's happening, this same brain region quiets down.",
      "confidence": -1,
      "time_begin": 473.655,
      "time_end": 481.675,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Now",
        "time_begin": 483.31998,
        "time_end": 483.56,
        "confidence": 0.99902344
        },
        {
        "word": "we're",
        "time_begin": 483.56,
        "time_end": 483.8,
        "confidence": 0.879869
        },
        {
        "word": "testing",
        "time_begin": 483.8,
        "time_end": 484.3,
        "confidence": 0.99994516
        },
        {
        "word": "app",
        "time_begin": 484.44,
        "time_end": 484.68,
        "confidence": 0.9992755
        },
        {
        "word": "and",
        "time_begin": 484.68,
        "time_end": 484.91998,
        "confidence": 0.9611527
        },
        {
        "word": "online",
        "time_begin": 484.91998,
        "time_end": 485.24,
        "confidence": 0.99924207
        },
        {
        "word": "based",
        "time_begin": 485.24,
        "time_end": 485.56,
        "confidence": 0.9989404
        },
        {
        "word": "mindfulness",
        "time_begin": 485.56,
        "time_end": 486.06,
        "confidence": 0.99933594
        },
        {
        "word": "training",
        "time_begin": 486.12,
        "time_end": 486.44,
        "confidence": 0.9992017
        },
        {
        "word": "programs",
        "time_begin": 486.44,
        "time_end": 486.94,
        "confidence": 0.999708
        },
        {
        "word": "that",
        "time_begin": 487.47998,
        "time_end": 487.97998,
        "confidence": 0.9940969
        },
        {
        "word": "target",
        "time_begin": 488.19998,
        "time_end": 488.68,
        "confidence": 0.99969125
        },
        {
        "word": "these",
        "time_begin": 488.68,
        "time_end": 489.08,
        "confidence": 0.9997793
        },
        {
        "word": "core",
        "time_begin": 489.08,
        "time_end": 489.47998,
        "confidence": 0.99979395
        },
        {
        "word": "mechanisms,",
        "time_begin": 489.47998,
        "time_end": 489.97998,
        "confidence": 0.74262786
        },
        {
        "word": "and",
        "time_begin": 490.52,
        "time_end": 490.84,
        "confidence": 0.99940646
        },
        {
        "word": "ironically,",
        "time_begin": 490.84,
        "time_end": 491.34,
        "confidence": 0.7917696
        },
        {
        "word": "use",
        "time_begin": 491.72,
        "time_end": 491.96,
        "confidence": 0.9813494
        },
        {
        "word": "that",
        "time_begin": 491.96,
        "time_end": 492.12,
        "confidence": 0.6271185
        },
        {
        "word": "same",
        "time_begin": 492.12,
        "time_end": 492.36,
        "confidence": 0.9995498
        },
        {
        "word": "technology",
        "time_begin": 492.36,
        "time_end": 492.86,
        "confidence": 0.99958307
        },
        {
        "word": "that's",
        "time_begin": 493,
        "time_end": 493.31998,
        "confidence": 0.9935566
        },
        {
        "word": "driving",
        "time_begin": 493.31998,
        "time_end": 493.72,
        "confidence": 0.99994314
        },
        {
        "word": "us",
        "time_begin": 493.72,
        "time_end": 493.96,
        "confidence": 0.9994228
        },
        {
        "word": "to",
        "time_begin": 493.96,
        "time_end": 494.12,
        "confidence": 0.9978483
        },
        {
        "word": "distraction",
        "time_begin": 494.12,
        "time_end": 494.62,
        "confidence": 0.99923563
        },
        {
        "word": "to",
        "time_begin": 495.115,
        "time_end": 495.275,
        "confidence": 0.9998685
        },
        {
        "word": "help",
        "time_begin": 495.275,
        "time_end": 495.435,
        "confidence": 0.9998822
        },
        {
        "word": "us",
        "time_begin": 495.435,
        "time_end": 495.675,
        "confidence": 0.99817574
        },
        {
        "word": "step",
        "time_begin": 495.675,
        "time_end": 495.995,
        "confidence": 0.99968886
        },
        {
        "word": "out",
        "time_begin": 495.995,
        "time_end": 496.235,
        "confidence": 0.9995503
        },
        {
        "word": "of",
        "time_begin": 496.235,
        "time_end": 496.395,
        "confidence": 0.9992342
        },
        {
        "word": "our",
        "time_begin": 496.395,
        "time_end": 496.63498,
        "confidence": 0.99568427
        },
        {
        "word": "unhealthy",
        "time_begin": 496.63498,
        "time_end": 497.03497,
        "confidence": 0.999691
        },
        {
        "word": "habit",
        "time_begin": 497.03497,
        "time_end": 497.35498,
        "confidence": 0.9945539
        },
        {
        "word": "patterns",
        "time_begin": 497.35498,
        "time_end": 497.75497,
        "confidence": 0.9993368
        },
        {
        "word": "of",
        "time_begin": 497.75497,
        "time_end": 497.91498,
        "confidence": 0.98499864
        },
        {
        "word": "smoking,",
        "time_begin": 497.91498,
        "time_end": 498.41498,
        "confidence": 0.99805677
        },
        {
        "word": "of",
        "time_begin": 498.47498,
        "time_end": 498.63498,
        "confidence": 0.983114
        },
        {
        "word": "stress",
        "time_begin": 498.63498,
        "time_end": 499.03497,
        "confidence": 0.99982786
        },
        {
        "word": "eating,",
        "time_begin": 499.03497,
        "time_end": 499.35498,
        "confidence": 0.7983185
        },
        {
        "word": "and",
        "time_begin": 499.35498,
        "time_end": 499.51498,
        "confidence": 0.9998166
        },
        {
        "word": "other",
        "time_begin": 499.51498,
        "time_end": 499.835,
        "confidence": 0.9998368
        },
        {
        "word": "addictive",
        "time_begin": 499.835,
        "time_end": 500.31497,
        "confidence": 0.99982256
        },
        {
        "word": "behaviors.",
        "time_begin": 500.31497,
        "time_end": 500.81497,
        "confidence": 0.98603225
        }
      ],
      "language": "en",
      "transcription": "Now we're testing app and online based mindfulness training programs that target these core mechanisms, and ironically, use that same technology that's driving us to distraction to help us step out of our unhealthy habit patterns of smoking, of stress eating, and other addictive behaviors.",
      "confidence": -1,
      "time_begin": 483.31998,
      "time_end": 500.81497,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Now",
        "time_begin": 501.595,
        "time_end": 501.835,
        "confidence": 0.9547767
        },
        {
        "word": "remember",
        "time_begin": 501.835,
        "time_end": 502.155,
        "confidence": 0.72525173
        },
        {
        "word": "that",
        "time_begin": 502.155,
        "time_end": 502.31497,
        "confidence": 0.9975182
        },
        {
        "word": "bit",
        "time_begin": 502.31497,
        "time_end": 502.47498,
        "confidence": 0.99944204
        },
        {
        "word": "about",
        "time_begin": 502.47498,
        "time_end": 502.79498,
        "confidence": 0.9990458
        },
        {
        "word": "context",
        "time_begin": 502.79498,
        "time_end": 503.115,
        "confidence": 0.99802566
        },
        {
        "word": "dependent",
        "time_begin": 503.115,
        "time_end": 503.59497,
        "confidence": 0.9977108
        },
        {
        "word": "memory?",
        "time_begin": 503.59497,
        "time_end": 504.09497,
        "confidence": 0.97591925
        }
      ],
      "language": "en",
      "transcription": "Now remember that bit about context dependent memory?",
      "confidence": -1,
      "time_begin": 501.595,
      "time_end": 504.09497,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "We",
        "time_begin": 504.155,
        "time_end": 504.31497,
        "confidence": 0.9995877
        },
        {
        "word": "can",
        "time_begin": 504.31497,
        "time_end": 504.47498,
        "confidence": 0.99992645
        },
        {
        "word": "deliver",
        "time_begin": 504.47498,
        "time_end": 504.955,
        "confidence": 0.99983025
        },
        {
        "word": "these",
        "time_begin": 504.955,
        "time_end": 505.19498,
        "confidence": 0.9996426
        },
        {
        "word": "tools",
        "time_begin": 505.19498,
        "time_end": 505.69498,
        "confidence": 0.9997099
        },
        {
        "word": "to",
        "time_begin": 505.995,
        "time_end": 506.155,
        "confidence": 0.9987109
        },
        {
        "word": "people's",
        "time_begin": 506.155,
        "time_end": 506.555,
        "confidence": 0.9905742
        },
        {
        "word": "fingertips",
        "time_begin": 506.555,
        "time_end": 507.055,
        "confidence": 0.9984357
        },
        {
        "word": "in",
        "time_begin": 507.275,
        "time_end": 507.435,
        "confidence": 0.9570376
        },
        {
        "word": "the",
        "time_begin": 507.435,
        "time_end": 507.59497,
        "confidence": 0.99912125
        },
        {
        "word": "contexts",
        "time_begin": 507.59497,
        "time_end": 508.09497,
        "confidence": 0.55898744
        },
        {
        "word": "that",
        "time_begin": 508.155,
        "time_end": 508.395,
        "confidence": 0.999156
        },
        {
        "word": "matter",
        "time_begin": 508.395,
        "time_end": 508.715,
        "confidence": 0.99773043
        },
        {
        "word": "most.",
        "time_begin": 508.715,
        "time_end": 509.215,
        "confidence": 0.7495489
        }
      ],
      "language": "en",
      "transcription": "We can deliver these tools to people's fingertips in the contexts that matter most.",
      "confidence": -1,
      "time_begin": 504.155,
      "time_end": 509.215,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "So",
        "time_begin": 509.44998,
        "time_end": 509.53,
        "confidence": 0.99952817
        },
        {
        "word": "we",
        "time_begin": 509.53,
        "time_end": 509.77,
        "confidence": 0.9984811
        },
        {
        "word": "can",
        "time_begin": 509.77,
        "time_end": 509.85,
        "confidence": 0.9995484
        },
        {
        "word": "help",
        "time_begin": 509.85,
        "time_end": 510.16998,
        "confidence": 0.99954116
        },
        {
        "word": "them",
        "time_begin": 510.16998,
        "time_end": 510.41,
        "confidence": 0.9994992
        },
        {
        "word": "tap",
        "time_begin": 510.41,
        "time_end": 510.72998,
        "confidence": 0.9996773
        },
        {
        "word": "into",
        "time_begin": 510.72998,
        "time_end": 511.05,
        "confidence": 0.98737794
        },
        {
        "word": "their",
        "time_begin": 511.05,
        "time_end": 511.44998,
        "confidence": 0.9990601
        },
        {
        "word": "inherent",
        "time_begin": 511.44998,
        "time_end": 511.85,
        "confidence": 0.99881685
        },
        {
        "word": "capacity",
        "time_begin": 511.85,
        "time_end": 512.35,
        "confidence": 0.99991536
        },
        {
        "word": "to",
        "time_begin": 512.65,
        "time_end": 512.81,
        "confidence": 0.98932964
        },
        {
        "word": "be",
        "time_begin": 512.81,
        "time_end": 512.97,
        "confidence": 0.9998468
        },
        {
        "word": "curiously",
        "time_begin": 512.97,
        "time_end": 513.45,
        "confidence": 0.9935134
        },
        {
        "word": "aware",
        "time_begin": 513.45,
        "time_end": 513.85,
        "confidence": 0.99970645
        },
        {
        "word": "right",
        "time_begin": 513.85,
        "time_end": 514.01,
        "confidence": 0.8480674
        },
        {
        "word": "when",
        "time_begin": 514.01,
        "time_end": 514.17,
        "confidence": 0.99866664
        },
        {
        "word": "that",
        "time_begin": 514.17,
        "time_end": 514.41,
        "confidence": 0.9950422
        },
        {
        "word": "urge",
        "time_begin": 514.41,
        "time_end": 514.73,
        "confidence": 0.99817693
        },
        {
        "word": "to",
        "time_begin": 514.73,
        "time_end": 514.97,
        "confidence": 0.9988538
        },
        {
        "word": "smoke",
        "time_begin": 514.97,
        "time_end": 515.29,
        "confidence": 0.99883765
        },
        {
        "word": "or",
        "time_begin": 515.29,
        "time_end": 515.52997,
        "confidence": 0.9017446
        },
        {
        "word": "stress",
        "time_begin": 515.52997,
        "time_end": 515.85,
        "confidence": 0.9998882
        },
        {
        "word": "eat",
        "time_begin": 515.85,
        "time_end": 516.08997,
        "confidence": 0.99685186
        },
        {
        "word": "or",
        "time_begin": 516.08997,
        "time_end": 516.25,
        "confidence": 0.94894195
        },
        {
        "word": "whatever",
        "time_begin": 516.25,
        "time_end": 516.73,
        "confidence": 0.99951935
        },
        {
        "word": "arises.",
        "time_begin": 516.73,
        "time_end": 517.23,
        "confidence": 0.99272966
        }
      ],
      "language": "en",
      "transcription": "So we can help them tap into their inherent capacity to be curiously aware right when that urge to smoke or stress eat or whatever arises.",
      "confidence": -1,
      "time_begin": 509.44998,
      "time_end": 517.23,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "So",
        "time_begin": 518.49,
        "time_end": 518.65,
        "confidence": 0.96004575
        },
        {
        "word": "if",
        "time_begin": 518.65,
        "time_end": 518.81,
        "confidence": 0.9919097
        },
        {
        "word": "you",
        "time_begin": 518.81,
        "time_end": 518.97,
        "confidence": 0.99916387
        },
        {
        "word": "don't",
        "time_begin": 518.97,
        "time_end": 519.21,
        "confidence": 0.9997816
        },
        {
        "word": "smoke",
        "time_begin": 519.21,
        "time_end": 519.52997,
        "confidence": 0.9995633
        },
        {
        "word": "or",
        "time_begin": 519.52997,
        "time_end": 519.69,
        "confidence": 0.9977563
        },
        {
        "word": "stress",
        "time_begin": 519.69,
        "time_end": 520.08997,
        "confidence": 0.99973255
        },
        {
        "word": "eat,",
        "time_begin": 520.08997,
        "time_end": 520.41,
        "confidence": 0.99698156
        },
        {
        "word": "maybe",
        "time_begin": 520.41,
        "time_end": 520.73,
        "confidence": 0.9993229
        },
        {
        "word": "the",
        "time_begin": 520.73,
        "time_end": 520.89,
        "confidence": 0.99392515
        },
        {
        "word": "next",
        "time_begin": 520.89,
        "time_end": 521.21,
        "confidence": 0.9994242
        },
        {
        "word": "time",
        "time_begin": 521.21,
        "time_end": 521.52997,
        "confidence": 0.99704224
        },
        {
        "word": "you",
        "time_begin": 521.52997,
        "time_end": 521.69,
        "confidence": 0.9862364
        },
        {
        "word": "feel",
        "time_begin": 521.69,
        "time_end": 521.93,
        "confidence": 0.990337
        },
        {
        "word": "this",
        "time_begin": 521.93,
        "time_end": 522.08997,
        "confidence": 0.9846874
        },
        {
        "word": "urge",
        "time_begin": 522.08997,
        "time_end": 522.33,
        "confidence": 0.9875535
        },
        {
        "word": "to",
        "time_begin": 522.33,
        "time_end": 522.465,
        "confidence": 0.79375684
        },
        {
        "word": "to",
        "time_begin": 522.54504,
        "time_end": 522.705,
        "confidence": 0.70749235
        },
        {
        "word": "check",
        "time_begin": 522.705,
        "time_end": 522.78503,
        "confidence": 0.9989152
        },
        {
        "word": "your",
        "time_begin": 522.78503,
        "time_end": 522.86505,
        "confidence": 0.9982685
        },
        {
        "word": "email",
        "time_begin": 522.86505,
        "time_end": 523.185,
        "confidence": 0.98946464
        },
        {
        "word": "when",
        "time_begin": 523.185,
        "time_end": 523.42505,
        "confidence": 0.9896225
        },
        {
        "word": "you're",
        "time_begin": 523.42505,
        "time_end": 523.505,
        "confidence": 0.99722
        },
        {
        "word": "bored",
        "time_begin": 523.505,
        "time_end": 523.74506,
        "confidence": 0.99992824
        },
        {
        "word": "or",
        "time_begin": 523.74506,
        "time_end": 523.98505,
        "confidence": 0.7085509
        },
        {
        "word": "you're",
        "time_begin": 523.98505,
        "time_end": 524.145,
        "confidence": 0.9599632
        },
        {
        "word": "trying",
        "time_begin": 524.145,
        "time_end": 524.385,
        "confidence": 0.99970394
        },
        {
        "word": "to",
        "time_begin": 524.385,
        "time_end": 524.465,
        "confidence": 0.99182945
        },
        {
        "word": "distract",
        "time_begin": 524.465,
        "time_end": 524.86505,
        "confidence": 0.99984515
        },
        {
        "word": "yourself",
        "time_begin": 524.86505,
        "time_end": 525.185,
        "confidence": 0.999511
        },
        {
        "word": "from",
        "time_begin": 525.185,
        "time_end": 525.42505,
        "confidence": 0.999037
        },
        {
        "word": "work,",
        "time_begin": 525.42505,
        "time_end": 525.92505,
        "confidence": 0.91472113
        },
        {
        "word": "or",
        "time_begin": 526.22504,
        "time_end": 526.385,
        "confidence": 0.9985336
        },
        {
        "word": "maybe",
        "time_begin": 526.385,
        "time_end": 526.705,
        "confidence": 0.9961844
        },
        {
        "word": "to",
        "time_begin": 526.705,
        "time_end": 526.86505,
        "confidence": 0.967747
        },
        {
        "word": "compulsively",
        "time_begin": 526.86505,
        "time_end": 527.36505,
        "confidence": 0.9998692
        },
        {
        "word": "respond",
        "time_begin": 527.825,
        "time_end": 528.145,
        "confidence": 0.99920255
        },
        {
        "word": "to",
        "time_begin": 528.145,
        "time_end": 528.30505,
        "confidence": 0.99899024
        },
        {
        "word": "that",
        "time_begin": 528.30505,
        "time_end": 528.54504,
        "confidence": 0.9990319
        },
        {
        "word": "text",
        "time_begin": 528.54504,
        "time_end": 528.78503,
        "confidence": 0.99945945
        },
        {
        "word": "message",
        "time_begin": 528.78503,
        "time_end": 529.10504,
        "confidence": 0.9994947
        },
        {
        "word": "when",
        "time_begin": 529.10504,
        "time_end": 529.265,
        "confidence": 0.99725646
        },
        {
        "word": "you're",
        "time_begin": 529.265,
        "time_end": 529.505,
        "confidence": 0.9982593
        },
        {
        "word": "driving,",
        "time_begin": 529.505,
        "time_end": 530.005,
        "confidence": 0.960793
        },
        {
        "word": "see",
        "time_begin": 531.025,
        "time_end": 531.265,
        "confidence": 0.9980118
        },
        {
        "word": "if",
        "time_begin": 531.265,
        "time_end": 531.42505,
        "confidence": 0.9993005
        },
        {
        "word": "you",
        "time_begin": 531.42505,
        "time_end": 531.505,
        "confidence": 0.99936837
        },
        {
        "word": "can",
        "time_begin": 531.505,
        "time_end": 531.825,
        "confidence": 0.9994874
        },
        {
        "word": "tap",
        "time_begin": 531.825,
        "time_end": 532.145,
        "confidence": 0.99985075
        },
        {
        "word": "into",
        "time_begin": 532.145,
        "time_end": 532.645,
        "confidence": 0.9966132
        },
        {
        "word": "this",
        "time_begin": 533.34503,
        "time_end": 533.74506,
        "confidence": 0.99944144
        },
        {
        "word": "natural",
        "time_begin": 533.74506,
        "time_end": 534.24506,
        "confidence": 0.99986744
        },
        {
        "word": "capacity.",
        "time_begin": 534.30505,
        "time_end": 534.80505,
        "confidence": 0.82293004
        }
      ],
      "language": "en",
      "transcription": "So if you don't smoke or stress eat, maybe the next time you feel this urge to to check your email when you're bored or you're trying to distract yourself from work, or maybe to compulsively respond to that text message when you're driving, see if you can tap into this natural capacity.",
      "confidence": -1,
      "time_begin": 518.49,
      "time_end": 534.80505,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Just",
        "time_begin": 534.945,
        "time_end": 535.185,
        "confidence": 0.99868935
        },
        {
        "word": "be",
        "time_begin": 535.185,
        "time_end": 535.44,
        "confidence": 0.99726284
        },
        {
        "word": "curiously",
        "time_begin": 535.6,
        "time_end": 535.84,
        "confidence": 0.9933502
        },
        {
        "word": "aware",
        "time_begin": 535.84,
        "time_end": 536.24,
        "confidence": 0.9999472
        },
        {
        "word": "of",
        "time_begin": 536.24,
        "time_end": 536.4,
        "confidence": 0.99984884
        },
        {
        "word": "what's",
        "time_begin": 536.4,
        "time_end": 536.64,
        "confidence": 0.99829674
        },
        {
        "word": "happening",
        "time_begin": 536.64,
        "time_end": 537.12,
        "confidence": 0.9999751
        },
        {
        "word": "in",
        "time_begin": 537.12,
        "time_end": 537.28,
        "confidence": 0.9996463
        },
        {
        "word": "your",
        "time_begin": 537.28,
        "time_end": 537.44,
        "confidence": 0.9994816
        },
        {
        "word": "body",
        "time_begin": 537.44,
        "time_end": 537.68,
        "confidence": 0.9998357
        },
        {
        "word": "and",
        "time_begin": 537.68,
        "time_end": 537.84,
        "confidence": 0.9971666
        },
        {
        "word": "mind",
        "time_begin": 537.84,
        "time_end": 538.08,
        "confidence": 0.99936694
        },
        {
        "word": "in",
        "time_begin": 538.08,
        "time_end": 538.24,
        "confidence": 0.9928658
        },
        {
        "word": "that",
        "time_begin": 538.24,
        "time_end": 538.4,
        "confidence": 0.9998462
        },
        {
        "word": "moment.",
        "time_begin": 538.4,
        "time_end": 538.9,
        "confidence": 0.9939413
        }
      ],
      "language": "en",
      "transcription": "Just be curiously aware of what's happening in your body and mind in that moment.",
      "confidence": -1,
      "time_begin": 534.945,
      "time_end": 538.9,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "It",
        "time_begin": 539.12,
        "time_end": 539.28,
        "confidence": 0.9992423
        },
        {
        "word": "will",
        "time_begin": 539.28,
        "time_end": 539.52,
        "confidence": 0.9958378
        },
        {
        "word": "just",
        "time_begin": 539.52,
        "time_end": 539.68,
        "confidence": 0.9753577
        },
        {
        "word": "be",
        "time_begin": 539.68,
        "time_end": 539.84,
        "confidence": 0.9996352
        },
        {
        "word": "another",
        "time_begin": 539.84,
        "time_end": 540.16,
        "confidence": 0.99992526
        },
        {
        "word": "chance",
        "time_begin": 540.16,
        "time_end": 540.48,
        "confidence": 0.99992895
        },
        {
        "word": "to",
        "time_begin": 540.48,
        "time_end": 540.64,
        "confidence": 0.99990094
        },
        {
        "word": "perpetuate",
        "time_begin": 540.64,
        "time_end": 541.14,
        "confidence": 0.9998294
        },
        {
        "word": "one",
        "time_begin": 541.28,
        "time_end": 541.44,
        "confidence": 0.9997799
        },
        {
        "word": "of",
        "time_begin": 541.44,
        "time_end": 541.52,
        "confidence": 0.9996556
        },
        {
        "word": "our",
        "time_begin": 541.52,
        "time_end": 541.76,
        "confidence": 0.9999399
        },
        {
        "word": "endless",
        "time_begin": 541.76,
        "time_end": 542.24,
        "confidence": 0.99966025
        },
        {
        "word": "and",
        "time_begin": 542.24,
        "time_end": 542.64,
        "confidence": 0.9994369
        },
        {
        "word": "exhaustive",
        "time_begin": 542.64,
        "time_end": 543.12,
        "confidence": 0.9942984
        },
        {
        "word": "habit",
        "time_begin": 543.12,
        "time_end": 543.44,
        "confidence": 0.99798054
        },
        {
        "word": "loops,",
        "time_begin": 543.44,
        "time_end": 543.94,
        "confidence": 0.7049726
        },
        {
        "word": "or",
        "time_begin": 544.32,
        "time_end": 544.56,
        "confidence": 0.99935824
        },
        {
        "word": "step",
        "time_begin": 544.56,
        "time_end": 544.8,
        "confidence": 0.9994973
        },
        {
        "word": "out",
        "time_begin": 544.8,
        "time_end": 544.96,
        "confidence": 0.9999267
        },
        {
        "word": "of",
        "time_begin": 544.96,
        "time_end": 545.12,
        "confidence": 0.99939513
        },
        {
        "word": "it.",
        "time_begin": 545.12,
        "time_end": 545.62,
        "confidence": 0.9892601
        }
      ],
      "language": "en",
      "transcription": "It will just be another chance to perpetuate one of our endless and exhaustive habit loops, or step out of it.",
      "confidence": -1,
      "time_begin": 539.12,
      "time_end": 545.62,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Instead",
        "time_begin": 546,
        "time_end": 546.4,
        "confidence": 0.9995814
        },
        {
        "word": "of",
        "time_begin": 546.4,
        "time_end": 546.72003,
        "confidence": 0.9975547
        },
        {
        "word": "see",
        "time_begin": 546.72003,
        "time_end": 546.88,
        "confidence": 0.9583337
        },
        {
        "word": "text",
        "time_begin": 546.88,
        "time_end": 547.2,
        "confidence": 0.997827
        },
        {
        "word": "message,",
        "time_begin": 547.2,
        "time_end": 547.6,
        "confidence": 0.89487386
        },
        {
        "word": "compulsively",
        "time_begin": 547.6,
        "time_end": 548.1,
        "confidence": 0.9997978
        },
        {
        "word": "text",
        "time_begin": 548.24,
        "time_end": 548.56,
        "confidence": 0.9982168
        },
        {
        "word": "back,",
        "time_begin": 548.56,
        "time_end": 548.96,
        "confidence": 0.92491674
        },
        {
        "word": "feel",
        "time_begin": 548.96,
        "time_end": 549.2,
        "confidence": 0.84879166
        },
        {
        "word": "a",
        "time_begin": 549.2,
        "time_end": 549.36,
        "confidence": 0.9973895
        },
        {
        "word": "little",
        "time_begin": 549.36,
        "time_end": 549.6,
        "confidence": 0.9980282
        },
        {
        "word": "bit",
        "time_begin": 549.6,
        "time_end": 549.76,
        "confidence": 0.9939215
        },
        {
        "word": "better,",
        "time_begin": 549.76,
        "time_end": 550.26,
        "confidence": 0.9814137
        },
        {
        "word": "notice",
        "time_begin": 550.755,
        "time_end": 551.075,
        "confidence": 0.9996669
        },
        {
        "word": "the",
        "time_begin": 551.075,
        "time_end": 551.315,
        "confidence": 0.9998524
        },
        {
        "word": "urge,",
        "time_begin": 551.315,
        "time_end": 551.815,
        "confidence": 0.99893963
        },
        {
        "word": "get",
        "time_begin": 552.195,
        "time_end": 552.515,
        "confidence": 0.9999511
        },
        {
        "word": "curious,",
        "time_begin": 552.515,
        "time_end": 553.015,
        "confidence": 0.9997215
        },
        {
        "word": "feel",
        "time_begin": 553.635,
        "time_end": 553.875,
        "confidence": 0.99979097
        },
        {
        "word": "the",
        "time_begin": 553.875,
        "time_end": 554.03503,
        "confidence": 0.9998111
        },
        {
        "word": "joy",
        "time_begin": 554.03503,
        "time_end": 554.275,
        "confidence": 0.9999089
        },
        {
        "word": "of",
        "time_begin": 554.275,
        "time_end": 554.435,
        "confidence": 0.99954283
        },
        {
        "word": "letting",
        "time_begin": 554.435,
        "time_end": 554.755,
        "confidence": 0.99987614
        },
        {
        "word": "go,",
        "time_begin": 554.755,
        "time_end": 555.255,
        "confidence": 0.942549
        },
        {
        "word": "and",
        "time_begin": 555.55505,
        "time_end": 555.875,
        "confidence": 0.999728
        },
        {
        "word": "repeat.",
        "time_begin": 555.875,
        "time_end": 556.375,
        "confidence": 0.9987671
        }
      ],
      "language": "en",
      "transcription": "Instead of see text message, compulsively text back, feel a little bit better, notice the urge, get curious, feel the joy of letting go, and repeat.",
      "confidence": -1,
      "time_begin": 546,
      "time_end": 556.375,
      "speaker": "",
      "channel": ""
      },
      {
      "words": [
        {
        "word": "Thank",
        "time_begin": 557.395,
        "time_end": 557.715,
        "confidence": 0.99850607
        },
        {
        "word": "you.",
        "time_begin": 557.715,
        "time_end": 558.215,
        "confidence": 0.9993899
        }
      ],
      "language": "en",
      "transcription": "Thank you.",
      "confidence": -1,
      "time_begin": 557.395,
      "time_end": 558.215,
      "speaker": "",
      "channel": ""
      }
    ]
    },
    "shorts": [
    {
      "id": 0,
      "title": "The Struggle of Meditation",
      "reason": "This short explores the difficulties of meditation and the tendency of our minds to wander, making it relatable and thought-provoking for viewers who have tried meditation or are interested in mindfulness.",
      "startId": 0,
      "endId": 6,
      "startTime": 0,
      "endTime": 70,
      "text": "When I was first learning to meditate, the instruction was to simply pay attention to my breath, and when my mind wandered, to bring it back. Sounded simple enough. Yet I'd sit on these silent retreats, sweating through T shirts in the middle of winter. I'd take naps every chance I got because it was really hard work. Actually, it was exhausting. The instruction was simple enough, but I was missing something really important. So why is it so hard to pay attention?",
      "cropFileUrl": "https://remotionlambda-useast1-5c5vrxj4r3.s3.amazonaws.com/media/files/cm47iam320003959wyvlb08np/1757681464830/A_Simple_Way_to_Break_a_Bad_Habit__Judson_Brewer__TED.mp4",
      "cropFilekey": "media/cmder2g1k0003u3nw1bzhg65l--moW9jvvMr4-0-.mp4",
      "asd":{"status": "completed", "success": true, "segment_id": "segment_1", "timestamp": "", "result": {"detection_results": [{"frame_number": 0, "faces": []}, {"frame_number": 1, "faces": []}, {"frame_number": 2, "faces": []}, {"frame_number": 3, "faces": []}, {"frame_number": 4, "faces": []}, {"frame_number": 5, "faces": []}, {"frame_number": 6, "faces": []}, {"frame_number": 7, "faces": []}, {"frame_number": 8, "faces": []}, {"frame_number": 9, "faces": []}, {"frame_number": 10, "faces": []}, {"frame_number": 11, "faces": []}, {"frame_number": 12, "faces": []}, {"frame_number": 13, "faces": []}, {"frame_number": 14, "faces": []}, {"frame_number": 15, "faces": []}, {"frame_number": 16, "faces": []}, {"frame_number": 17, "faces": []}, {"frame_number": 18, "faces": []}, {"frame_number": 19, "faces": []}, {"frame_number": 20, "faces": []}, {"frame_number": 21, "faces": []}, {"frame_number": 22, "faces": []}, {"frame_number": 23, "faces": []}, {"frame_number": 24, "faces": []}, {"frame_number": 25, "faces": []}, {"frame_number": 26, "faces": []}, {"frame_number": 27, "faces": []}, {"frame_number": 28, "faces": []}, {"frame_number": 29, "faces": []}, {"frame_number": 30, "faces": []}, {"frame_number": 31, "faces": []}, {"frame_number": 32, "faces": []}, {"frame_number": 33, "faces": []}, {"frame_number": 34, "faces": []}, {"frame_number": 35, "faces": []}, {"frame_number": 36, "faces": []}, {"frame_number": 37, "faces": []}, {"frame_number": 38, "faces": []}, {"frame_number": 39, "faces": []}, {"frame_number": 40, "faces": []}, {"frame_number": 41, "faces": []}, {"frame_number": 42, "faces": []}, {"frame_number": 43, "faces": []}, {"frame_number": 44, "faces": []}, {"frame_number": 45, "faces": []}, {"frame_number": 46, "faces": []}, {"frame_number": 47, "faces": []}, {"frame_number": 48, "faces": []}, {"frame_number": 49, "faces": []}, {"frame_number": 50, "faces": []}, {"frame_number": 51, "faces": []}, {"frame_number": 52, "faces": []}, {"frame_number": 53, "faces": []}, {"frame_number": 54, "faces": []}, {"frame_number": 55, "faces": []}, {"frame_number": 56, "faces": []}, {"frame_number": 57, "faces": []}, {"frame_number": 58, "faces": []}, {"frame_number": 59, "faces": []}, {"frame_number": 60, "faces": []}, {"frame_number": 61, "faces": []}, {"frame_number": 62, "faces": []}, {"frame_number": 63, "faces": []}, {"frame_number": 64, "faces": []}, {"frame_number": 65, "faces": []}, {"frame_number": 66, "faces": []}, {"frame_number": 67, "faces": []}, {"frame_number": 68, "faces": []}, {"frame_number": 69, "faces": []}, {"frame_number": 70, "faces": []}, {"frame_number": 71, "faces": []}, {"frame_number": 72, "faces": []}, {"frame_number": 73, "faces": []}, {"frame_number": 74, "faces": []}, {"frame_number": 75, "faces": []}, {"frame_number": 76, "faces": []}, {"frame_number": 77, "faces": []}, {"frame_number": 78, "faces": []}, {"frame_number": 79, "faces": []}, {"frame_number": 80, "faces": []}, {"frame_number": 81, "faces": []}, {"frame_number": 82, "faces": []}, {"frame_number": 83, "faces": []}, {"frame_number": 84, "faces": []}, {"frame_number": 85, "faces": []}, {"frame_number": 86, "faces": []}, {"frame_number": 87, "faces": []}, {"frame_number": 88, "faces": []}, {"frame_number": 89, "faces": []}, {"frame_number": 90, "faces": []}, {"frame_number": 91, "faces": []}, {"frame_number": 92, "faces": []}, {"frame_number": 93, "faces": []}, {"frame_number": 94, "faces": []}, {"frame_number": 95, "faces": []}, {"frame_number": 96, "faces": []}, {"frame_number": 97, "faces": []}, {"frame_number": 98, "faces": []}, {"frame_number": 99, "faces": []}, {"frame_number": 100, "faces": []}, {"frame_number": 101, "faces": []}, {"frame_number": 102, "faces": []}, {"frame_number": 103, "faces": []}, {"frame_number": 104, "faces": []}, {"frame_number": 105, "faces": []}, {"frame_number": 106, "faces": []}, {"frame_number": 107, "faces": []}, {"frame_number": 108, "faces": []}, {"frame_number": 109, "faces": []}, {"frame_number": 110, "faces": []}, {"frame_number": 111, "faces": []}, {"frame_number": 112, "faces": []}, {"frame_number": 113, "faces": []}, {"frame_number": 114, "faces": []}, {"frame_number": 115, "faces": []}, {"frame_number": 116, "faces": []}, {"frame_number": 117, "faces": []}, {"frame_number": 118, "faces": []}, {"frame_number": 119, "faces": []}, {"frame_number": 120, "faces": []}, {"frame_number": 121, "faces": []}, {"frame_number": 122, "faces": []}, {"frame_number": 123, "faces": []}, {"frame_number": 124, "faces": []}, {"frame_number": 125, "faces": []}, {"frame_number": 126, "faces": []}, {"frame_number": 127, "faces": []}, {"frame_number": 128, "faces": []}, {"frame_number": 129, "faces": []}, {"frame_number": 130, "faces": []}, {"frame_number": 131, "faces": []}, {"frame_number": 132, "faces": []}, {"frame_number": 133, "faces": []}, {"frame_number": 134, "faces": []}, {"frame_number": 135, "faces": []}, {"frame_number": 136, "faces": []}, {"frame_number": 137, "faces": []}, {"frame_number": 138, "faces": []}, {"frame_number": 139, "faces": []}, {"frame_number": 140, "faces": []}, {"frame_number": 141, "faces": []}, {"frame_number": 142, "faces": []}, {"frame_number": 143, "faces": []}, {"frame_number": 144, "faces": []}, {"frame_number": 145, "faces": []}, {"frame_number": 146, "faces": []}, {"frame_number": 146, "faces": []}, {"frame_number": 147, "faces": []}, {"frame_number": 148, "faces": []}, {"frame_number": 149, "faces": []}, {"frame_number": 150, "faces": []}, {"frame_number": 151, "faces": []}, {"frame_number": 152, "faces": []}, {"frame_number": 153, "faces": []}, {"frame_number": 154, "faces": []}, {"frame_number": 155, "faces": []}, {"frame_number": 156, "faces": []}, {"frame_number": 157, "faces": []}, {"frame_number": 158, "faces": []}, {"frame_number": 159, "faces": []}, {"frame_number": 160, "faces": []}, {"frame_number": 161, "faces": []}, {"frame_number": 162, "faces": []}, {"frame_number": 163, "faces": []}, {"frame_number": 164, "faces": []}, {"frame_number": 165, "faces": []}, {"frame_number": 166, "faces": []}, {"frame_number": 167, "faces": []}, {"frame_number": 168, "faces": []}, {"frame_number": 169, "faces": []}, {"frame_number": 170, "faces": []}, {"frame_number": 171, "faces": []}, {"frame_number": 172, "faces": []}, {"frame_number": 173, "faces": []}, {"frame_number": 174, "faces": []}, {"frame_number": 175, "faces": []}, {"frame_number": 176, "faces": []}, {"frame_number": 177, "faces": []}, {"frame_number": 178, "faces": []}, {"frame_number": 179, "faces": []}, {"frame_number": 180, "faces": []}, {"frame_number": 181, "faces": []}, {"frame_number": 182, "faces": []}, {"frame_number": 183, "faces": []}, {"frame_number": 184, "faces": []}, {"frame_number": 185, "faces": []}, {"frame_number": 186, "faces": []}, {"frame_number": 187, "faces": []}, {"frame_number": 188, "faces": []}, {"frame_number": 189, "faces": []}, {"frame_number": 190, "faces": []}, {"frame_number": 191, "faces": []}, {"frame_number": 192, "faces": []}, {"frame_number": 193, "faces": []}, {"frame_number": 194, "faces": []}, {"frame_number": 195, "faces": []}, {"frame_number": 196, "faces": []}, {"frame_number": 197, "faces": []}, {"frame_number": 198, "faces": []}, {"frame_number": 199, "faces": []}, {"frame_number": 200, "faces": []}, {"frame_number": 201, "faces": []}, {"frame_number": 202, "faces": []}, {"frame_number": 203, "faces": []}, {"frame_number": 204, "faces": []}, {"frame_number": 205, "faces": []}, {"frame_number": 206, "faces": []}, {"frame_number": 207, "faces": []}, {"frame_number": 208, "faces": []}, {"frame_number": 209, "faces": []}, {"frame_number": 210, "faces": []}, {"frame_number": 211, "faces": []}, {"frame_number": 212, "faces": []}, {"frame_number": 213, "faces": []}, {"frame_number": 214, "faces": []}, {"frame_number": 215, "faces": []}, {"frame_number": 216, "faces": []}, {"frame_number": 217, "faces": []}, {"frame_number": 218, "faces": []}, {"frame_number": 219, "faces": []}, {"frame_number": 220, "faces": []}, {"frame_number": 221, "faces": []}, {"frame_number": 222, "faces": []}, {"frame_number": 223, "faces": []}, {"frame_number": 224, "faces": []}, {"frame_number": 225, "faces": []}, {"frame_number": 226, "faces": []}, {"frame_number": 227, "faces": []}, {"frame_number": 228, "faces": []}, {"frame_number": 229, "faces": []}, {"frame_number": 230, "faces": []}, {"frame_number": 231, "faces": []}, {"frame_number": 232, "faces": []}, {"frame_number": 233, "faces": []}, {"frame_number": 234, "faces": []}, {"frame_number": 235, "faces": []}, {"frame_number": 236, "faces": []}, {"frame_number": 237, "faces": []}, {"frame_number": 238, "faces": []}, {"frame_number": 239, "faces": []}, {"frame_number": 240, "faces": []}, {"frame_number": 241, "faces": []}, {"frame_number": 242, "faces": []}, {"frame_number": 243, "faces": []}, {"frame_number": 244, "faces": []}, {"frame_number": 245, "faces": []}, {"frame_number": 246, "faces": []}, {"frame_number": 247, "faces": []}, {"frame_number": 248, "faces": []}, {"frame_number": 249, "faces": []}, {"frame_number": 250, "faces": []}, {"frame_number": 251, "faces": []}, {"frame_number": 252, "faces": []}, {"frame_number": 253, "faces": []}, {"frame_number": 254, "faces": []}, {"frame_number": 255, "faces": []}, {"frame_number": 256, "faces": []}, {"frame_number": 257, "faces": []}, {"frame_number": 258, "faces": []}, {"frame_number": 259, "faces": []}, {"frame_number": 260, "faces": []}, {"frame_number": 261, "faces": []}, {"frame_number": 262, "faces": []}, {"frame_number": 263, "faces": []}, {"frame_number": 264, "faces": []}, {"frame_number": 265, "faces": []}, {"frame_number": 266, "faces": []}, {"frame_number": 267, "faces": []}, {"frame_number": 268, "faces": []}, {"frame_number": 269, "faces": []}, {"frame_number": 270, "faces": []}, {"frame_number": 271, "faces": []}, {"frame_number": 272, "faces": []}, {"frame_number": 273, "faces": []}, {"frame_number": 274, "faces": []}, {"frame_number": 275, "faces": []}, {"frame_number": 276, "faces": []}, {"frame_number": 277, "faces": []}, {"frame_number": 278, "faces": []}, {"frame_number": 279, "faces": []}, {"frame_number": 280, "faces": []}, {"frame_number": 281, "faces": []}, {"frame_number": 282, "faces": []}, {"frame_number": 283, "faces": []}, {"frame_number": 284, "faces": []}, {"frame_number": 285, "faces": []}, {"frame_number": 286, "faces": []}, {"frame_number": 287, "faces": []}, {"frame_number": 288, "faces": []}, {"frame_number": 289, "faces": []}, {"frame_number": 290, "faces": []}, {"frame_number": 291, "faces": []}, {"frame_number": 292, "faces": []}, {"frame_number": 293, "faces": []}, {"frame_number": 294, "faces": []}, {"frame_number": 295, "faces": []}, {"frame_number": 296, "faces": []}, {"frame_number": 297, "faces": []}, {"frame_number": 298, "faces": []}, {"frame_number": 299, "faces": []}, {"frame_number": 300, "faces": []}, {"frame_number": 301, "faces": []}, {"frame_number": 302, "faces": []}, {"frame_number": 303, "faces": []}, {"frame_number": 304, "faces": []}, {"frame_number": 305, "faces": []}, {"frame_number": 306, "faces": []}, {"frame_number": 307, "faces": []}, {"frame_number": 308, "faces": []}, {"frame_number": 309, "faces": []}, {"frame_number": 310, "faces": []}, {"frame_number": 311, "faces": []}, {"frame_number": 312, "faces": []}, {"frame_number": 313, "faces": []}, {"frame_number": 314, "faces": []}, {"frame_number": 315, "faces": []}, {"frame_number": 316, "faces": []}, {"frame_number": 317, "faces": []}, {"frame_number": 318, "faces": []}, {"frame_number": 319, "faces": []}, {"frame_number": 320, "faces": []}, {"frame_number": 321, "faces": []}, {"frame_number": 322, "faces": []}, {"frame_number": 323, "faces": []}, {"frame_number": 324, "faces": []}, {"frame_number": 325, "faces": []}, {"frame_number": 326, "faces": []}, {"frame_number": 327, "faces": []}, {"frame_number": 328, "faces": []}, {"frame_number": 329, "faces": []}, {"frame_number": 330, "faces": []}, {"frame_number": 331, "faces": []}, {"frame_number": 332, "faces": []}, {"frame_number": 333, "faces": []}, {"frame_number": 334, "faces": []}, {"frame_number": 335, "faces": []}, {"frame_number": 336, "faces": []}, {"frame_number": 337, "faces": []}, {"frame_number": 338, "faces": []}, {"frame_number": 339, "faces": []}, {"frame_number": 340, "faces": []}, {"frame_number": 341, "faces": []}, {"frame_number": 342, "faces": []}, {"frame_number": 343, "faces": []}, {"frame_number": 344, "faces": []}, {"frame_number": 345, "faces": []}, {"frame_number": 346, "faces": []}, {"frame_number": 347, "faces": []}, {"frame_number": 348, "faces": []}, {"frame_number": 349, "faces": []}, {"frame_number": 350, "faces": []}, {"frame_number": 351, "faces": []}, {"frame_number": 352, "faces": []}, {"frame_number": 353, "faces": []}, {"frame_number": 354, "faces": []}, {"frame_number": 355, "faces": []}, {"frame_number": 356, "faces": []}, {"frame_number": 357, "faces": []}, {"frame_number": 358, "faces": []}, {"frame_number": 359, "faces": []}, {"frame_number": 360, "faces": []}, {"frame_number": 361, "faces": []}, {"frame_number": 362, "faces": []}, {"frame_number": 363, "faces": []}, {"frame_number": 364, "faces": []}, {"frame_number": 365, "faces": []}, {"frame_number": 366, "faces": []}, {"frame_number": 367, "faces": []}, {"frame_number": 368, "faces": []}, {"frame_number": 369, "faces": []}, {"frame_number": 370, "faces": []}, {"frame_number": 371, "faces": []}, {"frame_number": 372, "faces": []}, {"frame_number": 373, "faces": []}, {"frame_number": 374, "faces": []}, {"frame_number": 375, "faces": []}, {"frame_number": 376, "faces": []}, {"frame_number": 377, "faces": []}, {"frame_number": 378, "faces": []}, {"frame_number": 379, "faces": []}, {"frame_number": 380, "faces": []}, {"frame_number": 381, "faces": []}, {"frame_number": 381, "faces": [{"x1": 711, "y1": 190, "x2": 760, "y2": 239, "speaking_score": 0.600000003973643, "active": true, "track_id": 0}]}, {"frame_number": 382, "faces": [{"x1": 711, "y1": 190, "x2": 760, "y2": 239, "speaking_score": 0.7000000029802322, "active": true, "track_id": 0}]}, {"frame_number": 383, "faces": [{"x1": 710, "y1": 190, "x2": 760, "y2": 239, "speaking_score": 0.7399999976158143, "active": true, "track_id": 0}]}, {"frame_number": 384, "faces": [{"x1": 710, "y1": 190, "x2": 760, "y2": 240, "speaking_score": 0.8000000019868215, "active": true, "track_id": 0}]}, {"frame_number": 385, "faces": [{"x1": 710, "y1": 190, "x2": 760, "y2": 240, "speaking_score": 0.9000000059604645, "active": true, "track_id": 0}]}, {"frame_number": 386, "faces": [{"x1": 710, "y1": 190, "x2": 760, "y2": 240, "speaking_score": 0.9000000059604645, "active": true, "track_id": 0}]}, {"frame_number": 387, "faces": [{"x1": 710, "y1": 190, "x2": 760, "y2": 240, "speaking_score": 1.0500000019868214, "active": true, "track_id": 0}]}, {"frame_number": 388, "faces": [{"x1": 710, "y1": 191, "x2": 760, "y2": 241, "speaking_score": 1.1333333253860474, "active": true, "track_id": 0}]}, {"frame_number": 389, "faces": [{"x1": 707, "y1": 191, "x2": 758, "y2": 241, "speaking_score": 1.1833333174387615, "active": true, "track_id": 0}]}, {"frame_number": 390, "faces": [{"x1": 706, "y1": 191, "x2": 757, "y2": 241, "speaking_score": 1.2333333293596904, "active": true, "track_id": 0}]}, {"frame_number": 391, "faces": [{"x1": 706, "y1": 192, "x2": 756, "y2": 242, "speaking_score": 1.2333333293596904, "active": true, "track_id": 0}]}, {"frame_number": 392, "faces": [{"x1": 705, "y1": 192, "x2": 756, "y2": 242, "speaking_score": 1.25, "active": true, "track_id": 0}]}, {"frame_number": 393, "faces": [{"x1": 705, "y1": 192, "x2": 756, "y2": 242, "speaking_score": 1.25, "active": true, "track_id": 0}]}, {"frame_number": 394, "faces": [{"x1": 704, "y1": 192, "x2": 755, "y2": 242, "speaking_score": 1.1833333373069763, "active": true, "track_id": 0}]}, {"frame_number": 395, "faces": [{"x1": 702, "y1": 191, "x2": 753, "y2": 243, "speaking_score": 1.1166666746139526, "active": true, "track_id": 0}]}, {"frame_number": 396, "faces": [{"x1": 701, "y1": 191, "x2": 752, "y2": 243, "speaking_score": 1.0166666805744171, "active": true, "track_id": 0}]}, {"frame_number": 397, "faces": [{"x1": 700, "y1": 191, "x2": 752, "y2": 243, "speaking_score": 0.9333333373069763, "active": true, "track_id": 0}]}, {"frame_number": 398, "faces": [{"x1": 699, "y1": 191, "x2": 751, "y2": 243, "speaking_score": 0.8666666646798452, "active": true, "track_id": 0}]}, {"frame_number": 399, "faces": [{"x1": 699, "y1": 191, "x2": 751, "y2": 243, "speaking_score": 0.8666666646798452, "active": true, "track_id": 0}]}, {"frame_number": 400, "faces": [{"x1": 699, "y1": 191, "x2": 750, "y2": 243, "speaking_score": 0.8166666527589163, "active": true, "track_id": 0}]}, {"frame_number": 401, "faces": [{"x1": 697, "y1": 191, "x2": 748, "y2": 242, "speaking_score": 0.8499999940395355, "active": true, "track_id": 0}]}, {"frame_number": 402, "faces": [{"x1": 697, "y1": 191, "x2": 748, "y2": 242, "speaking_score": 0.9166666567325592, "active": true, "track_id": 0}]}, {"frame_number": 403, "faces": [{"x1": 696, "y1": 191, "x2": 748, "y2": 242, "speaking_score": 1.0166666507720947, "active": true, "track_id": 0}]}, {"frame_number": 404, "faces": [{"x1": 696, "y1": 191, "x2": 747, "y2": 242, "speaking_score": 1.1333333154519398, "active": true, "track_id": 0}]}, {"frame_number": 405, "faces": [{"x1": 696, "y1": 191, "x2": 747, "y2": 242, "speaking_score": 1.1333333154519398, "active": true, "track_id": 0}]}, {"frame_number": 406, "faces": [{"x1": 696, "y1": 191, "x2": 747, "y2": 242, "speaking_score": 1.2333333094914753, "active": true, "track_id": 0}]}, {"frame_number": 407, "faces": [{"x1": 694, "y1": 191, "x2": 746, "y2": 242, "speaking_score": 1.3666666547457378, "active": true, "track_id": 0}]}, {"frame_number": 408, "faces": [{"x1": 694, "y1": 191, "x2": 745, "y2": 242, "speaking_score": 1.5166666309038799, "active": true, "track_id": 0}]}, {"frame_number": 409, "faces": [{"x1": 693, "y1": 191, "x2": 745, "y2": 242, "speaking_score": 1.6499999562899272, "active": true, "track_id": 0}]}, {"frame_number": 410, "faces": [{"x1": 693, "y1": 191, "x2": 745, "y2": 242, "speaking_score": 1.7833332816759746, "active": true, "track_id": 0}]}, {"frame_number": 411, "faces": [{"x1": 693, "y1": 191, "x2": 745, "y2": 242, "speaking_score": 1.7833332816759746, "active": true, "track_id": 0}]}, {"frame_number": 412, "faces": [{"x1": 693, "y1": 190, "x2": 745, "y2": 242, "speaking_score": 1.9166666269302368, "active": true, "track_id": 0}]}, {"frame_number": 413, "faces": [{"x1": 693, "y1": 191, "x2": 745, "y2": 242, "speaking_score": 2.116666634877523, "active": true, "track_id": 0}]}, {"frame_number": 414, "faces": [{"x1": 693, "y1": 191, "x2": 745, "y2": 242, "speaking_score": 2.2833333015441895, "active": true, "track_id": 0}]}, {"frame_number": 415, "faces": [{"x1": 693, "y1": 191, "x2": 744, "y2": 242, "speaking_score": 2.4166666666666665, "active": true, "track_id": 0}]}, {"frame_number": 416, "faces": [{"x1": 693, "y1": 191, "x2": 744, "y2": 242, "speaking_score": 2.5833333333333335, "active": true, "track_id": 0}]}, {"frame_number": 417, "faces": [{"x1": 693, "y1": 191, "x2": 744, "y2": 242, "speaking_score": 2.5833333333333335, "active": true, "track_id": 0}]}, {"frame_number": 418, "faces": [{"x1": 693, "y1": 191, "x2": 744, "y2": 242, "speaking_score": 2.75, "active": true, "track_id": 0}]}, {"frame_number": 419, "faces": [{"x1": 693, "y1": 191, "x2": 744, "y2": 242, "speaking_score": 2.8666666746139526, "active": true, "track_id": 0}]}, {"frame_number": 420, "faces": [{"x1": 693, "y1": 191, "x2": 744, "y2": 242, "speaking_score": 2.950000007947286, "active": true, "track_id": 0}]}, {"frame_number": 421, "faces": [{"x1": 694, "y1": 192, "x2": 743, "y2": 241, "speaking_score": 3.0, "active": true, "track_id": 0}]}, {"frame_number": 422, "faces": [{"x1": 694, "y1": 192, "x2": 743, "y2": 241, "speaking_score": 3.0166666507720947, "active": true, "track_id": 0}]}, {"frame_number": 423, "faces": [{"x1": 694, "y1": 192, "x2": 743, "y2": 241, "speaking_score": 3.0166666507720947, "active": true, "track_id": 0}]}, {"frame_number": 424, "faces": [{"x1": 694, "y1": 192, "x2": 743, "y2": 241, "speaking_score": 3.0, "active": true, "track_id": 0}]}, {"frame_number": 425, "faces": [{"x1": 694, "y1": 192, "x2": 743, "y2": 241, "speaking_score": 2.950000007947286, "active": true, "track_id": 0}]}, {"frame_number": 426, "faces": [{"x1": 693, "y1": 192, "x2": 743, "y2": 241, "speaking_score": 2.950000007947286, "active": true, "track_id": 0}]}, {"frame_number": 427, "faces": [{"x1": 693, "y1": 192, "x2": 743, "y2": 241, "speaking_score": 2.900000015894572, "active": true, "track_id": 0}]}, {"frame_number": 428, "faces": [{"x1": 693, "y1": 192, "x2": 743, "y2": 241, "speaking_score": 2.7666666905085244, "active": true, "track_id": 0}]}, {"frame_number": 429, "faces": [{"x1": 693, "y1": 192, "x2": 743, "y2": 241, "speaking_score": 2.7666666905085244, "active": true, "track_id": 0}]}, {"frame_number": 430, "faces": [{"x1": 693, "y1": 192, "x2": 743, "y2": 242, "speaking_score": 2.600000023841858, "active": true, "track_id": 0}]}, {"frame_number": 431, "faces": [{"x1": 694, "y1": 192, "x2": 743, "y2": 242, "speaking_score": 2.400000015894572, "active": true, "track_id": 0}]}, {"frame_number": 432, "faces": [{"x1": 694, "y1": 192, "x2": 743, "y2": 242, "speaking_score": 2.2166666984558105, "active": true, "track_id": 0}]}, {"frame_number": 433, "faces": [{"x1": 694, "y1": 193, "x2": 743, "y2": 242, "speaking_score": 2.000000019868215, "active": true, "track_id": 0}]}, {"frame_number": 434, "faces": [{"x1": 694, "y1": 193, "x2": 743, "y2": 242, "speaking_score": 1.8333333532015483, "active": true, "track_id": 0}]}, {"frame_number": 435, "faces": [{"x1": 694, "y1": 193, "x2": 743, "y2": 242, "speaking_score": 1.8333333532015483, "active": true, "track_id": 0}]}, {"frame_number": 436, "faces": [{"x1": 694, "y1": 193, "x2": 743, "y2": 242, "speaking_score": 1.7333333492279053, "active": true, "track_id": 0}]}, {"frame_number": 437, "faces": [{"x1": 694, "y1": 193, "x2": 743, "y2": 242, "speaking_score": 1.7333333492279053, "active": true, "track_id": 0}]}, {"frame_number": 438, "faces": [{"x1": 694, "y1": 193, "x2": 743, "y2": 242, "speaking_score": 1.8333333730697632, "active": true, "track_id": 0}]}, {"frame_number": 439, "faces": [{"x1": 694, "y1": 193, "x2": 743, "y2": 242, "speaking_score": 1.9833333492279053, "active": true, "track_id": 0}]}, {"frame_number": 440, "faces": [{"x1": 694, "y1": 193, "x2": 743, "y2": 242, "speaking_score": 2.2166666785875955, "active": true, "track_id": 0}]}, {"frame_number": 441, "faces": [{"x1": 694, "y1": 193, "x2": 743, "y2": 242, "speaking_score": 2.3833333452542624, "active": true, "track_id": 0}]}, {"frame_number": 442, "faces": [{"x1": 694, "y1": 193, "x2": 743, "y2": 242, "speaking_score": 2.3833333452542624, "active": true, "track_id": 0}]}, {"frame_number": 443, "faces": [{"x1": 694, "y1": 193, "x2": 743, "y2": 242, "speaking_score": 2.5, "active": true, "track_id": 0}]}, {"frame_number": 444, "faces": [{"x1": 694, "y1": 193, "x2": 743, "y2": 242, "speaking_score": 2.549999992052714, "active": true, "track_id": 0}]}, {"frame_number": 445, "faces": [{"x1": 694, "y1": 193, "x2": 743, "y2": 242, "speaking_score": 2.4999999602635703, "active": true, "track_id": 0}]}, {"frame_number": 446, "faces": [{"x1": 694, "y1": 193, "x2": 743, "y2": 242, "speaking_score": 2.399999976158142, "active": true, "track_id": 0}]}, {"frame_number": 447, "faces": [{"x1": 694, "y1": 193, "x2": 743, "y2": 242, "speaking_score": 2.199999968210856, "active": true, "track_id": 0}]}, {"frame_number": 448, "faces": [{"x1": 694, "y1": 193, "x2": 743, "y2": 242, "speaking_score": 2.199999968210856, "active": true, "track_id": 0}]}, {"frame_number": 449, "faces": [{"x1": 694, "y1": 193, "x2": 743, "y2": 242, "speaking_score": 1.9833332896232605, "active": true, "track_id": 0}]}, {"frame_number": 450, "faces": [{"x1": 694, "y1": 193, "x2": 742, "y2": 242, "speaking_score": 1.8333332935969036, "active": true, "track_id": 0}]}, {"frame_number": 451, "faces": [{"x1": 693, "y1": 193, "x2": 742, "y2": 242, "speaking_score": 1.6999999682108562, "active": true, "track_id": 0}]}, {"frame_number": 452, "faces": [{"x1": 693, "y1": 193, "x2": 742, "y2": 242, "speaking_score": 1.6333333253860474, "active": true, "track_id": 0}]}, {"frame_number": 453, "faces": [{"x1": 693, "y1": 193, "x2": 742, "y2": 242, "speaking_score": 1.5833333333333333, "active": true, "track_id": 0}]}, {"frame_number": 454, "faces": [{"x1": 693, "y1": 193, "x2": 742, "y2": 242, "speaking_score": 1.5833333333333333, "active": true, "track_id": 0}]}, {"frame_number": 455, "faces": [{"x1": 693, "y1": 193, "x2": 742, "y2": 242, "speaking_score": 1.550000011920929, "active": true, "track_id": 0}]}, {"frame_number": 456, "faces": [{"x1": 693, "y1": 193, "x2": 742, "y2": 242, "speaking_score": 1.5833333532015483, "active": true, "track_id": 0}]}, {"frame_number": 457, "faces": [{"x1": 693, "y1": 194, "x2": 742, "y2": 242, "speaking_score": 1.6666666865348816, "active": true, "track_id": 0}]}, {"frame_number": 458, "faces": [{"x1": 693, "y1": 194, "x2": 742, "y2": 242, "speaking_score": 1.7166666785875957, "active": true, "track_id": 0}]}, {"frame_number": 459, "faces": [{"x1": 693, "y1": 194, "x2": 742, "y2": 242, "speaking_score": 1.6833333373069763, "active": true, "track_id": 0}]}, {"frame_number": 460, "faces": [{"x1": 693, "y1": 194, "x2": 742, "y2": 242, "speaking_score": 1.6833333373069763, "active": true, "track_id": 0}]}, {"frame_number": 461, "faces": [{"x1": 693, "y1": 194, "x2": 742, "y2": 242, "speaking_score": 1.6666666666666667, "active": true, "track_id": 0}]}, {"frame_number": 462, "faces": [{"x1": 693, "y1": 194, "x2": 742, "y2": 242, "speaking_score": 1.6666666666666667, "active": true, "track_id": 0}]}, {"frame_number": 463, "faces": [{"x1": 693, "y1": 194, "x2": 742, "y2": 242, "speaking_score": 1.6833333373069763, "active": true, "track_id": 0}]}, {"frame_number": 464, "faces": [{"x1": 693, "y1": 194, "x2": 742, "y2": 242, "speaking_score": 1.6666666666666667, "active": true, "track_id": 0}]}, {"frame_number": 465, "faces": [{"x1": 693, "y1": 194, "x2": 742, "y2": 242, "speaking_score": 1.6833333373069763, "active": true, "track_id": 0}]}, {"frame_number": 466, "faces": [{"x1": 693, "y1": 194, "x2": 742, "y2": 242, "speaking_score": 1.6833333373069763, "active": true, "track_id": 0}]}, {"frame_number": 467, "faces": [{"x1": 694, "y1": 194, "x2": 743, "y2": 242, "speaking_score": 1.7333333293596904, "active": true, "track_id": 0}]}, {"frame_number": 468, "faces": [{"x1": 695, "y1": 193, "x2": 743, "y2": 242, "speaking_score": 1.7666666507720947, "active": true, "track_id": 0}]}, {"frame_number": 469, "faces": [{"x1": 695, "y1": 193, "x2": 744, "y2": 242, "speaking_score": 1.8499999642372131, "active": true, "track_id": 0}]}, {"frame_number": 470, "faces": [{"x1": 696, "y1": 193, "x2": 745, "y2": 242, "speaking_score": 1.9666666388511658, "active": true, "track_id": 0}]}, {"frame_number": 471, "faces": [{"x1": 696, "y1": 193, "x2": 745, "y2": 242, "speaking_score": 2.0833333134651184, "active": true, "track_id": 0}]}, {"frame_number": 472, "faces": [{"x1": 696, "y1": 193, "x2": 745, "y2": 242, "speaking_score": 2.0833333134651184, "active": true, "track_id": 0}]}, {"frame_number": 473, "faces": [{"x1": 697, "y1": 193, "x2": 746, "y2": 241, "speaking_score": 2.149999976158142, "active": true, "track_id": 0}]}, {"frame_number": 474, "faces": [{"x1": 698, "y1": 193, "x2": 747, "y2": 241, "speaking_score": 2.2666666507720947, "active": true, "track_id": 0}]}, {"frame_number": 475, "faces": [{"x1": 699, "y1": 192, "x2": 749, "y2": 242, "speaking_score": 2.3833333253860474, "active": true, "track_id": 0}]}, {"frame_number": 476, "faces": [{"x1": 700, "y1": 192, "x2": 750, "y2": 242, "speaking_score": 2.5, "active": true, "track_id": 0}]}, {"frame_number": 477, "faces": [{"x1": 702, "y1": 192, "x2": 752, "y2": 242, "speaking_score": 2.549999992052714, "active": true, "track_id": 0}]}, {"frame_number": 478, "faces": [{"x1": 702, "y1": 192, "x2": 752, "y2": 242, "speaking_score": 2.549999992052714, "active": true, "track_id": 0}]}, {"frame_number": 479, "faces": [{"x1": 705, "y1": 192, "x2": 755, "y2": 242, "speaking_score": 2.5666666428248086, "active": true, "track_id": 0}]}, {"frame_number": 480, "faces": [{"x1": 707, "y1": 192, "x2": 757, "y2": 242, "speaking_score": 2.5333333015441895, "active": true, "track_id": 0}]}, {"frame_number": 481, "faces": [{"x1": 709, "y1": 192, "x2": 758, "y2": 242, "speaking_score": 2.4833333094914756, "active": true, "track_id": 0}]}, {"frame_number": 482, "faces": [{"x1": 710, "y1": 192, "x2": 760, "y2": 242, "speaking_score": 2.366666634877523, "active": true, "track_id": 0}]}, {"frame_number": 483, "faces": [{"x1": 712, "y1": 192, "x2": 762, "y2": 242, "speaking_score": 2.199999968210856, "active": true, "track_id": 0}]}, {"frame_number": 484, "faces": [{"x1": 712, "y1": 192, "x2": 762, "y2": 242, "speaking_score": 2.199999968210856, "active": true, "track_id": 0}]}, {"frame_number": 485, "faces": [{"x1": 717, "y1": 192, "x2": 766, "y2": 242, "speaking_score": 2.049999952316284, "active": true, "track_id": 0}]}, {"frame_number": 486, "faces": [{"x1": 720, "y1": 192, "x2": 769, "y2": 242, "speaking_score": 1.899999976158142, "active": true, "track_id": 0}]}, {"frame_number": 487, "faces": [{"x1": 722, "y1": 192, "x2": 771, "y2": 242, "speaking_score": 1.8833333253860474, "active": true, "track_id": 0}]}, {"frame_number": 488, "faces": [{"x1": 725, "y1": 192, "x2": 775, "y2": 242, "speaking_score": 1.799999992052714, "active": true, "track_id": 0}]}, {"frame_number": 489, "faces": [{"x1": 727, "y1": 192, "x2": 776, "y2": 242, "speaking_score": 1.7666666706403096, "active": true, "track_id": 0}]}, {"frame_number": 490, "faces": [{"x1": 732, "y1": 192, "x2": 781, "y2": 242, "speaking_score": 1.7666666706403096, "active": true, "track_id": 0}]}, {"frame_number": 491, "faces": [{"x1": 732, "y1": 192, "x2": 781, "y2": 242, "speaking_score": 1.7666666706403096, "active": true, "track_id": 0}]}, {"frame_number": 492, "faces": [{"x1": 735, "y1": 193, "x2": 784, "y2": 242, "speaking_score": 1.8666666944821675, "active": true, "track_id": 0}]}, {"frame_number": 493, "faces": [{"x1": 737, "y1": 193, "x2": 786, "y2": 242, "speaking_score": 1.9833333690961201, "active": true, "track_id": 0}]}, {"frame_number": 494, "faces": [{"x1": 739, "y1": 193, "x2": 788, "y2": 242, "speaking_score": 2.0333333611488342, "active": true, "track_id": 0}]}, {"frame_number": 495, "faces": [{"x1": 741, "y1": 193, "x2": 790, "y2": 242, "speaking_score": 2.150000035762787, "active": true, "track_id": 0}]}, {"frame_number": 496, "faces": [{"x1": 746, "y1": 193, "x2": 795, "y2": 242, "speaking_score": 2.2166666984558105, "active": true, "track_id": 0}]}, {"frame_number": 497, "faces": [{"x1": 746, "y1": 193, "x2": 795, "y2": 242, "speaking_score": 2.2166666984558105, "active": true, "track_id": 0}]}, {"frame_number": 498, "faces": [{"x1": 751, "y1": 193, "x2": 800, "y2": 242, "speaking_score": 2.333333373069763, "active": true, "track_id": 0}]}, {"frame_number": 499, "faces": [{"x1": 753, "y1": 193, "x2": 802, "y2": 242, "speaking_score": 2.4333333571751914, "active": true, "track_id": 0}]}, {"frame_number": 500, "faces": [{"x1": 755, "y1": 193, "x2": 804, "y2": 242, "speaking_score": 2.5666666825612388, "active": true, "track_id": 0}]}, {"frame_number": 501, "faces": [{"x1": 757, "y1": 193, "x2": 806, "y2": 242, "speaking_score": 2.7333333492279053, "active": true, "track_id": 0}]}, {"frame_number": 502, "faces": [{"x1": 760, "y1": 193, "x2": 809, "y2": 242, "speaking_score": 2.900000015894572, "active": true, "track_id": 0}]}, {"frame_number": 503, "faces": [{"x1": 760, "y1": 193, "x2": 809, "y2": 242, "speaking_score": 2.900000015894572, "active": true, "track_id": 0}]}, {"frame_number": 504, "faces": [{"x1": 761, "y1": 193, "x2": 810, "y2": 242, "speaking_score": 3.1166666746139526, "active": true, "track_id": 0}]}, {"frame_number": 505, "faces": [{"x1": 763, "y1": 192, "x2": 812, "y2": 241, "speaking_score": 3.25, "active": true, "track_id": 0}]}, {"frame_number": 506, "faces": [{"x1": 764, "y1": 192, "x2": 813, "y2": 241, "speaking_score": 3.299999992052714, "active": true, "track_id": 0}]}, {"frame_number": 507, "faces": [{"x1": 764, "y1": 192, "x2": 814, "y2": 241, "speaking_score": 3.3166666428248086, "active": true, "track_id": 0}]}, {"frame_number": 508, "faces": [{"x1": 765, "y1": 192, "x2": 814, "y2": 241, "speaking_score": 3.349999984105428, "active": true, "track_id": 0}]}, {"frame_number": 509, "faces": [{"x1": 765, "y1": 192, "x2": 814, "y2": 241, "speaking_score": 3.349999984105428, "active": true, "track_id": 0}]}, {"frame_number": 510, "faces": [{"x1": 765, "y1": 192, "x2": 814, "y2": 241, "speaking_score": 3.3333332935969033, "active": true, "track_id": 0}]}, {"frame_number": 511, "faces": [{"x1": 766, "y1": 192, "x2": 815, "y2": 241, "speaking_score": 3.3333332935969033, "active": true, "track_id": 0}]}, {"frame_number": 512, "faces": [{"x1": 766, "y1": 193, "x2": 815, "y2": 242, "speaking_score": 3.2833333015441895, "active": true, "track_id": 0}]}, {"frame_number": 513, "faces": [{"x1": 767, "y1": 193, "x2": 816, "y2": 242, "speaking_score": 3.166666626930237, "active": true, "track_id": 0}]}, {"frame_number": 514, "faces": [{"x1": 767, "y1": 193, "x2": 816, "y2": 242, "speaking_score": 2.9833333094914756, "active": true, "track_id": 0}]}, {"frame_number": 515, "faces": [{"x1": 767, "y1": 193, "x2": 816, "y2": 242, "speaking_score": 2.9833333094914756, "active": true, "track_id": 0}]}, {"frame_number": 516, "faces": [{"x1": 768, "y1": 193, "x2": 817, "y2": 242, "speaking_score": 2.699999968210856, "active": true, "track_id": 0}]}, {"frame_number": 517, "faces": [{"x1": 768, "y1": 194, "x2": 817, "y2": 242, "speaking_score": 2.3333333134651184, "active": true, "track_id": 0}]}, {"frame_number": 518, "faces": [{"x1": 769, "y1": 194, "x2": 817, "y2": 242, "speaking_score": 1.8999999860922496, "active": true, "track_id": 0}]}, {"frame_number": 519, "faces": [{"x1": 769, "y1": 194, "x2": 817, "y2": 242, "speaking_score": 1.4333333199222882, "active": true, "track_id": 0}]}, {"frame_number": 520, "faces": [{"x1": 769, "y1": 194, "x2": 817, "y2": 242, "speaking_score": 0.9833333355685075, "active": true, "track_id": 0}]}, {"frame_number": 521, "faces": [{"x1": 769, "y1": 194, "x2": 817, "y2": 242, "speaking_score": 0.9833333355685075, "active": true, "track_id": 0}]}, {"frame_number": 522, "faces": [{"x1": 769, "y1": 194, "x2": 817, "y2": 242, "speaking_score": 0.7399999931454658, "active": true, "track_id": 0}]}, {"frame_number": 523, "faces": [{"x1": 769, "y1": 194, "x2": 817, "y2": 242, "speaking_score": 0.47500000335276127, "active": true, "track_id": 0}]}, {"frame_number": 524, "faces": [{"x1": 769, "y1": 194, "x2": 817, "y2": 242, "speaking_score": 0.26666666318972904, "active": true, "track_id": 0}]}, {"frame_number": 525, "faces": [{"x1": 769, "y1": 194, "x2": 817, "y2": 242, "speaking_score": 0.05000000074505806, "active": true, "track_id": 0}]}, {"frame_number": 526, "faces": [{"x1": 769, "y1": 194, "x2": 817, "y2": 242, "speaking_score": 0.26666666318972904, "active": true, "track_id": 0}]}, {"frame_number": 527, "faces": [{"x1": 769, "y1": 194, "x2": 817, "y2": 242, "speaking_score": 0.05000000074505806, "active": true, "track_id": 0}]}, {"frame_number": 528, "faces": []}, {"frame_number": 529, "faces": []}, {"frame_number": 530, "faces": [{"x1": 779, "y1": 80, "x2": 1045, "y2": 346, "speaking_score": 2.3666667143503823, "active": true, "track_id": 1}]}, {"frame_number": 531, "faces": [{"x1": 781, "y1": 83, "x2": 1048, "y2": 350, "speaking_score": 2.675000011920929, "active": true, "track_id": 1}]}, {"frame_number": 532, "faces": [{"x1": 781, "y1": 84, "x2": 1048, "y2": 351, "speaking_score": 2.859999990463257, "active": true, "track_id": 1}]}, {"frame_number": 533, "faces": [{"x1": 783, "y1": 90, "x2": 1053, "y2": 360, "speaking_score": 3.033333341280619, "active": true, "track_id": 1}]}, {"frame_number": 534, "faces": [{"x1": 784, "y1": 91, "x2": 1056, "y2": 362, "speaking_score": 3.5, "active": true, "track_id": 1}]}, {"frame_number": 535, "faces": [{"x1": 784, "y1": 91, "x2": 1056, "y2": 362, "speaking_score": 3.5, "active": true, "track_id": 1}]}, {"frame_number": 536, "faces": [{"x1": 784, "y1": 90, "x2": 1058, "y2": 365, "speaking_score": 3.799999952316284, "active": true, "track_id": 1}]}, {"frame_number": 537, "faces": [{"x1": 783, "y1": 89, "x2": 1059, "y2": 365, "speaking_score": 3.9666666189829507, "active": true, "track_id": 1}]}, {"frame_number": 538, "faces": [{"x1": 783, "y1": 90, "x2": 1059, "y2": 365, "speaking_score": 4.099999984105428, "active": true, "track_id": 1}]}, {"frame_number": 539, "faces": [{"x1": 783, "y1": 90, "x2": 1059, "y2": 365, "speaking_score": 4.2166666984558105, "active": true, "track_id": 1}]}, {"frame_number": 540, "faces": [{"x1": 783, "y1": 90, "x2": 1059, "y2": 366, "speaking_score": 4.316666682561238, "active": true, "track_id": 1}]}, {"frame_number": 541, "faces": [{"x1": 783, "y1": 90, "x2": 1059, "y2": 366, "speaking_score": 4.316666682561238, "active": true, "track_id": 1}]}, {"frame_number": 542, "faces": [{"x1": 783, "y1": 90, "x2": 1059, "y2": 366, "speaking_score": 4.400000015894572, "active": true, "track_id": 1}]}, {"frame_number": 543, "faces": [{"x1": 783, "y1": 90, "x2": 1059, "y2": 366, "speaking_score": 4.4666666984558105, "active": true, "track_id": 1}]}, {"frame_number": 544, "faces": [{"x1": 782, "y1": 90, "x2": 1058, "y2": 366, "speaking_score": 4.5, "active": true, "track_id": 1}]}, {"frame_number": 545, "faces": [{"x1": 781, "y1": 90, "x2": 1057, "y2": 366, "speaking_score": 4.516666650772095, "active": true, "track_id": 1}]}, {"frame_number": 546, "faces": [{"x1": 779, "y1": 90, "x2": 1055, "y2": 366, "speaking_score": 4.5333333015441895, "active": true, "track_id": 1}]}, {"frame_number": 547, "faces": [{"x1": 779, "y1": 90, "x2": 1055, "y2": 366, "speaking_score": 4.5333333015441895, "active": true, "track_id": 1}]}, {"frame_number": 548, "faces": [{"x1": 779, "y1": 91, "x2": 1055, "y2": 366, "speaking_score": 4.516666650772095, "active": true, "track_id": 1}]}, {"frame_number": 549, "faces": [{"x1": 778, "y1": 91, "x2": 1054, "y2": 366, "speaking_score": 4.5, "active": true, "track_id": 1}]}, {"frame_number": 550, "faces": [{"x1": 776, "y1": 91, "x2": 1051, "y2": 366, "speaking_score": 4.483333349227905, "active": true, "track_id": 1}]}, {"frame_number": 551, "faces": [{"x1": 767, "y1": 91, "x2": 1042, "y2": 366, "speaking_score": 4.450000047683716, "active": true, "track_id": 1}]}, {"frame_number": 552, "faces": [{"x1": 763, "y1": 91, "x2": 1037, "y2": 366, "speaking_score": 4.450000047683716, "active": true, "track_id": 1}]}, {"frame_number": 553, "faces": [{"x1": 763, "y1": 91, "x2": 1037, "y2": 366, "speaking_score": 4.450000047683716, "active": true, "track_id": 1}]}, {"frame_number": 554, "faces": [{"x1": 758, "y1": 91, "x2": 1032, "y2": 365, "speaking_score": 4.450000047683716, "active": true, "track_id": 1}]}, {"frame_number": 555, "faces": [{"x1": 753, "y1": 88, "x2": 1028, "y2": 363, "speaking_score": 4.433333396911621, "active": true, "track_id": 1}]}, {"frame_number": 556, "faces": [{"x1": 748, "y1": 88, "x2": 1022, "y2": 361, "speaking_score": 4.366666714350383, "active": true, "track_id": 1}]}, {"frame_number": 557, "faces": [{"x1": 736, "y1": 84, "x2": 1009, "y2": 358, "speaking_score": 4.350000063578288, "active": true, "track_id": 1}]}, {"frame_number": 558, "faces": [{"x1": 730, "y1": 84, "x2": 1004, "y2": 358, "speaking_score": 4.366666714350383, "active": true, "track_id": 1}]}, {"frame_number": 559, "faces": [{"x1": 730, "y1": 84, "x2": 1004, "y2": 358, "speaking_score": 4.366666714350383, "active": true, "track_id": 1}]}, {"frame_number": 560, "faces": [{"x1": 726, "y1": 83, "x2": 998, "y2": 356, "speaking_score": 4.366666714350383, "active": true, "track_id": 1}]}, {"frame_number": 561, "faces": [{"x1": 717, "y1": 84, "x2": 989, "y2": 355, "speaking_score": 4.400000015894572, "active": true, "track_id": 1}]}, {"frame_number": 562, "faces": [{"x1": 706, "y1": 84, "x2": 977, "y2": 355, "speaking_score": 4.483333349227905, "active": true, "track_id": 1}]}, {"frame_number": 563, "faces": [{"x1": 686, "y1": 84, "x2": 957, "y2": 354, "speaking_score": 4.600000063578288, "active": true, "track_id": 1}]}, {"frame_number": 564, "faces": [{"x1": 677, "y1": 83, "x2": 948, "y2": 354, "speaking_score": 4.650000015894572, "active": true, "track_id": 1}]}, {"frame_number": 565, "faces": [{"x1": 677, "y1": 83, "x2": 948, "y2": 354, "speaking_score": 4.650000015894572, "active": true, "track_id": 1}]}, {"frame_number": 566, "faces": [{"x1": 670, "y1": 82, "x2": 941, "y2": 354, "speaking_score": 4.666666666666667, "active": true, "track_id": 1}]}, {"frame_number": 567, "faces": [{"x1": 662, "y1": 82, "x2": 933, "y2": 353, "speaking_score": 4.599999984105428, "active": true, "track_id": 1}]}, {"frame_number": 568, "faces": [{"x1": 654, "y1": 81, "x2": 925, "y2": 353, "speaking_score": 4.550000031789144, "active": true, "track_id": 1}]}, {"frame_number": 569, "faces": [{"x1": 636, "y1": 81, "x2": 906, "y2": 352, "speaking_score": 4.449999968210856, "active": true, "track_id": 1}]}, {"frame_number": 570, "faces": [{"x1": 628, "y1": 81, "x2": 899, "y2": 352, "speaking_score": 4.316666603088379, "active": true, "track_id": 1}]}, {"frame_number": 571, "faces": [{"x1": 628, "y1": 81, "x2": 899, "y2": 352, "speaking_score": 4.316666603088379, "active": true, "track_id": 1}]}, {"frame_number": 572, "faces": [{"x1": 622, "y1": 82, "x2": 891, "y2": 351, "speaking_score": 4.149999976158142, "active": true, "track_id": 1}]}, {"frame_number": 573, "faces": [{"x1": 614, "y1": 82, "x2": 882, "y2": 350, "speaking_score": 3.950000007947286, "active": true, "track_id": 1}]}, {"frame_number": 574, "faces": [{"x1": 608, "y1": 81, "x2": 876, "y2": 349, "speaking_score": 3.783333341280619, "active": true, "track_id": 1}]}, {"frame_number": 575, "faces": [{"x1": 598, "y1": 82, "x2": 864, "y2": 348, "speaking_score": 3.4333333174387612, "active": true, "track_id": 1}]}, {"frame_number": 576, "faces": [{"x1": 593, "y1": 81, "x2": 859, "y2": 348, "speaking_score": 3.000000019868215, "active": true, "track_id": 1}]}, {"frame_number": 577, "faces": [{"x1": 585, "y1": 80, "x2": 851, "y2": 346, "speaking_score": 2.5333333611488342, "active": true, "track_id": 1}]}, {"frame_number": 578, "faces": [{"x1": 585, "y1": 80, "x2": 851, "y2": 346, "speaking_score": 2.5333333611488342, "active": true, "track_id": 1}]}, {"frame_number": 579, "faces": [{"x1": 579, "y1": 79, "x2": 844, "y2": 345, "speaking_score": 2.000000019868215, "active": true, "track_id": 1}]}, {"frame_number": 580, "faces": [{"x1": 574, "y1": 80, "x2": 840, "y2": 345, "speaking_score": 1.350000003973643, "active": true, "track_id": 1}]}, {"frame_number": 581, "faces": [{"x1": 568, "y1": 80, "x2": 833, "y2": 345, "speaking_score": 0.6333333452542623, "active": true, "track_id": 1}]}, {"frame_number": 582, "faces": [{"x1": 566, "y1": 80, "x2": 831, "y2": 344, "speaking_score": 0.0, "active": true, "track_id": 1}]}, {"frame_number": 583, "faces": [{"x1": 563, "y1": 80, "x2": 827, "y2": 344, "speaking_score": -0.5666666626930237, "active": false, "track_id": 1}]}, {"frame_number": 584, "faces": [{"x1": 563, "y1": 80, "x2": 827, "y2": 344, "speaking_score": -0.5666666626930237, "active": false, "track_id": 1}]}, {"frame_number": 585, "faces": [{"x1": 560, "y1": 80, "x2": 824, "y2": 344, "speaking_score": -1.0833333333333333, "active": false, "track_id": 1}]}, {"frame_number": 586, "faces": [{"x1": 558, "y1": 80, "x2": 822, "y2": 344, "speaking_score": -1.5333333412806194, "active": false, "track_id": 1}]}, {"frame_number": 587, "faces": [{"x1": 554, "y1": 80, "x2": 817, "y2": 344, "speaking_score": -1.9666666587193806, "active": false, "track_id": 1}]}, {"frame_number": 588, "faces": [{"x1": 552, "y1": 81, "x2": 815, "y2": 344, "speaking_score": -2.3166666428248086, "active": false, "track_id": 1}]}, {"frame_number": 589, "faces": [{"x1": 550, "y1": 81, "x2": 814, "y2": 345, "speaking_score": -2.6166666547457376, "active": false, "track_id": 1}]}, {"frame_number": 590, "faces": [{"x1": 550, "y1": 81, "x2": 814, "y2": 345, "speaking_score": -2.6166666547457376, "active": false, "track_id": 1}]}, {"frame_number": 591, "faces": [{"x1": 550, "y1": 81, "x2": 813, "y2": 345, "speaking_score": -2.899999996026357, "active": false, "track_id": 1}]}, {"frame_number": 592, "faces": [{"x1": 548, "y1": 82, "x2": 811, "y2": 346, "speaking_score": -3.1833333174387612, "active": false, "track_id": 1}]}, {"frame_number": 593, "faces": [{"x1": 546, "y1": 82, "x2": 809, "y2": 346, "speaking_score": -3.416666626930237, "active": false, "track_id": 1}]}, {"frame_number": 594, "faces": [{"x1": 545, "y1": 83, "x2": 809, "y2": 346, "speaking_score": -3.5166666507720947, "active": false, "track_id": 1}]}, {"frame_number": 595, "faces": [{"x1": 545, "y1": 83, "x2": 808, "y2": 347, "speaking_score": -3.5666666428248086, "active": false, "track_id": 1}]}, {"frame_number": 596, "faces": [{"x1": 545, "y1": 83, "x2": 808, "y2": 347, "speaking_score": -3.5666666428248086, "active": false, "track_id": 1}]}, {"frame_number": 597, "faces": [{"x1": 545, "y1": 83, "x2": 808, "y2": 347, "speaking_score": -3.599999944368998, "active": false, "track_id": 1}]}, {"frame_number": 598, "faces": [{"x1": 544, "y1": 84, "x2": 808, "y2": 348, "speaking_score": -3.616666595141093, "active": false, "track_id": 1}]}, {"frame_number": 599, "faces": [{"x1": 542, "y1": 85, "x2": 805, "y2": 349, "speaking_score": -3.616666595141093, "active": false, "track_id": 1}]}, {"frame_number": 600, "faces": [{"x1": 541, "y1": 86, "x2": 804, "y2": 349, "speaking_score": -3.616666595141093, "active": false, "track_id": 1}]}, {"frame_number": 601, "faces": [{"x1": 541, "y1": 86, "x2": 804, "y2": 349, "speaking_score": -3.5999999046325684, "active": false, "track_id": 1}]}, {"frame_number": 602, "faces": [{"x1": 541, "y1": 86, "x2": 804, "y2": 349, "speaking_score": -3.5999999046325684, "active": false, "track_id": 1}]}, {"frame_number": 603, "faces": [{"x1": 540, "y1": 87, "x2": 804, "y2": 350, "speaking_score": -3.5999999046325684, "active": false, "track_id": 1}]}, {"frame_number": 604, "faces": [{"x1": 539, "y1": 87, "x2": 803, "y2": 350, "speaking_score": -3.5833332538604736, "active": false, "track_id": 1}]}, {"frame_number": 605, "faces": [{"x1": 536, "y1": 90, "x2": 800, "y2": 353, "speaking_score": -3.566666603088379, "active": false, "track_id": 1}]}, {"frame_number": 606, "faces": [{"x1": 535, "y1": 90, "x2": 797, "y2": 353, "speaking_score": -3.549999952316284, "active": false, "track_id": 1}]}, {"frame_number": 607, "faces": [{"x1": 533, "y1": 90, "x2": 795, "y2": 353, "speaking_score": -3.5166666507720947, "active": false, "track_id": 1}]}, {"frame_number": 608, "faces": [{"x1": 533, "y1": 90, "x2": 795, "y2": 353, "speaking_score": -3.5166666507720947, "active": false, "track_id": 1}]}, {"frame_number": 609, "faces": [{"x1": 532, "y1": 92, "x2": 795, "y2": 355, "speaking_score": -3.466666658719381, "active": false, "track_id": 1}]}, {"frame_number": 610, "faces": [{"x1": 531, "y1": 92, "x2": 794, "y2": 355, "speaking_score": -3.3666666746139526, "active": false, "track_id": 1}]}, {"frame_number": 611, "faces": [{"x1": 530, "y1": 93, "x2": 793, "y2": 356, "speaking_score": -3.2666666905085244, "active": false, "track_id": 1}]}, {"frame_number": 612, "faces": [{"x1": 529, "y1": 93, "x2": 792, "y2": 356, "speaking_score": -3.150000015894572, "active": false, "track_id": 1}]}, {"frame_number": 613, "faces": [{"x1": 529, "y1": 94, "x2": 790, "y2": 355, "speaking_score": -2.9833333492279053, "active": false, "track_id": 1}]}, {"frame_number": 614, "faces": [{"x1": 529, "y1": 94, "x2": 790, "y2": 355, "speaking_score": -2.9833333492279053, "active": false, "track_id": 1}]}, {"frame_number": 615, "faces": [{"x1": 526, "y1": 93, "x2": 788, "y2": 356, "speaking_score": -2.8166666825612388, "active": false, "track_id": 1}]}, {"frame_number": 616, "faces": [{"x1": 525, "y1": 92, "x2": 787, "y2": 355, "speaking_score": -2.650000015894572, "active": false, "track_id": 1}]}, {"frame_number": 617, "faces": [{"x1": 524, "y1": 92, "x2": 787, "y2": 355, "speaking_score": -2.1666666828095913, "active": false, "track_id": 1}]}, {"frame_number": 618, "faces": [{"x1": 524, "y1": 91, "x2": 787, "y2": 355, "speaking_score": -1.4500000042219956, "active": false, "track_id": 1}]}, {"frame_number": 619, "faces": [{"x1": 523, "y1": 90, "x2": 788, "y2": 354, "speaking_score": -0.483333345502615, "active": false, "track_id": 1}]}, {"frame_number": 620, "faces": [{"x1": 523, "y1": 90, "x2": 788, "y2": 354, "speaking_score": -0.483333345502615, "active": false, "track_id": 1}]}, {"frame_number": 621, "faces": [{"x1": 522, "y1": 89, "x2": 787, "y2": 354, "speaking_score": 0.566666646550099, "active": true, "track_id": 1}]}, {"frame_number": 622, "faces": [{"x1": 520, "y1": 89, "x2": 786, "y2": 355, "speaking_score": 1.6666666306555271, "active": true, "track_id": 1}]}, {"frame_number": 623, "faces": [{"x1": 509, "y1": 82, "x2": 788, "y2": 360, "speaking_score": 2.7333332734803357, "active": true, "track_id": 1}]}, {"frame_number": 624, "faces": [{"x1": 505, "y1": 80, "x2": 786, "y2": 360, "speaking_score": 3.449999908606211, "active": true, "track_id": 1}]}, {"frame_number": 625, "faces": [{"x1": 502, "y1": 79, "x2": 782, "y2": 359, "speaking_score": 3.966666579246521, "active": true, "track_id": 1}]}, {"frame_number": 626, "faces": [{"x1": 502, "y1": 79, "x2": 782, "y2": 359, "speaking_score": 3.966666579246521, "active": true, "track_id": 1}]}, {"frame_number": 627, "faces": [{"x1": 502, "y1": 77, "x2": 782, "y2": 358, "speaking_score": 4.216666579246521, "active": true, "track_id": 1}]}, {"frame_number": 628, "faces": [{"x1": 501, "y1": 76, "x2": 782, "y2": 357, "speaking_score": 4.299999952316284, "active": true, "track_id": 1}]}, {"frame_number": 629, "faces": [{"x1": 501, "y1": 71, "x2": 782, "y2": 352, "speaking_score": 4.333333333333333, "active": true, "track_id": 1}]}, {"frame_number": 630, "faces": [{"x1": 501, "y1": 70, "x2": 783, "y2": 353, "speaking_score": 4.366666714350383, "active": true, "track_id": 1}]}, {"frame_number": 631, "faces": [{"x1": 500, "y1": 70, "x2": 784, "y2": 353, "speaking_score": 4.383333444595337, "active": true, "track_id": 1}]}, {"frame_number": 632, "faces": [{"x1": 500, "y1": 70, "x2": 784, "y2": 353, "speaking_score": 4.383333444595337, "active": true, "track_id": 1}]}, {"frame_number": 633, "faces": [{"x1": 500, "y1": 69, "x2": 784, "y2": 353, "speaking_score": 4.3500001430511475, "active": true, "track_id": 1}]}, {"frame_number": 634, "faces": [{"x1": 500, "y1": 69, "x2": 784, "y2": 353, "speaking_score": 4.333333492279053, "active": true, "track_id": 1}]}, {"frame_number": 635, "faces": [{"x1": 504, "y1": 69, "x2": 788, "y2": 353, "speaking_score": 4.383333444595337, "active": true, "track_id": 1}]}, {"frame_number": 636, "faces": [{"x1": 507, "y1": 69, "x2": 792, "y2": 354, "speaking_score": 4.400000095367432, "active": true, "track_id": 1}]}, {"frame_number": 637, "faces": [{"x1": 512, "y1": 69, "x2": 797, "y2": 354, "speaking_score": 4.416666746139526, "active": true, "track_id": 1}]}, {"frame_number": 638, "faces": [{"x1": 512, "y1": 69, "x2": 797, "y2": 354, "speaking_score": 4.416666746139526, "active": true, "track_id": 1}]}, {"frame_number": 639, "faces": [{"x1": 514, "y1": 70, "x2": 800, "y2": 356, "speaking_score": 4.433333396911621, "active": true, "track_id": 1}]}, {"frame_number": 640, "faces": [{"x1": 518, "y1": 70, "x2": 803, "y2": 356, "speaking_score": 4.416666666666667, "active": true, "track_id": 1}]}, {"frame_number": 641, "faces": [{"x1": 525, "y1": 70, "x2": 810, "y2": 356, "speaking_score": 4.383333285649617, "active": true, "track_id": 1}]}, {"frame_number": 642, "faces": [{"x1": 531, "y1": 70, "x2": 817, "y2": 356, "speaking_score": 4.316666603088379, "active": true, "track_id": 1}]}, {"frame_number": 643, "faces": [{"x1": 539, "y1": 71, "x2": 823, "y2": 355, "speaking_score": 4.249999920527141, "active": true, "track_id": 1}]}, {"frame_number": 644, "faces": [{"x1": 539, "y1": 71, "x2": 823, "y2": 355, "speaking_score": 4.249999920527141, "active": true, "track_id": 1}]}, {"frame_number": 645, "faces": [{"x1": 546, "y1": 72, "x2": 830, "y2": 355, "speaking_score": 4.166666587193807, "active": true, "track_id": 1}]}, {"frame_number": 646, "faces": [{"x1": 552, "y1": 72, "x2": 834, "y2": 355, "speaking_score": 4.016666571299235, "active": true, "track_id": 1}]}, {"frame_number": 647, "faces": [{"x1": 567, "y1": 73, "x2": 848, "y2": 354, "speaking_score": 3.549999932448069, "active": true, "track_id": 1}]}, {"frame_number": 648, "faces": [{"x1": 577, "y1": 74, "x2": 856, "y2": 353, "speaking_score": 3.0333333015441895, "active": true, "track_id": 1}]}, {"frame_number": 649, "faces": [{"x1": 586, "y1": 75, "x2": 863, "y2": 352, "speaking_score": 2.5, "active": true, "track_id": 1}]}, {"frame_number": 650, "faces": [{"x1": 586, "y1": 75, "x2": 863, "y2": 352, "speaking_score": 2.5, "active": true, "track_id": 1}]}, {"frame_number": 651, "faces": [{"x1": 595, "y1": 75, "x2": 872, "y2": 352, "speaking_score": 1.8666666845480602, "active": true, "track_id": 1}]}, {"frame_number": 652, "faces": [{"x1": 606, "y1": 75, "x2": 883, "y2": 351, "speaking_score": 1.1666666666666667, "active": true, "track_id": 1}]}, {"frame_number": 653, "faces": [{"x1": 625, "y1": 76, "x2": 901, "y2": 351, "speaking_score": 0.38333332538604736, "active": true, "track_id": 1}]}, {"frame_number": 654, "faces": [{"x1": 636, "y1": 79, "x2": 912, "y2": 354, "speaking_score": -0.16666666666666666, "active": false, "track_id": 1}]}, {"frame_number": 655, "faces": [{"x1": 648, "y1": 81, "x2": 923, "y2": 357, "speaking_score": -0.7166666785875956, "active": false, "track_id": 1}]}, {"frame_number": 656, "faces": [{"x1": 658, "y1": 83, "x2": 932, "y2": 357, "speaking_score": -1.2833333611488342, "active": false, "track_id": 1}]}, {"frame_number": 657, "faces": [{"x1": 658, "y1": 83, "x2": 932, "y2": 357, "speaking_score": -1.2833333611488342, "active": false, "track_id": 1}]}, {"frame_number": 658, "faces": [{"x1": 666, "y1": 83, "x2": 940, "y2": 357, "speaking_score": -1.7500000298023224, "active": false, "track_id": 1}]}, {"frame_number": 659, "faces": [{"x1": 675, "y1": 84, "x2": 949, "y2": 358, "speaking_score": -2.1666666865348816, "active": false, "track_id": 1}]}, {"frame_number": 660, "faces": [{"x1": 680, "y1": 84, "x2": 954, "y2": 358, "speaking_score": -2.4500000278155007, "active": false, "track_id": 1}]}, {"frame_number": 661, "faces": [{"x1": 688, "y1": 85, "x2": 961, "y2": 358, "speaking_score": -2.650000015894572, "active": false, "track_id": 1}]}, {"frame_number": 662, "faces": [{"x1": 695, "y1": 86, "x2": 967, "y2": 358, "speaking_score": -2.8166666825612388, "active": false, "track_id": 1}]}, {"frame_number": 663, "faces": [{"x1": 695, "y1": 86, "x2": 967, "y2": 358, "speaking_score": -2.8166666825612388, "active": false, "track_id": 1}]}, {"frame_number": 664, "faces": [{"x1": 699, "y1": 87, "x2": 971, "y2": 359, "speaking_score": -2.950000007947286, "active": false, "track_id": 1}]}, {"frame_number": 665, "faces": [{"x1": 708, "y1": 90, "x2": 979, "y2": 361, "speaking_score": -3.0666666825612388, "active": false, "track_id": 1}]}, {"frame_number": 666, "faces": [{"x1": 716, "y1": 91, "x2": 986, "y2": 361, "speaking_score": -3.133333365122477, "active": false, "track_id": 1}]}, {"frame_number": 667, "faces": [{"x1": 721, "y1": 92, "x2": 990, "y2": 361, "speaking_score": -3.1833333571751914, "active": false, "track_id": 1}]}, {"frame_number": 668, "faces": [{"x1": 725, "y1": 92, "x2": 994, "y2": 361, "speaking_score": -3.1833333571751914, "active": false, "track_id": 1}]}, {"frame_number": 669, "faces": [{"x1": 725, "y1": 92, "x2": 994, "y2": 361, "speaking_score": -3.1833333571751914, "active": false, "track_id": 1}]}, {"frame_number": 670, "faces": [{"x1": 728, "y1": 92, "x2": 998, "y2": 362, "speaking_score": -3.1666666666666665, "active": false, "track_id": 1}]}, {"frame_number": 671, "faces": [{"x1": 735, "y1": 92, "x2": 1005, "y2": 362, "speaking_score": -3.149999976158142, "active": false, "track_id": 1}]}, {"frame_number": 672, "faces": [{"x1": 737, "y1": 92, "x2": 1007, "y2": 362, "speaking_score": -3.099999984105428, "active": false, "track_id": 1}]}, {"frame_number": 673, "faces": [{"x1": 739, "y1": 93, "x2": 1009, "y2": 362, "speaking_score": -2.9999999602635703, "active": false, "track_id": 1}]}, {"frame_number": 674, "faces": [{"x1": 740, "y1": 93, "x2": 1010, "y2": 362, "speaking_score": -2.8333332935969033, "active": false, "track_id": 1}]}, {"frame_number": 675, "faces": [{"x1": 740, "y1": 93, "x2": 1010, "y2": 362, "speaking_score": -2.8333332935969033, "active": false, "track_id": 1}]}, {"frame_number": 676, "faces": [{"x1": 742, "y1": 93, "x2": 1012, "y2": 362, "speaking_score": -2.649999976158142, "active": false, "track_id": 1}]}, {"frame_number": 677, "faces": [{"x1": 744, "y1": 93, "x2": 1014, "y2": 362, "speaking_score": -2.266666660706202, "active": false, "track_id": 1}]}, {"frame_number": 678, "faces": [{"x1": 745, "y1": 92, "x2": 1015, "y2": 363, "speaking_score": -1.783333343764146, "active": false, "track_id": 1}]}, {"frame_number": 679, "faces": [{"x1": 746, "y1": 91, "x2": 1018, "y2": 363, "speaking_score": -1.1499999985098839, "active": false, "track_id": 1}]}, {"frame_number": 680, "faces": [{"x1": 747, "y1": 92, "x2": 1019, "y2": 364, "speaking_score": -0.4000000183780988, "active": false, "track_id": 1}]}, {"frame_number": 681, "faces": [{"x1": 747, "y1": 92, "x2": 1019, "y2": 364, "speaking_score": -0.4000000183780988, "active": false, "track_id": 1}]}, {"frame_number": 682, "faces": [{"x1": 747, "y1": 92, "x2": 1019, "y2": 364, "speaking_score": 0.3166666403412819, "active": true, "track_id": 1}]}, {"frame_number": 683, "faces": [{"x1": 747, "y1": 92, "x2": 1019, "y2": 364, "speaking_score": 1.0499999895691872, "active": true, "track_id": 1}]}, {"frame_number": 684, "faces": [{"x1": 747, "y1": 91, "x2": 1019, "y2": 363, "speaking_score": 1.5499999995032947, "active": true, "track_id": 1}]}, {"frame_number": 685, "faces": [{"x1": 747, "y1": 91, "x2": 1019, "y2": 362, "speaking_score": 2.0, "active": true, "track_id": 1}]}, {"frame_number": 686, "faces": [{"x1": 747, "y1": 91, "x2": 1019, "y2": 362, "speaking_score": 2.300000011920929, "active": true, "track_id": 1}]}, {"frame_number": 687, "faces": [{"x1": 747, "y1": 91, "x2": 1019, "y2": 362, "speaking_score": 2.300000011920929, "active": true, "track_id": 1}]}, {"frame_number": 688, "faces": [{"x1": 747, "y1": 91, "x2": 1018, "y2": 361, "speaking_score": 2.4666666984558105, "active": true, "track_id": 1}]}, {"frame_number": 689, "faces": [{"x1": 747, "y1": 91, "x2": 1017, "y2": 361, "speaking_score": 2.583333373069763, "active": true, "track_id": 1}]}, {"frame_number": 690, "faces": [{"x1": 746, "y1": 91, "x2": 1016, "y2": 361, "speaking_score": 2.600000023841858, "active": true, "track_id": 1}]}, {"frame_number": 691, "faces": [{"x1": 746, "y1": 91, "x2": 1016, "y2": 361, "speaking_score": 2.6166666746139526, "active": true, "track_id": 1}]}, {"frame_number": 692, "faces": [{"x1": 745, "y1": 91, "x2": 1014, "y2": 361, "speaking_score": 2.6333333253860474, "active": true, "track_id": 1}]}, {"frame_number": 693, "faces": [{"x1": 745, "y1": 91, "x2": 1014, "y2": 361, "speaking_score": 2.6333333253860474, "active": true, "track_id": 1}]}, {"frame_number": 694, "faces": [{"x1": 743, "y1": 90, "x2": 1013, "y2": 360, "speaking_score": 2.649999976158142, "active": true, "track_id": 1}]}, {"frame_number": 695, "faces": [{"x1": 742, "y1": 90, "x2": 1011, "y2": 360, "speaking_score": 2.649999976158142, "active": true, "track_id": 1}]}, {"frame_number": 696, "faces": [{"x1": 741, "y1": 90, "x2": 1009, "y2": 359, "speaking_score": 2.699999968210856, "active": true, "track_id": 1}]}, {"frame_number": 697, "faces": [{"x1": 740, "y1": 91, "x2": 1008, "y2": 359, "speaking_score": 2.799999952316284, "active": true, "track_id": 1}]}, {"frame_number": 698, "faces": [{"x1": 738, "y1": 90, "x2": 1006, "y2": 358, "speaking_score": 2.9333332777023315, "active": true, "track_id": 1}]}, {"frame_number": 699, "faces": [{"x1": 738, "y1": 90, "x2": 1006, "y2": 358, "speaking_score": 2.9333332777023315, "active": true, "track_id": 1}]}, {"frame_number": 700, "faces": [{"x1": 737, "y1": 89, "x2": 1006, "y2": 358, "speaking_score": 2.9999999602635703, "active": true, "track_id": 1}]}, {"frame_number": 701, "faces": [{"x1": 734, "y1": 89, "x2": 1002, "y2": 357, "speaking_score": 3.0333333015441895, "active": true, "track_id": 1}]}, {"frame_number": 702, "faces": [{"x1": 731, "y1": 89, "x2": 999, "y2": 357, "speaking_score": 3.0833332935969033, "active": true, "track_id": 1}]}, {"frame_number": 703, "faces": [{"x1": 728, "y1": 89, "x2": 996, "y2": 357, "speaking_score": 3.0833332935969033, "active": true, "track_id": 1}]}, {"frame_number": 704, "faces": [{"x1": 723, "y1": 88, "x2": 991, "y2": 356, "speaking_score": 3.0333333015441895, "active": true, "track_id": 1}]}, {"frame_number": 705, "faces": [{"x1": 723, "y1": 88, "x2": 991, "y2": 356, "speaking_score": 3.0333333015441895, "active": true, "track_id": 1}]}, {"frame_number": 706, "faces": [{"x1": 718, "y1": 87, "x2": 987, "y2": 356, "speaking_score": 2.966666658719381, "active": true, "track_id": 1}]}, {"frame_number": 707, "faces": [{"x1": 704, "y1": 86, "x2": 974, "y2": 356, "speaking_score": 2.466666658719381, "active": true, "track_id": 1}]}, {"frame_number": 708, "faces": [{"x1": 698, "y1": 83, "x2": 971, "y2": 356, "speaking_score": 1.9999999925494194, "active": true, "track_id": 1}]}, {"frame_number": 709, "faces": [{"x1": 691, "y1": 83, "x2": 964, "y2": 356, "speaking_score": 1.4833333181838195, "active": true, "track_id": 1}]}, {"frame_number": 710, "faces": [{"x1": 686, "y1": 82, "x2": 959, "y2": 356, "speaking_score": 1.0166666693985462, "active": true, "track_id": 1}]}, {"frame_number": 711, "faces": [{"x1": 686, "y1": 82, "x2": 959, "y2": 356, "speaking_score": 1.0166666693985462, "active": true, "track_id": 1}]}, {"frame_number": 712, "faces": [{"x1": 679, "y1": 82, "x2": 953, "y2": 356, "speaking_score": 0.5833333445092043, "active": true, "track_id": 1}]}, {"frame_number": 713, "faces": [{"x1": 661, "y1": 77, "x2": 945, "y2": 360, "speaking_score": 0.10000000273187955, "active": true, "track_id": 1}]}, {"frame_number": 714, "faces": [{"x1": 656, "y1": 76, "x2": 940, "y2": 360, "speaking_score": 0.0833333358168602, "active": true, "track_id": 1}]}, {"frame_number": 715, "faces": [{"x1": 650, "y1": 75, "x2": 934, "y2": 359, "speaking_score": 0.2666666607062022, "active": true, "track_id": 1}]}, {"frame_number": 716, "faces": [{"x1": 644, "y1": 74, "x2": 928, "y2": 358, "speaking_score": 0.6333333191772302, "active": true, "track_id": 1}]}, {"frame_number": 717, "faces": [{"x1": 644, "y1": 74, "x2": 928, "y2": 358, "speaking_score": 0.6333333191772302, "active": true, "track_id": 1}]}, {"frame_number": 718, "faces": [{"x1": 640, "y1": 73, "x2": 924, "y2": 357, "speaking_score": 1.066666666418314, "active": true, "track_id": 1}]}, {"frame_number": 719, "faces": [{"x1": 629, "y1": 69, "x2": 913, "y2": 352, "speaking_score": 1.5333333325882752, "active": true, "track_id": 1}]}, {"frame_number": 720, "faces": [{"x1": 624, "y1": 68, "x2": 908, "y2": 352, "speaking_score": 2.0833333171904087, "active": true, "track_id": 1}]}, {"frame_number": 721, "faces": [{"x1": 619, "y1": 68, "x2": 902, "y2": 352, "speaking_score": 2.5666666428248086, "active": true, "track_id": 1}]}, {"frame_number": 722, "faces": [{"x1": 612, "y1": 67, "x2": 894, "y2": 350, "speaking_score": 2.899999976158142, "active": true, "track_id": 1}]}, {"frame_number": 723, "faces": [{"x1": 612, "y1": 67, "x2": 894, "y2": 350, "speaking_score": 2.899999976158142, "active": true, "track_id": 1}]}, {"frame_number": 724, "faces": [{"x1": 608, "y1": 67, "x2": 889, "y2": 348, "speaking_score": 3.099999984105428, "active": true, "track_id": 1}]}, {"frame_number": 725, "faces": [{"x1": 595, "y1": 68, "x2": 875, "y2": 348, "speaking_score": 3.2166666189829507, "active": true, "track_id": 1}]}, {"frame_number": 726, "faces": [{"x1": 588, "y1": 68, "x2": 869, "y2": 348, "speaking_score": 3.3333332935969033, "active": true, "track_id": 1}]}, {"frame_number": 727, "faces": [{"x1": 580, "y1": 68, "x2": 861, "y2": 348, "speaking_score": 3.416666626930237, "active": true, "track_id": 1}]}, {"frame_number": 728, "faces": [{"x1": 572, "y1": 68, "x2": 853, "y2": 348, "speaking_score": 3.5166666507720947, "active": true, "track_id": 1}]}, {"frame_number": 729, "faces": [{"x1": 572, "y1": 68, "x2": 853, "y2": 348, "speaking_score": 3.5166666507720947, "active": true, "track_id": 1}]}, {"frame_number": 730, "faces": [{"x1": 566, "y1": 70, "x2": 846, "y2": 349, "speaking_score": 3.5166666507720947, "active": true, "track_id": 1}]}, {"frame_number": 731, "faces": [{"x1": 553, "y1": 70, "x2": 831, "y2": 348, "speaking_score": 3.449999968210856, "active": true, "track_id": 1}]}, {"frame_number": 732, "faces": [{"x1": 548, "y1": 70, "x2": 826, "y2": 348, "speaking_score": 3.366666634877523, "active": true, "track_id": 1}]}, {"frame_number": 733, "faces": [{"x1": 545, "y1": 70, "x2": 821, "y2": 347, "speaking_score": 3.2499999602635703, "active": true, "track_id": 1}]}, {"frame_number": 734, "faces": [{"x1": 541, "y1": 70, "x2": 816, "y2": 345, "speaking_score": 3.199999968210856, "active": true, "track_id": 1}]}, {"frame_number": 735, "faces": [{"x1": 541, "y1": 70, "x2": 816, "y2": 345, "speaking_score": 3.199999968210856, "active": true, "track_id": 1}]}, {"frame_number": 736, "faces": [{"x1": 538, "y1": 73, "x2": 808, "y2": 344, "speaking_score": 3.1833332777023315, "active": true, "track_id": 1}]}, {"frame_number": 737, "faces": [{"x1": 529, "y1": 74, "x2": 800, "y2": 345, "speaking_score": 3.066666603088379, "active": true, "track_id": 1}]}, {"frame_number": 738, "faces": [{"x1": 524, "y1": 74, "x2": 794, "y2": 345, "speaking_score": 2.9833332697550454, "active": true, "track_id": 1}]}, {"frame_number": 739, "faces": [{"x1": 517, "y1": 74, "x2": 789, "y2": 346, "speaking_score": 2.9333332777023315, "active": true, "track_id": 1}]}, {"frame_number": 740, "faces": [{"x1": 512, "y1": 76, "x2": 784, "y2": 348, "speaking_score": 2.916666626930237, "active": true, "track_id": 1}]}, {"frame_number": 741, "faces": [{"x1": 508, "y1": 76, "x2": 780, "y2": 348, "speaking_score": 2.8833332856496177, "active": true, "track_id": 1}]}, {"frame_number": 742, "faces": [{"x1": 508, "y1": 76, "x2": 780, "y2": 348, "speaking_score": 2.8833332856496177, "active": true, "track_id": 1}]}, {"frame_number": 743, "faces": [{"x1": 501, "y1": 75, "x2": 773, "y2": 347, "speaking_score": 2.8833332856496177, "active": true, "track_id": 1}]}, {"frame_number": 744, "faces": [{"x1": 498, "y1": 75, "x2": 770, "y2": 346, "speaking_score": 2.9999999602635703, "active": true, "track_id": 1}]}, {"frame_number": 745, "faces": [{"x1": 496, "y1": 75, "x2": 768, "y2": 347, "speaking_score": 3.0833332935969033, "active": true, "track_id": 1}]}, {"frame_number": 746, "faces": [{"x1": 493, "y1": 76, "x2": 765, "y2": 348, "speaking_score": 3.116666634877523, "active": true, "track_id": 1}]}, {"frame_number": 747, "faces": [{"x1": 490, "y1": 76, "x2": 763, "y2": 348, "speaking_score": 3.1333332856496177, "active": true, "track_id": 1}]}, {"frame_number": 748, "faces": [{"x1": 490, "y1": 76, "x2": 763, "y2": 348, "speaking_score": 3.1333332856496177, "active": true, "track_id": 1}]}, {"frame_number": 749, "faces": [{"x1": 485, "y1": 76, "x2": 758, "y2": 348, "speaking_score": 3.1333332856496177, "active": true, "track_id": 1}]}, {"frame_number": 750, "faces": [{"x1": 483, "y1": 76, "x2": 756, "y2": 348, "speaking_score": 3.0833332935969033, "active": true, "track_id": 1}]}, {"frame_number": 751, "faces": [{"x1": 482, "y1": 76, "x2": 754, "y2": 348, "speaking_score": 3.0666666428248086, "active": true, "track_id": 1}]}, {"frame_number": 752, "faces": [{"x1": 479, "y1": 76, "x2": 752, "y2": 348, "speaking_score": 3.099999984105428, "active": true, "track_id": 1}]}, {"frame_number": 753, "faces": [{"x1": 479, "y1": 75, "x2": 751, "y2": 347, "speaking_score": 3.1833333174387612, "active": true, "track_id": 1}]}, {"frame_number": 754, "faces": [{"x1": 479, "y1": 75, "x2": 751, "y2": 347, "speaking_score": 3.1833333174387612, "active": true, "track_id": 1}]}, {"frame_number": 755, "faces": [{"x1": 476, "y1": 75, "x2": 748, "y2": 347, "speaking_score": 3.25, "active": true, "track_id": 1}]}, {"frame_number": 756, "faces": [{"x1": 475, "y1": 75, "x2": 747, "y2": 346, "speaking_score": 3.2666666905085244, "active": true, "track_id": 1}]}, {"frame_number": 757, "faces": [{"x1": 474, "y1": 74, "x2": 746, "y2": 345, "speaking_score": 3.300000031789144, "active": true, "track_id": 1}]}, {"frame_number": 758, "faces": [{"x1": 474, "y1": 72, "x2": 745, "y2": 344, "speaking_score": 3.283333341280619, "active": true, "track_id": 1}]}, {"frame_number": 759, "faces": [{"x1": 474, "y1": 72, "x2": 745, "y2": 343, "speaking_score": 3.2166666984558105, "active": true, "track_id": 1}]}, {"frame_number": 760, "faces": [{"x1": 474, "y1": 72, "x2": 745, "y2": 343, "speaking_score": 3.2166666984558105, "active": true, "track_id": 1}]}, {"frame_number": 761, "faces": [{"x1": 473, "y1": 72, "x2": 744, "y2": 343, "speaking_score": 3.100000023841858, "active": true, "track_id": 1}]}, {"frame_number": 762, "faces": [{"x1": 473, "y1": 72, "x2": 744, "y2": 343, "speaking_score": 2.850000003973643, "active": true, "track_id": 1}]}, {"frame_number": 763, "faces": [{"x1": 473, "y1": 72, "x2": 744, "y2": 343, "speaking_score": 2.5333333214124045, "active": true, "track_id": 1}]}, {"frame_number": 764, "faces": [{"x1": 473, "y1": 72, "x2": 744, "y2": 343, "speaking_score": 2.13333331545194, "active": true, "track_id": 1}]}, {"frame_number": 765, "faces": [{"x1": 472, "y1": 71, "x2": 744, "y2": 343, "speaking_score": 1.6999999980131786, "active": true, "track_id": 1}]}, {"frame_number": 766, "faces": [{"x1": 472, "y1": 71, "x2": 744, "y2": 343, "speaking_score": 1.6999999980131786, "active": true, "track_id": 1}]}, {"frame_number": 767, "faces": [{"x1": 471, "y1": 70, "x2": 746, "y2": 345, "speaking_score": 1.1166666448116302, "active": true, "track_id": 1}]}, {"frame_number": 768, "faces": [{"x1": 471, "y1": 71, "x2": 746, "y2": 346, "speaking_score": 0.6166666522622108, "active": true, "track_id": 1}]}, {"frame_number": 769, "faces": [{"x1": 471, "y1": 71, "x2": 746, "y2": 346, "speaking_score": 0.26666665573914844, "active": true, "track_id": 1}]}, {"frame_number": 770, "faces": [{"x1": 471, "y1": 72, "x2": 746, "y2": 347, "speaking_score": -0.033333336313565574, "active": false, "track_id": 1}]}, {"frame_number": 771, "faces": [{"x1": 472, "y1": 72, "x2": 747, "y2": 347, "speaking_score": -0.2666666756073634, "active": false, "track_id": 1}]}, {"frame_number": 772, "faces": [{"x1": 472, "y1": 72, "x2": 747, "y2": 347, "speaking_score": -0.2666666756073634, "active": false, "track_id": 1}]}, {"frame_number": 773, "faces": [{"x1": 473, "y1": 72, "x2": 748, "y2": 347, "speaking_score": -0.38333334277073544, "active": false, "track_id": 1}]}, {"frame_number": 774, "faces": [{"x1": 473, "y1": 72, "x2": 749, "y2": 347, "speaking_score": -0.2000000054637591, "active": false, "track_id": 1}]}, {"frame_number": 775, "faces": [{"x1": 475, "y1": 72, "x2": 750, "y2": 348, "speaking_score": 0.0499999870856603, "active": true, "track_id": 1}]}, {"frame_number": 776, "faces": [{"x1": 476, "y1": 72, "x2": 752, "y2": 348, "speaking_score": 0.3999999836087227, "active": true, "track_id": 1}]}, {"frame_number": 777, "faces": [{"x1": 478, "y1": 72, "x2": 754, "y2": 348, "speaking_score": 0.7999999796350797, "active": true, "track_id": 1}]}, {"frame_number": 778, "faces": [{"x1": 478, "y1": 72, "x2": 754, "y2": 348, "speaking_score": 0.7999999796350797, "active": true, "track_id": 1}]}, {"frame_number": 779, "faces": [{"x1": 483, "y1": 72, "x2": 759, "y2": 348, "speaking_score": 1.2166666463017464, "active": true, "track_id": 1}]}, {"frame_number": 780, "faces": [{"x1": 486, "y1": 72, "x2": 763, "y2": 349, "speaking_score": 1.5666666428248088, "active": true, "track_id": 1}]}, {"frame_number": 781, "faces": [{"x1": 489, "y1": 73, "x2": 766, "y2": 350, "speaking_score": 1.899999976158142, "active": true, "track_id": 1}]}, {"frame_number": 782, "faces": [{"x1": 492, "y1": 73, "x2": 769, "y2": 350, "speaking_score": 2.099999984105428, "active": true, "track_id": 1}]}, {"frame_number": 783, "faces": [{"x1": 491, "y1": 70, "x2": 774, "y2": 354, "speaking_score": 2.26666667064031, "active": true, "track_id": 1}]}, {"frame_number": 784, "faces": [{"x1": 491, "y1": 70, "x2": 774, "y2": 354, "speaking_score": 2.26666667064031, "active": true, "track_id": 1}]}, {"frame_number": 785, "faces": [{"x1": 495, "y1": 69, "x2": 780, "y2": 354, "speaking_score": 2.4833333492279053, "active": true, "track_id": 1}]}, {"frame_number": 786, "faces": [{"x1": 495, "y1": 69, "x2": 780, "y2": 355, "speaking_score": 2.7333333690961203, "active": true, "track_id": 1}]}, {"frame_number": 787, "faces": [{"x1": 495, "y1": 69, "x2": 780, "y2": 355, "speaking_score": 3.0000000397364297, "active": true, "track_id": 1}]}, {"frame_number": 788, "faces": [{"x1": 495, "y1": 70, "x2": 780, "y2": 356, "speaking_score": 3.1666667064030967, "active": true, "track_id": 1}]}, {"frame_number": 789, "faces": [{"x1": 497, "y1": 71, "x2": 782, "y2": 356, "speaking_score": 3.3166667222976685, "active": true, "track_id": 1}]}, {"frame_number": 790, "faces": [{"x1": 497, "y1": 71, "x2": 782, "y2": 356, "speaking_score": 3.3166667222976685, "active": true, "track_id": 1}]}, {"frame_number": 791, "faces": [{"x1": 499, "y1": 71, "x2": 784, "y2": 356, "speaking_score": 3.3666667143503823, "active": true, "track_id": 1}]}, {"frame_number": 792, "faces": [{"x1": 501, "y1": 71, "x2": 786, "y2": 356, "speaking_score": 3.3666667143503823, "active": true, "track_id": 1}]}, {"frame_number": 793, "faces": [{"x1": 504, "y1": 71, "x2": 790, "y2": 356, "speaking_score": 3.333333373069763, "active": true, "track_id": 1}]}, {"frame_number": 794, "faces": [{"x1": 511, "y1": 71, "x2": 795, "y2": 356, "speaking_score": 3.300000031789144, "active": true, "track_id": 1}]}, {"frame_number": 795, "faces": [{"x1": 517, "y1": 73, "x2": 800, "y2": 355, "speaking_score": 3.2166666984558105, "active": true, "track_id": 1}]}, {"frame_number": 796, "faces": [{"x1": 517, "y1": 73, "x2": 800, "y2": 355, "speaking_score": 3.2166666984558105, "active": true, "track_id": 1}]}, {"frame_number": 797, "faces": [{"x1": 527, "y1": 74, "x2": 808, "y2": 354, "speaking_score": 3.050000031789144, "active": true, "track_id": 1}]}, {"frame_number": 798, "faces": [{"x1": 530, "y1": 74, "x2": 811, "y2": 354, "speaking_score": 2.9333333571751914, "active": true, "track_id": 1}]}, {"frame_number": 799, "faces": [{"x1": 532, "y1": 74, "x2": 813, "y2": 354, "speaking_score": 2.850000023841858, "active": true, "track_id": 1}]}, {"frame_number": 800, "faces": [{"x1": 534, "y1": 74, "x2": 814, "y2": 355, "speaking_score": 2.800000031789144, "active": true, "track_id": 1}]}, {"frame_number": 801, "faces": [{"x1": 535, "y1": 74, "x2": 816, "y2": 355, "speaking_score": 2.7500000397364297, "active": true, "track_id": 1}]}, {"frame_number": 802, "faces": [{"x1": 535, "y1": 74, "x2": 816, "y2": 355, "speaking_score": 2.7500000397364297, "active": true, "track_id": 1}]}, {"frame_number": 803, "faces": [{"x1": 541, "y1": 76, "x2": 822, "y2": 356, "speaking_score": 2.7500000397364297, "active": true, "track_id": 1}]}, {"frame_number": 804, "faces": [{"x1": 545, "y1": 77, "x2": 826, "y2": 357, "speaking_score": 2.850000023841858, "active": true, "track_id": 1}]}, {"frame_number": 805, "faces": [{"x1": 549, "y1": 77, "x2": 829, "y2": 357, "speaking_score": 2.950000007947286, "active": true, "track_id": 1}]}, {"frame_number": 806, "faces": [{"x1": 549, "y1": 76, "x2": 832, "y2": 358, "speaking_score": 3.049999992052714, "active": true, "track_id": 1}]}, {"frame_number": 807, "faces": [{"x1": 551, "y1": 75, "x2": 835, "y2": 359, "speaking_score": 3.1333333253860474, "active": true, "track_id": 1}]}, {"frame_number": 808, "faces": [{"x1": 551, "y1": 75, "x2": 835, "y2": 359, "speaking_score": 3.1333333253860474, "active": true, "track_id": 1}]}, {"frame_number": 809, "faces": [{"x1": 556, "y1": 75, "x2": 839, "y2": 359, "speaking_score": 3.216666658719381, "active": true, "track_id": 1}]}, {"frame_number": 810, "faces": [{"x1": 558, "y1": 75, "x2": 842, "y2": 359, "speaking_score": 3.3166666428248086, "active": true, "track_id": 1}]}, {"frame_number": 811, "faces": [{"x1": 561, "y1": 75, "x2": 845, "y2": 358, "speaking_score": 3.349999984105428, "active": true, "track_id": 1}]}, {"frame_number": 812, "faces": [{"x1": 563, "y1": 75, "x2": 846, "y2": 358, "speaking_score": 3.3833333253860474, "active": true, "track_id": 1}]}, {"frame_number": 813, "faces": [{"x1": 564, "y1": 75, "x2": 848, "y2": 358, "speaking_score": 3.4166666666666665, "active": true, "track_id": 1}]}, {"frame_number": 814, "faces": [{"x1": 564, "y1": 75, "x2": 848, "y2": 358, "speaking_score": 3.4166666666666665, "active": true, "track_id": 1}]}, {"frame_number": 815, "faces": [{"x1": 569, "y1": 75, "x2": 853, "y2": 358, "speaking_score": 3.449999968210856, "active": true, "track_id": 1}]}, {"frame_number": 816, "faces": [{"x1": 570, "y1": 74, "x2": 854, "y2": 359, "speaking_score": 3.4666666189829507, "active": true, "track_id": 1}]}, {"frame_number": 817, "faces": [{"x1": 570, "y1": 74, "x2": 855, "y2": 359, "speaking_score": 3.416666626930237, "active": true, "track_id": 1}]}, {"frame_number": 818, "faces": [{"x1": 571, "y1": 74, "x2": 856, "y2": 359, "speaking_score": 3.3999999364217124, "active": true, "track_id": 1}]}, {"frame_number": 819, "faces": [{"x1": 573, "y1": 74, "x2": 858, "y2": 359, "speaking_score": 3.366666595141093, "active": true, "track_id": 1}]}, {"frame_number": 820, "faces": [{"x1": 577, "y1": 73, "x2": 863, "y2": 360, "speaking_score": 3.349999944368998, "active": true, "track_id": 1}]}, {"frame_number": 821, "faces": [{"x1": 577, "y1": 73, "x2": 863, "y2": 360, "speaking_score": 3.349999944368998, "active": true, "track_id": 1}]}, {"frame_number": 822, "faces": [{"x1": 578, "y1": 74, "x2": 865, "y2": 361, "speaking_score": 3.3166666428248086, "active": true, "track_id": 1}]}, {"frame_number": 823, "faces": [{"x1": 581, "y1": 77, "x2": 867, "y2": 364, "speaking_score": 3.2333333094914756, "active": true, "track_id": 1}]}, {"frame_number": 824, "faces": [{"x1": 583, "y1": 79, "x2": 869, "y2": 365, "speaking_score": 3.199999968210856, "active": true, "track_id": 1}]}, {"frame_number": 825, "faces": [{"x1": 585, "y1": 79, "x2": 872, "y2": 365, "speaking_score": 3.149999976158142, "active": true, "track_id": 1}]}, {"frame_number": 826, "faces": [{"x1": 589, "y1": 79, "x2": 875, "y2": 366, "speaking_score": 3.1166666746139526, "active": true, "track_id": 1}]}, {"frame_number": 827, "faces": [{"x1": 589, "y1": 79, "x2": 875, "y2": 366, "speaking_score": 3.1166666746139526, "active": true, "track_id": 1}]}, {"frame_number": 828, "faces": [{"x1": 590, "y1": 80, "x2": 877, "y2": 366, "speaking_score": 3.0833333333333335, "active": true, "track_id": 1}]}, {"frame_number": 829, "faces": [{"x1": 591, "y1": 80, "x2": 878, "y2": 366, "speaking_score": 3.049999992052714, "active": true, "track_id": 1}]}, {"frame_number": 830, "faces": [{"x1": 593, "y1": 81, "x2": 879, "y2": 367, "speaking_score": 3.0666666825612388, "active": true, "track_id": 1}]}, {"frame_number": 831, "faces": [{"x1": 596, "y1": 82, "x2": 879, "y2": 366, "speaking_score": 3.050000031789144, "active": true, "track_id": 1}]}, {"frame_number": 832, "faces": [{"x1": 598, "y1": 82, "x2": 882, "y2": 366, "speaking_score": 3.083333373069763, "active": true, "track_id": 1}]}, {"frame_number": 833, "faces": [{"x1": 598, "y1": 82, "x2": 882, "y2": 366, "speaking_score": 3.083333373069763, "active": true, "track_id": 1}]}, {"frame_number": 834, "faces": [{"x1": 601, "y1": 83, "x2": 883, "y2": 365, "speaking_score": 3.133333365122477, "active": true, "track_id": 1}]}, {"frame_number": 835, "faces": [{"x1": 602, "y1": 84, "x2": 884, "y2": 366, "speaking_score": 3.200000007947286, "active": true, "track_id": 1}]}, {"frame_number": 836, "faces": [{"x1": 605, "y1": 87, "x2": 885, "y2": 367, "speaking_score": 3.3333333333333335, "active": true, "track_id": 1}]}, {"frame_number": 837, "faces": [{"x1": 606, "y1": 88, "x2": 886, "y2": 369, "speaking_score": 3.466666658719381, "active": true, "track_id": 1}]}, {"frame_number": 838, "faces": [{"x1": 609, "y1": 90, "x2": 889, "y2": 369, "speaking_score": 3.599999984105428, "active": true, "track_id": 1}]}, {"frame_number": 839, "faces": [{"x1": 609, "y1": 90, "x2": 889, "y2": 369, "speaking_score": 3.599999984105428, "active": true, "track_id": 1}]}, {"frame_number": 840, "faces": [{"x1": 610, "y1": 90, "x2": 889, "y2": 370, "speaking_score": 3.649999976158142, "active": true, "track_id": 1}]}, {"frame_number": 841, "faces": [{"x1": 611, "y1": 90, "x2": 890, "y2": 369, "speaking_score": 3.599999984105428, "active": true, "track_id": 1}]}, {"frame_number": 842, "faces": [{"x1": 613, "y1": 91, "x2": 892, "y2": 369, "speaking_score": 3.4833333492279053, "active": true, "track_id": 1}]}, {"frame_number": 843, "faces": [{"x1": 615, "y1": 91, "x2": 894, "y2": 369, "speaking_score": 3.300000031789144, "active": true, "track_id": 1}]}, {"frame_number": 844, "faces": [{"x1": 618, "y1": 91, "x2": 896, "y2": 370, "speaking_score": 3.050000031789144, "active": true, "track_id": 1}]}, {"frame_number": 845, "faces": [{"x1": 618, "y1": 91, "x2": 896, "y2": 370, "speaking_score": 3.050000031789144, "active": true, "track_id": 1}]}, {"frame_number": 846, "faces": [{"x1": 619, "y1": 91, "x2": 898, "y2": 370, "speaking_score": 2.8166667222976685, "active": true, "track_id": 1}]}, {"frame_number": 847, "faces": [{"x1": 620, "y1": 91, "x2": 899, "y2": 370, "speaking_score": 2.6000000635782876, "active": true, "track_id": 1}]}, {"frame_number": 848, "faces": [{"x1": 621, "y1": 92, "x2": 900, "y2": 370, "speaking_score": 2.3666667143503823, "active": true, "track_id": 1}]}, {"frame_number": 849, "faces": [{"x1": 622, "y1": 92, "x2": 900, "y2": 370, "speaking_score": 2.0000000298023224, "active": true, "track_id": 1}]}, {"frame_number": 850, "faces": [{"x1": 622, "y1": 92, "x2": 900, "y2": 370, "speaking_score": 1.5833333482344945, "active": true, "track_id": 1}]}, {"frame_number": 851, "faces": [{"x1": 622, "y1": 92, "x2": 900, "y2": 370, "speaking_score": 1.5833333482344945, "active": true, "track_id": 1}]}, {"frame_number": 852, "faces": [{"x1": 622, "y1": 92, "x2": 900, "y2": 370, "speaking_score": 1.4000000178813934, "active": true, "track_id": 1}]}, {"frame_number": 853, "faces": [{"x1": 622, "y1": 92, "x2": 900, "y2": 370, "speaking_score": 1.1499999985098839, "active": true, "track_id": 1}]}, {"frame_number": 854, "faces": [{"x1": 622, "y1": 92, "x2": 900, "y2": 370, "speaking_score": 0.8666666646798452, "active": true, "track_id": 1}]}, {"frame_number": 855, "faces": [{"x1": 622, "y1": 92, "x2": 899, "y2": 369, "speaking_score": 0.5499999970197678, "active": true, "track_id": 1}]}, {"frame_number": 856, "faces": [{"x1": 622, "y1": 92, "x2": 900, "y2": 370, "speaking_score": 0.8666666646798452, "active": true, "track_id": 1}]}, {"frame_number": 857, "faces": [{"x1": 622, "y1": 92, "x2": 899, "y2": 369, "speaking_score": 0.5499999970197678, "active": true, "track_id": 1}]}, {"frame_number": 858, "faces": []}, {"frame_number": 859, "faces": []}, {"frame_number": 860, "faces": []}, {"frame_number": 861, "faces": []}, {"frame_number": 862, "faces": []}, {"frame_number": 863, "faces": []}, {"frame_number": 864, "faces": []}, {"frame_number": 865, "faces": []}, {"frame_number": 866, "faces": []}, {"frame_number": 867, "faces": []}, {"frame_number": 868, "faces": []}, {"frame_number": 869, "faces": []}, {"frame_number": 870, "faces": []}, {"frame_number": 871, "faces": []}, {"frame_number": 872, "faces": []}, {"frame_number": 873, "faces": []}, {"frame_number": 874, "faces": []}, {"frame_number": 875, "faces": []}, {"frame_number": 876, "faces": []}, {"frame_number": 877, "faces": []}, {"frame_number": 878, "faces": []}, {"frame_number": 879, "faces": []}, {"frame_number": 880, "faces": []}, {"frame_number": 881, "faces": []}, {"frame_number": 882, "faces": []}, {"frame_number": 883, "faces": []}, {"frame_number": 884, "faces": []}, {"frame_number": 885, "faces": []}, {"frame_number": 886, "faces": []}, {"frame_number": 887, "faces": []}, {"frame_number": 888, "faces": []}, {"frame_number": 889, "faces": []}, {"frame_number": 890, "faces": []}, {"frame_number": 891, "faces": []}, {"frame_number": 892, "faces": []}, {"frame_number": 893, "faces": []}, {"frame_number": 894, "faces": []}, {"frame_number": 895, "faces": []}, {"frame_number": 896, "faces": []}, {"frame_number": 897, "faces": []}, {"frame_number": 898, "faces": []}, {"frame_number": 899, "faces": []}, {"frame_number": 900, "faces": []}, {"frame_number": 901, "faces": []}, {"frame_number": 902, "faces": []}, {"frame_number": 903, "faces": []}, {"frame_number": 904, "faces": []}, {"frame_number": 905, "faces": []}, {"frame_number": 906, "faces": []}, {"frame_number": 907, "faces": []}, {"frame_number": 908, "faces": []}, {"frame_number": 909, "faces": []}, {"frame_number": 910, "faces": []}, {"frame_number": 911, "faces": []}, {"frame_number": 912, "faces": []}, {"frame_number": 913, "faces": []}, {"frame_number": 914, "faces": []}, {"frame_number": 915, "faces": []}, {"frame_number": 916, "faces": []}, {"frame_number": 917, "faces": []}, {"frame_number": 918, "faces": []}, {"frame_number": 919, "faces": []}, {"frame_number": 920, "faces": []}, {"frame_number": 921, "faces": []}, {"frame_number": 922, "faces": []}, {"frame_number": 923, "faces": []}, {"frame_number": 924, "faces": []}, {"frame_number": 925, "faces": []}, {"frame_number": 926, "faces": []}, {"frame_number": 927, "faces": []}, {"frame_number": 928, "faces": []}, {"frame_number": 929, "faces": []}, {"frame_number": 930, "faces": []}, {"frame_number": 931, "faces": []}, {"frame_number": 932, "faces": []}, {"frame_number": 933, "faces": []}, {"frame_number": 934, "faces": []}, {"frame_number": 935, "faces": []}, {"frame_number": 936, "faces": []}, {"frame_number": 937, "faces": []}, {"frame_number": 938, "faces": []}, {"frame_number": 939, "faces": []}, {"frame_number": 940, "faces": []}, {"frame_number": 941, "faces": []}, {"frame_number": 942, "faces": []}, {"frame_number": 943, "faces": []}, {"frame_number": 944, "faces": []}, {"frame_number": 945, "faces": []}, {"frame_number": 946, "faces": []}, {"frame_number": 947, "faces": []}, {"frame_number": 948, "faces": []}, {"frame_number": 949, "faces": []}, {"frame_number": 950, "faces": []}, {"frame_number": 951, "faces": []}, {"frame_number": 952, "faces": []}, {"frame_number": 953, "faces": []}, {"frame_number": 954, "faces": []}, {"frame_number": 955, "faces": []}, {"frame_number": 956, "faces": []}, {"frame_number": 957, "faces": []}, {"frame_number": 958, "faces": []}, {"frame_number": 959, "faces": []}, {"frame_number": 960, "faces": []}, {"frame_number": 961, "faces": []}, {"frame_number": 962, "faces": []}, {"frame_number": 963, "faces": []}, {"frame_number": 964, "faces": []}, {"frame_number": 965, "faces": []}, {"frame_number": 966, "faces": []}, {"frame_number": 967, "faces": []}, {"frame_number": 968, "faces": []}, {"frame_number": 969, "faces": []}, {"frame_number": 970, "faces": []}, {"frame_number": 971, "faces": []}, {"frame_number": 972, "faces": []}, {"frame_number": 973, "faces": []}, {"frame_number": 974, "faces": []}, {"frame_number": 975, "faces": []}, {"frame_number": 976, "faces": []}, {"frame_number": 977, "faces": []}, {"frame_number": 978, "faces": []}, {"frame_number": 979, "faces": []}, {"frame_number": 980, "faces": []}, {"frame_number": 981, "faces": []}, {"frame_number": 982, "faces": []}, {"frame_number": 983, "faces": []}, {"frame_number": 984, "faces": []}, {"frame_number": 985, "faces": []}, {"frame_number": 986, "faces": []}, {"frame_number": 987, "faces": []}, {"frame_number": 988, "faces": []}, {"frame_number": 989, "faces": []}, {"frame_number": 990, "faces": []}, {"frame_number": 991, "faces": []}, {"frame_number": 992, "faces": []}, {"frame_number": 993, "faces": []}, {"frame_number": 994, "faces": []}, {"frame_number": 995, "faces": []}, {"frame_number": 996, "faces": []}, {"frame_number": 997, "faces": []}, {"frame_number": 998, "faces": []}, {"frame_number": 999, "faces": []}, {"frame_number": 1000, "faces": []}, {"frame_number": 1001, "faces": []}, {"frame_number": 1002, "faces": []}, {"frame_number": 1003, "faces": []}, {"frame_number": 1004, "faces": []}, {"frame_number": 1005, "faces": []}, {"frame_number": 1006, "faces": []}, {"frame_number": 1007, "faces": []}, {"frame_number": 1008, "faces": []}, {"frame_number": 1009, "faces": []}, {"frame_number": 1010, "faces": []}, {"frame_number": 1011, "faces": []}, {"frame_number": 1012, "faces": []}, {"frame_number": 1013, "faces": []}, {"frame_number": 1014, "faces": []}, {"frame_number": 1015, "faces": []}, {"frame_number": 1016, "faces": []}, {"frame_number": 1017, "faces": []}, {"frame_number": 1018, "faces": []}, {"frame_number": 1019, "faces": []}, {"frame_number": 1020, "faces": []}, {"frame_number": 1021, "faces": []}, {"frame_number": 1022, "faces": []}, {"frame_number": 1023, "faces": []}, {"frame_number": 1024, "faces": []}, {"frame_number": 1025, "faces": []}, {"frame_number": 1026, "faces": []}, {"frame_number": 1027, "faces": []}, {"frame_number": 1028, "faces": []}, {"frame_number": 1029, "faces": []}, {"frame_number": 1030, "faces": []}, {"frame_number": 1031, "faces": []}, {"frame_number": 1032, "faces": []}, {"frame_number": 1033, "faces": []}, {"frame_number": 1034, "faces": []}, {"frame_number": 1035, "faces": []}, {"frame_number": 1036, "faces": []}, {"frame_number": 1037, "faces": []}, {"frame_number": 1038, "faces": []}, {"frame_number": 1039, "faces": []}, {"frame_number": 1040, "faces": []}, {"frame_number": 1041, "faces": []}, {"frame_number": 1042, "faces": []}, {"frame_number": 1043, "faces": []}, {"frame_number": 1044, "faces": []}, {"frame_number": 1045, "faces": []}, {"frame_number": 1046, "faces": []}, {"frame_number": 1047, "faces": []}, {"frame_number": 1048, "faces": []}, {"frame_number": 1049, "faces": []}, {"frame_number": 1050, "faces": []}, {"frame_number": 1051, "faces": []}, {"frame_number": 1052, "faces": []}, {"frame_number": 1053, "faces": []}, {"frame_number": 1054, "faces": []}, {"frame_number": 1055, "faces": []}, {"frame_number": 1056, "faces": []}, {"frame_number": 1057, "faces": []}, {"frame_number": 1058, "faces": []}, {"frame_number": 1059, "faces": []}, {"frame_number": 1060, "faces": []}, {"frame_number": 1061, "faces": []}, {"frame_number": 1062, "faces": []}, {"frame_number": 1062, "faces": [{"x1": 755, "y1": 192, "x2": 804, "y2": 241, "speaking_score": 2.949999988079071, "active": true, "track_id": 2}]}, {"frame_number": 1063, "faces": [{"x1": 754, "y1": 193, "x2": 804, "y2": 242, "speaking_score": 3.1, "active": true, "track_id": 2}]}, {"frame_number": 1064, "faces": [{"x1": 754, "y1": 193, "x2": 804, "y2": 242, "speaking_score": 3.1, "active": true, "track_id": 2}]}, {"frame_number": 1065, "faces": [{"x1": 754, "y1": 192, "x2": 805, "y2": 243, "speaking_score": 3.216666658719381, "active": true, "track_id": 2}]}, {"frame_number": 1066, "faces": [{"x1": 754, "y1": 192, "x2": 805, "y2": 243, "speaking_score": 3.5, "active": true, "track_id": 2}]}, {"frame_number": 1067, "faces": [{"x1": 754, "y1": 193, "x2": 805, "y2": 244, "speaking_score": 3.700000007947286, "active": true, "track_id": 2}]}, {"frame_number": 1068, "faces": [{"x1": 754, "y1": 193, "x2": 805, "y2": 244, "speaking_score": 3.6833333571751914, "active": true, "track_id": 2}]}, {"frame_number": 1069, "faces": [{"x1": 751, "y1": 193, "x2": 801, "y2": 244, "speaking_score": 3.6166666746139526, "active": true, "track_id": 2}]}, {"frame_number": 1070, "faces": [{"x1": 751, "y1": 193, "x2": 801, "y2": 244, "speaking_score": 3.6166666746139526, "active": true, "track_id": 2}]}, {"frame_number": 1071, "faces": [{"x1": 751, "y1": 194, "x2": 800, "y2": 244, "speaking_score": 3.5833333333333335, "active": true, "track_id": 2}]}, {"frame_number": 1072, "faces": [{"x1": 746, "y1": 194, "x2": 796, "y2": 243, "speaking_score": 3.5166666905085244, "active": true, "track_id": 2}]}, {"frame_number": 1073, "faces": [{"x1": 746, "y1": 194, "x2": 796, "y2": 243, "speaking_score": 3.400000015894572, "active": true, "track_id": 2}]}, {"frame_number": 1074, "faces": [{"x1": 743, "y1": 194, "x2": 792, "y2": 243, "speaking_score": 3.299999992052714, "active": true, "track_id": 2}]}, {"frame_number": 1075, "faces": [{"x1": 742, "y1": 194, "x2": 791, "y2": 243, "speaking_score": 3.2666666507720947, "active": true, "track_id": 2}]}, {"frame_number": 1076, "faces": [{"x1": 742, "y1": 194, "x2": 791, "y2": 243, "speaking_score": 3.2666666507720947, "active": true, "track_id": 2}]}, {"frame_number": 1077, "faces": [{"x1": 740, "y1": 194, "x2": 789, "y2": 243, "speaking_score": 3.2666666507720947, "active": true, "track_id": 2}]}, {"frame_number": 1078, "faces": [{"x1": 737, "y1": 194, "x2": 786, "y2": 243, "speaking_score": 3.2333333094914756, "active": true, "track_id": 2}]}, {"frame_number": 1079, "faces": [{"x1": 735, "y1": 194, "x2": 784, "y2": 243, "speaking_score": 3.199999968210856, "active": true, "track_id": 2}]}, {"frame_number": 1080, "faces": [{"x1": 734, "y1": 194, "x2": 783, "y2": 243, "speaking_score": 3.2333333094914756, "active": true, "track_id": 2}]}, {"frame_number": 1081, "faces": [{"x1": 732, "y1": 194, "x2": 780, "y2": 242, "speaking_score": 3.3166666428248086, "active": true, "track_id": 2}]}, {"frame_number": 1082, "faces": [{"x1": 731, "y1": 194, "x2": 780, "y2": 242, "speaking_score": 3.349999984105428, "active": true, "track_id": 2}]}, {"frame_number": 1083, "faces": [{"x1": 731, "y1": 194, "x2": 780, "y2": 242, "speaking_score": 3.349999984105428, "active": true, "track_id": 2}]}, {"frame_number": 1084, "faces": [{"x1": 730, "y1": 194, "x2": 778, "y2": 242, "speaking_score": 3.349999984105428, "active": true, "track_id": 2}]}, {"frame_number": 1085, "faces": [{"x1": 729, "y1": 194, "x2": 777, "y2": 242, "speaking_score": 3.3166666428248086, "active": true, "track_id": 2}]}, {"frame_number": 1086, "faces": [{"x1": 728, "y1": 195, "x2": 776, "y2": 242, "speaking_score": 3.3333332935969033, "active": true, "track_id": 2}]}, {"frame_number": 1087, "faces": [{"x1": 727, "y1": 195, "x2": 775, "y2": 242, "speaking_score": 3.299999952316284, "active": true, "track_id": 2}]}, {"frame_number": 1088, "faces": [{"x1": 727, "y1": 195, "x2": 774, "y2": 242, "speaking_score": 3.1833333174387612, "active": true, "track_id": 2}]}, {"frame_number": 1089, "faces": [{"x1": 727, "y1": 195, "x2": 774, "y2": 242, "speaking_score": 3.1833333174387612, "active": true, "track_id": 2}]}, {"frame_number": 1090, "faces": [{"x1": 725, "y1": 195, "x2": 773, "y2": 243, "speaking_score": 3.116666634877523, "active": true, "track_id": 2}]}, {"frame_number": 1091, "faces": [{"x1": 724, "y1": 195, "x2": 772, "y2": 243, "speaking_score": 3.0833332935969033, "active": true, "track_id": 2}]}, {"frame_number": 1092, "faces": [{"x1": 724, "y1": 195, "x2": 771, "y2": 243, "speaking_score": 3.0166666507720947, "active": true, "track_id": 2}]}, {"frame_number": 1093, "faces": [{"x1": 723, "y1": 195, "x2": 770, "y2": 243, "speaking_score": 2.899999976158142, "active": true, "track_id": 2}]}, {"frame_number": 1094, "faces": [{"x1": 722, "y1": 195, "x2": 770, "y2": 243, "speaking_score": 2.849999984105428, "active": true, "track_id": 2}]}, {"frame_number": 1095, "faces": [{"x1": 722, "y1": 195, "x2": 770, "y2": 243, "speaking_score": 2.849999984105428, "active": true, "track_id": 2}]}, {"frame_number": 1096, "faces": [{"x1": 722, "y1": 195, "x2": 769, "y2": 243, "speaking_score": 2.8333332935969033, "active": true, "track_id": 2}]}, {"frame_number": 1097, "faces": [{"x1": 721, "y1": 195, "x2": 769, "y2": 243, "speaking_score": 2.7833333015441895, "active": true, "track_id": 2}]}, {"frame_number": 1098, "faces": [{"x1": 720, "y1": 194, "x2": 769, "y2": 243, "speaking_score": 2.6666666666666665, "active": true, "track_id": 2}]}, {"frame_number": 1099, "faces": [{"x1": 718, "y1": 194, "x2": 768, "y2": 244, "speaking_score": 2.6166666746139526, "active": true, "track_id": 2}]}, {"frame_number": 1100, "faces": [{"x1": 718, "y1": 194, "x2": 767, "y2": 244, "speaking_score": 2.583333373069763, "active": true, "track_id": 2}]}, {"frame_number": 1101, "faces": [{"x1": 718, "y1": 194, "x2": 767, "y2": 244, "speaking_score": 2.583333373069763, "active": true, "track_id": 2}]}, {"frame_number": 1102, "faces": [{"x1": 717, "y1": 194, "x2": 767, "y2": 244, "speaking_score": 2.483333388964335, "active": true, "track_id": 2}]}, {"frame_number": 1103, "faces": [{"x1": 717, "y1": 194, "x2": 767, "y2": 244, "speaking_score": 2.2500000596046448, "active": true, "track_id": 2}]}, {"frame_number": 1104, "faces": [{"x1": 717, "y1": 193, "x2": 767, "y2": 244, "speaking_score": 1.9833333889643352, "active": true, "track_id": 2}]}, {"frame_number": 1105, "faces": [{"x1": 717, "y1": 193, "x2": 767, "y2": 244, "speaking_score": 1.7333333690961201, "active": true, "track_id": 2}]}, {"frame_number": 1106, "faces": [{"x1": 717, "y1": 193, "x2": 767, "y2": 244, "speaking_score": 1.4333333571751912, "active": true, "track_id": 2}]}, {"frame_number": 1107, "faces": [{"x1": 717, "y1": 193, "x2": 767, "y2": 244, "speaking_score": 1.4333333571751912, "active": true, "track_id": 2}]}, {"frame_number": 1108, "faces": [{"x1": 717, "y1": 193, "x2": 767, "y2": 244, "speaking_score": 1.1000000089406967, "active": true, "track_id": 2}]}, {"frame_number": 1109, "faces": [{"x1": 716, "y1": 193, "x2": 767, "y2": 244, "speaking_score": 0.8000000019868215, "active": true, "track_id": 2}]}, {"frame_number": 1110, "faces": [{"x1": 716, "y1": 193, "x2": 767, "y2": 244, "speaking_score": 0.6833333373069763, "active": true, "track_id": 2}]}, {"frame_number": 1111, "faces": [{"x1": 716, "y1": 193, "x2": 767, "y2": 244, "speaking_score": 0.8166666626930237, "active": true, "track_id": 2}]}, {"frame_number": 1112, "faces": [{"x1": 716, "y1": 193, "x2": 767, "y2": 244, "speaking_score": 1.0833333333333333, "active": true, "track_id": 2}]}, {"frame_number": 1113, "faces": [{"x1": 716, "y1": 193, "x2": 767, "y2": 244, "speaking_score": 1.0833333333333333, "active": true, "track_id": 2}]}, {"frame_number": 1114, "faces": [{"x1": 716, "y1": 194, "x2": 768, "y2": 247, "speaking_score": 1.449999988079071, "active": true, "track_id": 2}]}, {"frame_number": 1115, "faces": [{"x1": 716, "y1": 194, "x2": 769, "y2": 247, "speaking_score": 1.8999999711910884, "active": true, "track_id": 2}]}, {"frame_number": 1116, "faces": [{"x1": 716, "y1": 194, "x2": 769, "y2": 248, "speaking_score": 2.383333295583725, "active": true, "track_id": 2}]}, {"frame_number": 1117, "faces": [{"x1": 716, "y1": 194, "x2": 769, "y2": 248, "speaking_score": 2.7999999721844993, "active": true, "track_id": 2}]}, {"frame_number": 1118, "faces": [{"x1": 716, "y1": 194, "x2": 770, "y2": 248, "speaking_score": 2.966666658719381, "active": true, "track_id": 2}]}, {"frame_number": 1119, "faces": [{"x1": 716, "y1": 194, "x2": 770, "y2": 248, "speaking_score": 2.966666658719381, "active": true, "track_id": 2}]}, {"frame_number": 1120, "faces": [{"x1": 716, "y1": 194, "x2": 770, "y2": 248, "speaking_score": 3.0166666507720947, "active": true, "track_id": 2}]}, {"frame_number": 1121, "faces": [{"x1": 717, "y1": 194, "x2": 770, "y2": 248, "speaking_score": 3.033333341280619, "active": true, "track_id": 2}]}, {"frame_number": 1122, "faces": [{"x1": 717, "y1": 194, "x2": 771, "y2": 248, "speaking_score": 3.0000000397364297, "active": true, "track_id": 2}]}, {"frame_number": 1123, "faces": [{"x1": 717, "y1": 194, "x2": 771, "y2": 248, "speaking_score": 2.933333396911621, "active": true, "track_id": 2}]}, {"frame_number": 1124, "faces": [{"x1": 717, "y1": 194, "x2": 771, "y2": 248, "speaking_score": 2.9166667064030967, "active": true, "track_id": 2}]}, {"frame_number": 1125, "faces": [{"x1": 717, "y1": 194, "x2": 771, "y2": 248, "speaking_score": 2.9166667064030967, "active": true, "track_id": 2}]}, {"frame_number": 1126, "faces": [{"x1": 718, "y1": 194, "x2": 771, "y2": 247, "speaking_score": 2.9166667064030967, "active": true, "track_id": 2}]}, {"frame_number": 1127, "faces": [{"x1": 718, "y1": 194, "x2": 771, "y2": 247, "speaking_score": 2.9666666984558105, "active": true, "track_id": 2}]}, {"frame_number": 1128, "faces": [{"x1": 718, "y1": 194, "x2": 771, "y2": 247, "speaking_score": 3.033333341280619, "active": true, "track_id": 2}]}, {"frame_number": 1129, "faces": [{"x1": 718, "y1": 194, "x2": 771, "y2": 247, "speaking_score": 3.1166666746139526, "active": true, "track_id": 2}]}, {"frame_number": 1130, "faces": [{"x1": 718, "y1": 194, "x2": 771, "y2": 247, "speaking_score": 3.149999976158142, "active": true, "track_id": 2}]}, {"frame_number": 1131, "faces": [{"x1": 718, "y1": 194, "x2": 771, "y2": 247, "speaking_score": 3.149999976158142, "active": true, "track_id": 2}]}, {"frame_number": 1132, "faces": [{"x1": 718, "y1": 194, "x2": 771, "y2": 247, "speaking_score": 3.1333333253860474, "active": true, "track_id": 2}]}, {"frame_number": 1133, "faces": [{"x1": 718, "y1": 194, "x2": 771, "y2": 247, "speaking_score": 3.149999976158142, "active": true, "track_id": 2}]}, {"frame_number": 1134, "faces": [{"x1": 718, "y1": 194, "x2": 771, "y2": 247, "speaking_score": 3.1166666746139526, "active": true, "track_id": 2}]}, {"frame_number": 1135, "faces": [{"x1": 718, "y1": 194, "x2": 771, "y2": 247, "speaking_score": 3.050000031789144, "active": true, "track_id": 2}]}, {"frame_number": 1136, "faces": [{"x1": 719, "y1": 194, "x2": 771, "y2": 247, "speaking_score": 2.9333333571751914, "active": true, "track_id": 2}]}, {"frame_number": 1137, "faces": [{"x1": 719, "y1": 194, "x2": 771, "y2": 247, "speaking_score": 2.9333333571751914, "active": true, "track_id": 2}]}, {"frame_number": 1138, "faces": [{"x1": 721, "y1": 195, "x2": 773, "y2": 247, "speaking_score": 2.883333365122477, "active": true, "track_id": 2}]}, {"frame_number": 1139, "faces": [{"x1": 721, "y1": 196, "x2": 773, "y2": 247, "speaking_score": 2.883333365122477, "active": true, "track_id": 2}]}, {"frame_number": 1140, "faces": [{"x1": 721, "y1": 196, "x2": 773, "y2": 247, "speaking_score": 2.8666667143503823, "active": true, "track_id": 2}]}, {"frame_number": 1141, "faces": [{"x1": 722, "y1": 196, "x2": 773, "y2": 247, "speaking_score": 2.833333373069763, "active": true, "track_id": 2}]}, {"frame_number": 1142, "faces": [{"x1": 722, "y1": 196, "x2": 773, "y2": 247, "speaking_score": 2.800000031789144, "active": true, "track_id": 2}]}, {"frame_number": 1143, "faces": [{"x1": 722, "y1": 196, "x2": 773, "y2": 247, "speaking_score": 2.800000031789144, "active": true, "track_id": 2}]}, {"frame_number": 1144, "faces": [{"x1": 722, "y1": 196, "x2": 774, "y2": 248, "speaking_score": 2.8166666825612388, "active": true, "track_id": 2}]}, {"frame_number": 1145, "faces": [{"x1": 723, "y1": 196, "x2": 774, "y2": 248, "speaking_score": 2.7666666905085244, "active": true, "track_id": 2}]}, {"frame_number": 1146, "faces": [{"x1": 723, "y1": 196, "x2": 775, "y2": 248, "speaking_score": 2.650000015894572, "active": true, "track_id": 2}]}, {"frame_number": 1147, "faces": [{"x1": 723, "y1": 197, "x2": 775, "y2": 248, "speaking_score": 2.533333341280619, "active": true, "track_id": 2}]}, {"frame_number": 1148, "faces": [{"x1": 723, "y1": 197, "x2": 775, "y2": 248, "speaking_score": 2.5, "active": true, "track_id": 2}]}, {"frame_number": 1149, "faces": [{"x1": 723, "y1": 197, "x2": 775, "y2": 248, "speaking_score": 2.5, "active": true, "track_id": 2}]}, {"frame_number": 1150, "faces": [{"x1": 724, "y1": 197, "x2": 776, "y2": 248, "speaking_score": 2.450000007947286, "active": true, "track_id": 2}]}, {"frame_number": 1151, "faces": [{"x1": 725, "y1": 197, "x2": 776, "y2": 248, "speaking_score": 2.400000015894572, "active": true, "track_id": 2}]}, {"frame_number": 1152, "faces": [{"x1": 725, "y1": 197, "x2": 776, "y2": 248, "speaking_score": 2.4166666666666665, "active": true, "track_id": 2}]}, {"frame_number": 1153, "faces": [{"x1": 725, "y1": 197, "x2": 777, "y2": 248, "speaking_score": 2.450000007947286, "active": true, "track_id": 2}]}, {"frame_number": 1154, "faces": [{"x1": 725, "y1": 197, "x2": 777, "y2": 248, "speaking_score": 2.533333341280619, "active": true, "track_id": 2}]}, {"frame_number": 1155, "faces": [{"x1": 725, "y1": 197, "x2": 777, "y2": 249, "speaking_score": 2.600000023841858, "active": true, "track_id": 2}]}, {"frame_number": 1156, "faces": [{"x1": 725, "y1": 197, "x2": 777, "y2": 249, "speaking_score": 2.600000023841858, "active": true, "track_id": 2}]}, {"frame_number": 1157, "faces": [{"x1": 725, "y1": 197, "x2": 777, "y2": 249, "speaking_score": 2.700000007947286, "active": true, "track_id": 2}]}, {"frame_number": 1158, "faces": [{"x1": 725, "y1": 196, "x2": 777, "y2": 249, "speaking_score": 2.8166666825612388, "active": true, "track_id": 2}]}, {"frame_number": 1159, "faces": [{"x1": 725, "y1": 196, "x2": 778, "y2": 249, "speaking_score": 2.900000015894572, "active": true, "track_id": 2}]}, {"frame_number": 1160, "faces": [{"x1": 725, "y1": 196, "x2": 778, "y2": 249, "speaking_score": 2.9333333571751914, "active": true, "track_id": 2}]}, {"frame_number": 1161, "faces": [{"x1": 725, "y1": 196, "x2": 778, "y2": 249, "speaking_score": 2.8666666746139526, "active": true, "track_id": 2}]}, {"frame_number": 1162, "faces": [{"x1": 725, "y1": 196, "x2": 778, "y2": 249, "speaking_score": 2.8666666746139526, "active": true, "track_id": 2}]}, {"frame_number": 1163, "faces": [{"x1": 725, "y1": 196, "x2": 778, "y2": 249, "speaking_score": 2.7333333094914756, "active": true, "track_id": 2}]}, {"frame_number": 1164, "faces": [{"x1": 725, "y1": 196, "x2": 778, "y2": 249, "speaking_score": 2.5666666428248086, "active": true, "track_id": 2}]}, {"frame_number": 1165, "faces": [{"x1": 725, "y1": 196, "x2": 778, "y2": 248, "speaking_score": 2.3333332935969033, "active": true, "track_id": 2}]}, {"frame_number": 1166, "faces": [{"x1": 725, "y1": 196, "x2": 778, "y2": 248, "speaking_score": 2.0499999721844993, "active": true, "track_id": 2}]}, {"frame_number": 1167, "faces": [{"x1": 725, "y1": 196, "x2": 777, "y2": 248, "speaking_score": 1.6833332975705464, "active": true, "track_id": 2}]}, {"frame_number": 1168, "faces": [{"x1": 725, "y1": 196, "x2": 777, "y2": 248, "speaking_score": 1.6833332975705464, "active": true, "track_id": 2}]}, {"frame_number": 1169, "faces": [{"x1": 725, "y1": 196, "x2": 777, "y2": 248, "speaking_score": 1.2666666383544605, "active": true, "track_id": 2}]}, {"frame_number": 1170, "faces": [{"x1": 725, "y1": 196, "x2": 777, "y2": 248, "speaking_score": 0.7999999895691872, "active": true, "track_id": 2}]}, {"frame_number": 1171, "faces": [{"x1": 725, "y1": 196, "x2": 777, "y2": 248, "speaking_score": 0.3166666602094968, "active": true, "track_id": 2}]}, {"frame_number": 1172, "faces": [{"x1": 725, "y1": 196, "x2": 777, "y2": 248, "speaking_score": -0.13333332786957422, "active": false, "track_id": 2}]}, {"frame_number": 1173, "faces": [{"x1": 725, "y1": 196, "x2": 777, "y2": 248, "speaking_score": -0.5333333238959312, "active": false, "track_id": 2}]}, {"frame_number": 1174, "faces": [{"x1": 725, "y1": 196, "x2": 777, "y2": 248, "speaking_score": -0.5333333238959312, "active": false, "track_id": 2}]}, {"frame_number": 1175, "faces": [{"x1": 725, "y1": 196, "x2": 777, "y2": 248, "speaking_score": -0.7999999945362409, "active": false, "track_id": 2}]}, {"frame_number": 1176, "faces": [{"x1": 724, "y1": 196, "x2": 776, "y2": 248, "speaking_score": -0.9666666686534882, "active": false, "track_id": 2}]}, {"frame_number": 1177, "faces": [{"x1": 724, "y1": 196, "x2": 776, "y2": 248, "speaking_score": -1.0833333333333333, "active": false, "track_id": 2}]}, {"frame_number": 1178, "faces": [{"x1": 724, "y1": 196, "x2": 776, "y2": 248, "speaking_score": -1.4166666865348816, "active": false, "track_id": 2}]}, {"frame_number": 1179, "faces": [{"x1": 724, "y1": 195, "x2": 776, "y2": 247, "speaking_score": -1.75000003973643, "active": false, "track_id": 2}]}, {"frame_number": 1180, "faces": [{"x1": 724, "y1": 195, "x2": 776, "y2": 247, "speaking_score": -1.75000003973643, "active": false, "track_id": 2}]}, {"frame_number": 1181, "faces": [{"x1": 724, "y1": 195, "x2": 776, "y2": 247, "speaking_score": -2.083333373069763, "active": false, "track_id": 2}]}, {"frame_number": 1182, "faces": [{"x1": 724, "y1": 195, "x2": 776, "y2": 247, "speaking_score": -2.4166666865348816, "active": false, "track_id": 2}]}, {"frame_number": 1183, "faces": [{"x1": 724, "y1": 195, "x2": 776, "y2": 247, "speaking_score": -2.750000019868215, "active": false, "track_id": 2}]}, {"frame_number": 1184, "faces": [{"x1": 724, "y1": 195, "x2": 776, "y2": 247, "speaking_score": -3.0166666905085244, "active": false, "track_id": 2}]}, {"frame_number": 1185, "faces": [{"x1": 724, "y1": 195, "x2": 776, "y2": 247, "speaking_score": -2.9833333492279053, "active": false, "track_id": 2}]}, {"frame_number": 1186, "faces": [{"x1": 724, "y1": 195, "x2": 776, "y2": 247, "speaking_score": -2.9833333492279053, "active": false, "track_id": 2}]}, {"frame_number": 1187, "faces": [{"x1": 724, "y1": 195, "x2": 776, "y2": 247, "speaking_score": -2.9333333174387612, "active": false, "track_id": 2}]}, {"frame_number": 1188, "faces": [{"x1": 724, "y1": 195, "x2": 776, "y2": 247, "speaking_score": -2.8833333253860474, "active": false, "track_id": 2}]}, {"frame_number": 1189, "faces": [{"x1": 724, "y1": 195, "x2": 776, "y2": 247, "speaking_score": -2.850000023841858, "active": false, "track_id": 2}]}, {"frame_number": 1190, "faces": [{"x1": 724, "y1": 195, "x2": 776, "y2": 247, "speaking_score": -2.8166666825612388, "active": false, "track_id": 2}]}, {"frame_number": 1191, "faces": [{"x1": 724, "y1": 195, "x2": 776, "y2": 247, "speaking_score": -2.800000031789144, "active": false, "track_id": 2}]}, {"frame_number": 1192, "faces": [{"x1": 724, "y1": 195, "x2": 776, "y2": 247, "speaking_score": -2.800000031789144, "active": false, "track_id": 2}]}, {"frame_number": 1193, "faces": [{"x1": 724, "y1": 195, "x2": 776, "y2": 247, "speaking_score": -2.833333373069763, "active": false, "track_id": 2}]}, {"frame_number": 1194, "faces": [{"x1": 725, "y1": 195, "x2": 777, "y2": 246, "speaking_score": -2.8500000635782876, "active": false, "track_id": 2}]}, {"frame_number": 1195, "faces": [{"x1": 725, "y1": 194, "x2": 777, "y2": 246, "speaking_score": -2.833333373069763, "active": false, "track_id": 2}]}, {"frame_number": 1196, "faces": [{"x1": 726, "y1": 194, "x2": 778, "y2": 246, "speaking_score": -2.783333341280619, "active": false, "track_id": 2}]}, {"frame_number": 1197, "faces": [{"x1": 726, "y1": 193, "x2": 778, "y2": 246, "speaking_score": -2.6833333571751914, "active": false, "track_id": 2}]}, {"frame_number": 1198, "faces": [{"x1": 726, "y1": 193, "x2": 778, "y2": 246, "speaking_score": -2.6833333571751914, "active": false, "track_id": 2}]}, {"frame_number": 1199, "faces": [{"x1": 726, "y1": 193, "x2": 779, "y2": 246, "speaking_score": -2.5, "active": false, "track_id": 2}]}, {"frame_number": 1200, "faces": [{"x1": 726, "y1": 193, "x2": 779, "y2": 246, "speaking_score": -2.166666646798452, "active": false, "track_id": 2}]}, {"frame_number": 1201, "faces": [{"x1": 727, "y1": 193, "x2": 780, "y2": 246, "speaking_score": -1.8666666348775227, "active": false, "track_id": 2}]}, {"frame_number": 1202, "faces": [{"x1": 727, "y1": 192, "x2": 780, "y2": 245, "speaking_score": -1.599999984105428, "active": false, "track_id": 2}]}, {"frame_number": 1203, "faces": [{"x1": 729, "y1": 192, "x2": 782, "y2": 245, "speaking_score": -1.25, "active": false, "track_id": 2}]}, {"frame_number": 1204, "faces": [{"x1": 729, "y1": 192, "x2": 782, "y2": 245, "speaking_score": -1.25, "active": false, "track_id": 2}]}, {"frame_number": 1205, "faces": [{"x1": 730, "y1": 192, "x2": 783, "y2": 245, "speaking_score": -0.8499999841054281, "active": false, "track_id": 2}]}, {"frame_number": 1206, "faces": [{"x1": 731, "y1": 192, "x2": 784, "y2": 245, "speaking_score": -0.34999998410542804, "active": false, "track_id": 2}]}, {"frame_number": 1207, "faces": [{"x1": 733, "y1": 192, "x2": 786, "y2": 245, "speaking_score": 0.1666666865348816, "active": true, "track_id": 2}]}, {"frame_number": 1208, "faces": [{"x1": 734, "y1": 192, "x2": 788, "y2": 246, "speaking_score": 0.8000000317891439, "active": true, "track_id": 2}]}, {"frame_number": 1209, "faces": [{"x1": 736, "y1": 192, "x2": 790, "y2": 246, "speaking_score": 1.3833333651224773, "active": true, "track_id": 2}]}, {"frame_number": 1210, "faces": [{"x1": 736, "y1": 192, "x2": 790, "y2": 246, "speaking_score": 1.3833333651224773, "active": true, "track_id": 2}]}, {"frame_number": 1211, "faces": [{"x1": 738, "y1": 193, "x2": 792, "y2": 247, "speaking_score": 1.8666667143503826, "active": true, "track_id": 2}]}, {"frame_number": 1212, "faces": [{"x1": 740, "y1": 193, "x2": 793, "y2": 247, "speaking_score": 2.2666667302449546, "active": true, "track_id": 2}]}, {"frame_number": 1213, "faces": [{"x1": 741, "y1": 193, "x2": 795, "y2": 247, "speaking_score": 2.5000000397364297, "active": true, "track_id": 2}]}, {"frame_number": 1214, "faces": [{"x1": 741, "y1": 193, "x2": 795, "y2": 247, "speaking_score": 2.633333365122477, "active": true, "track_id": 2}]}, {"frame_number": 1215, "faces": [{"x1": 744, "y1": 193, "x2": 798, "y2": 247, "speaking_score": 2.6666666666666665, "active": true, "track_id": 2}]}, {"frame_number": 1216, "faces": [{"x1": 744, "y1": 193, "x2": 798, "y2": 247, "speaking_score": 2.6666666666666665, "active": true, "track_id": 2}]}, {"frame_number": 1217, "faces": [{"x1": 746, "y1": 193, "x2": 800, "y2": 247, "speaking_score": 2.8166666825612388, "active": true, "track_id": 2}]}, {"frame_number": 1218, "faces": [{"x1": 747, "y1": 193, "x2": 801, "y2": 247, "speaking_score": 3.0, "active": true, "track_id": 2}]}, {"frame_number": 1219, "faces": [{"x1": 748, "y1": 193, "x2": 802, "y2": 246, "speaking_score": 3.1666666666666665, "active": true, "track_id": 2}]}, {"frame_number": 1220, "faces": [{"x1": 750, "y1": 192, "x2": 804, "y2": 246, "speaking_score": 3.300000031789144, "active": true, "track_id": 2}]}, {"frame_number": 1221, "faces": [{"x1": 753, "y1": 192, "x2": 807, "y2": 245, "speaking_score": 3.333333373069763, "active": true, "track_id": 2}]}, {"frame_number": 1222, "faces": [{"x1": 753, "y1": 192, "x2": 807, "y2": 245, "speaking_score": 3.333333373069763, "active": true, "track_id": 2}]}, {"frame_number": 1223, "faces": [{"x1": 755, "y1": 191, "x2": 808, "y2": 244, "speaking_score": 3.3500000635782876, "active": true, "track_id": 2}]}, {"frame_number": 1224, "faces": [{"x1": 756, "y1": 191, "x2": 809, "y2": 244, "speaking_score": 3.3166667222976685, "active": true, "track_id": 2}]}, {"frame_number": 1225, "faces": [{"x1": 757, "y1": 191, "x2": 810, "y2": 244, "speaking_score": 3.2833333810170493, "active": true, "track_id": 2}]}, {"frame_number": 1226, "faces": [{"x1": 759, "y1": 191, "x2": 811, "y2": 243, "speaking_score": 3.3166666825612388, "active": true, "track_id": 2}]}, {"frame_number": 1227, "faces": [{"x1": 763, "y1": 192, "x2": 815, "y2": 243, "speaking_score": 3.349999984105428, "active": true, "track_id": 2}]}, {"frame_number": 1228, "faces": [{"x1": 763, "y1": 192, "x2": 815, "y2": 243, "speaking_score": 3.349999984105428, "active": true, "track_id": 2}]}, {"frame_number": 1229, "faces": [{"x1": 765, "y1": 191, "x2": 817, "y2": 243, "speaking_score": 3.416666626930237, "active": true, "track_id": 2}]}, {"frame_number": 1230, "faces": [{"x1": 768, "y1": 191, "x2": 820, "y2": 243, "speaking_score": 3.4833332697550454, "active": true, "track_id": 2}]}, {"frame_number": 1231, "faces": [{"x1": 771, "y1": 192, "x2": 822, "y2": 243, "speaking_score": 3.5499999125798545, "active": true, "track_id": 2}]}, {"frame_number": 1232, "faces": [{"x1": 772, "y1": 192, "x2": 823, "y2": 243, "speaking_score": 3.566666603088379, "active": true, "track_id": 2}]}, {"frame_number": 1233, "faces": [{"x1": 774, "y1": 192, "x2": 826, "y2": 243, "speaking_score": 3.566666603088379, "active": true, "track_id": 2}]}, {"frame_number": 1234, "faces": [{"x1": 775, "y1": 192, "x2": 826, "y2": 243, "speaking_score": 3.5333333015441895, "active": true, "track_id": 2}]}, {"frame_number": 1235, "faces": [{"x1": 775, "y1": 192, "x2": 826, "y2": 243, "speaking_score": 3.5333333015441895, "active": true, "track_id": 2}]}, {"frame_number": 1236, "faces": [{"x1": 775, "y1": 192, "x2": 826, "y2": 243, "speaking_score": 3.5, "active": true, "track_id": 2}]}, {"frame_number": 1237, "faces": [{"x1": 775, "y1": 192, "x2": 826, "y2": 243, "speaking_score": 3.450000007947286, "active": true, "track_id": 2}]}, {"frame_number": 1238, "faces": [{"x1": 776, "y1": 193, "x2": 826, "y2": 243, "speaking_score": 3.283333341280619, "active": true, "track_id": 2}]}, {"frame_number": 1239, "faces": [{"x1": 778, "y1": 193, "x2": 828, "y2": 243, "speaking_score": 3.149999976158142, "active": true, "track_id": 2}]}, {"frame_number": 1240, "faces": [{"x1": 778, "y1": 193, "x2": 828, "y2": 243, "speaking_score": 2.9833333094914756, "active": true, "track_id": 2}]}, {"frame_number": 1241, "faces": [{"x1": 778, "y1": 193, "x2": 828, "y2": 243, "speaking_score": 2.9833333094914756, "active": true, "track_id": 2}]}, {"frame_number": 1242, "faces": [{"x1": 780, "y1": 193, "x2": 829, "y2": 243, "speaking_score": 2.866666634877523, "active": true, "track_id": 2}]}, {"frame_number": 1243, "faces": [{"x1": 781, "y1": 194, "x2": 830, "y2": 243, "speaking_score": 2.7499999602635703, "active": true, "track_id": 2}]}, {"frame_number": 1244, "faces": [{"x1": 781, "y1": 194, "x2": 830, "y2": 243, "speaking_score": 2.616666634877523, "active": true, "track_id": 2}]}, {"frame_number": 1245, "faces": [{"x1": 782, "y1": 194, "x2": 830, "y2": 243, "speaking_score": 2.5833333333333335, "active": true, "track_id": 2}]}, {"frame_number": 1246, "faces": [{"x1": 782, "y1": 195, "x2": 830, "y2": 243, "speaking_score": 2.633333365122477, "active": true, "track_id": 2}]}, {"frame_number": 1247, "faces": [{"x1": 782, "y1": 195, "x2": 830, "y2": 243, "speaking_score": 2.633333365122477, "active": true, "track_id": 2}]}, {"frame_number": 1248, "faces": [{"x1": 782, "y1": 195, "x2": 831, "y2": 243, "speaking_score": 2.650000055631002, "active": true, "track_id": 2}]}, {"frame_number": 1249, "faces": [{"x1": 783, "y1": 195, "x2": 831, "y2": 243, "speaking_score": 2.6000000635782876, "active": true, "track_id": 2}]}, {"frame_number": 1250, "faces": [{"x1": 783, "y1": 196, "x2": 831, "y2": 243, "speaking_score": 2.5166667302449546, "active": true, "track_id": 2}]}, {"frame_number": 1251, "faces": [{"x1": 783, "y1": 196, "x2": 831, "y2": 244, "speaking_score": 2.483333388964335, "active": true, "track_id": 2}]}, {"frame_number": 1252, "faces": [{"x1": 783, "y1": 196, "x2": 831, "y2": 244, "speaking_score": 2.5333333810170493, "active": true, "track_id": 2}]}, {"frame_number": 1253, "faces": [{"x1": 783, "y1": 196, "x2": 831, "y2": 244, "speaking_score": 2.5333333810170493, "active": true, "track_id": 2}]}, {"frame_number": 1254, "faces": [{"x1": 783, "y1": 196, "x2": 831, "y2": 244, "speaking_score": 2.4333333571751914, "active": true, "track_id": 2}]}, {"frame_number": 1255, "faces": [{"x1": 783, "y1": 196, "x2": 831, "y2": 244, "speaking_score": 2.3166666825612388, "active": true, "track_id": 2}]}, {"frame_number": 1256, "faces": [{"x1": 783, "y1": 196, "x2": 831, "y2": 244, "speaking_score": 2.216666658719381, "active": true, "track_id": 2}]}, {"frame_number": 1257, "faces": [{"x1": 783, "y1": 196, "x2": 831, "y2": 244, "speaking_score": 2.1833333174387612, "active": true, "track_id": 2}]}, {"frame_number": 1258, "faces": [{"x1": 783, "y1": 196, "x2": 831, "y2": 244, "speaking_score": 2.149999976158142, "active": true, "track_id": 2}]}, {"frame_number": 1259, "faces": [{"x1": 783, "y1": 196, "x2": 831, "y2": 244, "speaking_score": 2.149999976158142, "active": true, "track_id": 2}]}, {"frame_number": 1260, "faces": [{"x1": 783, "y1": 196, "x2": 831, "y2": 244, "speaking_score": 2.0166666309038797, "active": true, "track_id": 2}]}, {"frame_number": 1261, "faces": [{"x1": 783, "y1": 196, "x2": 830, "y2": 244, "speaking_score": 1.9333332975705464, "active": true, "track_id": 2}]}, {"frame_number": 1262, "faces": [{"x1": 782, "y1": 196, "x2": 830, "y2": 244, "speaking_score": 1.8833333055178325, "active": true, "track_id": 2}]}, {"frame_number": 1263, "faces": [{"x1": 782, "y1": 194, "x2": 831, "y2": 243, "speaking_score": 1.8166666428248088, "active": true, "track_id": 2}]}, {"frame_number": 1264, "faces": [{"x1": 782, "y1": 194, "x2": 831, "y2": 243, "speaking_score": 1.649999976158142, "active": true, "track_id": 2}]}, {"frame_number": 1265, "faces": [{"x1": 782, "y1": 194, "x2": 831, "y2": 243, "speaking_score": 1.649999976158142, "active": true, "track_id": 2}]}, {"frame_number": 1266, "faces": [{"x1": 782, "y1": 194, "x2": 831, "y2": 243, "speaking_score": 1.4166666567325592, "active": true, "track_id": 2}]}, {"frame_number": 1267, "faces": [{"x1": 782, "y1": 194, "x2": 831, "y2": 243, "speaking_score": 1.1166666609545548, "active": true, "track_id": 2}]}, {"frame_number": 1268, "faces": [{"x1": 781, "y1": 194, "x2": 831, "y2": 243, "speaking_score": 0.7500000012417635, "active": true, "track_id": 2}]}, {"frame_number": 1269, "faces": [{"x1": 780, "y1": 193, "x2": 830, "y2": 243, "speaking_score": 0.34999999528129894, "active": true, "track_id": 2}]}, {"frame_number": 1270, "faces": [{"x1": 780, "y1": 193, "x2": 830, "y2": 243, "speaking_score": -0.033333330104748406, "active": false, "track_id": 2}]}, {"frame_number": 1271, "faces": [{"x1": 780, "y1": 193, "x2": 830, "y2": 243, "speaking_score": -0.033333330104748406, "active": false, "track_id": 2}]}, {"frame_number": 1272, "faces": [{"x1": 780, "y1": 193, "x2": 830, "y2": 243, "speaking_score": -0.3833333340783914, "active": false, "track_id": 2}]}, {"frame_number": 1273, "faces": [{"x1": 779, "y1": 193, "x2": 830, "y2": 243, "speaking_score": -0.6833333360652128, "active": false, "track_id": 2}]}, {"frame_number": 1274, "faces": [{"x1": 779, "y1": 193, "x2": 829, "y2": 243, "speaking_score": -0.9333333323399226, "active": false, "track_id": 2}]}, {"frame_number": 1275, "faces": [{"x1": 779, "y1": 193, "x2": 829, "y2": 243, "speaking_score": -1.133333335320155, "active": false, "track_id": 2}]}, {"frame_number": 1276, "faces": [{"x1": 779, "y1": 193, "x2": 829, "y2": 243, "speaking_score": -1.350000003973643, "active": false, "track_id": 2}]}, {"frame_number": 1277, "faces": [{"x1": 779, "y1": 193, "x2": 829, "y2": 243, "speaking_score": -1.350000003973643, "active": false, "track_id": 2}]}, {"frame_number": 1278, "faces": [{"x1": 779, "y1": 193, "x2": 829, "y2": 243, "speaking_score": -1.5166666706403096, "active": false, "track_id": 2}]}, {"frame_number": 1279, "faces": [{"x1": 779, "y1": 193, "x2": 828, "y2": 242, "speaking_score": -1.6666666666666667, "active": false, "track_id": 2}]}, {"frame_number": 1280, "faces": [{"x1": 779, "y1": 193, "x2": 828, "y2": 242, "speaking_score": -1.8333333134651184, "active": false, "track_id": 2}]}, {"frame_number": 1281, "faces": [{"x1": 778, "y1": 193, "x2": 828, "y2": 242, "speaking_score": -1.9833333094914753, "active": false, "track_id": 2}]}, {"frame_number": 1282, "faces": [{"x1": 778, "y1": 192, "x2": 827, "y2": 242, "speaking_score": -2.0833333134651184, "active": false, "track_id": 2}]}, {"frame_number": 1283, "faces": [{"x1": 778, "y1": 192, "x2": 827, "y2": 242, "speaking_score": -2.0833333134651184, "active": false, "track_id": 2}]}, {"frame_number": 1284, "faces": [{"x1": 778, "y1": 192, "x2": 827, "y2": 242, "speaking_score": -2.0833333134651184, "active": false, "track_id": 2}]}, {"frame_number": 1285, "faces": [{"x1": 778, "y1": 193, "x2": 827, "y2": 241, "speaking_score": -1.9999999801317851, "active": false, "track_id": 2}]}, {"frame_number": 1286, "faces": [{"x1": 778, "y1": 193, "x2": 827, "y2": 241, "speaking_score": -1.9999999761581422, "active": false, "track_id": 2}]}, {"frame_number": 1287, "faces": [{"x1": 778, "y1": 193, "x2": 827, "y2": 241, "speaking_score": -1.9749999940395355, "active": false, "track_id": 2}]}, {"frame_number": 1288, "faces": [{"x1": 778, "y1": 192, "x2": 827, "y2": 241, "speaking_score": -1.8666666746139526, "active": false, "track_id": 2}]}, {"frame_number": 1289, "faces": [{"x1": 778, "y1": 192, "x2": 827, "y2": 241, "speaking_score": -1.8666666746139526, "active": false, "track_id": 2}]}, {"frame_number": 1290, "faces": [{"x1": 778, "y1": 192, "x2": 826, "y2": 241, "speaking_score": -1.699999988079071, "active": false, "track_id": 2}]}, {"frame_number": 1291, "faces": [{"x1": 778, "y1": 193, "x2": 827, "y2": 241, "speaking_score": -1.9749999940395355, "active": false, "track_id": 2}]}, {"frame_number": 1292, "faces": [{"x1": 550, "y1": 78, "x2": 826, "y2": 353, "speaking_score": 2.799999952316284, "active": true, "track_id": 3}]}, {"frame_number": 1293, "faces": [{"x1": 550, "y1": 78, "x2": 826, "y2": 355, "speaking_score": 2.8749999403953552, "active": true, "track_id": 3}]}, {"frame_number": 1293, "faces": [{"x1": 778, "y1": 192, "x2": 826, "y2": 241, "speaking_score": -1.699999988079071, "active": false, "track_id": 2}]}, {"frame_number": 1294, "faces": [{"x1": 550, "y1": 78, "x2": 826, "y2": 353, "speaking_score": 2.799999952316284, "active": true, "track_id": 3}]}, {"frame_number": 1295, "faces": [{"x1": 550, "y1": 78, "x2": 826, "y2": 355, "speaking_score": 2.8749999403953552, "active": true, "track_id": 3}]}, {"frame_number": 1296, "faces": [{"x1": 548, "y1": 81, "x2": 828, "y2": 360, "speaking_score": 2.839999961853027, "active": true, "track_id": 3}]}, {"frame_number": 1297, "faces": [{"x1": 548, "y1": 83, "x2": 828, "y2": 364, "speaking_score": 2.8166666428248086, "active": true, "track_id": 3}]}, {"frame_number": 1298, "faces": [{"x1": 548, "y1": 83, "x2": 828, "y2": 364, "speaking_score": 2.8166666428248086, "active": true, "track_id": 3}]}, {"frame_number": 1299, "faces": [{"x1": 544, "y1": 80, "x2": 832, "y2": 368, "speaking_score": 2.8333333333333335, "active": true, "track_id": 3}]}, {"frame_number": 1300, "faces": [{"x1": 543, "y1": 78, "x2": 833, "y2": 369, "speaking_score": 2.8833333253860474, "active": true, "track_id": 3}]}, {"frame_number": 1301, "faces": [{"x1": 542, "y1": 77, "x2": 834, "y2": 370, "speaking_score": 2.9333333174387612, "active": true, "track_id": 3}]}, {"frame_number": 1302, "faces": [{"x1": 535, "y1": 78, "x2": 826, "y2": 369, "speaking_score": 2.9833333492279053, "active": true, "track_id": 3}]}, {"frame_number": 1303, "faces": [{"x1": 528, "y1": 77, "x2": 821, "y2": 370, "speaking_score": 3.1166666746139526, "active": true, "track_id": 3}]}, {"frame_number": 1304, "faces": [{"x1": 528, "y1": 77, "x2": 821, "y2": 370, "speaking_score": 3.1166666746139526, "active": true, "track_id": 3}]}, {"frame_number": 1305, "faces": [{"x1": 522, "y1": 77, "x2": 815, "y2": 370, "speaking_score": 3.216666658719381, "active": true, "track_id": 3}]}, {"frame_number": 1306, "faces": [{"x1": 514, "y1": 77, "x2": 807, "y2": 370, "speaking_score": 3.25, "active": true, "track_id": 3}]}, {"frame_number": 1307, "faces": [{"x1": 496, "y1": 72, "x2": 789, "y2": 365, "speaking_score": 3.200000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1308, "faces": [{"x1": 487, "y1": 72, "x2": 780, "y2": 365, "speaking_score": 3.133333365122477, "active": true, "track_id": 3}]}, {"frame_number": 1309, "faces": [{"x1": 480, "y1": 71, "x2": 773, "y2": 364, "speaking_score": 3.100000023841858, "active": true, "track_id": 3}]}, {"frame_number": 1310, "faces": [{"x1": 480, "y1": 71, "x2": 773, "y2": 364, "speaking_score": 3.100000023841858, "active": true, "track_id": 3}]}, {"frame_number": 1311, "faces": [{"x1": 472, "y1": 71, "x2": 765, "y2": 364, "speaking_score": 3.0666666825612388, "active": true, "track_id": 3}]}, {"frame_number": 1312, "faces": [{"x1": 465, "y1": 70, "x2": 758, "y2": 363, "speaking_score": 3.033333341280619, "active": true, "track_id": 3}]}, {"frame_number": 1313, "faces": [{"x1": 451, "y1": 67, "x2": 744, "y2": 361, "speaking_score": 3.049999992052714, "active": true, "track_id": 3}]}, {"frame_number": 1314, "faces": [{"x1": 442, "y1": 67, "x2": 735, "y2": 360, "speaking_score": 3.0833333333333335, "active": true, "track_id": 3}]}, {"frame_number": 1315, "faces": [{"x1": 432, "y1": 67, "x2": 726, "y2": 360, "speaking_score": 3.116666634877523, "active": true, "track_id": 3}]}, {"frame_number": 1316, "faces": [{"x1": 432, "y1": 67, "x2": 726, "y2": 360, "speaking_score": 3.116666634877523, "active": true, "track_id": 3}]}, {"frame_number": 1317, "faces": [{"x1": 424, "y1": 66, "x2": 718, "y2": 360, "speaking_score": 3.099999944368998, "active": true, "track_id": 3}]}, {"frame_number": 1318, "faces": [{"x1": 416, "y1": 65, "x2": 711, "y2": 359, "speaking_score": 3.0333333015441895, "active": true, "track_id": 3}]}, {"frame_number": 1319, "faces": [{"x1": 399, "y1": 63, "x2": 697, "y2": 361, "speaking_score": 2.9833333094914756, "active": true, "track_id": 3}]}, {"frame_number": 1320, "faces": [{"x1": 395, "y1": 63, "x2": 693, "y2": 361, "speaking_score": 2.966666658719381, "active": true, "track_id": 3}]}, {"frame_number": 1321, "faces": [{"x1": 389, "y1": 63, "x2": 688, "y2": 361, "speaking_score": 2.899999976158142, "active": true, "track_id": 3}]}, {"frame_number": 1322, "faces": [{"x1": 389, "y1": 63, "x2": 688, "y2": 361, "speaking_score": 2.899999976158142, "active": true, "track_id": 3}]}, {"frame_number": 1323, "faces": [{"x1": 382, "y1": 63, "x2": 681, "y2": 362, "speaking_score": 2.8166666428248086, "active": true, "track_id": 3}]}, {"frame_number": 1324, "faces": [{"x1": 376, "y1": 63, "x2": 675, "y2": 363, "speaking_score": 2.7333333094914756, "active": true, "track_id": 3}]}, {"frame_number": 1325, "faces": [{"x1": 362, "y1": 63, "x2": 662, "y2": 363, "speaking_score": 2.699999968210856, "active": true, "track_id": 3}]}, {"frame_number": 1326, "faces": [{"x1": 357, "y1": 63, "x2": 657, "y2": 363, "speaking_score": 2.6833333174387612, "active": true, "track_id": 3}]}, {"frame_number": 1327, "faces": [{"x1": 355, "y1": 64, "x2": 655, "y2": 363, "speaking_score": 2.649999976158142, "active": true, "track_id": 3}]}, {"frame_number": 1328, "faces": [{"x1": 355, "y1": 64, "x2": 655, "y2": 363, "speaking_score": 2.649999976158142, "active": true, "track_id": 3}]}, {"frame_number": 1329, "faces": [{"x1": 352, "y1": 64, "x2": 652, "y2": 364, "speaking_score": 2.649999976158142, "active": true, "track_id": 3}]}, {"frame_number": 1330, "faces": [{"x1": 350, "y1": 65, "x2": 650, "y2": 364, "speaking_score": 2.6166666746139526, "active": true, "track_id": 3}]}, {"frame_number": 1331, "faces": [{"x1": 347, "y1": 68, "x2": 645, "y2": 366, "speaking_score": 2.5166666905085244, "active": true, "track_id": 3}]}, {"frame_number": 1332, "faces": [{"x1": 348, "y1": 69, "x2": 643, "y2": 365, "speaking_score": 2.283333341280619, "active": true, "track_id": 3}]}, {"frame_number": 1333, "faces": [{"x1": 347, "y1": 70, "x2": 642, "y2": 365, "speaking_score": 2.0, "active": true, "track_id": 3}]}, {"frame_number": 1334, "faces": [{"x1": 347, "y1": 70, "x2": 642, "y2": 365, "speaking_score": 2.0, "active": true, "track_id": 3}]}, {"frame_number": 1335, "faces": [{"x1": 347, "y1": 70, "x2": 641, "y2": 364, "speaking_score": 1.7666666507720947, "active": true, "track_id": 3}]}, {"frame_number": 1336, "faces": [{"x1": 346, "y1": 70, "x2": 640, "y2": 364, "speaking_score": 1.5833333333333333, "active": true, "track_id": 3}]}, {"frame_number": 1337, "faces": [{"x1": 345, "y1": 71, "x2": 638, "y2": 364, "speaking_score": 1.4333333174387615, "active": true, "track_id": 3}]}, {"frame_number": 1338, "faces": [{"x1": 346, "y1": 71, "x2": 638, "y2": 364, "speaking_score": 1.399999976158142, "active": true, "track_id": 3}]}, {"frame_number": 1339, "faces": [{"x1": 346, "y1": 72, "x2": 637, "y2": 363, "speaking_score": 1.4666666587193806, "active": true, "track_id": 3}]}, {"frame_number": 1340, "faces": [{"x1": 346, "y1": 72, "x2": 637, "y2": 363, "speaking_score": 1.4666666587193806, "active": true, "track_id": 3}]}, {"frame_number": 1341, "faces": [{"x1": 345, "y1": 73, "x2": 637, "y2": 364, "speaking_score": 1.599999984105428, "active": true, "track_id": 3}]}, {"frame_number": 1342, "faces": [{"x1": 345, "y1": 73, "x2": 637, "y2": 364, "speaking_score": 1.7333333094914753, "active": true, "track_id": 3}]}, {"frame_number": 1343, "faces": [{"x1": 344, "y1": 76, "x2": 634, "y2": 366, "speaking_score": 1.8333332935969036, "active": true, "track_id": 3}]}, {"frame_number": 1344, "faces": [{"x1": 342, "y1": 77, "x2": 632, "y2": 367, "speaking_score": 1.8833332856496174, "active": true, "track_id": 3}]}, {"frame_number": 1345, "faces": [{"x1": 341, "y1": 78, "x2": 631, "y2": 368, "speaking_score": 1.8333332935969036, "active": true, "track_id": 3}]}, {"frame_number": 1346, "faces": [{"x1": 341, "y1": 78, "x2": 631, "y2": 368, "speaking_score": 1.8333332935969036, "active": true, "track_id": 3}]}, {"frame_number": 1347, "faces": [{"x1": 339, "y1": 78, "x2": 629, "y2": 368, "speaking_score": 1.8166666229565938, "active": true, "track_id": 3}]}, {"frame_number": 1348, "faces": [{"x1": 333, "y1": 79, "x2": 623, "y2": 368, "speaking_score": 1.7833333015441895, "active": true, "track_id": 3}]}, {"frame_number": 1349, "faces": [{"x1": 325, "y1": 79, "x2": 614, "y2": 368, "speaking_score": 1.7166666587193806, "active": true, "track_id": 3}]}, {"frame_number": 1350, "faces": [{"x1": 324, "y1": 81, "x2": 612, "y2": 369, "speaking_score": 1.700000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1351, "faces": [{"x1": 324, "y1": 82, "x2": 611, "y2": 369, "speaking_score": 1.7666666905085247, "active": true, "track_id": 3}]}, {"frame_number": 1352, "faces": [{"x1": 324, "y1": 82, "x2": 611, "y2": 369, "speaking_score": 1.7666666905085247, "active": true, "track_id": 3}]}, {"frame_number": 1353, "faces": [{"x1": 323, "y1": 83, "x2": 609, "y2": 369, "speaking_score": 1.900000015894572, "active": true, "track_id": 3}]}, {"frame_number": 1354, "faces": [{"x1": 323, "y1": 84, "x2": 609, "y2": 370, "speaking_score": 2.1166666944821677, "active": true, "track_id": 3}]}, {"frame_number": 1355, "faces": [{"x1": 322, "y1": 87, "x2": 608, "y2": 373, "speaking_score": 2.350000023841858, "active": true, "track_id": 3}]}, {"frame_number": 1356, "faces": [{"x1": 321, "y1": 90, "x2": 607, "y2": 375, "speaking_score": 2.5666666825612388, "active": true, "track_id": 3}]}, {"frame_number": 1357, "faces": [{"x1": 320, "y1": 92, "x2": 606, "y2": 378, "speaking_score": 2.75, "active": true, "track_id": 3}]}, {"frame_number": 1358, "faces": [{"x1": 320, "y1": 92, "x2": 606, "y2": 378, "speaking_score": 2.75, "active": true, "track_id": 3}]}, {"frame_number": 1359, "faces": [{"x1": 320, "y1": 92, "x2": 606, "y2": 379, "speaking_score": 2.8833333253860474, "active": true, "track_id": 3}]}, {"frame_number": 1360, "faces": [{"x1": 320, "y1": 93, "x2": 606, "y2": 379, "speaking_score": 2.9833333492279053, "active": true, "track_id": 3}]}, {"frame_number": 1361, "faces": [{"x1": 319, "y1": 96, "x2": 605, "y2": 381, "speaking_score": 3.0, "active": true, "track_id": 3}]}, {"frame_number": 1362, "faces": [{"x1": 319, "y1": 100, "x2": 604, "y2": 384, "speaking_score": 2.9833333492279053, "active": true, "track_id": 3}]}, {"frame_number": 1363, "faces": [{"x1": 319, "y1": 102, "x2": 603, "y2": 386, "speaking_score": 2.950000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1364, "faces": [{"x1": 319, "y1": 102, "x2": 603, "y2": 386, "speaking_score": 2.950000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1365, "faces": [{"x1": 319, "y1": 102, "x2": 603, "y2": 386, "speaking_score": 2.900000015894572, "active": true, "track_id": 3}]}, {"frame_number": 1366, "faces": [{"x1": 320, "y1": 103, "x2": 603, "y2": 386, "speaking_score": 2.883333365122477, "active": true, "track_id": 3}]}, {"frame_number": 1367, "faces": [{"x1": 320, "y1": 105, "x2": 603, "y2": 388, "speaking_score": 2.883333365122477, "active": true, "track_id": 3}]}, {"frame_number": 1368, "faces": [{"x1": 319, "y1": 105, "x2": 603, "y2": 389, "speaking_score": 2.900000015894572, "active": true, "track_id": 3}]}, {"frame_number": 1369, "faces": [{"x1": 318, "y1": 106, "x2": 603, "y2": 391, "speaking_score": 2.950000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1370, "faces": [{"x1": 318, "y1": 106, "x2": 603, "y2": 391, "speaking_score": 2.950000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1371, "faces": [{"x1": 318, "y1": 106, "x2": 603, "y2": 392, "speaking_score": 2.9833333492279053, "active": true, "track_id": 3}]}, {"frame_number": 1372, "faces": [{"x1": 317, "y1": 106, "x2": 603, "y2": 392, "speaking_score": 2.950000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1373, "faces": [{"x1": 314, "y1": 105, "x2": 600, "y2": 391, "speaking_score": 2.899999976158142, "active": true, "track_id": 3}]}, {"frame_number": 1374, "faces": [{"x1": 314, "y1": 104, "x2": 600, "y2": 390, "speaking_score": 2.866666634877523, "active": true, "track_id": 3}]}, {"frame_number": 1375, "faces": [{"x1": 314, "y1": 104, "x2": 600, "y2": 390, "speaking_score": 2.8333333333333335, "active": true, "track_id": 3}]}, {"frame_number": 1376, "faces": [{"x1": 314, "y1": 104, "x2": 600, "y2": 390, "speaking_score": 2.8333333333333335, "active": true, "track_id": 3}]}, {"frame_number": 1377, "faces": [{"x1": 313, "y1": 104, "x2": 599, "y2": 390, "speaking_score": 2.8166666428248086, "active": true, "track_id": 3}]}, {"frame_number": 1378, "faces": [{"x1": 313, "y1": 103, "x2": 600, "y2": 391, "speaking_score": 2.849999984105428, "active": true, "track_id": 3}]}, {"frame_number": 1379, "faces": [{"x1": 312, "y1": 102, "x2": 601, "y2": 391, "speaking_score": 2.950000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1380, "faces": [{"x1": 312, "y1": 100, "x2": 601, "y2": 389, "speaking_score": 3.0000000397364297, "active": true, "track_id": 3}]}, {"frame_number": 1381, "faces": [{"x1": 312, "y1": 100, "x2": 601, "y2": 388, "speaking_score": 3.0000000397364297, "active": true, "track_id": 3}]}, {"frame_number": 1382, "faces": [{"x1": 312, "y1": 100, "x2": 601, "y2": 388, "speaking_score": 3.0000000397364297, "active": true, "track_id": 3}]}, {"frame_number": 1383, "faces": [{"x1": 312, "y1": 100, "x2": 601, "y2": 388, "speaking_score": 3.0166666905085244, "active": true, "track_id": 3}]}, {"frame_number": 1384, "faces": [{"x1": 312, "y1": 98, "x2": 601, "y2": 387, "speaking_score": 2.983333388964335, "active": true, "track_id": 3}]}, {"frame_number": 1385, "faces": [{"x1": 313, "y1": 97, "x2": 600, "y2": 385, "speaking_score": 2.900000055631002, "active": true, "track_id": 3}]}, {"frame_number": 1386, "faces": [{"x1": 314, "y1": 97, "x2": 601, "y2": 384, "speaking_score": 2.8166667222976685, "active": true, "track_id": 3}]}, {"frame_number": 1387, "faces": [{"x1": 316, "y1": 97, "x2": 603, "y2": 384, "speaking_score": 2.7500000397364297, "active": true, "track_id": 3}]}, {"frame_number": 1388, "faces": [{"x1": 316, "y1": 97, "x2": 603, "y2": 384, "speaking_score": 2.7500000397364297, "active": true, "track_id": 3}]}, {"frame_number": 1389, "faces": [{"x1": 317, "y1": 96, "x2": 603, "y2": 383, "speaking_score": 2.7333333492279053, "active": true, "track_id": 3}]}, {"frame_number": 1390, "faces": [{"x1": 318, "y1": 96, "x2": 604, "y2": 383, "speaking_score": 2.6833333571751914, "active": true, "track_id": 3}]}, {"frame_number": 1391, "faces": [{"x1": 319, "y1": 96, "x2": 605, "y2": 383, "speaking_score": 2.650000015894572, "active": true, "track_id": 3}]}, {"frame_number": 1392, "faces": [{"x1": 320, "y1": 97, "x2": 606, "y2": 383, "speaking_score": 2.6333333253860474, "active": true, "track_id": 3}]}, {"frame_number": 1393, "faces": [{"x1": 321, "y1": 97, "x2": 606, "y2": 383, "speaking_score": 2.599999984105428, "active": true, "track_id": 3}]}, {"frame_number": 1394, "faces": [{"x1": 321, "y1": 97, "x2": 606, "y2": 383, "speaking_score": 2.599999984105428, "active": true, "track_id": 3}]}, {"frame_number": 1395, "faces": [{"x1": 322, "y1": 97, "x2": 607, "y2": 383, "speaking_score": 2.5833333333333335, "active": true, "track_id": 3}]}, {"frame_number": 1396, "faces": [{"x1": 322, "y1": 96, "x2": 608, "y2": 383, "speaking_score": 2.550000031789144, "active": true, "track_id": 3}]}, {"frame_number": 1397, "faces": [{"x1": 325, "y1": 96, "x2": 611, "y2": 383, "speaking_score": 2.5000000397364297, "active": true, "track_id": 3}]}, {"frame_number": 1398, "faces": [{"x1": 326, "y1": 96, "x2": 613, "y2": 383, "speaking_score": 2.4666666984558105, "active": true, "track_id": 3}]}, {"frame_number": 1399, "faces": [{"x1": 328, "y1": 96, "x2": 615, "y2": 383, "speaking_score": 2.450000047683716, "active": true, "track_id": 3}]}, {"frame_number": 1400, "faces": [{"x1": 328, "y1": 96, "x2": 615, "y2": 383, "speaking_score": 2.450000047683716, "active": true, "track_id": 3}]}, {"frame_number": 1401, "faces": [{"x1": 333, "y1": 96, "x2": 621, "y2": 383, "speaking_score": 2.400000055631002, "active": true, "track_id": 3}]}, {"frame_number": 1402, "faces": [{"x1": 338, "y1": 95, "x2": 627, "y2": 384, "speaking_score": 2.383333365122477, "active": true, "track_id": 3}]}, {"frame_number": 1403, "faces": [{"x1": 340, "y1": 92, "x2": 635, "y2": 387, "speaking_score": 2.3333333333333335, "active": true, "track_id": 3}]}, {"frame_number": 1404, "faces": [{"x1": 342, "y1": 92, "x2": 637, "y2": 387, "speaking_score": 2.249999980131785, "active": true, "track_id": 3}]}, {"frame_number": 1405, "faces": [{"x1": 343, "y1": 92, "x2": 639, "y2": 387, "speaking_score": 2.166666646798452, "active": true, "track_id": 3}]}, {"frame_number": 1406, "faces": [{"x1": 343, "y1": 92, "x2": 639, "y2": 387, "speaking_score": 2.166666646798452, "active": true, "track_id": 3}]}, {"frame_number": 1407, "faces": [{"x1": 345, "y1": 91, "x2": 640, "y2": 387, "speaking_score": 2.166666646798452, "active": true, "track_id": 3}]}, {"frame_number": 1408, "faces": [{"x1": 347, "y1": 91, "x2": 643, "y2": 387, "speaking_score": 2.2333332896232605, "active": true, "track_id": 3}]}, {"frame_number": 1409, "faces": [{"x1": 353, "y1": 91, "x2": 649, "y2": 387, "speaking_score": 2.316666622956594, "active": true, "track_id": 3}]}, {"frame_number": 1410, "faces": [{"x1": 357, "y1": 90, "x2": 654, "y2": 387, "speaking_score": 2.416666646798452, "active": true, "track_id": 3}]}, {"frame_number": 1411, "faces": [{"x1": 361, "y1": 88, "x2": 659, "y2": 386, "speaking_score": 2.5, "active": true, "track_id": 3}]}, {"frame_number": 1412, "faces": [{"x1": 361, "y1": 88, "x2": 659, "y2": 386, "speaking_score": 2.5, "active": true, "track_id": 3}]}, {"frame_number": 1413, "faces": [{"x1": 365, "y1": 87, "x2": 665, "y2": 387, "speaking_score": 2.599999984105428, "active": true, "track_id": 3}]}, {"frame_number": 1414, "faces": [{"x1": 365, "y1": 87, "x2": 665, "y2": 387, "speaking_score": 2.599999984105428, "active": true, "track_id": 3}]}, {"frame_number": 1415, "faces": [{"x1": 365, "y1": 87, "x2": 665, "y2": 387, "speaking_score": 2.5666666825612388, "active": true, "track_id": 3}]}, {"frame_number": 1416, "faces": [{"x1": 365, "y1": 86, "x2": 666, "y2": 388, "speaking_score": 2.5000000397364297, "active": true, "track_id": 3}]}, {"frame_number": 1417, "faces": [{"x1": 365, "y1": 86, "x2": 666, "y2": 388, "speaking_score": 2.4166667064030967, "active": true, "track_id": 3}]}, {"frame_number": 1418, "faces": [{"x1": 365, "y1": 86, "x2": 666, "y2": 388, "speaking_score": 2.4166667064030967, "active": true, "track_id": 3}]}, {"frame_number": 1419, "faces": [{"x1": 365, "y1": 86, "x2": 666, "y2": 388, "speaking_score": 2.3666666746139526, "active": true, "track_id": 3}]}, {"frame_number": 1420, "faces": [{"x1": 365, "y1": 89, "x2": 666, "y2": 390, "speaking_score": 2.2166666984558105, "active": true, "track_id": 3}]}, {"frame_number": 1421, "faces": [{"x1": 341, "y1": 89, "x2": 643, "y2": 390, "speaking_score": 2.100000023841858, "active": true, "track_id": 3}]}, {"frame_number": 1422, "faces": [{"x1": 334, "y1": 88, "x2": 637, "y2": 391, "speaking_score": 2.049999992052714, "active": true, "track_id": 3}]}, {"frame_number": 1423, "faces": [{"x1": 328, "y1": 87, "x2": 633, "y2": 392, "speaking_score": 2.0666666428248086, "active": true, "track_id": 3}]}, {"frame_number": 1424, "faces": [{"x1": 318, "y1": 84, "x2": 628, "y2": 394, "speaking_score": 2.0833332935969033, "active": true, "track_id": 3}]}, {"frame_number": 1425, "faces": [{"x1": 318, "y1": 84, "x2": 628, "y2": 394, "speaking_score": 2.0833332935969033, "active": true, "track_id": 3}]}, {"frame_number": 1426, "faces": [{"x1": 313, "y1": 84, "x2": 623, "y2": 394, "speaking_score": 2.0666666428248086, "active": true, "track_id": 3}]}, {"frame_number": 1427, "faces": [{"x1": 307, "y1": 84, "x2": 618, "y2": 394, "speaking_score": 1.99999996026357, "active": true, "track_id": 3}]}, {"frame_number": 1428, "faces": [{"x1": 303, "y1": 80, "x2": 615, "y2": 392, "speaking_score": 1.8666666348775227, "active": true, "track_id": 3}]}, {"frame_number": 1429, "faces": [{"x1": 298, "y1": 77, "x2": 610, "y2": 389, "speaking_score": 1.6833333174387615, "active": true, "track_id": 3}]}, {"frame_number": 1430, "faces": [{"x1": 295, "y1": 72, "x2": 607, "y2": 384, "speaking_score": 1.449999988079071, "active": true, "track_id": 3}]}, {"frame_number": 1431, "faces": [{"x1": 295, "y1": 72, "x2": 607, "y2": 384, "speaking_score": 1.449999988079071, "active": true, "track_id": 3}]}, {"frame_number": 1432, "faces": [{"x1": 289, "y1": 66, "x2": 601, "y2": 379, "speaking_score": 1.299999992052714, "active": true, "track_id": 3}]}, {"frame_number": 1433, "faces": [{"x1": 283, "y1": 60, "x2": 594, "y2": 372, "speaking_score": 1.3166666428248088, "active": true, "track_id": 3}]}, {"frame_number": 1434, "faces": [{"x1": 283, "y1": 60, "x2": 594, "y2": 371, "speaking_score": 1.4833333094914753, "active": true, "track_id": 3}]}, {"frame_number": 1435, "faces": [{"x1": 283, "y1": 60, "x2": 594, "y2": 370, "speaking_score": 1.6999999682108562, "active": true, "track_id": 3}]}, {"frame_number": 1436, "faces": [{"x1": 284, "y1": 61, "x2": 593, "y2": 369, "speaking_score": 1.9166666269302368, "active": true, "track_id": 3}]}, {"frame_number": 1437, "faces": [{"x1": 284, "y1": 61, "x2": 593, "y2": 369, "speaking_score": 1.9166666269302368, "active": true, "track_id": 3}]}, {"frame_number": 1438, "faces": [{"x1": 284, "y1": 60, "x2": 593, "y2": 369, "speaking_score": 2.1833332975705466, "active": true, "track_id": 3}]}, {"frame_number": 1439, "faces": [{"x1": 284, "y1": 59, "x2": 593, "y2": 368, "speaking_score": 2.416666626930237, "active": true, "track_id": 3}]}, {"frame_number": 1440, "faces": [{"x1": 284, "y1": 59, "x2": 593, "y2": 368, "speaking_score": 2.5166666507720947, "active": true, "track_id": 3}]}, {"frame_number": 1441, "faces": [{"x1": 284, "y1": 59, "x2": 593, "y2": 368, "speaking_score": 2.5833333333333335, "active": true, "track_id": 3}]}, {"frame_number": 1442, "faces": [{"x1": 284, "y1": 58, "x2": 594, "y2": 369, "speaking_score": 2.6666666666666665, "active": true, "track_id": 3}]}, {"frame_number": 1443, "faces": [{"x1": 284, "y1": 58, "x2": 594, "y2": 369, "speaking_score": 2.6666666666666665, "active": true, "track_id": 3}]}, {"frame_number": 1444, "faces": [{"x1": 285, "y1": 59, "x2": 594, "y2": 368, "speaking_score": 2.783333341280619, "active": true, "track_id": 3}]}, {"frame_number": 1445, "faces": [{"x1": 290, "y1": 59, "x2": 598, "y2": 367, "speaking_score": 2.8833333253860474, "active": true, "track_id": 3}]}, {"frame_number": 1446, "faces": [{"x1": 296, "y1": 59, "x2": 603, "y2": 367, "speaking_score": 2.950000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1447, "faces": [{"x1": 304, "y1": 59, "x2": 611, "y2": 367, "speaking_score": 3.033333341280619, "active": true, "track_id": 3}]}, {"frame_number": 1448, "faces": [{"x1": 318, "y1": 59, "x2": 625, "y2": 366, "speaking_score": 3.1166666746139526, "active": true, "track_id": 3}]}, {"frame_number": 1449, "faces": [{"x1": 318, "y1": 59, "x2": 625, "y2": 366, "speaking_score": 3.1166666746139526, "active": true, "track_id": 3}]}, {"frame_number": 1450, "faces": [{"x1": 334, "y1": 60, "x2": 641, "y2": 367, "speaking_score": 3.200000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1451, "faces": [{"x1": 365, "y1": 61, "x2": 672, "y2": 368, "speaking_score": 3.200000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1452, "faces": [{"x1": 388, "y1": 69, "x2": 680, "y2": 361, "speaking_score": 3.0666666825612388, "active": true, "track_id": 3}]}, {"frame_number": 1453, "faces": [{"x1": 400, "y1": 69, "x2": 692, "y2": 361, "speaking_score": 2.9166666666666665, "active": true, "track_id": 3}]}, {"frame_number": 1454, "faces": [{"x1": 412, "y1": 71, "x2": 703, "y2": 363, "speaking_score": 2.7333333094914756, "active": true, "track_id": 3}]}, {"frame_number": 1455, "faces": [{"x1": 412, "y1": 71, "x2": 703, "y2": 363, "speaking_score": 2.7333333094914756, "active": true, "track_id": 3}]}, {"frame_number": 1456, "faces": [{"x1": 427, "y1": 72, "x2": 718, "y2": 363, "speaking_score": 2.5166666309038797, "active": true, "track_id": 3}]}, {"frame_number": 1457, "faces": [{"x1": 451, "y1": 72, "x2": 743, "y2": 363, "speaking_score": 2.2166666388511658, "active": true, "track_id": 3}]}, {"frame_number": 1458, "faces": [{"x1": 463, "y1": 72, "x2": 755, "y2": 363, "speaking_score": 1.8666666348775227, "active": true, "track_id": 3}]}, {"frame_number": 1459, "faces": [{"x1": 473, "y1": 73, "x2": 764, "y2": 365, "speaking_score": 1.5333333015441895, "active": true, "track_id": 3}]}, {"frame_number": 1460, "faces": [{"x1": 483, "y1": 74, "x2": 775, "y2": 366, "speaking_score": 1.1999999781449635, "active": true, "track_id": 3}]}, {"frame_number": 1461, "faces": [{"x1": 483, "y1": 74, "x2": 775, "y2": 366, "speaking_score": 1.1999999781449635, "active": true, "track_id": 3}]}, {"frame_number": 1462, "faces": [{"x1": 497, "y1": 75, "x2": 789, "y2": 366, "speaking_score": 0.8833333278695742, "active": true, "track_id": 3}]}, {"frame_number": 1463, "faces": [{"x1": 525, "y1": 76, "x2": 817, "y2": 368, "speaking_score": 0.5833333320915699, "active": true, "track_id": 3}]}, {"frame_number": 1464, "faces": [{"x1": 531, "y1": 74, "x2": 829, "y2": 371, "speaking_score": 0.34999999900658924, "active": true, "track_id": 3}]}, {"frame_number": 1465, "faces": [{"x1": 543, "y1": 74, "x2": 842, "y2": 372, "speaking_score": 0.28333333631356555, "active": true, "track_id": 3}]}, {"frame_number": 1466, "faces": [{"x1": 555, "y1": 74, "x2": 853, "y2": 372, "speaking_score": 0.34999999900658924, "active": true, "track_id": 3}]}, {"frame_number": 1467, "faces": [{"x1": 555, "y1": 74, "x2": 853, "y2": 372, "speaking_score": 0.34999999900658924, "active": true, "track_id": 3}]}, {"frame_number": 1468, "faces": [{"x1": 568, "y1": 77, "x2": 866, "y2": 376, "speaking_score": 0.40000000099341076, "active": true, "track_id": 3}]}, {"frame_number": 1469, "faces": [{"x1": 585, "y1": 82, "x2": 883, "y2": 380, "speaking_score": 0.36666666716337204, "active": true, "track_id": 3}]}, {"frame_number": 1470, "faces": [{"x1": 590, "y1": 82, "x2": 889, "y2": 381, "speaking_score": 0.2499999962747097, "active": true, "track_id": 3}]}, {"frame_number": 1471, "faces": [{"x1": 594, "y1": 83, "x2": 893, "y2": 381, "speaking_score": -0.01666667064030965, "active": false, "track_id": 3}]}, {"frame_number": 1472, "faces": [{"x1": 598, "y1": 84, "x2": 896, "y2": 382, "speaking_score": -0.3166666626930237, "active": false, "track_id": 3}]}, {"frame_number": 1473, "faces": [{"x1": 598, "y1": 84, "x2": 896, "y2": 382, "speaking_score": -0.3166666626930237, "active": false, "track_id": 3}]}, {"frame_number": 1474, "faces": [{"x1": 600, "y1": 85, "x2": 898, "y2": 383, "speaking_score": -0.6833333174387614, "active": false, "track_id": 3}]}, {"frame_number": 1475, "faces": [{"x1": 606, "y1": 86, "x2": 902, "y2": 382, "speaking_score": -0.949999988079071, "active": false, "track_id": 3}]}, {"frame_number": 1476, "faces": [{"x1": 611, "y1": 89, "x2": 903, "y2": 381, "speaking_score": -1.049999992052714, "active": false, "track_id": 3}]}, {"frame_number": 1477, "faces": [{"x1": 611, "y1": 91, "x2": 902, "y2": 383, "speaking_score": -0.9166666542490324, "active": false, "track_id": 3}]}, {"frame_number": 1478, "faces": [{"x1": 611, "y1": 94, "x2": 902, "y2": 386, "speaking_score": -0.4166666542490323, "active": false, "track_id": 3}]}, {"frame_number": 1479, "faces": [{"x1": 611, "y1": 94, "x2": 902, "y2": 386, "speaking_score": -0.4166666542490323, "active": false, "track_id": 3}]}, {"frame_number": 1480, "faces": [{"x1": 611, "y1": 94, "x2": 902, "y2": 385, "speaking_score": 0.3333333457509677, "active": true, "track_id": 3}]}, {"frame_number": 1481, "faces": [{"x1": 611, "y1": 95, "x2": 902, "y2": 386, "speaking_score": 1.216666671137015, "active": true, "track_id": 3}]}, {"frame_number": 1482, "faces": [{"x1": 612, "y1": 96, "x2": 901, "y2": 386, "speaking_score": 2.0000000124176345, "active": true, "track_id": 3}]}, {"frame_number": 1483, "faces": [{"x1": 612, "y1": 97, "x2": 901, "y2": 386, "speaking_score": 2.7000000004967055, "active": true, "track_id": 3}]}, {"frame_number": 1484, "faces": [{"x1": 610, "y1": 98, "x2": 896, "y2": 384, "speaking_score": 3.2666666507720947, "active": true, "track_id": 3}]}, {"frame_number": 1485, "faces": [{"x1": 610, "y1": 98, "x2": 896, "y2": 384, "speaking_score": 3.2666666507720947, "active": true, "track_id": 3}]}, {"frame_number": 1486, "faces": [{"x1": 607, "y1": 98, "x2": 893, "y2": 384, "speaking_score": 3.6333333253860474, "active": true, "track_id": 3}]}, {"frame_number": 1487, "faces": [{"x1": 603, "y1": 99, "x2": 888, "y2": 384, "speaking_score": 3.699999968210856, "active": true, "track_id": 3}]}, {"frame_number": 1488, "faces": [{"x1": 601, "y1": 99, "x2": 886, "y2": 384, "speaking_score": 3.649999976158142, "active": true, "track_id": 3}]}, {"frame_number": 1489, "faces": [{"x1": 598, "y1": 98, "x2": 884, "y2": 384, "speaking_score": 3.6333332856496177, "active": true, "track_id": 3}]}, {"frame_number": 1490, "faces": [{"x1": 595, "y1": 97, "x2": 883, "y2": 385, "speaking_score": 3.666666626930237, "active": true, "track_id": 3}]}, {"frame_number": 1491, "faces": [{"x1": 595, "y1": 97, "x2": 883, "y2": 385, "speaking_score": 3.666666626930237, "active": true, "track_id": 3}]}, {"frame_number": 1492, "faces": [{"x1": 592, "y1": 96, "x2": 881, "y2": 385, "speaking_score": 3.699999968210856, "active": true, "track_id": 3}]}, {"frame_number": 1493, "faces": [{"x1": 586, "y1": 96, "x2": 876, "y2": 385, "speaking_score": 3.7333333094914756, "active": true, "track_id": 3}]}, {"frame_number": 1494, "faces": [{"x1": 583, "y1": 94, "x2": 873, "y2": 384, "speaking_score": 3.799999992052714, "active": true, "track_id": 3}]}, {"frame_number": 1495, "faces": [{"x1": 580, "y1": 93, "x2": 870, "y2": 384, "speaking_score": 3.849999984105428, "active": true, "track_id": 3}]}, {"frame_number": 1496, "faces": [{"x1": 576, "y1": 91, "x2": 866, "y2": 382, "speaking_score": 3.9166666666666665, "active": true, "track_id": 3}]}, {"frame_number": 1497, "faces": [{"x1": 576, "y1": 91, "x2": 866, "y2": 382, "speaking_score": 3.9166666666666665, "active": true, "track_id": 3}]}, {"frame_number": 1498, "faces": [{"x1": 570, "y1": 87, "x2": 862, "y2": 378, "speaking_score": 3.950000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1499, "faces": [{"x1": 558, "y1": 84, "x2": 850, "y2": 376, "speaking_score": 4.0, "active": true, "track_id": 3}]}, {"frame_number": 1500, "faces": [{"x1": 551, "y1": 83, "x2": 845, "y2": 377, "speaking_score": 4.049999952316284, "active": true, "track_id": 3}]}, {"frame_number": 1501, "faces": [{"x1": 544, "y1": 80, "x2": 840, "y2": 376, "speaking_score": 4.049999952316284, "active": true, "track_id": 3}]}, {"frame_number": 1502, "faces": [{"x1": 537, "y1": 79, "x2": 833, "y2": 375, "speaking_score": 4.049999952316284, "active": true, "track_id": 3}]}, {"frame_number": 1503, "faces": [{"x1": 537, "y1": 79, "x2": 833, "y2": 375, "speaking_score": 4.049999952316284, "active": true, "track_id": 3}]}, {"frame_number": 1504, "faces": [{"x1": 531, "y1": 78, "x2": 827, "y2": 374, "speaking_score": 3.9999999602635703, "active": true, "track_id": 3}]}, {"frame_number": 1505, "faces": [{"x1": 523, "y1": 77, "x2": 819, "y2": 373, "speaking_score": 3.9833333094914756, "active": true, "track_id": 3}]}, {"frame_number": 1506, "faces": [{"x1": 517, "y1": 76, "x2": 813, "y2": 372, "speaking_score": 3.966666658719381, "active": true, "track_id": 3}]}, {"frame_number": 1507, "faces": [{"x1": 512, "y1": 73, "x2": 808, "y2": 369, "speaking_score": 3.950000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1508, "faces": [{"x1": 505, "y1": 70, "x2": 801, "y2": 366, "speaking_score": 3.966666658719381, "active": true, "track_id": 3}]}, {"frame_number": 1509, "faces": [{"x1": 505, "y1": 70, "x2": 801, "y2": 366, "speaking_score": 3.966666658719381, "active": true, "track_id": 3}]}, {"frame_number": 1510, "faces": [{"x1": 498, "y1": 70, "x2": 794, "y2": 366, "speaking_score": 3.9833333094914756, "active": true, "track_id": 3}]}, {"frame_number": 1511, "faces": [{"x1": 485, "y1": 66, "x2": 783, "y2": 364, "speaking_score": 3.9999999602635703, "active": true, "track_id": 3}]}, {"frame_number": 1512, "faces": [{"x1": 479, "y1": 66, "x2": 776, "y2": 364, "speaking_score": 3.9833332697550454, "active": true, "track_id": 3}]}, {"frame_number": 1513, "faces": [{"x1": 473, "y1": 67, "x2": 771, "y2": 364, "speaking_score": 3.9833332697550454, "active": true, "track_id": 3}]}, {"frame_number": 1514, "faces": [{"x1": 467, "y1": 68, "x2": 763, "y2": 363, "speaking_score": 3.949999968210856, "active": true, "track_id": 3}]}, {"frame_number": 1515, "faces": [{"x1": 467, "y1": 68, "x2": 763, "y2": 363, "speaking_score": 3.949999968210856, "active": true, "track_id": 3}]}, {"frame_number": 1516, "faces": [{"x1": 461, "y1": 68, "x2": 757, "y2": 363, "speaking_score": 3.8833333253860474, "active": true, "track_id": 3}]}, {"frame_number": 1517, "faces": [{"x1": 448, "y1": 68, "x2": 744, "y2": 363, "speaking_score": 3.8333333333333335, "active": true, "track_id": 3}]}, {"frame_number": 1518, "faces": [{"x1": 443, "y1": 67, "x2": 739, "y2": 362, "speaking_score": 3.799999992052714, "active": true, "track_id": 3}]}, {"frame_number": 1519, "faces": [{"x1": 443, "y1": 67, "x2": 739, "y2": 362, "speaking_score": 3.783333341280619, "active": true, "track_id": 3}]}, {"frame_number": 1520, "faces": [{"x1": 441, "y1": 66, "x2": 738, "y2": 363, "speaking_score": 3.700000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1521, "faces": [{"x1": 441, "y1": 66, "x2": 738, "y2": 363, "speaking_score": 3.700000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1522, "faces": [{"x1": 441, "y1": 66, "x2": 738, "y2": 363, "speaking_score": 3.6166666746139526, "active": true, "track_id": 3}]}, {"frame_number": 1523, "faces": [{"x1": 437, "y1": 66, "x2": 735, "y2": 363, "speaking_score": 3.5833333333333335, "active": true, "track_id": 3}]}, {"frame_number": 1524, "faces": [{"x1": 436, "y1": 66, "x2": 734, "y2": 364, "speaking_score": 3.5166666905085244, "active": true, "track_id": 3}]}, {"frame_number": 1525, "faces": [{"x1": 435, "y1": 65, "x2": 733, "y2": 363, "speaking_score": 3.483333388964335, "active": true, "track_id": 3}]}, {"frame_number": 1526, "faces": [{"x1": 431, "y1": 64, "x2": 729, "y2": 362, "speaking_score": 3.483333388964335, "active": true, "track_id": 3}]}, {"frame_number": 1527, "faces": [{"x1": 431, "y1": 64, "x2": 729, "y2": 362, "speaking_score": 3.483333388964335, "active": true, "track_id": 3}]}, {"frame_number": 1528, "faces": [{"x1": 431, "y1": 63, "x2": 729, "y2": 361, "speaking_score": 3.5000000397364297, "active": true, "track_id": 3}]}, {"frame_number": 1529, "faces": [{"x1": 426, "y1": 61, "x2": 724, "y2": 360, "speaking_score": 3.550000031789144, "active": true, "track_id": 3}]}, {"frame_number": 1530, "faces": [{"x1": 423, "y1": 59, "x2": 725, "y2": 361, "speaking_score": 3.583333373069763, "active": true, "track_id": 3}]}, {"frame_number": 1531, "faces": [{"x1": 420, "y1": 58, "x2": 724, "y2": 362, "speaking_score": 3.583333373069763, "active": true, "track_id": 3}]}, {"frame_number": 1532, "faces": [{"x1": 418, "y1": 57, "x2": 721, "y2": 360, "speaking_score": 3.550000031789144, "active": true, "track_id": 3}]}, {"frame_number": 1533, "faces": [{"x1": 418, "y1": 57, "x2": 721, "y2": 360, "speaking_score": 3.550000031789144, "active": true, "track_id": 3}]}, {"frame_number": 1534, "faces": [{"x1": 416, "y1": 54, "x2": 720, "y2": 358, "speaking_score": 3.4333333571751914, "active": true, "track_id": 3}]}, {"frame_number": 1535, "faces": [{"x1": 411, "y1": 51, "x2": 716, "y2": 355, "speaking_score": 3.3666667143503823, "active": true, "track_id": 3}]}, {"frame_number": 1536, "faces": [{"x1": 410, "y1": 50, "x2": 714, "y2": 354, "speaking_score": 3.2666666905085244, "active": true, "track_id": 3}]}, {"frame_number": 1537, "faces": [{"x1": 410, "y1": 50, "x2": 714, "y2": 354, "speaking_score": 3.200000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1538, "faces": [{"x1": 410, "y1": 49, "x2": 714, "y2": 353, "speaking_score": 3.200000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1539, "faces": [{"x1": 410, "y1": 49, "x2": 714, "y2": 353, "speaking_score": 3.200000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1540, "faces": [{"x1": 410, "y1": 48, "x2": 714, "y2": 353, "speaking_score": 3.216666658719381, "active": true, "track_id": 3}]}, {"frame_number": 1541, "faces": [{"x1": 409, "y1": 48, "x2": 714, "y2": 353, "speaking_score": 3.299999992052714, "active": true, "track_id": 3}]}, {"frame_number": 1542, "faces": [{"x1": 409, "y1": 48, "x2": 714, "y2": 353, "speaking_score": 3.366666634877523, "active": true, "track_id": 3}]}, {"frame_number": 1543, "faces": [{"x1": 409, "y1": 48, "x2": 714, "y2": 353, "speaking_score": 3.449999968210856, "active": true, "track_id": 3}]}, {"frame_number": 1544, "faces": [{"x1": 411, "y1": 48, "x2": 716, "y2": 353, "speaking_score": 3.5166666507720947, "active": true, "track_id": 3}]}, {"frame_number": 1545, "faces": [{"x1": 411, "y1": 48, "x2": 716, "y2": 353, "speaking_score": 3.5166666507720947, "active": true, "track_id": 3}]}, {"frame_number": 1546, "faces": [{"x1": 412, "y1": 48, "x2": 716, "y2": 353, "speaking_score": 3.5833332935969033, "active": true, "track_id": 3}]}, {"frame_number": 1547, "faces": [{"x1": 414, "y1": 50, "x2": 719, "y2": 355, "speaking_score": 3.6333332856496177, "active": true, "track_id": 3}]}, {"frame_number": 1548, "faces": [{"x1": 414, "y1": 52, "x2": 719, "y2": 357, "speaking_score": 3.666666626930237, "active": true, "track_id": 3}]}, {"frame_number": 1549, "faces": [{"x1": 415, "y1": 53, "x2": 719, "y2": 357, "speaking_score": 3.649999976158142, "active": true, "track_id": 3}]}, {"frame_number": 1550, "faces": [{"x1": 415, "y1": 53, "x2": 719, "y2": 357, "speaking_score": 3.6833333174387612, "active": true, "track_id": 3}]}, {"frame_number": 1551, "faces": [{"x1": 415, "y1": 53, "x2": 719, "y2": 357, "speaking_score": 3.6833333174387612, "active": true, "track_id": 3}]}, {"frame_number": 1552, "faces": [{"x1": 415, "y1": 53, "x2": 720, "y2": 358, "speaking_score": 3.716666658719381, "active": true, "track_id": 3}]}, {"frame_number": 1553, "faces": [{"x1": 417, "y1": 53, "x2": 722, "y2": 358, "speaking_score": 3.700000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1554, "faces": [{"x1": 417, "y1": 54, "x2": 722, "y2": 359, "speaking_score": 3.650000015894572, "active": true, "track_id": 3}]}, {"frame_number": 1555, "faces": [{"x1": 418, "y1": 55, "x2": 722, "y2": 359, "speaking_score": 3.533333341280619, "active": true, "track_id": 3}]}, {"frame_number": 1556, "faces": [{"x1": 420, "y1": 55, "x2": 724, "y2": 359, "speaking_score": 3.4833333492279053, "active": true, "track_id": 3}]}, {"frame_number": 1557, "faces": [{"x1": 420, "y1": 55, "x2": 724, "y2": 359, "speaking_score": 3.4833333492279053, "active": true, "track_id": 3}]}, {"frame_number": 1558, "faces": [{"x1": 421, "y1": 56, "x2": 724, "y2": 358, "speaking_score": 3.400000015894572, "active": true, "track_id": 3}]}, {"frame_number": 1559, "faces": [{"x1": 423, "y1": 56, "x2": 725, "y2": 358, "speaking_score": 3.283333341280619, "active": true, "track_id": 3}]}, {"frame_number": 1560, "faces": [{"x1": 424, "y1": 56, "x2": 724, "y2": 357, "speaking_score": 3.216666658719381, "active": true, "track_id": 3}]}, {"frame_number": 1561, "faces": [{"x1": 425, "y1": 56, "x2": 725, "y2": 356, "speaking_score": 3.049999992052714, "active": true, "track_id": 3}]}, {"frame_number": 1562, "faces": [{"x1": 425, "y1": 56, "x2": 725, "y2": 356, "speaking_score": 2.9333333174387612, "active": true, "track_id": 3}]}, {"frame_number": 1563, "faces": [{"x1": 425, "y1": 56, "x2": 725, "y2": 356, "speaking_score": 2.9333333174387612, "active": true, "track_id": 3}]}, {"frame_number": 1564, "faces": [{"x1": 426, "y1": 56, "x2": 725, "y2": 355, "speaking_score": 2.7333333094914756, "active": true, "track_id": 3}]}, {"frame_number": 1565, "faces": [{"x1": 427, "y1": 56, "x2": 726, "y2": 355, "speaking_score": 2.449999988079071, "active": true, "track_id": 3}]}, {"frame_number": 1566, "faces": [{"x1": 428, "y1": 55, "x2": 727, "y2": 355, "speaking_score": 2.1166666547457376, "active": true, "track_id": 3}]}, {"frame_number": 1567, "faces": [{"x1": 429, "y1": 55, "x2": 729, "y2": 355, "speaking_score": 1.75, "active": true, "track_id": 3}]}, {"frame_number": 1568, "faces": [{"x1": 431, "y1": 55, "x2": 730, "y2": 355, "speaking_score": 1.5000000099341075, "active": true, "track_id": 3}]}, {"frame_number": 1569, "faces": [{"x1": 431, "y1": 55, "x2": 730, "y2": 355, "speaking_score": 1.5000000099341075, "active": true, "track_id": 3}]}, {"frame_number": 1570, "faces": [{"x1": 431, "y1": 55, "x2": 730, "y2": 355, "speaking_score": 1.1500000183780987, "active": true, "track_id": 3}]}, {"frame_number": 1571, "faces": [{"x1": 431, "y1": 55, "x2": 731, "y2": 355, "speaking_score": 0.7333333517114321, "active": true, "track_id": 3}]}, {"frame_number": 1572, "faces": [{"x1": 432, "y1": 55, "x2": 731, "y2": 355, "speaking_score": 0.3500000163912773, "active": true, "track_id": 3}]}, {"frame_number": 1573, "faces": [{"x1": 434, "y1": 55, "x2": 733, "y2": 355, "speaking_score": 1.241763432820638e-08, "active": true, "track_id": 3}]}, {"frame_number": 1574, "faces": [{"x1": 435, "y1": 55, "x2": 734, "y2": 355, "speaking_score": -0.333333320915699, "active": false, "track_id": 3}]}, {"frame_number": 1575, "faces": [{"x1": 435, "y1": 55, "x2": 734, "y2": 355, "speaking_score": -0.333333320915699, "active": false, "track_id": 3}]}, {"frame_number": 1576, "faces": [{"x1": 434, "y1": 55, "x2": 735, "y2": 356, "speaking_score": -0.6166666522622108, "active": false, "track_id": 3}]}, {"frame_number": 1577, "faces": [{"x1": 433, "y1": 54, "x2": 736, "y2": 357, "speaking_score": -0.7833333214124044, "active": false, "track_id": 3}]}, {"frame_number": 1578, "faces": [{"x1": 433, "y1": 54, "x2": 736, "y2": 357, "speaking_score": -0.8333333233992258, "active": false, "track_id": 3}]}, {"frame_number": 1579, "faces": [{"x1": 432, "y1": 55, "x2": 737, "y2": 361, "speaking_score": -0.899999996026357, "active": false, "track_id": 3}]}, {"frame_number": 1580, "faces": [{"x1": 431, "y1": 55, "x2": 738, "y2": 362, "speaking_score": -0.9333333373069763, "active": false, "track_id": 3}]}, {"frame_number": 1581, "faces": [{"x1": 431, "y1": 55, "x2": 738, "y2": 362, "speaking_score": -0.9333333373069763, "active": false, "track_id": 3}]}, {"frame_number": 1582, "faces": [{"x1": 431, "y1": 56, "x2": 738, "y2": 363, "speaking_score": -0.9333333373069763, "active": false, "track_id": 3}]}, {"frame_number": 1583, "faces": [{"x1": 431, "y1": 56, "x2": 738, "y2": 363, "speaking_score": -0.9833333492279053, "active": false, "track_id": 3}]}, {"frame_number": 1584, "faces": [{"x1": 431, "y1": 56, "x2": 738, "y2": 363, "speaking_score": -1.0333333512147267, "active": false, "track_id": 3}]}, {"frame_number": 1585, "faces": [{"x1": 428, "y1": 56, "x2": 735, "y2": 364, "speaking_score": -0.9833333492279053, "active": false, "track_id": 3}]}, {"frame_number": 1586, "faces": [{"x1": 426, "y1": 56, "x2": 733, "y2": 364, "speaking_score": -0.500000019868215, "active": false, "track_id": 3}]}, {"frame_number": 1587, "faces": [{"x1": 426, "y1": 56, "x2": 733, "y2": 364, "speaking_score": -0.500000019868215, "active": false, "track_id": 3}]}, {"frame_number": 1588, "faces": [{"x1": 419, "y1": 58, "x2": 726, "y2": 365, "speaking_score": 0.18333331743876138, "active": true, "track_id": 3}]}, {"frame_number": 1589, "faces": [{"x1": 402, "y1": 63, "x2": 711, "y2": 372, "speaking_score": 0.8666666547457377, "active": true, "track_id": 3}]}, {"frame_number": 1590, "faces": [{"x1": 393, "y1": 61, "x2": 706, "y2": 374, "speaking_score": 1.600000003973643, "active": true, "track_id": 3}]}, {"frame_number": 1591, "faces": [{"x1": 389, "y1": 61, "x2": 701, "y2": 373, "speaking_score": 2.3333333333333335, "active": true, "track_id": 3}]}, {"frame_number": 1592, "faces": [{"x1": 385, "y1": 62, "x2": 696, "y2": 373, "speaking_score": 2.9833333492279053, "active": true, "track_id": 3}]}, {"frame_number": 1593, "faces": [{"x1": 385, "y1": 62, "x2": 696, "y2": 373, "speaking_score": 2.9833333492279053, "active": true, "track_id": 3}]}, {"frame_number": 1594, "faces": [{"x1": 381, "y1": 63, "x2": 690, "y2": 372, "speaking_score": 3.2500000397364297, "active": true, "track_id": 3}]}, {"frame_number": 1595, "faces": [{"x1": 372, "y1": 64, "x2": 678, "y2": 370, "speaking_score": 3.333333373069763, "active": true, "track_id": 3}]}, {"frame_number": 1596, "faces": [{"x1": 370, "y1": 64, "x2": 676, "y2": 370, "speaking_score": 3.4166667064030967, "active": true, "track_id": 3}]}, {"frame_number": 1597, "faces": [{"x1": 368, "y1": 58, "x2": 678, "y2": 368, "speaking_score": 3.5166666905085244, "active": true, "track_id": 3}]}, {"frame_number": 1598, "faces": [{"x1": 364, "y1": 52, "x2": 675, "y2": 363, "speaking_score": 3.583333373069763, "active": true, "track_id": 3}]}, {"frame_number": 1599, "faces": [{"x1": 364, "y1": 52, "x2": 675, "y2": 363, "speaking_score": 3.583333373069763, "active": true, "track_id": 3}]}, {"frame_number": 1600, "faces": [{"x1": 362, "y1": 51, "x2": 674, "y2": 362, "speaking_score": 3.6166666746139526, "active": true, "track_id": 3}]}, {"frame_number": 1601, "faces": [{"x1": 359, "y1": 46, "x2": 671, "y2": 358, "speaking_score": 3.6166666746139526, "active": true, "track_id": 3}]}, {"frame_number": 1602, "faces": [{"x1": 359, "y1": 46, "x2": 670, "y2": 358, "speaking_score": 3.650000015894572, "active": true, "track_id": 3}]}, {"frame_number": 1603, "faces": [{"x1": 359, "y1": 47, "x2": 669, "y2": 357, "speaking_score": 3.650000015894572, "active": true, "track_id": 3}]}, {"frame_number": 1604, "faces": [{"x1": 359, "y1": 46, "x2": 669, "y2": 356, "speaking_score": 3.600000023841858, "active": true, "track_id": 3}]}, {"frame_number": 1605, "faces": [{"x1": 359, "y1": 46, "x2": 669, "y2": 356, "speaking_score": 3.5666666825612388, "active": true, "track_id": 3}]}, {"frame_number": 1606, "faces": [{"x1": 359, "y1": 46, "x2": 669, "y2": 356, "speaking_score": 3.5666666825612388, "active": true, "track_id": 3}]}, {"frame_number": 1607, "faces": [{"x1": 359, "y1": 45, "x2": 668, "y2": 354, "speaking_score": 3.5666666825612388, "active": true, "track_id": 3}]}, {"frame_number": 1608, "faces": [{"x1": 361, "y1": 46, "x2": 667, "y2": 352, "speaking_score": 3.599999984105428, "active": true, "track_id": 3}]}, {"frame_number": 1609, "faces": [{"x1": 361, "y1": 46, "x2": 667, "y2": 351, "speaking_score": 3.5166666507720947, "active": true, "track_id": 3}]}, {"frame_number": 1610, "faces": [{"x1": 361, "y1": 46, "x2": 666, "y2": 350, "speaking_score": 3.5166666507720947, "active": true, "track_id": 3}]}, {"frame_number": 1611, "faces": [{"x1": 362, "y1": 46, "x2": 667, "y2": 350, "speaking_score": 3.549999992052714, "active": true, "track_id": 3}]}, {"frame_number": 1612, "faces": [{"x1": 362, "y1": 46, "x2": 667, "y2": 350, "speaking_score": 3.549999992052714, "active": true, "track_id": 3}]}, {"frame_number": 1613, "faces": [{"x1": 364, "y1": 46, "x2": 669, "y2": 350, "speaking_score": 3.599999984105428, "active": true, "track_id": 3}]}, {"frame_number": 1614, "faces": [{"x1": 364, "y1": 46, "x2": 669, "y2": 350, "speaking_score": 3.5666666825612388, "active": true, "track_id": 3}]}, {"frame_number": 1615, "faces": [{"x1": 366, "y1": 46, "x2": 671, "y2": 350, "speaking_score": 3.4833333492279053, "active": true, "track_id": 3}]}, {"frame_number": 1616, "faces": [{"x1": 367, "y1": 46, "x2": 671, "y2": 350, "speaking_score": 3.450000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1617, "faces": [{"x1": 369, "y1": 45, "x2": 674, "y2": 350, "speaking_score": 3.349999984105428, "active": true, "track_id": 3}]}, {"frame_number": 1618, "faces": [{"x1": 369, "y1": 45, "x2": 674, "y2": 350, "speaking_score": 3.349999984105428, "active": true, "track_id": 3}]}, {"frame_number": 1619, "faces": [{"x1": 374, "y1": 46, "x2": 677, "y2": 349, "speaking_score": 3.199999968210856, "active": true, "track_id": 3}]}, {"frame_number": 1620, "faces": [{"x1": 376, "y1": 47, "x2": 679, "y2": 349, "speaking_score": 3.0666666428248086, "active": true, "track_id": 3}]}, {"frame_number": 1621, "faces": [{"x1": 377, "y1": 45, "x2": 682, "y2": 350, "speaking_score": 2.9999999602635703, "active": true, "track_id": 3}]}, {"frame_number": 1622, "faces": [{"x1": 377, "y1": 45, "x2": 683, "y2": 351, "speaking_score": 2.9833333094914756, "active": true, "track_id": 3}]}, {"frame_number": 1623, "faces": [{"x1": 380, "y1": 45, "x2": 686, "y2": 351, "speaking_score": 2.9833333094914756, "active": true, "track_id": 3}]}, {"frame_number": 1624, "faces": [{"x1": 380, "y1": 45, "x2": 686, "y2": 351, "speaking_score": 2.9833333094914756, "active": true, "track_id": 3}]}, {"frame_number": 1625, "faces": [{"x1": 385, "y1": 45, "x2": 691, "y2": 351, "speaking_score": 2.950000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1626, "faces": [{"x1": 389, "y1": 46, "x2": 695, "y2": 352, "speaking_score": 2.9166666666666665, "active": true, "track_id": 3}]}, {"frame_number": 1627, "faces": [{"x1": 393, "y1": 47, "x2": 696, "y2": 350, "speaking_score": 2.9166666666666665, "active": true, "track_id": 3}]}, {"frame_number": 1628, "faces": [{"x1": 397, "y1": 47, "x2": 699, "y2": 349, "speaking_score": 2.9333333174387612, "active": true, "track_id": 3}]}, {"frame_number": 1629, "faces": [{"x1": 403, "y1": 48, "x2": 704, "y2": 348, "speaking_score": 2.9833333094914756, "active": true, "track_id": 3}]}, {"frame_number": 1630, "faces": [{"x1": 403, "y1": 48, "x2": 704, "y2": 348, "speaking_score": 2.9833333094914756, "active": true, "track_id": 3}]}, {"frame_number": 1631, "faces": [{"x1": 417, "y1": 48, "x2": 717, "y2": 348, "speaking_score": 3.0166666507720947, "active": true, "track_id": 3}]}, {"frame_number": 1632, "faces": [{"x1": 423, "y1": 48, "x2": 723, "y2": 348, "speaking_score": 3.0333333015441895, "active": true, "track_id": 3}]}, {"frame_number": 1633, "faces": [{"x1": 430, "y1": 50, "x2": 727, "y2": 347, "speaking_score": 3.0833333333333335, "active": true, "track_id": 3}]}, {"frame_number": 1634, "faces": [{"x1": 438, "y1": 51, "x2": 733, "y2": 346, "speaking_score": 3.049999992052714, "active": true, "track_id": 3}]}, {"frame_number": 1635, "faces": [{"x1": 443, "y1": 52, "x2": 737, "y2": 346, "speaking_score": 3.0166666905085244, "active": true, "track_id": 3}]}, {"frame_number": 1636, "faces": [{"x1": 443, "y1": 52, "x2": 737, "y2": 346, "speaking_score": 3.0166666905085244, "active": true, "track_id": 3}]}, {"frame_number": 1637, "faces": [{"x1": 460, "y1": 55, "x2": 753, "y2": 348, "speaking_score": 2.9666666984558105, "active": true, "track_id": 3}]}, {"frame_number": 1638, "faces": [{"x1": 470, "y1": 56, "x2": 762, "y2": 349, "speaking_score": 2.950000007947286, "active": true, "track_id": 3}]}, {"frame_number": 1639, "faces": [{"x1": 479, "y1": 57, "x2": 771, "y2": 349, "speaking_score": 2.9333333571751914, "active": true, "track_id": 3}]}, {"frame_number": 1640, "faces": [{"x1": 490, "y1": 57, "x2": 781, "y2": 349, "speaking_score": 2.900000015894572, "active": true, "track_id": 3}]}, {"frame_number": 1641, "faces": [{"x1": 491, "y1": 58, "x2": 780, "y2": 348, "speaking_score": 2.800000031789144, "active": true, "track_id": 3}]}, {"frame_number": 1642, "faces": [{"x1": 491, "y1": 58, "x2": 780, "y2": 348, "speaking_score": 2.800000031789144, "active": true, "track_id": 3}]}, {"frame_number": 1643, "faces": [{"x1": 491, "y1": 58, "x2": 780, "y2": 347, "speaking_score": 2.5666666825612388, "active": true, "track_id": 3}]}, {"frame_number": 1644, "faces": [{"x1": 491, "y1": 59, "x2": 780, "y2": 347, "speaking_score": 2.4800000190734863, "active": true, "track_id": 3}]}, {"frame_number": 1645, "faces": [{"x1": 491, "y1": 58, "x2": 780, "y2": 347, "speaking_score": 2.325000047683716, "active": true, "track_id": 3}]}, {"frame_number": 1646, "faces": [{"x1": 491, "y1": 58, "x2": 780, "y2": 346, "speaking_score": 2.133333365122477, "active": true, "track_id": 3}]}, {"frame_number": 1647, "faces": [{"x1": 493, "y1": 58, "x2": 778, "y2": 344, "speaking_score": 1.850000023841858, "active": true, "track_id": 3}]}, {"frame_number": 1648, "faces": [{"x1": 493, "y1": 58, "x2": 778, "y2": 344, "speaking_score": 1.850000023841858, "active": true, "track_id": 3}]}, {"frame_number": 1649, "faces": [{"x1": 1072, "y1": 106, "x2": 1208, "y2": 242, "speaking_score": -1.3333332935969036, "active": false, "track_id": 4}, {"x1": 29, "y1": 73, "x2": 176, "y2": 220, "speaking_score": -1.0666666825612385, "active": false, "track_id": 5}, {"x1": 205, "y1": 111, "x2": 324, "y2": 230, "speaking_score": -1.6333333651224773, "active": false, "track_id": 6}, {"x1": 773, "y1": 121, "x2": 897, "y2": 244, "speaking_score": -1.1666667064030964, "active": false, "track_id": 7}, {"x1": 757, "y1": 7, "x2": 884, "y2": 134, "speaking_score": -0.800000011920929, "active": false, "track_id": 8}, {"x1": 365, "y1": 42, "x2": 472, "y2": 150, "speaking_score": -1.0333333412806194, "active": false, "track_id": 9}, {"x1": 870, "y1": 100, "x2": 990, "y2": 220, "speaking_score": -0.600000003973643, "active": false, "track_id": 10}]}, {"frame_number": 1650, "faces": [{"x1": 1072, "y1": 106, "x2": 1208, "y2": 242, "speaking_score": -1.2833333214124043, "active": false, "track_id": 4}, {"x1": 29, "y1": 74, "x2": 176, "y2": 221, "speaking_score": -0.9666666587193807, "active": false, "track_id": 5}, {"x1": 205, "y1": 111, "x2": 324, "y2": 230, "speaking_score": -1.6666666865348816, "active": false, "track_id": 6}, {"x1": 773, "y1": 123, "x2": 897, "y2": 248, "speaking_score": -1.100000023841858, "active": false, "track_id": 7}, {"x1": 757, "y1": 7, "x2": 884, "y2": 135, "speaking_score": -0.5166666805744171, "active": false, "track_id": 8}, {"x1": 365, "y1": 43, "x2": 473, "y2": 151, "speaking_score": -0.8999999860922495, "active": false, "track_id": 9}, {"x1": 870, "y1": 101, "x2": 991, "y2": 222, "speaking_score": -0.4166666766007741, "active": false, "track_id": 10}]}, {"frame_number": 1651, "faces": [{"x1": 1072, "y1": 106, "x2": 1208, "y2": 242, "speaking_score": -1.3166666626930237, "active": false, "track_id": 4}, {"x1": 29, "y1": 74, "x2": 176, "y2": 221, "speaking_score": -1.0333333214124043, "active": false, "track_id": 5}, {"x1": 205, "y1": 111, "x2": 324, "y2": 230, "speaking_score": -1.700000007947286, "active": false, "track_id": 6}, {"x1": 773, "y1": 123, "x2": 897, "y2": 248, "speaking_score": -1.1166666944821675, "active": false, "track_id": 7}, {"x1": 757, "y1": 7, "x2": 884, "y2": 135, "speaking_score": -0.5166666805744171, "active": false, "track_id": 8}, {"x1": 365, "y1": 43, "x2": 473, "y2": 151, "speaking_score": -0.9166666567325592, "active": false, "track_id": 9}, {"x1": 870, "y1": 101, "x2": 991, "y2": 222, "speaking_score": -0.45000000794728595, "active": false, "track_id": 10}]}, {"frame_number": 1652, "faces": [{"x1": 1072, "y1": 106, "x2": 1208, "y2": 242, "speaking_score": -1.3833333452542622, "active": false, "track_id": 4}, {"x1": 29, "y1": 74, "x2": 176, "y2": 221, "speaking_score": -1.1333333253860474, "active": false, "track_id": 5}, {"x1": 205, "y1": 111, "x2": 324, "y2": 230, "speaking_score": -1.7833333214124043, "active": false, "track_id": 6}, {"x1": 772, "y1": 123, "x2": 897, "y2": 248, "speaking_score": -1.1833333571751912, "active": false, "track_id": 7}, {"x1": 757, "y1": 7, "x2": 884, "y2": 135, "speaking_score": -0.5666666726271311, "active": false, "track_id": 8}, {"x1": 365, "y1": 43, "x2": 473, "y2": 151, "speaking_score": -0.9833333194255829, "active": false, "track_id": 9}, {"x1": 869, "y1": 101, "x2": 990, "y2": 222, "speaking_score": -0.5500000069538752, "active": false, "track_id": 10}]}, {"frame_number": 1653, "faces": [{"x1": 1071, "y1": 106, "x2": 1207, "y2": 242, "speaking_score": -1.4833333492279053, "active": false, "track_id": 4}, {"x1": 29, "y1": 74, "x2": 176, "y2": 221, "speaking_score": -1.25, "active": false, "track_id": 5}, {"x1": 205, "y1": 111, "x2": 324, "y2": 230, "speaking_score": -1.8666666547457378, "active": false, "track_id": 6}, {"x1": 772, "y1": 123, "x2": 897, "y2": 248, "speaking_score": -1.2666666905085247, "active": false, "track_id": 7}, {"x1": 757, "y1": 7, "x2": 884, "y2": 135, "speaking_score": -0.6500000059604645, "active": false, "track_id": 8}, {"x1": 365, "y1": 43, "x2": 473, "y2": 151, "speaking_score": -1.0666666527589161, "active": false, "track_id": 9}, {"x1": 869, "y1": 100, "x2": 991, "y2": 222, "speaking_score": -0.7000000129143397, "active": false, "track_id": 10}]}, {"frame_number": 1654, "faces": [{"x1": 1070, "y1": 106, "x2": 1206, "y2": 242, "speaking_score": -1.6333333253860474, "active": false, "track_id": 4}, {"x1": 29, "y1": 74, "x2": 176, "y2": 221, "speaking_score": -1.399999996026357, "active": false, "track_id": 5}, {"x1": 205, "y1": 111, "x2": 323, "y2": 230, "speaking_score": -2.0, "active": false, "track_id": 6}, {"x1": 772, "y1": 123, "x2": 897, "y2": 248, "speaking_score": -1.400000015894572, "active": false, "track_id": 7}, {"x1": 757, "y1": 7, "x2": 884, "y2": 135, "speaking_score": -0.783333346247673, "active": false, "track_id": 8}, {"x1": 364, "y1": 43, "x2": 473, "y2": 151, "speaking_score": -1.199999988079071, "active": false, "track_id": 9}, {"x1": 869, "y1": 100, "x2": 991, "y2": 222, "speaking_score": -0.8666666696468989, "active": false, "track_id": 10}]}, {"frame_number": 1655, "faces": [{"x1": 1070, "y1": 106, "x2": 1206, "y2": 242, "speaking_score": -1.8166666428248088, "active": false, "track_id": 4}, {"x1": 29, "y1": 74, "x2": 175, "y2": 221, "speaking_score": -1.5666666626930237, "active": false, "track_id": 5}, {"x1": 205, "y1": 111, "x2": 323, "y2": 229, "speaking_score": -2.1333333253860474, "active": false, "track_id": 6}, {"x1": 771, "y1": 123, "x2": 896, "y2": 248, "speaking_score": -1.550000011920929, "active": false, "track_id": 7}, {"x1": 756, "y1": 7, "x2": 884, "y2": 135, "speaking_score": -0.9333333373069763, "active": false, "track_id": 8}, {"x1": 363, "y1": 43, "x2": 472, "y2": 152, "speaking_score": -1.3333333333333333, "active": false, "track_id": 9}, {"x1": 867, "y1": 100, "x2": 989, "y2": 222, "speaking_score": -1.0333333313465118, "active": false, "track_id": 10}]}, {"frame_number": 1656, "faces": [{"x1": 1070, "y1": 106, "x2": 1206, "y2": 242, "speaking_score": -1.8166666428248088, "active": false, "track_id": 4}, {"x1": 29, "y1": 74, "x2": 175, "y2": 221, "speaking_score": -1.5666666626930237, "active": false, "track_id": 5}, {"x1": 205, "y1": 111, "x2": 323, "y2": 229, "speaking_score": -2.1333333253860474, "active": false, "track_id": 6}, {"x1": 771, "y1": 123, "x2": 896, "y2": 248, "speaking_score": -1.550000011920929, "active": false, "track_id": 7}, {"x1": 756, "y1": 7, "x2": 884, "y2": 135, "speaking_score": -0.9333333373069763, "active": false, "track_id": 8}, {"x1": 363, "y1": 43, "x2": 472, "y2": 152, "speaking_score": -1.3333333333333333, "active": false, "track_id": 9}, {"x1": 867, "y1": 100, "x2": 989, "y2": 222, "speaking_score": -1.0333333313465118, "active": false, "track_id": 10}]}, {"frame_number": 1657, "faces": [{"x1": 1070, "y1": 106, "x2": 1206, "y2": 242, "speaking_score": -1.9833333293596904, "active": false, "track_id": 4}, {"x1": 28, "y1": 74, "x2": 175, "y2": 221, "speaking_score": -1.7333333094914753, "active": false, "track_id": 5}, {"x1": 205, "y1": 111, "x2": 323, "y2": 229, "speaking_score": -2.2666666507720947, "active": false, "track_id": 6}, {"x1": 771, "y1": 123, "x2": 896, "y2": 248, "speaking_score": -1.699999988079071, "active": false, "track_id": 7}, {"x1": 756, "y1": 7, "x2": 884, "y2": 135, "speaking_score": -1.0666666626930237, "active": false, "track_id": 8}, {"x1": 363, "y1": 42, "x2": 472, "y2": 152, "speaking_score": -1.4833333293596904, "active": false, "track_id": 9}, {"x1": 867, "y1": 100, "x2": 989, "y2": 222, "speaking_score": -1.1666666567325592, "active": false, "track_id": 10}]}, {"frame_number": 1658, "faces": [{"x1": 1069, "y1": 106, "x2": 1205, "y2": 242, "speaking_score": -2.149999996026357, "active": false, "track_id": 4}, {"x1": 28, "y1": 74, "x2": 175, "y2": 221, "speaking_score": -1.899999976158142, "active": false, "track_id": 5}, {"x1": 204, "y1": 111, "x2": 322, "y2": 229, "speaking_score": -2.4166666666666665, "active": false, "track_id": 6}, {"x1": 771, "y1": 123, "x2": 895, "y2": 248, "speaking_score": -1.8666666547457378, "active": false, "track_id": 7}, {"x1": 755, "y1": 7, "x2": 883, "y2": 135, "speaking_score": -1.2166666587193806, "active": false, "track_id": 8}, {"x1": 363, "y1": 42, "x2": 472, "y2": 152, "speaking_score": -1.6166666547457378, "active": false, "track_id": 9}, {"x1": 866, "y1": 100, "x2": 988, "y2": 222, "speaking_score": -1.3166666626930237, "active": false, "track_id": 10}]}, {"frame_number": 1659, "faces": [{"x1": 1069, "y1": 106, "x2": 1205, "y2": 242, "speaking_score": -2.2999999721844993, "active": false, "track_id": 4}, {"x1": 28, "y1": 74, "x2": 175, "y2": 221, "speaking_score": -2.0333333015441895, "active": false, "track_id": 5}, {"x1": 204, "y1": 111, "x2": 322, "y2": 229, "speaking_score": -2.533333341280619, "active": false, "track_id": 6}, {"x1": 771, "y1": 123, "x2": 895, "y2": 248, "speaking_score": -1.9999999801317851, "active": false, "track_id": 7}, {"x1": 755, "y1": 7, "x2": 882, "y2": 135, "speaking_score": -1.3333333333333333, "active": false, "track_id": 8}, {"x1": 362, "y1": 42, "x2": 472, "y2": 152, "speaking_score": -1.7333333293596904, "active": false, "track_id": 9}, {"x1": 866, "y1": 100, "x2": 988, "y2": 222, "speaking_score": -1.4333333373069763, "active": false, "track_id": 10}]}, {"frame_number": 1660, "faces": [{"x1": 1068, "y1": 106, "x2": 1204, "y2": 242, "speaking_score": -2.416666626930237, "active": false, "track_id": 4}, {"x1": 28, "y1": 74, "x2": 175, "y2": 221, "speaking_score": -2.1333332856496177, "active": false, "track_id": 5}, {"x1": 204, "y1": 111, "x2": 322, "y2": 229, "speaking_score": -2.650000015894572, "active": false, "track_id": 6}, {"x1": 770, "y1": 123, "x2": 894, "y2": 247, "speaking_score": -2.116666634877523, "active": false, "track_id": 7}, {"x1": 754, "y1": 7, "x2": 882, "y2": 135, "speaking_score": -1.450000007947286, "active": false, "track_id": 8}, {"x1": 362, "y1": 42, "x2": 472, "y2": 152, "speaking_score": -1.849999984105428, "active": false, "track_id": 9}, {"x1": 866, "y1": 100, "x2": 987, "y2": 222, "speaking_score": -1.5333333214124043, "active": false, "track_id": 10}]}, {"frame_number": 1661, "faces": [{"x1": 1068, "y1": 106, "x2": 1204, "y2": 242, "speaking_score": -2.5166666507720947, "active": false, "track_id": 4}, {"x1": 28, "y1": 74, "x2": 175, "y2": 221, "speaking_score": -2.2166666189829507, "active": false, "track_id": 5}, {"x1": 204, "y1": 111, "x2": 322, "y2": 229, "speaking_score": -2.75, "active": false, "track_id": 6}, {"x1": 770, "y1": 124, "x2": 894, "y2": 247, "speaking_score": -2.216666658719381, "active": false, "track_id": 7}, {"x1": 754, "y1": 7, "x2": 881, "y2": 135, "speaking_score": -1.549999992052714, "active": false, "track_id": 8}, {"x1": 361, "y1": 42, "x2": 472, "y2": 153, "speaking_score": -1.9333332975705464, "active": false, "track_id": 9}, {"x1": 865, "y1": 100, "x2": 987, "y2": 222, "speaking_score": -1.600000003973643, "active": false, "track_id": 10}]}, {"frame_number": 1662, "faces": [{"x1": 1068, "y1": 106, "x2": 1204, "y2": 242, "speaking_score": -2.5166666507720947, "active": false, "track_id": 4}, {"x1": 28, "y1": 74, "x2": 175, "y2": 221, "speaking_score": -2.2166666189829507, "active": false, "track_id": 5}, {"x1": 204, "y1": 111, "x2": 322, "y2": 229, "speaking_score": -2.75, "active": false, "track_id": 6}, {"x1": 770, "y1": 124, "x2": 894, "y2": 247, "speaking_score": -2.216666658719381, "active": false, "track_id": 7}, {"x1": 754, "y1": 7, "x2": 881, "y2": 135, "speaking_score": -1.549999992052714, "active": false, "track_id": 8}, {"x1": 361, "y1": 42, "x2": 472, "y2": 153, "speaking_score": -1.9333332975705464, "active": false, "track_id": 9}, {"x1": 865, "y1": 100, "x2": 987, "y2": 222, "speaking_score": -1.600000003973643, "active": false, "track_id": 10}]}, {"frame_number": 1663, "faces": [{"x1": 1067, "y1": 106, "x2": 1203, "y2": 242, "speaking_score": -2.5833333333333335, "active": false, "track_id": 4}, {"x1": 28, "y1": 74, "x2": 175, "y2": 221, "speaking_score": -2.2833333015441895, "active": false, "track_id": 5}, {"x1": 204, "y1": 112, "x2": 322, "y2": 229, "speaking_score": -2.8333333333333335, "active": false, "track_id": 6}, {"x1": 770, "y1": 124, "x2": 894, "y2": 247, "speaking_score": -2.283333341280619, "active": false, "track_id": 7}, {"x1": 754, "y1": 7, "x2": 881, "y2": 134, "speaking_score": -1.6333333253860474, "active": false, "track_id": 8}, {"x1": 361, "y1": 42, "x2": 472, "y2": 153, "speaking_score": -1.9999999403953552, "active": false, "track_id": 9}, {"x1": 865, "y1": 100, "x2": 987, "y2": 222, "speaking_score": -1.6666666666666667, "active": false, "track_id": 10}]}, {"frame_number": 1664, "faces": [{"x1": 1067, "y1": 106, "x2": 1203, "y2": 242, "speaking_score": -2.6333333253860474, "active": false, "track_id": 4}, {"x1": 28, "y1": 74, "x2": 175, "y2": 221, "speaking_score": -2.3333333333333335, "active": false, "track_id": 5}, {"x1": 204, "y1": 112, "x2": 321, "y2": 229, "speaking_score": -2.900000015894572, "active": false, "track_id": 6}, {"x1": 770, "y1": 123, "x2": 894, "y2": 247, "speaking_score": -2.333333373069763, "active": false, "track_id": 7}, {"x1": 754, "y1": 7, "x2": 881, "y2": 134, "speaking_score": -1.7166666587193806, "active": false, "track_id": 8}, {"x1": 360, "y1": 42, "x2": 472, "y2": 154, "speaking_score": -2.049999932448069, "active": false, "track_id": 9}, {"x1": 864, "y1": 100, "x2": 987, "y2": 222, "speaking_score": -1.7166666785875957, "active": false, "track_id": 10}]}, {"frame_number": 1665, "faces": [{"x1": 1066, "y1": 106, "x2": 1202, "y2": 242, "speaking_score": -2.6666666666666665, "active": false, "track_id": 4}, {"x1": 28, "y1": 74, "x2": 174, "y2": 221, "speaking_score": -2.3333333333333335, "active": false, "track_id": 5}, {"x1": 203, "y1": 112, "x2": 321, "y2": 230, "speaking_score": -2.950000007947286, "active": false, "track_id": 6}, {"x1": 770, "y1": 123, "x2": 894, "y2": 246, "speaking_score": -2.3666667143503823, "active": false, "track_id": 7}, {"x1": 753, "y1": 7, "x2": 880, "y2": 134, "speaking_score": -1.7666666507720947, "active": false, "track_id": 8}, {"x1": 360, "y1": 42, "x2": 472, "y2": 154, "speaking_score": -2.066666603088379, "active": false, "track_id": 9}, {"x1": 864, "y1": 99, "x2": 987, "y2": 221, "speaking_score": -1.7333333492279053, "active": false, "track_id": 10}]}, {"frame_number": 1666, "faces": [{"x1": 1066, "y1": 106, "x2": 1202, "y2": 243, "speaking_score": -2.6666666666666665, "active": false, "track_id": 4}, {"x1": 28, "y1": 74, "x2": 174, "y2": 221, "speaking_score": -2.3166666825612388, "active": false, "track_id": 5}, {"x1": 203, "y1": 112, "x2": 321, "y2": 230, "speaking_score": -2.9666666984558105, "active": false, "track_id": 6}, {"x1": 770, "y1": 122, "x2": 894, "y2": 246, "speaking_score": -2.3666667143503823, "active": false, "track_id": 7}, {"x1": 753, "y1": 8, "x2": 880, "y2": 134, "speaking_score": -1.799999972184499, "active": false, "track_id": 8}, {"x1": 359, "y1": 42, "x2": 472, "y2": 154, "speaking_score": -2.049999932448069, "active": false, "track_id": 9}, {"x1": 864, "y1": 99, "x2": 986, "y2": 221, "speaking_score": -1.7166666785875957, "active": false, "track_id": 10}]}, {"frame_number": 1667, "faces": [{"x1": 1065, "y1": 106, "x2": 1201, "y2": 243, "speaking_score": -2.650000015894572, "active": false, "track_id": 4}, {"x1": 28, "y1": 75, "x2": 174, "y2": 220, "speaking_score": -2.300000031789144, "active": false, "track_id": 5}, {"x1": 203, "y1": 112, "x2": 320, "y2": 230, "speaking_score": -2.950000007947286, "active": false, "track_id": 6}, {"x1": 770, "y1": 122, "x2": 893, "y2": 246, "speaking_score": -2.3500000635782876, "active": false, "track_id": 7}, {"x1": 753, "y1": 8, "x2": 880, "y2": 134, "speaking_score": -1.8166666229565938, "active": false, "track_id": 8}, {"x1": 358, "y1": 41, "x2": 471, "y2": 154, "speaking_score": -2.016666611035665, "active": false, "track_id": 9}, {"x1": 862, "y1": 99, "x2": 984, "y2": 222, "speaking_score": -1.6833333571751912, "active": false, "track_id": 10}]}, {"frame_number": 1668, "faces": [{"x1": 1065, "y1": 106, "x2": 1201, "y2": 243, "speaking_score": -2.650000015894572, "active": false, "track_id": 4}, {"x1": 28, "y1": 75, "x2": 174, "y2": 220, "speaking_score": -2.300000031789144, "active": false, "track_id": 5}, {"x1": 203, "y1": 112, "x2": 320, "y2": 230, "speaking_score": -2.950000007947286, "active": false, "track_id": 6}, {"x1": 770, "y1": 122, "x2": 893, "y2": 246, "speaking_score": -2.3500000635782876, "active": false, "track_id": 7}, {"x1": 753, "y1": 8, "x2": 880, "y2": 134, "speaking_score": -1.8166666229565938, "active": false, "track_id": 8}, {"x1": 358, "y1": 41, "x2": 471, "y2": 154, "speaking_score": -2.016666611035665, "active": false, "track_id": 9}, {"x1": 862, "y1": 99, "x2": 984, "y2": 222, "speaking_score": -1.6833333571751912, "active": false, "track_id": 10}]}, {"frame_number": 1669, "faces": [{"x1": 1065, "y1": 106, "x2": 1201, "y2": 243, "speaking_score": -2.6166666746139526, "active": false, "track_id": 4}, {"x1": 28, "y1": 75, "x2": 174, "y2": 220, "speaking_score": -2.2666666905085244, "active": false, "track_id": 5}, {"x1": 202, "y1": 113, "x2": 320, "y2": 230, "speaking_score": -2.9166666666666665, "active": false, "track_id": 6}, {"x1": 770, "y1": 122, "x2": 893, "y2": 246, "speaking_score": -2.3166667222976685, "active": false, "track_id": 7}, {"x1": 752, "y1": 8, "x2": 879, "y2": 134, "speaking_score": -1.799999972184499, "active": false, "track_id": 8}, {"x1": 358, "y1": 41, "x2": 471, "y2": 154, "speaking_score": -1.9833332896232605, "active": false, "track_id": 9}, {"x1": 861, "y1": 99, "x2": 984, "y2": 222, "speaking_score": -1.6666666865348816, "active": false, "track_id": 10}]}, {"frame_number": 1670, "faces": [{"x1": 1065, "y1": 107, "x2": 1201, "y2": 243, "speaking_score": -2.5833333333333335, "active": false, "track_id": 4}, {"x1": 28, "y1": 75, "x2": 174, "y2": 220, "speaking_score": -2.216666658719381, "active": false, "track_id": 5}, {"x1": 202, "y1": 113, "x2": 320, "y2": 230, "speaking_score": -2.8833333253860474, "active": false, "track_id": 6}, {"x1": 770, "y1": 122, "x2": 893, "y2": 246, "speaking_score": -2.2833333810170493, "active": false, "track_id": 7}, {"x1": 752, "y1": 8, "x2": 879, "y2": 134, "speaking_score": -1.7833333214124043, "active": false, "track_id": 8}, {"x1": 358, "y1": 42, "x2": 471, "y2": 154, "speaking_score": -1.9499999682108562, "active": false, "track_id": 9}, {"x1": 861, "y1": 98, "x2": 984, "y2": 222, "speaking_score": -1.6500000357627869, "active": false, "track_id": 10}]}, {"frame_number": 1671, "faces": [{"x1": 1064, "y1": 107, "x2": 1200, "y2": 243, "speaking_score": -2.5166666507720947, "active": false, "track_id": 4}, {"x1": 28, "y1": 75, "x2": 173, "y2": 220, "speaking_score": -2.149999976158142, "active": false, "track_id": 5}, {"x1": 202, "y1": 113, "x2": 320, "y2": 230, "speaking_score": -2.8166666428248086, "active": false, "track_id": 6}, {"x1": 770, "y1": 122, "x2": 893, "y2": 245, "speaking_score": -2.2166666984558105, "active": false, "track_id": 7}, {"x1": 752, "y1": 8, "x2": 878, "y2": 134, "speaking_score": -1.7666666507720947, "active": false, "track_id": 8}, {"x1": 358, "y1": 42, "x2": 471, "y2": 155, "speaking_score": -1.8833333253860474, "active": false, "track_id": 9}, {"x1": 859, "y1": 98, "x2": 983, "y2": 222, "speaking_score": -1.600000023841858, "active": false, "track_id": 10}]}, {"frame_number": 1672, "faces": [{"x1": 1064, "y1": 107, "x2": 1200, "y2": 243, "speaking_score": -2.399999976158142, "active": false, "track_id": 4}, {"x1": 28, "y1": 75, "x2": 173, "y2": 220, "speaking_score": -2.0666666428248086, "active": false, "track_id": 5}, {"x1": 202, "y1": 113, "x2": 319, "y2": 230, "speaking_score": -2.699999968210856, "active": false, "track_id": 6}, {"x1": 770, "y1": 122, "x2": 893, "y2": 245, "speaking_score": -2.1166666746139526, "active": false, "track_id": 7}, {"x1": 752, "y1": 8, "x2": 878, "y2": 134, "speaking_score": -1.699999988079071, "active": false, "track_id": 8}, {"x1": 358, "y1": 42, "x2": 471, "y2": 155, "speaking_score": -1.799999992052714, "active": false, "track_id": 9}, {"x1": 859, "y1": 98, "x2": 983, "y2": 221, "speaking_score": -1.5166666905085247, "active": false, "track_id": 10}]}, {"frame_number": 1673, "faces": [{"x1": 1063, "y1": 107, "x2": 1199, "y2": 243, "speaking_score": -2.216666658719381, "active": false, "track_id": 4}, {"x1": 27, "y1": 75, "x2": 172, "y2": 220, "speaking_score": -1.9166666269302368, "active": false, "track_id": 5}, {"x1": 202, "y1": 114, "x2": 319, "y2": 230, "speaking_score": -2.5333332816759744, "active": false, "track_id": 6}, {"x1": 770, "y1": 122, "x2": 893, "y2": 245, "speaking_score": -1.950000007947286, "active": false, "track_id": 7}, {"x1": 752, "y1": 8, "x2": 878, "y2": 134, "speaking_score": -1.5333333313465118, "active": false, "track_id": 8}, {"x1": 356, "y1": 42, "x2": 470, "y2": 155, "speaking_score": -1.6666666666666667, "active": false, "track_id": 9}, {"x1": 858, "y1": 98, "x2": 981, "y2": 221, "speaking_score": -1.3833333551883698, "active": false, "track_id": 10}]}, {"frame_number": 1674, "faces": [{"x1": 1063, "y1": 107, "x2": 1199, "y2": 243, "speaking_score": -2.216666658719381, "active": false, "track_id": 4}, {"x1": 27, "y1": 75, "x2": 172, "y2": 220, "speaking_score": -1.9166666269302368, "active": false, "track_id": 5}, {"x1": 202, "y1": 114, "x2": 319, "y2": 230, "speaking_score": -2.5333332816759744, "active": false, "track_id": 6}, {"x1": 770, "y1": 122, "x2": 893, "y2": 245, "speaking_score": -1.950000007947286, "active": false, "track_id": 7}, {"x1": 752, "y1": 8, "x2": 878, "y2": 134, "speaking_score": -1.5333333313465118, "active": false, "track_id": 8}, {"x1": 356, "y1": 42, "x2": 470, "y2": 155, "speaking_score": -1.6666666666666667, "active": false, "track_id": 9}, {"x1": 858, "y1": 98, "x2": 981, "y2": 221, "speaking_score": -1.3833333551883698, "active": false, "track_id": 10}]}, {"frame_number": 1675, "faces": [{"x1": 1063, "y1": 108, "x2": 1199, "y2": 243, "speaking_score": -1.949999988079071, "active": false, "track_id": 4}, {"x1": 27, "y1": 75, "x2": 172, "y2": 220, "speaking_score": -1.683333287636439, "active": false, "track_id": 5}, {"x1": 202, "y1": 114, "x2": 318, "y2": 230, "speaking_score": -2.316666622956594, "active": false, "track_id": 6}, {"x1": 770, "y1": 121, "x2": 893, "y2": 245, "speaking_score": -1.7166666686534882, "active": false, "track_id": 7}, {"x1": 751, "y1": 8, "x2": 877, "y2": 134, "speaking_score": -1.2666666731238365, "active": false, "track_id": 8}, {"x1": 356, "y1": 42, "x2": 470, "y2": 156, "speaking_score": -1.450000007947286, "active": false, "track_id": 9}, {"x1": 857, "y1": 97, "x2": 981, "y2": 221, "speaking_score": -1.1666666865348816, "active": false, "track_id": 10}]}, {"frame_number": 1676, "faces": [{"x1": 1063, "y1": 108, "x2": 1198, "y2": 243, "speaking_score": -1.6333333253860474, "active": false, "track_id": 4}, {"x1": 27, "y1": 75, "x2": 172, "y2": 220, "speaking_score": -1.4166666368643444, "active": false, "track_id": 5}, {"x1": 202, "y1": 114, "x2": 318, "y2": 230, "speaking_score": -2.0499999721844993, "active": false, "track_id": 6}, {"x1": 770, "y1": 121, "x2": 893, "y2": 244, "speaking_score": -1.4333333273728688, "active": false, "track_id": 7}, {"x1": 751, "y1": 8, "x2": 877, "y2": 134, "speaking_score": -0.9499999980131785, "active": false, "track_id": 8}, {"x1": 355, "y1": 42, "x2": 470, "y2": 156, "speaking_score": -1.1833333472410839, "active": false, "track_id": 9}, {"x1": 857, "y1": 97, "x2": 981, "y2": 221, "speaking_score": -0.9166666828095913, "active": false, "track_id": 10}]}, {"frame_number": 1677, "faces": [{"x1": 1062, "y1": 108, "x2": 1197, "y2": 243, "speaking_score": -1.299999992052714, "active": false, "track_id": 4}, {"x1": 27, "y1": 76, "x2": 171, "y2": 219, "speaking_score": -1.1333333204189937, "active": false, "track_id": 5}, {"x1": 202, "y1": 114, "x2": 318, "y2": 231, "speaking_score": -1.7833333214124043, "active": false, "track_id": 6}, {"x1": 769, "y1": 121, "x2": 893, "y2": 244, "speaking_score": -1.1333333204189937, "active": false, "track_id": 7}, {"x1": 751, "y1": 8, "x2": 876, "y2": 134, "speaking_score": -0.6166666547457377, "active": false, "track_id": 8}, {"x1": 353, "y1": 41, "x2": 471, "y2": 158, "speaking_score": -0.9000000183780988, "active": false, "track_id": 9}, {"x1": 857, "y1": 97, "x2": 981, "y2": 221, "speaking_score": -0.633333341528972, "active": false, "track_id": 10}]}, {"frame_number": 1678, "faces": [{"x1": 1062, "y1": 108, "x2": 1197, "y2": 243, "speaking_score": -1.0166666706403096, "active": false, "track_id": 4}, {"x1": 27, "y1": 76, "x2": 170, "y2": 219, "speaking_score": -0.8833333204189936, "active": false, "track_id": 5}, {"x1": 202, "y1": 115, "x2": 318, "y2": 231, "speaking_score": -1.550000011920929, "active": false, "track_id": 6}, {"x1": 769, "y1": 121, "x2": 892, "y2": 244, "speaking_score": -0.8833333204189936, "active": false, "track_id": 7}, {"x1": 750, "y1": 8, "x2": 876, "y2": 134, "speaking_score": -0.29999999577800435, "active": false, "track_id": 8}, {"x1": 353, "y1": 41, "x2": 470, "y2": 158, "speaking_score": -0.666666679084301, "active": false, "track_id": 9}, {"x1": 856, "y1": 97, "x2": 981, "y2": 221, "speaking_score": -0.416666679084301, "active": false, "track_id": 10}]}, {"frame_number": 1679, "faces": [{"x1": 1061, "y1": 108, "x2": 1195, "y2": 243, "speaking_score": -0.8000000019868215, "active": false, "track_id": 4}, {"x1": 27, "y1": 76, "x2": 170, "y2": 219, "speaking_score": -0.6999999930461248, "active": false, "track_id": 5}, {"x1": 201, "y1": 115, "x2": 317, "y2": 231, "speaking_score": -1.3833333452542622, "active": false, "track_id": 6}, {"x1": 769, "y1": 121, "x2": 892, "y2": 244, "speaking_score": -0.666666661699613, "active": false, "track_id": 7}, {"x1": 750, "y1": 8, "x2": 876, "y2": 134, "speaking_score": -0.08333333333333333, "active": false, "track_id": 8}, {"x1": 352, "y1": 41, "x2": 469, "y2": 158, "speaking_score": -0.4833333467443784, "active": false, "track_id": 9}, {"x1": 856, "y1": 97, "x2": 980, "y2": 221, "speaking_score": -0.23333333805203438, "active": false, "track_id": 10}]}, {"frame_number": 1680, "faces": [{"x1": 1061, "y1": 108, "x2": 1195, "y2": 243, "speaking_score": -0.8000000019868215, "active": false, "track_id": 4}, {"x1": 27, "y1": 76, "x2": 170, "y2": 219, "speaking_score": -0.6999999930461248, "active": false, "track_id": 5}, {"x1": 201, "y1": 115, "x2": 317, "y2": 231, "speaking_score": -1.3833333452542622, "active": false, "track_id": 6}, {"x1": 769, "y1": 121, "x2": 892, "y2": 244, "speaking_score": -0.666666661699613, "active": false, "track_id": 7}, {"x1": 750, "y1": 8, "x2": 876, "y2": 134, "speaking_score": -0.08333333333333333, "active": false, "track_id": 8}, {"x1": 352, "y1": 41, "x2": 469, "y2": 158, "speaking_score": -0.4833333467443784, "active": false, "track_id": 9}, {"x1": 856, "y1": 97, "x2": 980, "y2": 221, "speaking_score": -0.23333333805203438, "active": false, "track_id": 10}]}, {"frame_number": 1681, "faces": [{"x1": 1061, "y1": 108, "x2": 1195, "y2": 243, "speaking_score": -0.6999999980131785, "active": false, "track_id": 4}, {"x1": 26, "y1": 76, "x2": 170, "y2": 219, "speaking_score": -0.6166666696468989, "active": false, "track_id": 5}, {"x1": 201, "y1": 115, "x2": 317, "y2": 231, "speaking_score": -1.300000011920929, "active": false, "track_id": 6}, {"x1": 768, "y1": 121, "x2": 892, "y2": 244, "speaking_score": -0.5666666676600774, "active": false, "track_id": 7}, {"x1": 750, "y1": 8, "x2": 875, "y2": 134, "speaking_score": 0.0, "active": true, "track_id": 8}, {"x1": 352, "y1": 41, "x2": 469, "y2": 158, "speaking_score": -0.38333334277073544, "active": false, "track_id": 9}, {"x1": 856, "y1": 96, "x2": 981, "y2": 221, "speaking_score": -0.15000000471870104, "active": false, "track_id": 10}]}, {"frame_number": 1682, "faces": [{"x1": 1061, "y1": 109, "x2": 1195, "y2": 243, "speaking_score": -0.6833333373069763, "active": false, "track_id": 4}, {"x1": 26, "y1": 76, "x2": 169, "y2": 220, "speaking_score": -0.5999999990065893, "active": false, "track_id": 5}, {"x1": 200, "y1": 115, "x2": 317, "y2": 231, "speaking_score": -1.2833333412806194, "active": false, "track_id": 6}, {"x1": 768, "y1": 121, "x2": 892, "y2": 244, "speaking_score": -0.5333333363135656, "active": false, "track_id": 7}, {"x1": 749, "y1": 8, "x2": 875, "y2": 134, "speaking_score": -0.016666668156782787, "active": false, "track_id": 8}, {"x1": 352, "y1": 41, "x2": 469, "y2": 158, "speaking_score": -0.36666667213042575, "active": false, "track_id": 9}, {"x1": 854, "y1": 96, "x2": 980, "y2": 222, "speaking_score": -0.15000000471870104, "active": false, "track_id": 10}]}, {"frame_number": 1683, "faces": [{"x1": 1061, "y1": 109, "x2": 1195, "y2": 243, "speaking_score": -0.6333333353201548, "active": false, "track_id": 4}, {"x1": 26, "y1": 77, "x2": 169, "y2": 220, "speaking_score": -0.5666666676600774, "active": false, "track_id": 5}, {"x1": 200, "y1": 115, "x2": 316, "y2": 231, "speaking_score": -1.2666666706403096, "active": false, "track_id": 6}, {"x1": 768, "y1": 121, "x2": 892, "y2": 244, "speaking_score": -0.48333333681027096, "active": false, "track_id": 7}, {"x1": 749, "y1": 9, "x2": 874, "y2": 134, "speaking_score": -0.016666668156782787, "active": false, "track_id": 8}, {"x1": 351, "y1": 41, "x2": 469, "y2": 159, "speaking_score": -0.3166666701436043, "active": false, "track_id": 9}, {"x1": 853, "y1": 95, "x2": 979, "y2": 221, "speaking_score": -0.1333333378036817, "active": false, "track_id": 10}]}, {"frame_number": 1684, "faces": [{"x1": 1061, "y1": 109, "x2": 1194, "y2": 243, "speaking_score": -0.5666666689018408, "active": false, "track_id": 4}, {"x1": 26, "y1": 77, "x2": 169, "y2": 220, "speaking_score": -0.5166666669150194, "active": false, "track_id": 5}, {"x1": 200, "y1": 115, "x2": 316, "y2": 231, "speaking_score": -1.1999999980131786, "active": false, "track_id": 6}, {"x1": 768, "y1": 121, "x2": 891, "y2": 244, "speaking_score": -0.4000000022351742, "active": false, "track_id": 7}, {"x1": 749, "y1": 9, "x2": 874, "y2": 134, "speaking_score": 0.0499999945362409, "active": true, "track_id": 8}, {"x1": 351, "y1": 41, "x2": 469, "y2": 159, "speaking_score": -0.23333333432674408, "active": false, "track_id": 9}, {"x1": 853, "y1": 93, "x2": 979, "y2": 219, "speaking_score": -0.10000000397364299, "active": false, "track_id": 10}]}, {"frame_number": 1685, "faces": [{"x1": 1060, "y1": 109, "x2": 1193, "y2": 243, "speaking_score": -0.4833333318432172, "active": false, "track_id": 4}, {"x1": 25, "y1": 77, "x2": 168, "y2": 220, "speaking_score": -0.46666666741172474, "active": false, "track_id": 5}, {"x1": 199, "y1": 115, "x2": 315, "y2": 231, "speaking_score": -1.1499999860922496, "active": false, "track_id": 6}, {"x1": 764, "y1": 121, "x2": 888, "y2": 245, "speaking_score": -0.31666666890184086, "active": false, "track_id": 7}, {"x1": 747, "y1": 9, "x2": 872, "y2": 133, "speaking_score": 0.13333333159486452, "active": true, "track_id": 8}, {"x1": 351, "y1": 41, "x2": 469, "y2": 159, "speaking_score": -0.1333333303531011, "active": false, "track_id": 9}, {"x1": 851, "y1": 89, "x2": 977, "y2": 215, "speaking_score": -0.06666667014360428, "active": false, "track_id": 10}]}, {"frame_number": 1686, "faces": [{"x1": 1060, "y1": 109, "x2": 1193, "y2": 243, "speaking_score": -0.4833333318432172, "active": false, "track_id": 4}, {"x1": 25, "y1": 77, "x2": 168, "y2": 220, "speaking_score": -0.46666666741172474, "active": false, "track_id": 5}, {"x1": 199, "y1": 115, "x2": 315, "y2": 231, "speaking_score": -1.1499999860922496, "active": false, "track_id": 6}, {"x1": 764, "y1": 121, "x2": 888, "y2": 245, "speaking_score": -0.31666666890184086, "active": false, "track_id": 7}, {"x1": 747, "y1": 9, "x2": 872, "y2": 133, "speaking_score": 0.13333333159486452, "active": true, "track_id": 8}, {"x1": 351, "y1": 41, "x2": 469, "y2": 159, "speaking_score": -0.1333333303531011, "active": false, "track_id": 9}, {"x1": 851, "y1": 89, "x2": 977, "y2": 215, "speaking_score": -0.06666667014360428, "active": false, "track_id": 10}]}, {"frame_number": 1687, "faces": [{"x1": 1059, "y1": 109, "x2": 1193, "y2": 243, "speaking_score": -0.40000000099341076, "active": false, "track_id": 4}, {"x1": 25, "y1": 77, "x2": 168, "y2": 220, "speaking_score": -0.38333333656191826, "active": false, "track_id": 5}, {"x1": 199, "y1": 115, "x2": 315, "y2": 231, "speaking_score": -1.0999999940395355, "active": false, "track_id": 6}, {"x1": 764, "y1": 122, "x2": 887, "y2": 245, "speaking_score": -0.23333333556850752, "active": false, "track_id": 7}, {"x1": 747, "y1": 9, "x2": 871, "y2": 133, "speaking_score": 0.26666666318972904, "active": true, "track_id": 8}, {"x1": 351, "y1": 41, "x2": 469, "y2": 159, "speaking_score": -0.01666666070620219, "active": false, "track_id": 9}, {"x1": 851, "y1": 87, "x2": 977, "y2": 214, "speaking_score": -0.05000000322858492, "active": false, "track_id": 10}]}, {"frame_number": 1688, "faces": [{"x1": 1059, "y1": 110, "x2": 1192, "y2": 243, "speaking_score": -0.30000000695387524, "active": false, "track_id": 4}, {"x1": 25, "y1": 77, "x2": 168, "y2": 220, "speaking_score": -0.28333333507180214, "active": false, "track_id": 5}, {"x1": 199, "y1": 115, "x2": 315, "y2": 231, "speaking_score": -1.0333333313465118, "active": false, "track_id": 6}, {"x1": 763, "y1": 122, "x2": 887, "y2": 245, "speaking_score": -0.10000000397364299, "active": false, "track_id": 7}, {"x1": 746, "y1": 9, "x2": 871, "y2": 133, "speaking_score": 0.4333333298563957, "active": true, "track_id": 8}, {"x1": 350, "y1": 41, "x2": 469, "y2": 159, "speaking_score": 0.11666667461395264, "active": true, "track_id": 9}, {"x1": 847, "y1": 86, "x2": 974, "y2": 213, "speaking_score": -1.241763432820638e-09, "active": false, "track_id": 10}]}, {"frame_number": 1689, "faces": [{"x1": 1058, "y1": 110, "x2": 1192, "y2": 243, "speaking_score": -0.23333333929379782, "active": false, "track_id": 4}, {"x1": 24, "y1": 77, "x2": 168, "y2": 220, "speaking_score": -0.23333333805203438, "active": false, "track_id": 5}, {"x1": 199, "y1": 115, "x2": 315, "y2": 231, "speaking_score": -1.0000000099341075, "active": false, "track_id": 6}, {"x1": 763, "y1": 122, "x2": 887, "y2": 246, "speaking_score": 0.0, "active": true, "track_id": 7}, {"x1": 746, "y1": 9, "x2": 870, "y2": 133, "speaking_score": 0.5833333358168602, "active": true, "track_id": 8}, {"x1": 350, "y1": 42, "x2": 469, "y2": 161, "speaking_score": 0.23333334177732468, "active": true, "track_id": 9}, {"x1": 844, "y1": 84, "x2": 971, "y2": 211, "speaking_score": 0.033333333830038704, "active": true, "track_id": 10}]}, {"frame_number": 1690, "faces": [{"x1": 1058, "y1": 110, "x2": 1191, "y2": 243, "speaking_score": -0.23333333929379782, "active": false, "track_id": 4}, {"x1": 24, "y1": 77, "x2": 168, "y2": 220, "speaking_score": -0.23333333805203438, "active": false, "track_id": 5}, {"x1": 199, "y1": 115, "x2": 315, "y2": 231, "speaking_score": -1.0000000099341075, "active": false, "track_id": 6}, {"x1": 763, "y1": 122, "x2": 886, "y2": 246, "speaking_score": 0.033333333830038704, "active": true, "track_id": 7}, {"x1": 745, "y1": 9, "x2": 869, "y2": 134, "speaking_score": 0.6666666666666666, "active": true, "track_id": 8}, {"x1": 350, "y1": 42, "x2": 468, "y2": 160, "speaking_score": 0.30000000943740207, "active": true, "track_id": 9}, {"x1": 843, "y1": 83, "x2": 970, "y2": 209, "speaking_score": 0.033333333830038704, "active": true, "track_id": 10}]}, {"frame_number": 1691, "faces": [{"x1": 1057, "y1": 111, "x2": 1189, "y2": 243, "speaking_score": -0.28333334003885585, "active": false, "track_id": 4}, {"x1": 23, "y1": 77, "x2": 167, "y2": 220, "speaking_score": -0.2666666731238365, "active": false, "track_id": 5}, {"x1": 198, "y1": 115, "x2": 315, "y2": 232, "speaking_score": -1.050000011920929, "active": false, "track_id": 6}, {"x1": 763, "y1": 122, "x2": 886, "y2": 246, "speaking_score": 0.016666666915019352, "active": true, "track_id": 7}, {"x1": 745, "y1": 9, "x2": 869, "y2": 134, "speaking_score": 0.6666666666666666, "active": true, "track_id": 8}, {"x1": 350, "y1": 42, "x2": 468, "y2": 160, "speaking_score": 0.316666675110658, "active": true, "track_id": 9}, {"x1": 839, "y1": 81, "x2": 966, "y2": 208, "speaking_score": -0.016666666915019352, "active": false, "track_id": 10}]}, {"frame_number": 1692, "faces": [{"x1": 1056, "y1": 111, "x2": 1188, "y2": 243, "speaking_score": -0.3333333407839139, "active": false, "track_id": 4}, {"x1": 23, "y1": 77, "x2": 167, "y2": 220, "speaking_score": -0.2833333412806193, "active": false, "track_id": 5}, {"x1": 198, "y1": 115, "x2": 314, "y2": 232, "speaking_score": -1.0833333532015483, "active": false, "track_id": 6}, {"x1": 763, "y1": 122, "x2": 886, "y2": 246, "speaking_score": 0.016666666915019352, "active": true, "track_id": 7}, {"x1": 744, "y1": 10, "x2": 869, "y2": 134, "speaking_score": 0.6666666666666666, "active": true, "track_id": 8}, {"x1": 349, "y1": 42, "x2": 467, "y2": 160, "speaking_score": 0.316666675110658, "active": true, "track_id": 9}, {"x1": 839, "y1": 81, "x2": 966, "y2": 208, "speaking_score": -0.06666666766007741, "active": false, "track_id": 10}]}, {"frame_number": 1693, "faces": [{"x1": 1056, "y1": 111, "x2": 1188, "y2": 243, "speaking_score": -0.3333333407839139, "active": false, "track_id": 4}, {"x1": 23, "y1": 77, "x2": 167, "y2": 220, "speaking_score": -0.2833333412806193, "active": false, "track_id": 5}, {"x1": 198, "y1": 115, "x2": 314, "y2": 232, "speaking_score": -1.0833333532015483, "active": false, "track_id": 6}, {"x1": 763, "y1": 122, "x2": 886, "y2": 246, "speaking_score": 0.016666666915019352, "active": true, "track_id": 7}, {"x1": 744, "y1": 10, "x2": 869, "y2": 134, "speaking_score": 0.6666666666666666, "active": true, "track_id": 8}, {"x1": 349, "y1": 42, "x2": 467, "y2": 160, "speaking_score": 0.316666675110658, "active": true, "track_id": 9}, {"x1": 839, "y1": 81, "x2": 966, "y2": 208, "speaking_score": -0.06666666766007741, "active": false, "track_id": 10}]}, {"frame_number": 1694, "faces": [{"x1": 1056, "y1": 111, "x2": 1188, "y2": 243, "speaking_score": -0.36666667461395264, "active": false, "track_id": 4}, {"x1": 23, "y1": 76, "x2": 167, "y2": 220, "speaking_score": -0.30000000943740207, "active": false, "track_id": 5}, {"x1": 198, "y1": 115, "x2": 314, "y2": 232, "speaking_score": -1.100000023841858, "active": false, "track_id": 6}, {"x1": 762, "y1": 122, "x2": 886, "y2": 246, "speaking_score": 0.016666666915019352, "active": true, "track_id": 7}, {"x1": 744, "y1": 10, "x2": 868, "y2": 134, "speaking_score": 0.6500000059604645, "active": true, "track_id": 8}, {"x1": 349, "y1": 42, "x2": 467, "y2": 160, "speaking_score": 0.30000000695387524, "active": true, "track_id": 9}, {"x1": 839, "y1": 80, "x2": 966, "y2": 207, "speaking_score": -0.10000000149011612, "active": false, "track_id": 10}]}, {"frame_number": 1695, "faces": [{"x1": 1056, "y1": 111, "x2": 1188, "y2": 243, "speaking_score": -0.4000000059604645, "active": false, "track_id": 4}, {"x1": 23, "y1": 76, "x2": 167, "y2": 220, "speaking_score": -0.3166666775941849, "active": false, "track_id": 5}, {"x1": 197, "y1": 115, "x2": 314, "y2": 232, "speaking_score": -1.1166666944821675, "active": false, "track_id": 6}, {"x1": 762, "y1": 123, "x2": 885, "y2": 246, "speaking_score": -0.016666666915019352, "active": false, "track_id": 7}, {"x1": 744, "y1": 10, "x2": 868, "y2": 134, "speaking_score": 0.6333333452542623, "active": true, "track_id": 8}, {"x1": 348, "y1": 42, "x2": 467, "y2": 160, "speaking_score": 0.2666666718820731, "active": true, "track_id": 9}, {"x1": 838, "y1": 80, "x2": 966, "y2": 208, "speaking_score": -0.13333333532015482, "active": false, "track_id": 10}]}, {"frame_number": 1696, "faces": [{"x1": 1056, "y1": 111, "x2": 1188, "y2": 243, "speaking_score": -0.38333334028720856, "active": false, "track_id": 4}, {"x1": 23, "y1": 76, "x2": 167, "y2": 220, "speaking_score": -0.28333334376414615, "active": false, "track_id": 5}, {"x1": 197, "y1": 115, "x2": 313, "y2": 232, "speaking_score": -1.0666666825612385, "active": false, "track_id": 6}, {"x1": 762, "y1": 123, "x2": 885, "y2": 246, "speaking_score": -0.016666666915019352, "active": false, "track_id": 7}, {"x1": 744, "y1": 10, "x2": 867, "y2": 133, "speaking_score": 0.6500000059604645, "active": true, "track_id": 8}, {"x1": 348, "y1": 42, "x2": 466, "y2": 160, "speaking_score": 0.2666666718820731, "active": true, "track_id": 9}, {"x1": 838, "y1": 80, "x2": 965, "y2": 207, "speaking_score": -0.13333333532015482, "active": false, "track_id": 10}]}, {"frame_number": 1697, "faces": [{"x1": 1056, "y1": 110, "x2": 1188, "y2": 242, "speaking_score": -0.38333334028720856, "active": false, "track_id": 4}, {"x1": 22, "y1": 76, "x2": 166, "y2": 220, "speaking_score": -0.28333334376414615, "active": false, "track_id": 5}, {"x1": 196, "y1": 116, "x2": 313, "y2": 232, "speaking_score": -1.050000011920929, "active": false, "track_id": 6}, {"x1": 761, "y1": 123, "x2": 884, "y2": 246, "speaking_score": -0.016666666915019352, "active": false, "track_id": 7}, {"x1": 743, "y1": 10, "x2": 866, "y2": 133, "speaking_score": 0.6500000059604645, "active": true, "track_id": 8}, {"x1": 350, "y1": 43, "x2": 465, "y2": 158, "speaking_score": 0.21666667113701502, "active": true, "track_id": 9}, {"x1": 839, "y1": 81, "x2": 965, "y2": 207, "speaking_score": -0.15000000223517418, "active": false, "track_id": 10}]}, {"frame_number": 1698, "faces": [{"x1": 1055, "y1": 110, "x2": 1187, "y2": 242, "speaking_score": -0.36666667461395264, "active": false, "track_id": 4}, {"x1": 22, "y1": 76, "x2": 166, "y2": 220, "speaking_score": -0.28333334376414615, "active": false, "track_id": 5}, {"x1": 196, "y1": 115, "x2": 312, "y2": 232, "speaking_score": -1.0333333412806194, "active": false, "track_id": 6}, {"x1": 760, "y1": 123, "x2": 883, "y2": 246, "speaking_score": -0.016666666915019352, "active": false, "track_id": 7}, {"x1": 743, "y1": 10, "x2": 866, "y2": 133, "speaking_score": 0.6333333452542623, "active": true, "track_id": 8}, {"x1": 350, "y1": 44, "x2": 463, "y2": 157, "speaking_score": 0.18333333730697632, "active": true, "track_id": 9}, {"x1": 839, "y1": 81, "x2": 965, "y2": 207, "speaking_score": -0.15000000223517418, "active": false, "track_id": 10}]}, {"frame_number": 1699, "faces": [{"x1": 1055, "y1": 110, "x2": 1187, "y2": 242, "speaking_score": -0.36666667461395264, "active": false, "track_id": 4}, {"x1": 22, "y1": 76, "x2": 166, "y2": 220, "speaking_score": -0.28333334376414615, "active": false, "track_id": 5}, {"x1": 196, "y1": 115, "x2": 312, "y2": 232, "speaking_score": -1.0333333412806194, "active": false, "track_id": 6}, {"x1": 760, "y1": 123, "x2": 883, "y2": 246, "speaking_score": -0.016666666915019352, "active": false, "track_id": 7}, {"x1": 743, "y1": 10, "x2": 866, "y2": 133, "speaking_score": 0.6333333452542623, "active": true, "track_id": 8}, {"x1": 350, "y1": 44, "x2": 463, "y2": 157, "speaking_score": 0.18333333730697632, "active": true, "track_id": 9}, {"x1": 839, "y1": 81, "x2": 965, "y2": 207, "speaking_score": -0.15000000223517418, "active": false, "track_id": 10}]}, {"frame_number": 1700, "faces": [{"x1": 1054, "y1": 110, "x2": 1186, "y2": 242, "speaking_score": -0.38333334028720856, "active": false, "track_id": 4}, {"x1": 22, "y1": 76, "x2": 166, "y2": 220, "speaking_score": -0.30000000943740207, "active": false, "track_id": 5}, {"x1": 196, "y1": 115, "x2": 312, "y2": 232, "speaking_score": -1.0333333412806194, "active": false, "track_id": 6}, {"x1": 760, "y1": 123, "x2": 883, "y2": 246, "speaking_score": -0.05000000074505806, "active": false, "track_id": 7}, {"x1": 742, "y1": 10, "x2": 865, "y2": 133, "speaking_score": 0.6333333452542623, "active": true, "track_id": 8}, {"x1": 351, "y1": 44, "x2": 463, "y2": 156, "speaking_score": 0.13333333532015482, "active": true, "track_id": 9}, {"x1": 838, "y1": 80, "x2": 965, "y2": 207, "speaking_score": -0.15000000223517418, "active": false, "track_id": 10}]}, {"frame_number": 1701, "faces": [{"x1": 1053, "y1": 110, "x2": 1186, "y2": 242, "speaking_score": -0.38333334028720856, "active": false, "track_id": 4}, {"x1": 22, "y1": 75, "x2": 166, "y2": 220, "speaking_score": -0.30000000943740207, "active": false, "track_id": 5}, {"x1": 196, "y1": 116, "x2": 312, "y2": 232, "speaking_score": -0.9833333392937978, "active": false, "track_id": 6}, {"x1": 760, "y1": 123, "x2": 882, "y2": 246, "speaking_score": -0.06666666766007741, "active": false, "track_id": 7}, {"x1": 741, "y1": 10, "x2": 864, "y2": 133, "speaking_score": 0.5833333432674408, "active": true, "track_id": 8}, {"x1": 351, "y1": 44, "x2": 462, "y2": 156, "speaking_score": 0.06666666766007741, "active": true, "track_id": 9}, {"x1": 838, "y1": 80, "x2": 965, "y2": 207, "speaking_score": -0.15000000223517418, "active": false, "track_id": 10}]}, {"frame_number": 1702, "faces": [{"x1": 1053, "y1": 110, "x2": 1185, "y2": 242, "speaking_score": -0.3500000089406967, "active": false, "track_id": 4}, {"x1": 21, "y1": 75, "x2": 166, "y2": 220, "speaking_score": -0.2833333412806193, "active": false, "track_id": 5}, {"x1": 195, "y1": 116, "x2": 312, "y2": 232, "speaking_score": -0.9166666666666666, "active": false, "track_id": 6}, {"x1": 760, "y1": 123, "x2": 882, "y2": 246, "speaking_score": -0.05000000074505806, "active": false, "track_id": 7}, {"x1": 741, "y1": 10, "x2": 864, "y2": 133, "speaking_score": 0.5500000069538752, "active": true, "track_id": 8}, {"x1": 350, "y1": 45, "x2": 461, "y2": 156, "speaking_score": 0.05000000074505806, "active": true, "track_id": 9}, {"x1": 838, "y1": 81, "x2": 965, "y2": 207, "speaking_score": -0.13333333532015482, "active": false, "track_id": 10}]}, {"frame_number": 1703, "faces": [{"x1": 1052, "y1": 110, "x2": 1184, "y2": 242, "speaking_score": -0.3333333407839139, "active": false, "track_id": 4}, {"x1": 20, "y1": 75, "x2": 166, "y2": 221, "speaking_score": -0.26666667436559993, "active": false, "track_id": 5}, {"x1": 195, "y1": 116, "x2": 311, "y2": 232, "speaking_score": -0.8833333353201548, "active": false, "track_id": 6}, {"x1": 759, "y1": 123, "x2": 882, "y2": 246, "speaking_score": -0.033333333830038704, "active": false, "track_id": 7}, {"x1": 741, "y1": 10, "x2": 863, "y2": 133, "speaking_score": 0.5166666756073633, "active": true, "track_id": 8}, {"x1": 350, "y1": 45, "x2": 460, "y2": 155, "speaking_score": 0.033333333830038704, "active": true, "track_id": 9}, {"x1": 838, "y1": 81, "x2": 965, "y2": 208, "speaking_score": -0.11666666840513547, "active": false, "track_id": 10}]}, {"frame_number": 1704, "faces": [{"x1": 1052, "y1": 110, "x2": 1184, "y2": 242, "speaking_score": -0.31666667262713116, "active": false, "track_id": 4}, {"x1": 20, "y1": 76, "x2": 165, "y2": 221, "speaking_score": -0.2500000062088172, "active": false, "track_id": 5}, {"x1": 194, "y1": 116, "x2": 311, "y2": 233, "speaking_score": -0.8333333333333334, "active": false, "track_id": 6}, {"x1": 759, "y1": 123, "x2": 882, "y2": 246, "speaking_score": -0.033333333830038704, "active": false, "track_id": 7}, {"x1": 741, "y1": 10, "x2": 863, "y2": 132, "speaking_score": 0.46666667858759564, "active": true, "track_id": 8}, {"x1": 350, "y1": 45, "x2": 459, "y2": 155, "speaking_score": 0.016666666915019352, "active": true, "track_id": 9}, {"x1": 837, "y1": 81, "x2": 964, "y2": 208, "speaking_score": -0.10000000149011612, "active": false, "track_id": 10}]}, {"frame_number": 1705, "faces": [{"x1": 1052, "y1": 110, "x2": 1184, "y2": 242, "speaking_score": -0.31666667262713116, "active": false, "track_id": 4}, {"x1": 20, "y1": 76, "x2": 165, "y2": 221, "speaking_score": -0.2500000062088172, "active": false, "track_id": 5}, {"x1": 194, "y1": 116, "x2": 311, "y2": 233, "speaking_score": -0.8333333333333334, "active": false, "track_id": 6}, {"x1": 759, "y1": 123, "x2": 882, "y2": 246, "speaking_score": -0.033333333830038704, "active": false, "track_id": 7}, {"x1": 741, "y1": 10, "x2": 863, "y2": 132, "speaking_score": 0.46666667858759564, "active": true, "track_id": 8}, {"x1": 350, "y1": 45, "x2": 459, "y2": 155, "speaking_score": 0.016666666915019352, "active": true, "track_id": 9}, {"x1": 837, "y1": 81, "x2": 964, "y2": 208, "speaking_score": -0.10000000149011612, "active": false, "track_id": 10}]}, {"frame_number": 1706, "faces": [{"x1": 1051, "y1": 110, "x2": 1183, "y2": 242, "speaking_score": -0.30000000447034836, "active": false, "track_id": 4}, {"x1": 19, "y1": 76, "x2": 165, "y2": 221, "speaking_score": -0.23333333805203438, "active": false, "track_id": 5}, {"x1": 194, "y1": 116, "x2": 311, "y2": 233, "speaking_score": -0.7833333313465118, "active": false, "track_id": 6}, {"x1": 759, "y1": 123, "x2": 882, "y2": 246, "speaking_score": -0.016666666915019352, "active": false, "track_id": 7}, {"x1": 741, "y1": 11, "x2": 863, "y2": 132, "speaking_score": 0.45000000794728595, "active": true, "track_id": 8}, {"x1": 349, "y1": 45, "x2": 459, "y2": 155, "speaking_score": 0.0, "active": true, "track_id": 9}, {"x1": 837, "y1": 81, "x2": 964, "y2": 208, "speaking_score": -0.08333333457509677, "active": false, "track_id": 10}]}, {"frame_number": 1707, "faces": [{"x1": 1050, "y1": 110, "x2": 1183, "y2": 242, "speaking_score": -0.2666666731238365, "active": false, "track_id": 4}, {"x1": 19, "y1": 76, "x2": 165, "y2": 221, "speaking_score": -0.21666667237877846, "active": false, "track_id": 5}, {"x1": 194, "y1": 116, "x2": 311, "y2": 233, "speaking_score": -0.7333333293596903, "active": false, "track_id": 6}, {"x1": 758, "y1": 123, "x2": 881, "y2": 246, "speaking_score": 0.033333333830038704, "active": true, "track_id": 7}, {"x1": 741, "y1": 11, "x2": 863, "y2": 132, "speaking_score": 0.4333333373069763, "active": true, "track_id": 8}, {"x1": 349, "y1": 45, "x2": 458, "y2": 155, "speaking_score": 0.0, "active": true, "track_id": 9}, {"x1": 837, "y1": 81, "x2": 964, "y2": 208, "speaking_score": -0.05000000074505806, "active": false, "track_id": 10}]}, {"frame_number": 1708, "faces": [{"x1": 1050, "y1": 110, "x2": 1182, "y2": 242, "speaking_score": -0.23333333929379782, "active": false, "track_id": 4}, {"x1": 19, "y1": 76, "x2": 164, "y2": 221, "speaking_score": -0.20000000422199568, "active": false, "track_id": 5}, {"x1": 194, "y1": 116, "x2": 310, "y2": 233, "speaking_score": -0.7166666587193807, "active": false, "track_id": 6}, {"x1": 758, "y1": 123, "x2": 880, "y2": 246, "speaking_score": 0.06666666766007741, "active": true, "track_id": 7}, {"x1": 741, "y1": 11, "x2": 863, "y2": 132, "speaking_score": 0.46666666865348816, "active": true, "track_id": 8}, {"x1": 348, "y1": 45, "x2": 457, "y2": 155, "speaking_score": 0.033333333830038704, "active": true, "track_id": 9}, {"x1": 837, "y1": 81, "x2": 964, "y2": 209, "speaking_score": -0.016666666915019352, "active": false, "track_id": 10}]}, {"frame_number": 1709, "faces": [{"x1": 1048, "y1": 110, "x2": 1181, "y2": 243, "speaking_score": -0.21666667113701502, "active": false, "track_id": 4}, {"x1": 18, "y1": 76, "x2": 164, "y2": 222, "speaking_score": -0.20000000422199568, "active": false, "track_id": 5}, {"x1": 193, "y1": 116, "x2": 310, "y2": 233, "speaking_score": -0.7333333293596903, "active": false, "track_id": 6}, {"x1": 757, "y1": 123, "x2": 879, "y2": 246, "speaking_score": 0.08333333457509677, "active": true, "track_id": 7}, {"x1": 741, "y1": 11, "x2": 863, "y2": 132, "speaking_score": 0.4833333343267441, "active": true, "track_id": 8}, {"x1": 347, "y1": 46, "x2": 456, "y2": 155, "speaking_score": 0.05000000074505806, "active": true, "track_id": 9}, {"x1": 836, "y1": 81, "x2": 963, "y2": 209, "speaking_score": 0.016666666915019352, "active": true, "track_id": 10}]}, {"frame_number": 1710, "faces": [{"x1": 1047, "y1": 110, "x2": 1180, "y2": 243, "speaking_score": -0.21666667113701502, "active": false, "track_id": 4}, {"x1": 18, "y1": 76, "x2": 164, "y2": 222, "speaking_score": -0.20000000422199568, "active": false, "track_id": 5}, {"x1": 193, "y1": 116, "x2": 310, "y2": 233, "speaking_score": -0.75, "active": false, "track_id": 6}, {"x1": 756, "y1": 123, "x2": 879, "y2": 246, "speaking_score": 0.08333333457509677, "active": true, "track_id": 7}, {"x1": 741, "y1": 11, "x2": 862, "y2": 133, "speaking_score": 0.4833333343267441, "active": true, "track_id": 8}, {"x1": 347, "y1": 46, "x2": 456, "y2": 155, "speaking_score": 0.05000000074505806, "active": true, "track_id": 9}, {"x1": 836, "y1": 82, "x2": 963, "y2": 209, "speaking_score": 0.033333333830038704, "active": true, "track_id": 10}]}, {"frame_number": 1711, "faces": [{"x1": 1047, "y1": 110, "x2": 1180, "y2": 243, "speaking_score": -0.21666667113701502, "active": false, "track_id": 4}, {"x1": 18, "y1": 76, "x2": 164, "y2": 222, "speaking_score": -0.20000000422199568, "active": false, "track_id": 5}, {"x1": 193, "y1": 116, "x2": 310, "y2": 233, "speaking_score": -0.75, "active": false, "track_id": 6}, {"x1": 756, "y1": 123, "x2": 879, "y2": 246, "speaking_score": 0.08333333457509677, "active": true, "track_id": 7}, {"x1": 741, "y1": 11, "x2": 862, "y2": 133, "speaking_score": 0.4833333343267441, "active": true, "track_id": 8}, {"x1": 347, "y1": 46, "x2": 456, "y2": 155, "speaking_score": 0.05000000074505806, "active": true, "track_id": 9}, {"x1": 836, "y1": 82, "x2": 963, "y2": 209, "speaking_score": 0.033333333830038704, "active": true, "track_id": 10}]}, {"frame_number": 1712, "faces": [{"x1": 1046, "y1": 110, "x2": 1179, "y2": 243, "speaking_score": -0.20000000422199568, "active": false, "track_id": 4}, {"x1": 18, "y1": 76, "x2": 163, "y2": 222, "speaking_score": -0.16666667039195696, "active": false, "track_id": 5}, {"x1": 192, "y1": 116, "x2": 309, "y2": 233, "speaking_score": -0.7333333392937978, "active": false, "track_id": 6}, {"x1": 755, "y1": 123, "x2": 878, "y2": 246, "speaking_score": 0.11666666840513547, "active": true, "track_id": 7}, {"x1": 741, "y1": 12, "x2": 862, "y2": 132, "speaking_score": 0.5166666706403097, "active": true, "track_id": 8}, {"x1": 347, "y1": 46, "x2": 456, "y2": 155, "speaking_score": 0.08333333457509677, "active": true, "track_id": 9}, {"x1": 836, "y1": 82, "x2": 963, "y2": 209, "speaking_score": 0.05000000074505806, "active": true, "track_id": 10}]}, {"frame_number": 1713, "faces": [{"x1": 1046, "y1": 110, "x2": 1178, "y2": 243, "speaking_score": -0.16666667039195696, "active": false, "track_id": 4}, {"x1": 17, "y1": 76, "x2": 163, "y2": 222, "speaking_score": -0.13333333656191826, "active": false, "track_id": 5}, {"x1": 192, "y1": 116, "x2": 309, "y2": 233, "speaking_score": -0.700000007947286, "active": false, "track_id": 6}, {"x1": 755, "y1": 123, "x2": 878, "y2": 246, "speaking_score": 0.13333333532015482, "active": true, "track_id": 7}, {"x1": 741, "y1": 12, "x2": 862, "y2": 132, "speaking_score": 0.5333333412806193, "active": true, "track_id": 8}, {"x1": 347, "y1": 46, "x2": 456, "y2": 155, "speaking_score": 0.10000000149011612, "active": true, "track_id": 9}, {"x1": 835, "y1": 82, "x2": 962, "y2": 209, "speaking_score": 0.06666666766007741, "active": true, "track_id": 10}]}, {"frame_number": 1714, "faces": [{"x1": 1045, "y1": 110, "x2": 1178, "y2": 243, "speaking_score": -0.11666666840513547, "active": false, "track_id": 4}, {"x1": 17, "y1": 76, "x2": 163, "y2": 222, "speaking_score": -0.08333333457509677, "active": false, "track_id": 5}, {"x1": 192, "y1": 116, "x2": 309, "y2": 233, "speaking_score": -0.6500000059604645, "active": false, "track_id": 6}, {"x1": 754, "y1": 124, "x2": 877, "y2": 246, "speaking_score": 0.15000000223517418, "active": true, "track_id": 7}, {"x1": 741, "y1": 12, "x2": 862, "y2": 132, "speaking_score": 0.5333333412806193, "active": true, "track_id": 8}, {"x1": 346, "y1": 46, "x2": 456, "y2": 155, "speaking_score": 0.13333333532015482, "active": true, "track_id": 9}, {"x1": 835, "y1": 82, "x2": 962, "y2": 209, "speaking_score": 0.08333333457509677, "active": true, "track_id": 10}]}, {"frame_number": 1715, "faces": [{"x1": 1043, "y1": 110, "x2": 1176, "y2": 243, "speaking_score": -0.10000000149011612, "active": false, "track_id": 4}, {"x1": 17, "y1": 76, "x2": 162, "y2": 222, "speaking_score": -0.05000000074505806, "active": false, "track_id": 5}, {"x1": 191, "y1": 116, "x2": 308, "y2": 233, "speaking_score": -0.6166666746139526, "active": false, "track_id": 6}, {"x1": 753, "y1": 124, "x2": 876, "y2": 246, "speaking_score": 0.16666666915019354, "active": true, "track_id": 7}, {"x1": 741, "y1": 12, "x2": 862, "y2": 132, "speaking_score": 0.550000011920929, "active": true, "track_id": 8}, {"x1": 346, "y1": 46, "x2": 455, "y2": 155, "speaking_score": 0.15000000223517418, "active": true, "track_id": 9}, {"x1": 835, "y1": 82, "x2": 962, "y2": 209, "speaking_score": 0.11666666840513547, "active": true, "track_id": 10}]}, {"frame_number": 1716, "faces": [{"x1": 1043, "y1": 110, "x2": 1176, "y2": 244, "speaking_score": -0.08333333457509677, "active": false, "track_id": 4}, {"x1": 17, "y1": 76, "x2": 162, "y2": 222, "speaking_score": -0.016666666915019352, "active": false, "track_id": 5}, {"x1": 191, "y1": 116, "x2": 308, "y2": 233, "speaking_score": -0.5833333432674408, "active": false, "track_id": 6}, {"x1": 753, "y1": 123, "x2": 876, "y2": 247, "speaking_score": 0.16666666915019354, "active": true, "track_id": 7}, {"x1": 741, "y1": 12, "x2": 861, "y2": 132, "speaking_score": 0.5666666825612386, "active": true, "track_id": 8}, {"x1": 346, "y1": 46, "x2": 455, "y2": 156, "speaking_score": 0.15000000223517418, "active": true, "track_id": 9}, {"x1": 835, "y1": 83, "x2": 961, "y2": 209, "speaking_score": 0.13333333532015482, "active": true, "track_id": 10}]}, {"frame_number": 1717, "faces": [{"x1": 1043, "y1": 110, "x2": 1176, "y2": 244, "speaking_score": -0.08333333457509677, "active": false, "track_id": 4}, {"x1": 17, "y1": 76, "x2": 162, "y2": 222, "speaking_score": -0.016666666915019352, "active": false, "track_id": 5}, {"x1": 191, "y1": 116, "x2": 308, "y2": 233, "speaking_score": -0.5833333432674408, "active": false, "track_id": 6}, {"x1": 753, "y1": 123, "x2": 876, "y2": 247, "speaking_score": 0.16666666915019354, "active": true, "track_id": 7}, {"x1": 741, "y1": 12, "x2": 861, "y2": 132, "speaking_score": 0.5666666825612386, "active": true, "track_id": 8}, {"x1": 346, "y1": 46, "x2": 455, "y2": 156, "speaking_score": 0.15000000223517418, "active": true, "track_id": 9}, {"x1": 835, "y1": 83, "x2": 961, "y2": 209, "speaking_score": 0.13333333532015482, "active": true, "track_id": 10}]}, {"frame_number": 1718, "faces": [{"x1": 1042, "y1": 110, "x2": 1176, "y2": 244, "speaking_score": -0.06666666766007741, "active": false, "track_id": 4}, {"x1": 16, "y1": 76, "x2": 162, "y2": 222, "speaking_score": -0.033333333830038704, "active": false, "track_id": 5}, {"x1": 191, "y1": 117, "x2": 307, "y2": 233, "speaking_score": -0.550000011920929, "active": false, "track_id": 6}, {"x1": 752, "y1": 123, "x2": 876, "y2": 247, "speaking_score": 0.15000000223517418, "active": true, "track_id": 7}, {"x1": 740, "y1": 12, "x2": 861, "y2": 132, "speaking_score": 0.5666666825612386, "active": true, "track_id": 8}, {"x1": 346, "y1": 46, "x2": 455, "y2": 156, "speaking_score": 0.13333333532015482, "active": true, "track_id": 9}, {"x1": 835, "y1": 83, "x2": 961, "y2": 209, "speaking_score": 0.15000000223517418, "active": true, "track_id": 10}]}, {"frame_number": 1719, "faces": [{"x1": 1041, "y1": 110, "x2": 1175, "y2": 244, "speaking_score": -0.10000000273187955, "active": false, "track_id": 4}, {"x1": 16, "y1": 77, "x2": 161, "y2": 222, "speaking_score": -0.0833333358168602, "active": false, "track_id": 5}, {"x1": 190, "y1": 116, "x2": 307, "y2": 233, "speaking_score": -0.5833333432674408, "active": false, "track_id": 6}, {"x1": 752, "y1": 123, "x2": 876, "y2": 247, "speaking_score": 0.10000000149011612, "active": true, "track_id": 7}, {"x1": 740, "y1": 12, "x2": 861, "y2": 132, "speaking_score": 0.550000011920929, "active": true, "track_id": 8}, {"x1": 345, "y1": 46, "x2": 454, "y2": 156, "speaking_score": 0.08333333457509677, "active": true, "track_id": 9}, {"x1": 835, "y1": 83, "x2": 961, "y2": 209, "speaking_score": 0.15000000223517418, "active": true, "track_id": 10}]}, {"frame_number": 1720, "faces": [{"x1": 1041, "y1": 110, "x2": 1175, "y2": 244, "speaking_score": -0.18333333606521288, "active": false, "track_id": 4}, {"x1": 16, "y1": 77, "x2": 161, "y2": 222, "speaking_score": -0.18333333979050317, "active": false, "track_id": 5}, {"x1": 190, "y1": 117, "x2": 306, "y2": 233, "speaking_score": -0.6666666766007742, "active": false, "track_id": 6}, {"x1": 752, "y1": 123, "x2": 876, "y2": 247, "speaking_score": 0.01666666567325592, "active": true, "track_id": 7}, {"x1": 740, "y1": 12, "x2": 860, "y2": 132, "speaking_score": 0.4833333417773247, "active": true, "track_id": 8}, {"x1": 344, "y1": 46, "x2": 454, "y2": 156, "speaking_score": 0.016666666915019352, "active": true, "track_id": 9}, {"x1": 835, "y1": 83, "x2": 960, "y2": 209, "speaking_score": 0.13333333532015482, "active": true, "track_id": 10}]}, {"frame_number": 1721, "faces": [{"x1": 1040, "y1": 110, "x2": 1174, "y2": 244, "speaking_score": -0.3166666713853677, "active": false, "track_id": 4}, {"x1": 15, "y1": 77, "x2": 161, "y2": 222, "speaking_score": -0.316666675110658, "active": false, "track_id": 5}, {"x1": 190, "y1": 117, "x2": 305, "y2": 233, "speaking_score": -0.8000000019868215, "active": false, "track_id": 6}, {"x1": 751, "y1": 123, "x2": 875, "y2": 247, "speaking_score": -0.13333333283662796, "active": false, "track_id": 7}, {"x1": 740, "y1": 12, "x2": 860, "y2": 132, "speaking_score": 0.38333334152897197, "active": true, "track_id": 8}, {"x1": 344, "y1": 46, "x2": 454, "y2": 156, "speaking_score": -0.08333333457509677, "active": false, "track_id": 9}, {"x1": 834, "y1": 83, "x2": 960, "y2": 209, "speaking_score": 0.08333333457509677, "active": true, "track_id": 10}]}, {"frame_number": 1722, "faces": [{"x1": 1039, "y1": 110, "x2": 1173, "y2": 244, "speaking_score": -0.4833333417773247, "active": false, "track_id": 4}, {"x1": 15, "y1": 77, "x2": 160, "y2": 222, "speaking_score": -0.5000000124176344, "active": false, "track_id": 5}, {"x1": 189, "y1": 117, "x2": 305, "y2": 233, "speaking_score": -0.9833333392937978, "active": false, "track_id": 6}, {"x1": 751, "y1": 123, "x2": 875, "y2": 247, "speaking_score": -0.3166666626930237, "active": false, "track_id": 7}, {"x1": 740, "y1": 13, "x2": 860, "y2": 132, "speaking_score": 0.23333333556850752, "active": true, "track_id": 8}, {"x1": 343, "y1": 46, "x2": 453, "y2": 156, "speaking_score": -0.2000000054637591, "active": false, "track_id": 9}, {"x1": 834, "y1": 83, "x2": 960, "y2": 209, "speaking_score": -0.016666666915019352, "active": false, "track_id": 10}]}, {"frame_number": 1723, "faces": [{"x1": 1039, "y1": 110, "x2": 1173, "y2": 244, "speaking_score": -0.4833333417773247, "active": false, "track_id": 4}, {"x1": 15, "y1": 77, "x2": 160, "y2": 222, "speaking_score": -0.5000000124176344, "active": false, "track_id": 5}, {"x1": 189, "y1": 117, "x2": 305, "y2": 233, "speaking_score": -0.9833333392937978, "active": false, "track_id": 6}, {"x1": 751, "y1": 123, "x2": 875, "y2": 247, "speaking_score": -0.3166666626930237, "active": false, "track_id": 7}, {"x1": 740, "y1": 13, "x2": 860, "y2": 132, "speaking_score": 0.23333333556850752, "active": true, "track_id": 8}, {"x1": 343, "y1": 46, "x2": 453, "y2": 156, "speaking_score": -0.2000000054637591, "active": false, "track_id": 9}, {"x1": 834, "y1": 83, "x2": 960, "y2": 209, "speaking_score": -0.016666666915019352, "active": false, "track_id": 10}]}, {"frame_number": 1724, "faces": [{"x1": 1038, "y1": 110, "x2": 1173, "y2": 244, "speaking_score": -0.7000000042219957, "active": false, "track_id": 4}, {"x1": 14, "y1": 77, "x2": 160, "y2": 222, "speaking_score": -0.7333333417773247, "active": false, "track_id": 5}, {"x1": 189, "y1": 117, "x2": 305, "y2": 232, "speaking_score": -1.1833333273728688, "active": false, "track_id": 6}, {"x1": 750, "y1": 123, "x2": 874, "y2": 247, "speaking_score": -0.533333337555329, "active": false, "track_id": 7}, {"x1": 740, "y1": 13, "x2": 860, "y2": 132, "speaking_score": 0.03333332762122154, "active": true, "track_id": 8}, {"x1": 343, "y1": 46, "x2": 453, "y2": 156, "speaking_score": -0.3333333370586236, "active": false, "track_id": 9}, {"x1": 834, "y1": 83, "x2": 959, "y2": 209, "speaking_score": -0.15000000471870104, "active": false, "track_id": 10}]}, {"frame_number": 1725, "faces": [{"x1": 1037, "y1": 110, "x2": 1172, "y2": 244, "speaking_score": -0.950000007947286, "active": false, "track_id": 4}, {"x1": 14, "y1": 77, "x2": 160, "y2": 222, "speaking_score": -0.950000007947286, "active": false, "track_id": 5}, {"x1": 189, "y1": 117, "x2": 304, "y2": 232, "speaking_score": -1.4166666567325592, "active": false, "track_id": 6}, {"x1": 750, "y1": 123, "x2": 874, "y2": 247, "speaking_score": -0.7499999962747097, "active": false, "track_id": 7}, {"x1": 740, "y1": 13, "x2": 859, "y2": 132, "speaking_score": -0.18333334103226662, "active": false, "track_id": 8}, {"x1": 342, "y1": 46, "x2": 452, "y2": 156, "speaking_score": -0.46666667237877846, "active": false, "track_id": 9}, {"x1": 833, "y1": 83, "x2": 959, "y2": 209, "speaking_score": -0.30000000322858494, "active": false, "track_id": 10}]}, {"frame_number": 1726, "faces": [{"x1": 1037, "y1": 110, "x2": 1171, "y2": 244, "speaking_score": -1.1833333472410839, "active": false, "track_id": 4}, {"x1": 14, "y1": 77, "x2": 159, "y2": 222, "speaking_score": -1.1833333472410839, "active": false, "track_id": 5}, {"x1": 189, "y1": 117, "x2": 304, "y2": 232, "speaking_score": -1.649999996026357, "active": false, "track_id": 6}, {"x1": 749, "y1": 123, "x2": 874, "y2": 247, "speaking_score": -0.9833333293596903, "active": false, "track_id": 7}, {"x1": 739, "y1": 13, "x2": 859, "y2": 133, "speaking_score": -0.4333333410322666, "active": false, "track_id": 8}, {"x1": 342, "y1": 46, "x2": 452, "y2": 156, "speaking_score": -0.6000000014901161, "active": false, "track_id": 9}, {"x1": 832, "y1": 83, "x2": 958, "y2": 209, "speaking_score": -0.4500000054637591, "active": false, "track_id": 10}]}, {"frame_number": 1727, "faces": [{"x1": 1035, "y1": 110, "x2": 1170, "y2": 245, "speaking_score": -1.4000000059604645, "active": false, "track_id": 4}, {"x1": 13, "y1": 78, "x2": 158, "y2": 222, "speaking_score": -1.3666666845480602, "active": false, "track_id": 5}, {"x1": 188, "y1": 117, "x2": 304, "y2": 232, "speaking_score": -1.8666666547457378, "active": false, "track_id": 6}, {"x1": 749, "y1": 123, "x2": 873, "y2": 247, "speaking_score": -1.1999999980131786, "active": false, "track_id": 7}, {"x1": 737, "y1": 13, "x2": 857, "y2": 133, "speaking_score": -0.6500000121692816, "active": false, "track_id": 8}, {"x1": 342, "y1": 46, "x2": 451, "y2": 156, "speaking_score": -0.6666666716337204, "active": false, "track_id": 9}, {"x1": 831, "y1": 83, "x2": 957, "y2": 209, "speaking_score": -0.6000000014901161, "active": false, "track_id": 10}]}, {"frame_number": 1728, "faces": [{"x1": 1035, "y1": 110, "x2": 1169, "y2": 245, "speaking_score": -1.5833333333333333, "active": false, "track_id": 4}, {"x1": 13, "y1": 78, "x2": 157, "y2": 222, "speaking_score": -1.5333333412806194, "active": false, "track_id": 5}, {"x1": 188, "y1": 117, "x2": 304, "y2": 232, "speaking_score": -2.0333333214124045, "active": false, "track_id": 6}, {"x1": 748, "y1": 123, "x2": 872, "y2": 247, "speaking_score": -1.3666666746139526, "active": false, "track_id": 7}, {"x1": 737, "y1": 13, "x2": 857, "y2": 133, "speaking_score": -0.850000003973643, "active": false, "track_id": 8}, {"x1": 342, "y1": 47, "x2": 451, "y2": 156, "speaking_score": -0.7200000047683716, "active": false, "track_id": 9}, {"x1": 831, "y1": 83, "x2": 957, "y2": 209, "speaking_score": -0.7166666636864344, "active": false, "track_id": 10}]}, {"frame_number": 1729, "faces": [{"x1": 1035, "y1": 110, "x2": 1169, "y2": 245, "speaking_score": -1.5833333333333333, "active": false, "track_id": 4}, {"x1": 13, "y1": 78, "x2": 157, "y2": 222, "speaking_score": -1.5333333412806194, "active": false, "track_id": 5}, {"x1": 188, "y1": 117, "x2": 304, "y2": 232, "speaking_score": -2.0333333214124045, "active": false, "track_id": 6}, {"x1": 748, "y1": 123, "x2": 872, "y2": 247, "speaking_score": -1.3666666746139526, "active": false, "track_id": 7}, {"x1": 737, "y1": 13, "x2": 857, "y2": 133, "speaking_score": -0.850000003973643, "active": false, "track_id": 8}, {"x1": 342, "y1": 47, "x2": 451, "y2": 156, "speaking_score": -0.7200000047683716, "active": false, "track_id": 9}, {"x1": 831, "y1": 83, "x2": 957, "y2": 209, "speaking_score": -0.7166666636864344, "active": false, "track_id": 10}]}, {"frame_number": 1730, "faces": [{"x1": 1035, "y1": 110, "x2": 1169, "y2": 245, "speaking_score": -1.7333333293596904, "active": false, "track_id": 4}, {"x1": 13, "y1": 78, "x2": 157, "y2": 222, "speaking_score": -1.6666666666666667, "active": false, "track_id": 5}, {"x1": 188, "y1": 117, "x2": 303, "y2": 232, "speaking_score": -2.1833333174387612, "active": false, "track_id": 6}, {"x1": 748, "y1": 123, "x2": 872, "y2": 247, "speaking_score": -1.5166666706403096, "active": false, "track_id": 7}, {"x1": 736, "y1": 13, "x2": 856, "y2": 133, "speaking_score": -1.0500000019868214, "active": false, "track_id": 8}, {"x1": 342, "y1": 47, "x2": 450, "y2": 155, "speaking_score": -0.75, "active": false, "track_id": 9}, {"x1": 830, "y1": 84, "x2": 956, "y2": 210, "speaking_score": -0.8166666626930237, "active": false, "track_id": 10}]}, {"frame_number": 1731, "faces": [{"x1": 1034, "y1": 110, "x2": 1169, "y2": 245, "speaking_score": -1.900000015894572, "active": false, "track_id": 4}, {"x1": 13, "y1": 78, "x2": 157, "y2": 222, "speaking_score": -1.8166666626930237, "active": false, "track_id": 5}, {"x1": 188, "y1": 117, "x2": 303, "y2": 232, "speaking_score": -2.349999984105428, "active": false, "track_id": 6}, {"x1": 747, "y1": 123, "x2": 871, "y2": 247, "speaking_score": -1.6833333373069763, "active": false, "track_id": 7}, {"x1": 735, "y1": 12, "x2": 857, "y2": 134, "speaking_score": -1.2499999900658925, "active": false, "track_id": 8}, {"x1": 342, "y1": 47, "x2": 449, "y2": 154, "speaking_score": -0.7666666706403097, "active": false, "track_id": 9}, {"x1": 830, "y1": 84, "x2": 956, "y2": 210, "speaking_score": -0.9166666666666666, "active": false, "track_id": 10}]}, {"frame_number": 1732, "faces": [{"x1": 1034, "y1": 111, "x2": 1168, "y2": 245, "speaking_score": -2.0666666626930237, "active": false, "track_id": 4}, {"x1": 13, "y1": 78, "x2": 156, "y2": 222, "speaking_score": -1.9666666785875957, "active": false, "track_id": 5}, {"x1": 188, "y1": 117, "x2": 303, "y2": 232, "speaking_score": -2.5166666507720947, "active": false, "track_id": 6}, {"x1": 746, "y1": 123, "x2": 870, "y2": 247, "speaking_score": -1.8666666944821675, "active": false, "track_id": 7}, {"x1": 733, "y1": 13, "x2": 856, "y2": 135, "speaking_score": -1.4333333174387615, "active": false, "track_id": 8}, {"x1": 342, "y1": 47, "x2": 448, "y2": 153, "speaking_score": -0.75, "active": false, "track_id": 9}, {"x1": 829, "y1": 84, "x2": 955, "y2": 210, "speaking_score": -1.0166666607062023, "active": false, "track_id": 10}]}, {"frame_number": 1733, "faces": [{"x1": 1033, "y1": 112, "x2": 1167, "y2": 245, "speaking_score": -2.23333332935969, "active": false, "track_id": 4}, {"x1": 12, "y1": 79, "x2": 156, "y2": 222, "speaking_score": -2.100000003973643, "active": false, "track_id": 5}, {"x1": 187, "y1": 117, "x2": 303, "y2": 232, "speaking_score": -2.666666626930237, "active": false, "track_id": 6}, {"x1": 745, "y1": 122, "x2": 868, "y2": 245, "speaking_score": -2.050000011920929, "active": false, "track_id": 7}, {"x1": 731, "y1": 13, "x2": 853, "y2": 135, "speaking_score": -1.599999984105428, "active": false, "track_id": 8}, {"x1": 827, "y1": 84, "x2": 954, "y2": 211, "speaking_score": -1.099999984105428, "active": false, "track_id": 10}]}, {"frame_number": 1734, "faces": [{"x1": 1033, "y1": 112, "x2": 1166, "y2": 245, "speaking_score": -2.3833333452542624, "active": false, "track_id": 4}, {"x1": 12, "y1": 79, "x2": 156, "y2": 222, "speaking_score": -2.249999980131785, "active": false, "track_id": 5}, {"x1": 187, "y1": 117, "x2": 302, "y2": 232, "speaking_score": -2.799999952316284, "active": false, "track_id": 6}, {"x1": 744, "y1": 121, "x2": 867, "y2": 244, "speaking_score": -2.216666658719381, "active": false, "track_id": 7}, {"x1": 730, "y1": 13, "x2": 852, "y2": 135, "speaking_score": -1.7666666309038799, "active": false, "track_id": 8}, {"x1": 827, "y1": 84, "x2": 954, "y2": 211, "speaking_score": -1.1833333174387615, "active": false, "track_id": 10}]}, {"frame_number": 1735, "faces": [{"x1": 1033, "y1": 112, "x2": 1166, "y2": 245, "speaking_score": -2.3833333452542624, "active": false, "track_id": 4}, {"x1": 12, "y1": 79, "x2": 156, "y2": 222, "speaking_score": -2.249999980131785, "active": false, "track_id": 5}, {"x1": 187, "y1": 117, "x2": 302, "y2": 232, "speaking_score": -2.799999952316284, "active": false, "track_id": 6}, {"x1": 744, "y1": 121, "x2": 867, "y2": 244, "speaking_score": -2.216666658719381, "active": false, "track_id": 7}, {"x1": 730, "y1": 13, "x2": 852, "y2": 135, "speaking_score": -1.7666666309038799, "active": false, "track_id": 8}, {"x1": 827, "y1": 84, "x2": 954, "y2": 211, "speaking_score": -1.1833333174387615, "active": false, "track_id": 10}]}, {"frame_number": 1736, "faces": [{"x1": 1032, "y1": 112, "x2": 1166, "y2": 245, "speaking_score": -2.5166666905085244, "active": false, "track_id": 4}, {"x1": 12, "y1": 79, "x2": 155, "y2": 222, "speaking_score": -2.3833333055178323, "active": false, "track_id": 5}, {"x1": 187, "y1": 117, "x2": 302, "y2": 233, "speaking_score": -2.9333332777023315, "active": false, "track_id": 6}, {"x1": 743, "y1": 120, "x2": 866, "y2": 244, "speaking_score": -2.366666634877523, "active": false, "track_id": 7}, {"x1": 728, "y1": 13, "x2": 851, "y2": 135, "speaking_score": -1.9166666467984517, "active": false, "track_id": 8}, {"x1": 825, "y1": 84, "x2": 953, "y2": 212, "speaking_score": -1.2833333214124043, "active": false, "track_id": 10}]}, {"frame_number": 1737, "faces": [{"x1": 1032, "y1": 112, "x2": 1165, "y2": 245, "speaking_score": -2.633333365122477, "active": false, "track_id": 4}, {"x1": 12, "y1": 79, "x2": 155, "y2": 222, "speaking_score": -2.4999999602635703, "active": false, "track_id": 5}, {"x1": 186, "y1": 117, "x2": 301, "y2": 233, "speaking_score": -3.0333332618077598, "active": false, "track_id": 6}, {"x1": 742, "y1": 120, "x2": 865, "y2": 243, "speaking_score": -2.4999999602635703, "active": false, "track_id": 7}, {"x1": 727, "y1": 13, "x2": 849, "y2": 135, "speaking_score": -2.0499999721844993, "active": false, "track_id": 8}, {"x1": 823, "y1": 84, "x2": 951, "y2": 212, "speaking_score": -1.3666666547457378, "active": false, "track_id": 10}]}, {"frame_number": 1738, "faces": [{"x1": 1032, "y1": 112, "x2": 1165, "y2": 245, "speaking_score": -2.6833333571751914, "active": false, "track_id": 4}, {"x1": 12, "y1": 79, "x2": 155, "y2": 222, "speaking_score": -2.5333333015441895, "active": false, "track_id": 5}, {"x1": 186, "y1": 118, "x2": 301, "y2": 233, "speaking_score": -3.0833332538604736, "active": false, "track_id": 6}, {"x1": 741, "y1": 118, "x2": 864, "y2": 241, "speaking_score": -2.566666603088379, "active": false, "track_id": 7}, {"x1": 726, "y1": 13, "x2": 848, "y2": 135, "speaking_score": -2.1333333055178323, "active": false, "track_id": 8}, {"x1": 822, "y1": 84, "x2": 951, "y2": 213, "speaking_score": -1.4166666467984517, "active": false, "track_id": 10}]}, {"frame_number": 1739, "faces": [{"x1": 1031, "y1": 112, "x2": 1164, "y2": 245, "speaking_score": -2.700000047683716, "active": false, "track_id": 4}, {"x1": 11, "y1": 79, "x2": 154, "y2": 222, "speaking_score": -2.566666603088379, "active": false, "track_id": 5}, {"x1": 185, "y1": 118, "x2": 301, "y2": 233, "speaking_score": -3.0999999046325684, "active": false, "track_id": 6}, {"x1": 740, "y1": 115, "x2": 863, "y2": 237, "speaking_score": -2.5999999046325684, "active": false, "track_id": 7}, {"x1": 724, "y1": 13, "x2": 846, "y2": 135, "speaking_score": -2.216666658719381, "active": false, "track_id": 8}, {"x1": 818, "y1": 83, "x2": 949, "y2": 214, "speaking_score": -1.4666666587193806, "active": false, "track_id": 10}]}, {"frame_number": 1740, "faces": [{"x1": 1031, "y1": 112, "x2": 1164, "y2": 245, "speaking_score": -2.700000047683716, "active": false, "track_id": 4}, {"x1": 11, "y1": 80, "x2": 154, "y2": 222, "speaking_score": -2.566666603088379, "active": false, "track_id": 5}, {"x1": 185, "y1": 118, "x2": 300, "y2": 233, "speaking_score": -3.0999999046325684, "active": false, "track_id": 6}, {"x1": 737, "y1": 115, "x2": 859, "y2": 237, "speaking_score": -2.5999999046325684, "active": false, "track_id": 7}, {"x1": 723, "y1": 13, "x2": 845, "y2": 135, "speaking_score": -2.283333341280619, "active": false, "track_id": 8}, {"x1": 818, "y1": 83, "x2": 949, "y2": 214, "speaking_score": -1.5166666706403096, "active": false, "track_id": 10}]}, {"frame_number": 1741, "faces": [{"x1": 1030, "y1": 112, "x2": 1163, "y2": 245, "speaking_score": -2.6833333571751914, "active": false, "track_id": 4}, {"x1": 11, "y1": 80, "x2": 154, "y2": 222, "speaking_score": -2.549999952316284, "active": false, "track_id": 5}, {"x1": 185, "y1": 118, "x2": 300, "y2": 233, "speaking_score": -3.0833332538604736, "active": false, "track_id": 6}, {"x1": 736, "y1": 115, "x2": 858, "y2": 236, "speaking_score": -2.5999999046325684, "active": false, "track_id": 7}, {"x1": 722, "y1": 13, "x2": 844, "y2": 135, "speaking_score": -2.333333373069763, "active": false, "track_id": 8}, {"x1": 817, "y1": 83, "x2": 948, "y2": 214, "speaking_score": -1.5333333412806194, "active": false, "track_id": 10}]}, {"frame_number": 1742, "faces": [{"x1": 1030, "y1": 112, "x2": 1163, "y2": 245, "speaking_score": -2.6833333571751914, "active": false, "track_id": 4}, {"x1": 11, "y1": 80, "x2": 154, "y2": 222, "speaking_score": -2.549999952316284, "active": false, "track_id": 5}, {"x1": 185, "y1": 118, "x2": 300, "y2": 233, "speaking_score": -3.0833332538604736, "active": false, "track_id": 6}, {"x1": 736, "y1": 115, "x2": 858, "y2": 236, "speaking_score": -2.5999999046325684, "active": false, "track_id": 7}, {"x1": 722, "y1": 13, "x2": 844, "y2": 135, "speaking_score": -2.333333373069763, "active": false, "track_id": 8}, {"x1": 817, "y1": 83, "x2": 948, "y2": 214, "speaking_score": -1.5333333412806194, "active": false, "track_id": 10}]}, {"frame_number": 1743, "faces": [{"x1": 1030, "y1": 112, "x2": 1163, "y2": 245, "speaking_score": -2.6666666666666665, "active": false, "track_id": 4}, {"x1": 11, "y1": 80, "x2": 153, "y2": 222, "speaking_score": -2.5333333015441895, "active": false, "track_id": 5}, {"x1": 185, "y1": 118, "x2": 300, "y2": 233, "speaking_score": -3.066666603088379, "active": false, "track_id": 6}, {"x1": 736, "y1": 114, "x2": 857, "y2": 235, "speaking_score": -2.5999999046325684, "active": false, "track_id": 7}, {"x1": 721, "y1": 13, "x2": 843, "y2": 134, "speaking_score": -2.350000023841858, "active": false, "track_id": 8}, {"x1": 816, "y1": 83, "x2": 946, "y2": 214, "speaking_score": -1.5166666706403096, "active": false, "track_id": 10}]}, {"frame_number": 1744, "faces": [{"x1": 1029, "y1": 112, "x2": 1162, "y2": 245, "speaking_score": -2.6333333253860474, "active": false, "track_id": 4}, {"x1": 10, "y1": 80, "x2": 153, "y2": 222, "speaking_score": -2.5, "active": false, "track_id": 5}, {"x1": 185, "y1": 118, "x2": 300, "y2": 233, "speaking_score": -3.0333333015441895, "active": false, "track_id": 6}, {"x1": 735, "y1": 113, "x2": 855, "y2": 234, "speaking_score": -2.566666603088379, "active": false, "track_id": 7}, {"x1": 720, "y1": 13, "x2": 841, "y2": 134, "speaking_score": -2.350000023841858, "active": false, "track_id": 8}, {"x1": 815, "y1": 83, "x2": 946, "y2": 214, "speaking_score": -1.4833333293596904, "active": false, "track_id": 10}]}, {"frame_number": 1745, "faces": [{"x1": 1029, "y1": 112, "x2": 1161, "y2": 245, "speaking_score": -2.5833333333333335, "active": false, "track_id": 4}, {"x1": 10, "y1": 80, "x2": 152, "y2": 223, "speaking_score": -2.4833333492279053, "active": false, "track_id": 5}, {"x1": 184, "y1": 118, "x2": 299, "y2": 233, "speaking_score": -3.0, "active": false, "track_id": 6}, {"x1": 732, "y1": 112, "x2": 852, "y2": 232, "speaking_score": -2.5333333015441895, "active": false, "track_id": 7}, {"x1": 718, "y1": 13, "x2": 838, "y2": 133, "speaking_score": -2.333333373069763, "active": false, "track_id": 8}, {"x1": 814, "y1": 83, "x2": 945, "y2": 214, "speaking_score": -1.449999988079071, "active": false, "track_id": 10}, {"x1": 334, "y1": 48, "x2": 443, "y2": 157, "speaking_score": -1.7333333492279053, "active": false, "track_id": 11}]}, {"frame_number": 1746, "faces": [{"x1": 1028, "y1": 113, "x2": 1160, "y2": 245, "speaking_score": -2.533333341280619, "active": false, "track_id": 4}, {"x1": 9, "y1": 80, "x2": 152, "y2": 223, "speaking_score": -2.450000047683716, "active": false, "track_id": 5}, {"x1": 184, "y1": 118, "x2": 299, "y2": 233, "speaking_score": -2.9666666984558105, "active": false, "track_id": 6}, {"x1": 731, "y1": 112, "x2": 851, "y2": 231, "speaking_score": -2.5, "active": false, "track_id": 7}, {"x1": 718, "y1": 13, "x2": 837, "y2": 133, "speaking_score": -2.300000031789144, "active": false, "track_id": 8}, {"x1": 814, "y1": 83, "x2": 944, "y2": 213, "speaking_score": -1.4166666467984517, "active": false, "track_id": 10}, {"x1": 334, "y1": 49, "x2": 444, "y2": 159, "speaking_score": -1.7750000059604645, "active": false, "track_id": 11}]}, {"frame_number": 1747, "faces": [{"x1": 1028, "y1": 113, "x2": 1160, "y2": 245, "speaking_score": -2.4833333492279053, "active": false, "track_id": 4}, {"x1": 10, "y1": 81, "x2": 151, "y2": 222, "speaking_score": -2.4166667064030967, "active": false, "track_id": 5}, {"x1": 183, "y1": 118, "x2": 299, "y2": 233, "speaking_score": -2.9166667064030967, "active": false, "track_id": 6}, {"x1": 730, "y1": 111, "x2": 850, "y2": 230, "speaking_score": -2.4666666984558105, "active": false, "track_id": 7}, {"x1": 717, "y1": 13, "x2": 836, "y2": 132, "speaking_score": -2.2666666905085244, "active": false, "track_id": 8}, {"x1": 811, "y1": 83, "x2": 942, "y2": 213, "speaking_score": -1.3833333055178325, "active": false, "track_id": 10}, {"x1": 333, "y1": 49, "x2": 444, "y2": 160, "speaking_score": -1.7799999952316283, "active": false, "track_id": 11}]}, {"frame_number": 1748, "faces": [{"x1": 1028, "y1": 113, "x2": 1160, "y2": 245, "speaking_score": -2.4833333492279053, "active": false, "track_id": 4}, {"x1": 10, "y1": 81, "x2": 151, "y2": 222, "speaking_score": -2.4166667064030967, "active": false, "track_id": 5}, {"x1": 183, "y1": 118, "x2": 299, "y2": 233, "speaking_score": -2.9166667064030967, "active": false, "track_id": 6}, {"x1": 730, "y1": 111, "x2": 850, "y2": 230, "speaking_score": -2.4666666984558105, "active": false, "track_id": 7}, {"x1": 717, "y1": 13, "x2": 836, "y2": 132, "speaking_score": -2.2666666905085244, "active": false, "track_id": 8}, {"x1": 811, "y1": 83, "x2": 942, "y2": 213, "speaking_score": -1.3833333055178325, "active": false, "track_id": 10}, {"x1": 333, "y1": 49, "x2": 444, "y2": 160, "speaking_score": -1.7799999952316283, "active": false, "track_id": 11}]}, {"frame_number": 1749, "faces": [{"x1": 1028, "y1": 113, "x2": 1160, "y2": 245, "speaking_score": -2.4333333571751914, "active": false, "track_id": 4}, {"x1": 10, "y1": 81, "x2": 151, "y2": 222, "speaking_score": -2.3666667143503823, "active": false, "track_id": 5}, {"x1": 183, "y1": 118, "x2": 299, "y2": 234, "speaking_score": -2.8666667143503823, "active": false, "track_id": 6}, {"x1": 729, "y1": 110, "x2": 848, "y2": 229, "speaking_score": -2.4166667064030967, "active": false, "track_id": 7}, {"x1": 717, "y1": 13, "x2": 836, "y2": 132, "speaking_score": -2.200000007947286, "active": false, "track_id": 8}, {"x1": 810, "y1": 83, "x2": 940, "y2": 213, "speaking_score": -1.3499999642372131, "active": false, "track_id": 10}, {"x1": 333, "y1": 50, "x2": 444, "y2": 161, "speaking_score": -1.7666666706403096, "active": false, "track_id": 11}]}, {"frame_number": 1750, "faces": [{"x1": 1027, "y1": 113, "x2": 1159, "y2": 245, "speaking_score": -2.333333373069763, "active": false, "track_id": 4}, {"x1": 10, "y1": 81, "x2": 151, "y2": 222, "speaking_score": -2.2833333810170493, "active": false, "track_id": 5}, {"x1": 183, "y1": 119, "x2": 298, "y2": 234, "speaking_score": -2.7666667302449546, "active": false, "track_id": 6}, {"x1": 728, "y1": 110, "x2": 847, "y2": 229, "speaking_score": -2.3166667222976685, "active": false, "track_id": 7}, {"x1": 717, "y1": 13, "x2": 835, "y2": 131, "speaking_score": -2.100000023841858, "active": false, "track_id": 8}, {"x1": 810, "y1": 83, "x2": 940, "y2": 212, "speaking_score": -1.2833333015441895, "active": false, "track_id": 10}, {"x1": 333, "y1": 50, "x2": 444, "y2": 161, "speaking_score": -1.75, "active": false, "track_id": 11}]}, {"frame_number": 1751, "faces": [{"x1": 1027, "y1": 113, "x2": 1159, "y2": 245, "speaking_score": -2.100000043710073, "active": false, "track_id": 4}, {"x1": 9, "y1": 81, "x2": 151, "y2": 222, "speaking_score": -2.083333373069763, "active": false, "track_id": 5}, {"x1": 182, "y1": 119, "x2": 297, "y2": 234, "speaking_score": -2.5500000516573587, "active": false, "track_id": 6}, {"x1": 725, "y1": 108, "x2": 844, "y2": 227, "speaking_score": -2.133333365122477, "active": false, "track_id": 7}, {"x1": 718, "y1": 13, "x2": 834, "y2": 129, "speaking_score": -1.8333333631356556, "active": false, "track_id": 8}, {"x1": 810, "y1": 83, "x2": 939, "y2": 212, "speaking_score": -1.0999999766548474, "active": false, "track_id": 10}, {"x1": 333, "y1": 50, "x2": 444, "y2": 161, "speaking_score": -1.6333333253860474, "active": false, "track_id": 11}]}, {"frame_number": 1752, "faces": [{"x1": 1026, "y1": 113, "x2": 1158, "y2": 245, "speaking_score": -1.7666666954755783, "active": false, "track_id": 4}, {"x1": 9, "y1": 81, "x2": 150, "y2": 222, "speaking_score": -1.816666692495346, "active": false, "track_id": 5}, {"x1": 181, "y1": 119, "x2": 297, "y2": 234, "speaking_score": -2.2500000397364297, "active": false, "track_id": 6}, {"x1": 723, "y1": 107, "x2": 842, "y2": 225, "speaking_score": -1.8333333532015483, "active": false, "track_id": 7}, {"x1": 718, "y1": 13, "x2": 833, "y2": 128, "speaking_score": -1.466666688521703, "active": false, "track_id": 8}, {"x1": 810, "y1": 83, "x2": 939, "y2": 212, "speaking_score": -0.8333333159486452, "active": false, "track_id": 10}, {"x1": 333, "y1": 50, "x2": 444, "y2": 161, "speaking_score": -1.4166666666666667, "active": false, "track_id": 11}]}, {"frame_number": 1753, "faces": [{"x1": 1026, "y1": 113, "x2": 1157, "y2": 245, "speaking_score": -1.416666681567828, "active": false, "track_id": 4}, {"x1": 9, "y1": 81, "x2": 150, "y2": 222, "speaking_score": -1.5333333412806194, "active": false, "track_id": 5}, {"x1": 181, "y1": 119, "x2": 296, "y2": 234, "speaking_score": -1.9166666865348816, "active": false, "track_id": 6}, {"x1": 722, "y1": 106, "x2": 841, "y2": 225, "speaking_score": -1.5166666706403096, "active": false, "track_id": 7}, {"x1": 717, "y1": 13, "x2": 832, "y2": 127, "speaking_score": -1.0666666800777118, "active": false, "track_id": 8}, {"x1": 810, "y1": 83, "x2": 939, "y2": 212, "speaking_score": -0.5333333189288775, "active": false, "track_id": 10}, {"x1": 334, "y1": 50, "x2": 444, "y2": 161, "speaking_score": -1.200000007947286, "active": false, "track_id": 11}]}, {"frame_number": 1754, "faces": [{"x1": 1026, "y1": 113, "x2": 1157, "y2": 245, "speaking_score": -1.416666681567828, "active": false, "track_id": 4}, {"x1": 9, "y1": 81, "x2": 150, "y2": 222, "speaking_score": -1.5333333412806194, "active": false, "track_id": 5}, {"x1": 181, "y1": 119, "x2": 296, "y2": 234, "speaking_score": -1.9166666865348816, "active": false, "track_id": 6}, {"x1": 722, "y1": 106, "x2": 841, "y2": 225, "speaking_score": -1.5166666706403096, "active": false, "track_id": 7}, {"x1": 717, "y1": 13, "x2": 832, "y2": 127, "speaking_score": -1.0666666800777118, "active": false, "track_id": 8}, {"x1": 810, "y1": 83, "x2": 939, "y2": 212, "speaking_score": -0.5333333189288775, "active": false, "track_id": 10}, {"x1": 334, "y1": 50, "x2": 444, "y2": 161, "speaking_score": -1.200000007947286, "active": false, "track_id": 11}]}, {"frame_number": 1755, "faces": [{"x1": 1025, "y1": 113, "x2": 1157, "y2": 245, "speaking_score": -1.0333333325882752, "active": false, "track_id": 4}, {"x1": 9, "y1": 81, "x2": 150, "y2": 223, "speaking_score": -1.2166666835546494, "active": false, "track_id": 5}, {"x1": 181, "y1": 119, "x2": 296, "y2": 234, "speaking_score": -1.566666692495346, "active": false, "track_id": 6}, {"x1": 721, "y1": 106, "x2": 840, "y2": 224, "speaking_score": -1.1499999885757763, "active": false, "track_id": 7}, {"x1": 718, "y1": 13, "x2": 831, "y2": 127, "speaking_score": -0.6166666721304258, "active": false, "track_id": 8}, {"x1": 810, "y1": 83, "x2": 939, "y2": 212, "speaking_score": -0.1999999855955442, "active": false, "track_id": 10}, {"x1": 333, "y1": 50, "x2": 444, "y2": 161, "speaking_score": -0.9833333492279053, "active": false, "track_id": 11}]}, {"frame_number": 1756, "faces": [{"x1": 1025, "y1": 113, "x2": 1156, "y2": 244, "speaking_score": -0.650000007202228, "active": false, "track_id": 4}, {"x1": 8, "y1": 81, "x2": 150, "y2": 223, "speaking_score": -0.9000000109275182, "active": false, "track_id": 5}, {"x1": 180, "y1": 119, "x2": 296, "y2": 234, "speaking_score": -1.2333333492279053, "active": false, "track_id": 6}, {"x1": 720, "y1": 106, "x2": 838, "y2": 224, "speaking_score": -0.7833333301047484, "active": false, "track_id": 7}, {"x1": 718, "y1": 13, "x2": 830, "y2": 125, "speaking_score": -0.16666667411724725, "active": false, "track_id": 8}, {"x1": 810, "y1": 83, "x2": 938, "y2": 212, "speaking_score": 0.1333333378036817, "active": true, "track_id": 10}, {"x1": 333, "y1": 50, "x2": 443, "y2": 160, "speaking_score": -0.7666666756073633, "active": false, "track_id": 11}]}, {"frame_number": 1757, "faces": [{"x1": 1025, "y1": 113, "x2": 1156, "y2": 244, "speaking_score": -0.3166666738688946, "active": false, "track_id": 4}, {"x1": 8, "y1": 82, "x2": 150, "y2": 223, "speaking_score": -0.6166666795810064, "active": false, "track_id": 5}, {"x1": 180, "y1": 119, "x2": 296, "y2": 234, "speaking_score": -0.9333333373069763, "active": false, "track_id": 6}, {"x1": 718, "y1": 106, "x2": 836, "y2": 224, "speaking_score": -0.46666666368643445, "active": false, "track_id": 7}, {"x1": 719, "y1": 13, "x2": 829, "y2": 123, "speaking_score": 0.23333333184321722, "active": true, "track_id": 8}, {"x1": 810, "y1": 84, "x2": 938, "y2": 212, "speaking_score": 0.4166666691501935, "active": true, "track_id": 10}, {"x1": 332, "y1": 50, "x2": 441, "y2": 159, "speaking_score": -0.5833333432674408, "active": false, "track_id": 11}]}, {"frame_number": 1758, "faces": [{"x1": 1024, "y1": 113, "x2": 1155, "y2": 244, "speaking_score": -0.15000000347693762, "active": false, "track_id": 4}, {"x1": 8, "y1": 82, "x2": 150, "y2": 223, "speaking_score": -0.46666667362054187, "active": false, "track_id": 5}, {"x1": 180, "y1": 119, "x2": 296, "y2": 234, "speaking_score": -0.7833333313465118, "active": false, "track_id": 6}, {"x1": 717, "y1": 106, "x2": 835, "y2": 224, "speaking_score": -0.30000000695387524, "active": false, "track_id": 7}, {"x1": 719, "y1": 13, "x2": 829, "y2": 123, "speaking_score": 0.46666666120290756, "active": true, "track_id": 8}, {"x1": 810, "y1": 84, "x2": 938, "y2": 213, "speaking_score": 0.5500000069538752, "active": true, "track_id": 10}, {"x1": 332, "y1": 50, "x2": 441, "y2": 159, "speaking_score": -0.46666667858759564, "active": false, "track_id": 11}]}, {"frame_number": 1759, "faces": [{"x1": 1024, "y1": 113, "x2": 1155, "y2": 244, "speaking_score": -0.10000000273187955, "active": false, "track_id": 4}, {"x1": 8, "y1": 82, "x2": 149, "y2": 223, "speaking_score": -0.38333334028720856, "active": false, "track_id": 5}, {"x1": 180, "y1": 119, "x2": 295, "y2": 235, "speaking_score": -0.7166666587193807, "active": false, "track_id": 6}, {"x1": 716, "y1": 106, "x2": 834, "y2": 224, "speaking_score": -0.2500000049670537, "active": false, "track_id": 7}, {"x1": 719, "y1": 13, "x2": 829, "y2": 123, "speaking_score": 0.5666666651765505, "active": true, "track_id": 8}, {"x1": 809, "y1": 84, "x2": 938, "y2": 213, "speaking_score": 0.583333338300387, "active": true, "track_id": 10}, {"x1": 332, "y1": 50, "x2": 441, "y2": 158, "speaking_score": -0.40000000844399136, "active": false, "track_id": 11}]}, {"frame_number": 1760, "faces": [{"x1": 1024, "y1": 113, "x2": 1155, "y2": 244, "speaking_score": -0.10000000273187955, "active": false, "track_id": 4}, {"x1": 8, "y1": 82, "x2": 149, "y2": 223, "speaking_score": -0.38333334028720856, "active": false, "track_id": 5}, {"x1": 180, "y1": 119, "x2": 295, "y2": 235, "speaking_score": -0.7166666587193807, "active": false, "track_id": 6}, {"x1": 716, "y1": 106, "x2": 834, "y2": 224, "speaking_score": -0.2500000049670537, "active": false, "track_id": 7}, {"x1": 719, "y1": 13, "x2": 829, "y2": 123, "speaking_score": 0.5666666651765505, "active": true, "track_id": 8}, {"x1": 809, "y1": 84, "x2": 938, "y2": 213, "speaking_score": 0.583333338300387, "active": true, "track_id": 10}, {"x1": 332, "y1": 50, "x2": 441, "y2": 158, "speaking_score": -0.40000000844399136, "active": false, "track_id": 11}]}, {"frame_number": 1761, "faces": [{"x1": 1024, "y1": 113, "x2": 1155, "y2": 244, "speaking_score": -0.18333333606521288, "active": false, "track_id": 4}, {"x1": 7, "y1": 82, "x2": 149, "y2": 223, "speaking_score": -0.43333334227403003, "active": false, "track_id": 5}, {"x1": 179, "y1": 119, "x2": 295, "y2": 235, "speaking_score": -0.7833333214124044, "active": false, "track_id": 6}, {"x1": 715, "y1": 106, "x2": 833, "y2": 224, "speaking_score": -0.3333333383003871, "active": false, "track_id": 7}, {"x1": 719, "y1": 13, "x2": 829, "y2": 123, "speaking_score": 0.5166666644314925, "active": true, "track_id": 8}, {"x1": 809, "y1": 84, "x2": 938, "y2": 213, "speaking_score": 0.48333333681027096, "active": true, "track_id": 10}, {"x1": 332, "y1": 50, "x2": 441, "y2": 158, "speaking_score": -0.3333333383003871, "active": false, "track_id": 11}]}, {"frame_number": 1762, "faces": [{"x1": 1023, "y1": 113, "x2": 1154, "y2": 244, "speaking_score": -0.2833333338300387, "active": false, "track_id": 4}, {"x1": 7, "y1": 82, "x2": 149, "y2": 223, "speaking_score": -0.5333333412806193, "active": false, "track_id": 5}, {"x1": 179, "y1": 119, "x2": 294, "y2": 235, "speaking_score": -0.8666666646798452, "active": false, "track_id": 6}, {"x1": 715, "y1": 106, "x2": 833, "y2": 224, "speaking_score": -0.45000000049670535, "active": false, "track_id": 7}, {"x1": 719, "y1": 13, "x2": 828, "y2": 123, "speaking_score": 0.4166666641831398, "active": true, "track_id": 8}, {"x1": 808, "y1": 84, "x2": 938, "y2": 214, "speaking_score": 0.34999999900658924, "active": true, "track_id": 10}, {"x1": 332, "y1": 50, "x2": 440, "y2": 158, "speaking_score": -0.2666666718820731, "active": false, "track_id": 11}]}, {"frame_number": 1763, "faces": [{"x1": 1023, "y1": 113, "x2": 1153, "y2": 244, "speaking_score": -0.3833333378036817, "active": false, "track_id": 4}, {"x1": 7, "y1": 82, "x2": 149, "y2": 223, "speaking_score": -0.6333333353201548, "active": false, "track_id": 5}, {"x1": 178, "y1": 119, "x2": 294, "y2": 235, "speaking_score": -0.950000007947286, "active": false, "track_id": 6}, {"x1": 715, "y1": 106, "x2": 833, "y2": 224, "speaking_score": -0.5666666689018408, "active": false, "track_id": 7}, {"x1": 718, "y1": 13, "x2": 828, "y2": 123, "speaking_score": 0.316666666418314, "active": true, "track_id": 8}, {"x1": 808, "y1": 84, "x2": 937, "y2": 214, "speaking_score": 0.20000000049670538, "active": true, "track_id": 10}, {"x1": 333, "y1": 50, "x2": 440, "y2": 157, "speaking_score": -0.20000000422199568, "active": false, "track_id": 11}]}, {"frame_number": 1764, "faces": [{"x1": 1022, "y1": 113, "x2": 1153, "y2": 244, "speaking_score": -0.4500000054637591, "active": false, "track_id": 4}, {"x1": 7, "y1": 82, "x2": 149, "y2": 224, "speaking_score": -0.7166666686534882, "active": false, "track_id": 5}, {"x1": 178, "y1": 119, "x2": 294, "y2": 235, "speaking_score": -1.0166666706403096, "active": false, "track_id": 6}, {"x1": 715, "y1": 106, "x2": 833, "y2": 224, "speaking_score": -0.6333333353201548, "active": false, "track_id": 7}, {"x1": 718, "y1": 13, "x2": 828, "y2": 123, "speaking_score": 0.3000000057121118, "active": true, "track_id": 8}, {"x1": 808, "y1": 84, "x2": 937, "y2": 214, "speaking_score": 0.0833333358168602, "active": true, "track_id": 10}, {"x1": 333, "y1": 50, "x2": 440, "y2": 157, "speaking_score": -0.10000000273187955, "active": false, "track_id": 11}]}, {"frame_number": 1765, "faces": [{"x1": 1022, "y1": 113, "x2": 1152, "y2": 244, "speaking_score": -0.5000000062088171, "active": false, "track_id": 4}, {"x1": 7, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.8000000019868215, "active": false, "track_id": 5}, {"x1": 178, "y1": 119, "x2": 294, "y2": 235, "speaking_score": -1.0666666726271312, "active": false, "track_id": 6}, {"x1": 715, "y1": 107, "x2": 833, "y2": 225, "speaking_score": -0.6666666666666666, "active": false, "track_id": 7}, {"x1": 717, "y1": 13, "x2": 827, "y2": 123, "speaking_score": 0.2833333450059096, "active": true, "track_id": 8}, {"x1": 807, "y1": 84, "x2": 936, "y2": 214, "speaking_score": -0.016666668156782787, "active": false, "track_id": 10}, {"x1": 333, "y1": 50, "x2": 440, "y2": 158, "speaking_score": -0.016666666915019352, "active": false, "track_id": 11}]}, {"frame_number": 1766, "faces": [{"x1": 1022, "y1": 113, "x2": 1152, "y2": 244, "speaking_score": -0.5000000062088171, "active": false, "track_id": 4}, {"x1": 7, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.8000000019868215, "active": false, "track_id": 5}, {"x1": 178, "y1": 119, "x2": 294, "y2": 235, "speaking_score": -1.0666666726271312, "active": false, "track_id": 6}, {"x1": 715, "y1": 107, "x2": 833, "y2": 225, "speaking_score": -0.6666666666666666, "active": false, "track_id": 7}, {"x1": 717, "y1": 13, "x2": 827, "y2": 123, "speaking_score": 0.2833333450059096, "active": true, "track_id": 8}, {"x1": 807, "y1": 84, "x2": 936, "y2": 214, "speaking_score": -0.016666668156782787, "active": false, "track_id": 10}, {"x1": 333, "y1": 50, "x2": 440, "y2": 158, "speaking_score": -0.016666666915019352, "active": false, "track_id": 11}]}, {"frame_number": 1767, "faces": [{"x1": 1021, "y1": 113, "x2": 1152, "y2": 244, "speaking_score": -0.5666666726271311, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.8833333353201548, "active": false, "track_id": 5}, {"x1": 178, "y1": 119, "x2": 293, "y2": 235, "speaking_score": -1.1166666746139526, "active": false, "track_id": 6}, {"x1": 715, "y1": 107, "x2": 833, "y2": 225, "speaking_score": -0.7166666686534882, "active": false, "track_id": 7}, {"x1": 716, "y1": 13, "x2": 827, "y2": 124, "speaking_score": 0.2833333450059096, "active": true, "track_id": 8}, {"x1": 806, "y1": 84, "x2": 936, "y2": 214, "speaking_score": -0.11666666840513547, "active": false, "track_id": 10}, {"x1": 333, "y1": 50, "x2": 440, "y2": 158, "speaking_score": 0.05000000074505806, "active": true, "track_id": 11}]}, {"frame_number": 1768, "faces": [{"x1": 1021, "y1": 113, "x2": 1151, "y2": 244, "speaking_score": -0.5166666706403097, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.850000003973643, "active": false, "track_id": 5}, {"x1": 178, "y1": 119, "x2": 293, "y2": 235, "speaking_score": -1.0833333532015483, "active": false, "track_id": 6}, {"x1": 715, "y1": 108, "x2": 833, "y2": 226, "speaking_score": -0.6833333373069763, "active": false, "track_id": 7}, {"x1": 716, "y1": 14, "x2": 827, "y2": 124, "speaking_score": 0.36666667958100635, "active": true, "track_id": 8}, {"x1": 806, "y1": 84, "x2": 936, "y2": 214, "speaking_score": -0.10000000149011612, "active": false, "track_id": 10}, {"x1": 332, "y1": 50, "x2": 440, "y2": 158, "speaking_score": 0.11666666840513547, "active": true, "track_id": 11}]}, {"frame_number": 1769, "faces": [{"x1": 1019, "y1": 113, "x2": 1150, "y2": 244, "speaking_score": -0.4833333392937978, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.8166666726271311, "active": false, "track_id": 5}, {"x1": 178, "y1": 120, "x2": 293, "y2": 234, "speaking_score": -1.050000011920929, "active": false, "track_id": 6}, {"x1": 716, "y1": 109, "x2": 835, "y2": 228, "speaking_score": -0.6500000059604645, "active": false, "track_id": 7}, {"x1": 715, "y1": 14, "x2": 827, "y2": 126, "speaking_score": 0.45000001415610313, "active": true, "track_id": 8}, {"x1": 806, "y1": 84, "x2": 935, "y2": 214, "speaking_score": -0.08333333457509677, "active": false, "track_id": 10}, {"x1": 332, "y1": 50, "x2": 440, "y2": 158, "speaking_score": 0.15000000223517418, "active": true, "track_id": 11}]}, {"frame_number": 1770, "faces": [{"x1": 1019, "y1": 113, "x2": 1150, "y2": 244, "speaking_score": -0.46666666865348816, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.800000011920929, "active": false, "track_id": 5}, {"x1": 178, "y1": 120, "x2": 292, "y2": 234, "speaking_score": -1.0166666706403096, "active": false, "track_id": 6}, {"x1": 717, "y1": 110, "x2": 835, "y2": 228, "speaking_score": -0.6333333353201548, "active": false, "track_id": 7}, {"x1": 715, "y1": 14, "x2": 827, "y2": 126, "speaking_score": 0.5000000149011612, "active": true, "track_id": 8}, {"x1": 806, "y1": 84, "x2": 935, "y2": 213, "speaking_score": -0.06666666766007741, "active": false, "track_id": 10}, {"x1": 332, "y1": 50, "x2": 440, "y2": 158, "speaking_score": 0.15000000223517418, "active": true, "track_id": 11}]}, {"frame_number": 1771, "faces": [{"x1": 1019, "y1": 113, "x2": 1149, "y2": 244, "speaking_score": -0.46666666865348816, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.7833333412806193, "active": false, "track_id": 5}, {"x1": 178, "y1": 120, "x2": 292, "y2": 234, "speaking_score": -1.0166666706403096, "active": false, "track_id": 6}, {"x1": 717, "y1": 110, "x2": 835, "y2": 228, "speaking_score": -0.6500000059604645, "active": false, "track_id": 7}, {"x1": 714, "y1": 15, "x2": 827, "y2": 127, "speaking_score": 0.46666667858759564, "active": true, "track_id": 8}, {"x1": 806, "y1": 84, "x2": 934, "y2": 212, "speaking_score": -0.06666666766007741, "active": false, "track_id": 10}, {"x1": 332, "y1": 51, "x2": 440, "y2": 159, "speaking_score": 0.11666666840513547, "active": true, "track_id": 11}]}, {"frame_number": 1772, "faces": [{"x1": 1019, "y1": 113, "x2": 1149, "y2": 244, "speaking_score": -0.46666666865348816, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.7833333412806193, "active": false, "track_id": 5}, {"x1": 178, "y1": 120, "x2": 292, "y2": 234, "speaking_score": -1.0166666706403096, "active": false, "track_id": 6}, {"x1": 717, "y1": 110, "x2": 835, "y2": 228, "speaking_score": -0.6500000059604645, "active": false, "track_id": 7}, {"x1": 714, "y1": 15, "x2": 827, "y2": 127, "speaking_score": 0.46666667858759564, "active": true, "track_id": 8}, {"x1": 806, "y1": 84, "x2": 934, "y2": 212, "speaking_score": -0.06666666766007741, "active": false, "track_id": 10}, {"x1": 332, "y1": 51, "x2": 440, "y2": 159, "speaking_score": 0.11666666840513547, "active": true, "track_id": 11}]}, {"frame_number": 1773, "faces": [{"x1": 1018, "y1": 113, "x2": 1149, "y2": 244, "speaking_score": -0.46666666865348816, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.7833333412806193, "active": false, "track_id": 5}, {"x1": 177, "y1": 120, "x2": 292, "y2": 234, "speaking_score": -1.0333333412806194, "active": false, "track_id": 6}, {"x1": 717, "y1": 110, "x2": 836, "y2": 228, "speaking_score": -0.6833333373069763, "active": false, "track_id": 7}, {"x1": 714, "y1": 14, "x2": 827, "y2": 127, "speaking_score": 0.40000000844399136, "active": true, "track_id": 8}, {"x1": 806, "y1": 84, "x2": 934, "y2": 212, "speaking_score": -0.08333333457509677, "active": false, "track_id": 10}, {"x1": 331, "y1": 51, "x2": 440, "y2": 159, "speaking_score": 0.08333333457509677, "active": true, "track_id": 11}]}, {"frame_number": 1774, "faces": [{"x1": 1017, "y1": 113, "x2": 1148, "y2": 244, "speaking_score": -0.46666666865348816, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.7833333412806193, "active": false, "track_id": 5}, {"x1": 177, "y1": 120, "x2": 292, "y2": 234, "speaking_score": -1.050000011920929, "active": false, "track_id": 6}, {"x1": 718, "y1": 110, "x2": 836, "y2": 228, "speaking_score": -0.6833333373069763, "active": false, "track_id": 7}, {"x1": 713, "y1": 15, "x2": 826, "y2": 128, "speaking_score": 0.3166666713853677, "active": true, "track_id": 8}, {"x1": 805, "y1": 84, "x2": 934, "y2": 212, "speaking_score": -0.10000000149011612, "active": false, "track_id": 10}, {"x1": 331, "y1": 51, "x2": 440, "y2": 160, "speaking_score": 0.06666666766007741, "active": true, "track_id": 11}]}, {"frame_number": 1775, "faces": [{"x1": 1016, "y1": 113, "x2": 1147, "y2": 244, "speaking_score": -0.4333333373069763, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.7500000099341074, "active": false, "track_id": 5}, {"x1": 178, "y1": 120, "x2": 291, "y2": 234, "speaking_score": -1.0333333412806194, "active": false, "track_id": 6}, {"x1": 719, "y1": 110, "x2": 837, "y2": 228, "speaking_score": -0.6333333353201548, "active": false, "track_id": 7}, {"x1": 712, "y1": 15, "x2": 825, "y2": 128, "speaking_score": 0.3000000057121118, "active": true, "track_id": 8}, {"x1": 805, "y1": 84, "x2": 933, "y2": 212, "speaking_score": -0.08333333457509677, "active": false, "track_id": 10}, {"x1": 329, "y1": 50, "x2": 441, "y2": 161, "speaking_score": 0.06666666766007741, "active": true, "track_id": 11}]}, {"frame_number": 1776, "faces": [{"x1": 1016, "y1": 113, "x2": 1147, "y2": 244, "speaking_score": -0.3833333378036817, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.700000007947286, "active": false, "track_id": 5}, {"x1": 177, "y1": 120, "x2": 291, "y2": 234, "speaking_score": -1.0000000099341075, "active": false, "track_id": 6}, {"x1": 719, "y1": 111, "x2": 837, "y2": 229, "speaking_score": -0.583333338300387, "active": false, "track_id": 7}, {"x1": 712, "y1": 15, "x2": 825, "y2": 128, "speaking_score": 0.3166666713853677, "active": true, "track_id": 8}, {"x1": 805, "y1": 84, "x2": 933, "y2": 212, "speaking_score": -0.033333333830038704, "active": false, "track_id": 10}, {"x1": 329, "y1": 49, "x2": 441, "y2": 161, "speaking_score": 0.08333333457509677, "active": true, "track_id": 11}]}, {"frame_number": 1777, "faces": [{"x1": 1016, "y1": 113, "x2": 1146, "y2": 244, "speaking_score": -0.35000000645716983, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.6666666766007742, "active": false, "track_id": 5}, {"x1": 177, "y1": 120, "x2": 291, "y2": 234, "speaking_score": -0.9666666785875956, "active": false, "track_id": 6}, {"x1": 719, "y1": 111, "x2": 837, "y2": 229, "speaking_score": -0.5500000069538752, "active": false, "track_id": 7}, {"x1": 712, "y1": 15, "x2": 825, "y2": 128, "speaking_score": 0.3000000057121118, "active": true, "track_id": 8}, {"x1": 805, "y1": 84, "x2": 933, "y2": 212, "speaking_score": -0.016666666915019352, "active": false, "track_id": 10}, {"x1": 329, "y1": 49, "x2": 441, "y2": 161, "speaking_score": 0.10000000149011612, "active": true, "track_id": 11}]}, {"frame_number": 1778, "faces": [{"x1": 1016, "y1": 113, "x2": 1146, "y2": 244, "speaking_score": -0.35000000645716983, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.6666666766007742, "active": false, "track_id": 5}, {"x1": 177, "y1": 120, "x2": 291, "y2": 234, "speaking_score": -0.9666666785875956, "active": false, "track_id": 6}, {"x1": 719, "y1": 111, "x2": 837, "y2": 229, "speaking_score": -0.5500000069538752, "active": false, "track_id": 7}, {"x1": 712, "y1": 15, "x2": 825, "y2": 128, "speaking_score": 0.3000000057121118, "active": true, "track_id": 8}, {"x1": 805, "y1": 84, "x2": 933, "y2": 212, "speaking_score": -0.016666666915019352, "active": false, "track_id": 10}, {"x1": 329, "y1": 49, "x2": 441, "y2": 161, "speaking_score": 0.10000000149011612, "active": true, "track_id": 11}]}, {"frame_number": 1779, "faces": [{"x1": 1015, "y1": 113, "x2": 1146, "y2": 244, "speaking_score": -0.35000000645716983, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.6500000158945719, "active": false, "track_id": 5}, {"x1": 177, "y1": 120, "x2": 291, "y2": 234, "speaking_score": -0.9333333472410837, "active": false, "track_id": 6}, {"x1": 719, "y1": 111, "x2": 837, "y2": 229, "speaking_score": -0.5333333363135656, "active": false, "track_id": 7}, {"x1": 712, "y1": 15, "x2": 825, "y2": 128, "speaking_score": 0.28333334003885585, "active": true, "track_id": 8}, {"x1": 805, "y1": 84, "x2": 932, "y2": 212, "speaking_score": -0.016666666915019352, "active": false, "track_id": 10}, {"x1": 329, "y1": 49, "x2": 441, "y2": 161, "speaking_score": 0.10000000149011612, "active": true, "track_id": 11}]}, {"frame_number": 1780, "faces": [{"x1": 1015, "y1": 113, "x2": 1145, "y2": 244, "speaking_score": -0.3400000065565109, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.6200000166893005, "active": false, "track_id": 5}, {"x1": 177, "y1": 120, "x2": 291, "y2": 234, "speaking_score": -0.9000000119209289, "active": false, "track_id": 6}, {"x1": 719, "y1": 110, "x2": 837, "y2": 228, "speaking_score": -0.5000000059604645, "active": false, "track_id": 7}, {"x1": 711, "y1": 15, "x2": 825, "y2": 128, "speaking_score": 0.3000000074505806, "active": true, "track_id": 8}, {"x1": 805, "y1": 84, "x2": 932, "y2": 211, "speaking_score": 0.0, "active": true, "track_id": 10}, {"x1": 329, "y1": 49, "x2": 440, "y2": 161, "speaking_score": 0.12000000178813934, "active": true, "track_id": 11}]}, {"frame_number": 1781, "faces": [{"x1": 1014, "y1": 113, "x2": 1145, "y2": 244, "speaking_score": -0.30000000819563866, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.5750000178813934, "active": false, "track_id": 5}, {"x1": 177, "y1": 120, "x2": 290, "y2": 234, "speaking_score": -0.8500000089406967, "active": false, "track_id": 6}, {"x1": 719, "y1": 110, "x2": 837, "y2": 228, "speaking_score": -0.4750000014901161, "active": false, "track_id": 7}, {"x1": 712, "y1": 15, "x2": 825, "y2": 128, "speaking_score": 0.3500000089406967, "active": true, "track_id": 8}, {"x1": 806, "y1": 86, "x2": 930, "y2": 210, "speaking_score": 0.05000000074505806, "active": true, "track_id": 10}, {"x1": 328, "y1": 49, "x2": 440, "y2": 160, "speaking_score": 0.12500000186264515, "active": true, "track_id": 11}]}, {"frame_number": 1782, "faces": [{"x1": 1014, "y1": 113, "x2": 1144, "y2": 244, "speaking_score": -0.30000000695387524, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.5666666825612386, "active": false, "track_id": 5}, {"x1": 177, "y1": 120, "x2": 290, "y2": 234, "speaking_score": -0.800000011920929, "active": false, "track_id": 6}, {"x1": 719, "y1": 110, "x2": 837, "y2": 228, "speaking_score": -0.46666666865348816, "active": false, "track_id": 7}, {"x1": 711, "y1": 15, "x2": 824, "y2": 128, "speaking_score": 0.36666667461395264, "active": true, "track_id": 8}, {"x1": 806, "y1": 86, "x2": 930, "y2": 210, "speaking_score": 0.06666666766007741, "active": true, "track_id": 10}, {"x1": 328, "y1": 49, "x2": 440, "y2": 160, "speaking_score": 0.10000000149011612, "active": true, "track_id": 11}]}, {"frame_number": 1783, "faces": [{"x1": 1013, "y1": 113, "x2": 1144, "y2": 244, "speaking_score": -0.3500000089406967, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.6000000238418579, "active": false, "track_id": 5}, {"x1": 177, "y1": 120, "x2": 290, "y2": 234, "speaking_score": -0.800000011920929, "active": false, "track_id": 6}, {"x1": 719, "y1": 110, "x2": 837, "y2": 228, "speaking_score": -0.5, "active": false, "track_id": 7}, {"x1": 711, "y1": 15, "x2": 824, "y2": 128, "speaking_score": 0.30000001192092896, "active": true, "track_id": 8}, {"x1": 806, "y1": 86, "x2": 930, "y2": 210, "speaking_score": 0.0, "active": true, "track_id": 10}, {"x1": 328, "y1": 48, "x2": 440, "y2": 160, "speaking_score": 0.05000000074505806, "active": true, "track_id": 11}]}, {"frame_number": 1784, "faces": [{"x1": 1013, "y1": 113, "x2": 1144, "y2": 244, "speaking_score": -0.3500000089406967, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.6000000238418579, "active": false, "track_id": 5}, {"x1": 177, "y1": 120, "x2": 290, "y2": 234, "speaking_score": -0.800000011920929, "active": false, "track_id": 6}, {"x1": 719, "y1": 110, "x2": 837, "y2": 228, "speaking_score": -0.5, "active": false, "track_id": 7}, {"x1": 711, "y1": 15, "x2": 824, "y2": 128, "speaking_score": 0.30000001192092896, "active": true, "track_id": 8}, {"x1": 806, "y1": 86, "x2": 930, "y2": 210, "speaking_score": 0.0, "active": true, "track_id": 10}, {"x1": 328, "y1": 48, "x2": 440, "y2": 160, "speaking_score": 0.05000000074505806, "active": true, "track_id": 11}]}, {"frame_number": 1785, "faces": [{"x1": 1016, "y1": 113, "x2": 1146, "y2": 244, "speaking_score": -0.35000000645716983, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.6666666766007742, "active": false, "track_id": 5}, {"x1": 177, "y1": 120, "x2": 291, "y2": 234, "speaking_score": -0.9666666785875956, "active": false, "track_id": 6}, {"x1": 719, "y1": 111, "x2": 837, "y2": 229, "speaking_score": -0.5500000069538752, "active": false, "track_id": 7}, {"x1": 712, "y1": 15, "x2": 825, "y2": 128, "speaking_score": 0.3000000057121118, "active": true, "track_id": 8}, {"x1": 805, "y1": 84, "x2": 933, "y2": 212, "speaking_score": -0.016666666915019352, "active": false, "track_id": 10}, {"x1": 329, "y1": 49, "x2": 441, "y2": 161, "speaking_score": 0.10000000149011612, "active": true, "track_id": 11}]}, {"frame_number": 1786, "faces": [{"x1": 1015, "y1": 113, "x2": 1146, "y2": 244, "speaking_score": -0.35000000645716983, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.6500000158945719, "active": false, "track_id": 5}, {"x1": 177, "y1": 120, "x2": 291, "y2": 234, "speaking_score": -0.9333333472410837, "active": false, "track_id": 6}, {"x1": 719, "y1": 111, "x2": 837, "y2": 229, "speaking_score": -0.5333333363135656, "active": false, "track_id": 7}, {"x1": 712, "y1": 15, "x2": 825, "y2": 128, "speaking_score": 0.28333334003885585, "active": true, "track_id": 8}, {"x1": 805, "y1": 84, "x2": 932, "y2": 212, "speaking_score": -0.016666666915019352, "active": false, "track_id": 10}, {"x1": 329, "y1": 49, "x2": 441, "y2": 161, "speaking_score": 0.10000000149011612, "active": true, "track_id": 11}]}, {"frame_number": 1787, "faces": [{"x1": 1015, "y1": 113, "x2": 1145, "y2": 244, "speaking_score": -0.3400000065565109, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.6200000166893005, "active": false, "track_id": 5}, {"x1": 177, "y1": 120, "x2": 291, "y2": 234, "speaking_score": -0.9000000119209289, "active": false, "track_id": 6}, {"x1": 719, "y1": 110, "x2": 837, "y2": 228, "speaking_score": -0.5000000059604645, "active": false, "track_id": 7}, {"x1": 711, "y1": 15, "x2": 825, "y2": 128, "speaking_score": 0.3000000074505806, "active": true, "track_id": 8}, {"x1": 805, "y1": 84, "x2": 932, "y2": 211, "speaking_score": 0.0, "active": true, "track_id": 10}, {"x1": 329, "y1": 49, "x2": 440, "y2": 161, "speaking_score": 0.12000000178813934, "active": true, "track_id": 11}]}, {"frame_number": 1788, "faces": [{"x1": 1014, "y1": 113, "x2": 1145, "y2": 244, "speaking_score": -0.30000000819563866, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.5750000178813934, "active": false, "track_id": 5}, {"x1": 177, "y1": 120, "x2": 290, "y2": 234, "speaking_score": -0.8500000089406967, "active": false, "track_id": 6}, {"x1": 719, "y1": 110, "x2": 837, "y2": 228, "speaking_score": -0.4750000014901161, "active": false, "track_id": 7}, {"x1": 712, "y1": 15, "x2": 825, "y2": 128, "speaking_score": 0.3500000089406967, "active": true, "track_id": 8}, {"x1": 806, "y1": 86, "x2": 930, "y2": 210, "speaking_score": 0.05000000074505806, "active": true, "track_id": 10}, {"x1": 328, "y1": 49, "x2": 440, "y2": 160, "speaking_score": 0.12500000186264515, "active": true, "track_id": 11}]}, {"frame_number": 1789, "faces": [{"x1": 1014, "y1": 113, "x2": 1145, "y2": 244, "speaking_score": -0.30000000819563866, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.5750000178813934, "active": false, "track_id": 5}, {"x1": 177, "y1": 120, "x2": 290, "y2": 234, "speaking_score": -0.8500000089406967, "active": false, "track_id": 6}, {"x1": 719, "y1": 110, "x2": 837, "y2": 228, "speaking_score": -0.4750000014901161, "active": false, "track_id": 7}, {"x1": 712, "y1": 15, "x2": 825, "y2": 128, "speaking_score": 0.3500000089406967, "active": true, "track_id": 8}, {"x1": 806, "y1": 86, "x2": 930, "y2": 210, "speaking_score": 0.05000000074505806, "active": true, "track_id": 10}, {"x1": 328, "y1": 49, "x2": 440, "y2": 160, "speaking_score": 0.12500000186264515, "active": true, "track_id": 11}]}, {"frame_number": 1790, "faces": [{"x1": 1014, "y1": 113, "x2": 1144, "y2": 244, "speaking_score": -0.30000000695387524, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.5666666825612386, "active": false, "track_id": 5}, {"x1": 177, "y1": 120, "x2": 290, "y2": 234, "speaking_score": -0.800000011920929, "active": false, "track_id": 6}, {"x1": 719, "y1": 110, "x2": 837, "y2": 228, "speaking_score": -0.46666666865348816, "active": false, "track_id": 7}, {"x1": 711, "y1": 15, "x2": 824, "y2": 128, "speaking_score": 0.36666667461395264, "active": true, "track_id": 8}, {"x1": 806, "y1": 86, "x2": 930, "y2": 210, "speaking_score": 0.06666666766007741, "active": true, "track_id": 10}, {"x1": 328, "y1": 49, "x2": 440, "y2": 160, "speaking_score": 0.10000000149011612, "active": true, "track_id": 11}]}, {"frame_number": 1791, "faces": [{"x1": 1013, "y1": 113, "x2": 1144, "y2": 244, "speaking_score": -0.3500000089406967, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.6000000238418579, "active": false, "track_id": 5}, {"x1": 177, "y1": 120, "x2": 290, "y2": 234, "speaking_score": -0.800000011920929, "active": false, "track_id": 6}, {"x1": 719, "y1": 110, "x2": 837, "y2": 228, "speaking_score": -0.5, "active": false, "track_id": 7}, {"x1": 711, "y1": 15, "x2": 824, "y2": 128, "speaking_score": 0.30000001192092896, "active": true, "track_id": 8}, {"x1": 806, "y1": 86, "x2": 930, "y2": 210, "speaking_score": 0.0, "active": true, "track_id": 10}, {"x1": 328, "y1": 48, "x2": 440, "y2": 160, "speaking_score": 0.05000000074505806, "active": true, "track_id": 11}]}, {"frame_number": 1791, "faces": [{"x1": 1013, "y1": 113, "x2": 1144, "y2": 244, "speaking_score": -0.3500000089406967, "active": false, "track_id": 4}, {"x1": 6, "y1": 82, "x2": 148, "y2": 224, "speaking_score": -0.6000000238418579, "active": false, "track_id": 5}, {"x1": 177, "y1": 120, "x2": 290, "y2": 234, "speaking_score": -0.800000011920929, "active": false, "track_id": 6}, {"x1": 719, "y1": 110, "x2": 837, "y2": 228, "speaking_score": -0.5, "active": false, "track_id": 7}, {"x1": 711, "y1": 15, "x2": 824, "y2": 128, "speaking_score": 0.30000001192092896, "active": true, "track_id": 8}, {"x1": 806, "y1": 86, "x2": 930, "y2": 210, "speaking_score": 0.0, "active": true, "track_id": 10}, {"x1": 328, "y1": 48, "x2": 440, "y2": 160, "speaking_score": 0.05000000074505806, "active": true, "track_id": 11}]}, {"frame_number": 1792, "faces": []}, {"frame_number": 1793, "faces": []}, {"frame_number": 1794, "faces": []}, {"frame_number": 1795, "faces": []}, {"frame_number": 1796, "faces": []}, {"frame_number": 1797, "faces": []}, {"frame_number": 1798, "faces": []}, {"frame_number": 1799, "faces": []}, {"frame_number": 1800, "faces": []}, {"frame_number": 1801, "faces": []}, {"frame_number": 1802, "faces": []}, {"frame_number": 1803, "faces": []}, {"frame_number": 1804, "faces": []}, {"frame_number": 1805, "faces": []}, {"frame_number": 1806, "faces": []}, {"frame_number": 1807, "faces": []}, {"frame_number": 1808, "faces": []}, {"frame_number": 1809, "faces": []}, {"frame_number": 1810, "faces": []}, {"frame_number": 1811, "faces": []}, {"frame_number": 1812, "faces": []}, {"frame_number": 1813, "faces": []}, {"frame_number": 1814, "faces": []}, {"frame_number": 1815, "faces": []}, {"frame_number": 1816, "faces": []}, {"frame_number": 1817, "faces": []}, {"frame_number": 1818, "faces": []}, {"frame_number": 1819, "faces": []}, {"frame_number": 1820, "faces": []}, {"frame_number": 1821, "faces": []}, {"frame_number": 1822, "faces": []}, {"frame_number": 1823, "faces": []}, {"frame_number": 1824, "faces": []}, {"frame_number": 1825, "faces": []}, {"frame_number": 1826, "faces": []}, {"frame_number": 1827, "faces": []}, {"frame_number": 1828, "faces": []}, {"frame_number": 1829, "faces": []}, {"frame_number": 1830, "faces": []}, {"frame_number": 1831, "faces": []}, {"frame_number": 1832, "faces": []}, {"frame_number": 1833, "faces": []}, {"frame_number": 1834, "faces": []}, {"frame_number": 1835, "faces": []}, {"frame_number": 1836, "faces": []}, {"frame_number": 1837, "faces": []}, {"frame_number": 1838, "faces": []}, {"frame_number": 1839, "faces": []}, {"frame_number": 1840, "faces": []}, {"frame_number": 1841, "faces": []}, {"frame_number": 1842, "faces": []}, {"frame_number": 1843, "faces": []}, {"frame_number": 1844, "faces": []}, {"frame_number": 1845, "faces": []}, {"frame_number": 1846, "faces": []}, {"frame_number": 1847, "faces": []}, {"frame_number": 1848, "faces": []}, {"frame_number": 1849, "faces": []}, {"frame_number": 1850, "faces": []}, {"frame_number": 1851, "faces": []}, {"frame_number": 1852, "faces": []}, {"frame_number": 1853, "faces": []}, {"frame_number": 1854, "faces": []}, {"frame_number": 1855, "faces": []}, {"frame_number": 1856, "faces": []}, {"frame_number": 1857, "faces": []}, {"frame_number": 1858, "faces": []}, {"frame_number": 1859, "faces": []}, {"frame_number": 1860, "faces": []}, {"frame_number": 1861, "faces": []}, {"frame_number": 1862, "faces": []}, {"frame_number": 1863, "faces": []}, {"frame_number": 1864, "faces": []}, {"frame_number": 1865, "faces": []}, {"frame_number": 1866, "faces": []}, {"frame_number": 1867, "faces": []}, {"frame_number": 1868, "faces": []}, {"frame_number": 1869, "faces": []}, {"frame_number": 1870, "faces": []}, {"frame_number": 1871, "faces": []}, {"frame_number": 1872, "faces": []}, {"frame_number": 1873, "faces": []}, {"frame_number": 1874, "faces": []}, {"frame_number": 1875, "faces": []}, {"frame_number": 1876, "faces": []}, {"frame_number": 1877, "faces": []}, {"frame_number": 1878, "faces": []}, {"frame_number": 1879, "faces": []}, {"frame_number": 1880, "faces": []}, {"frame_number": 1881, "faces": []}, {"frame_number": 1882, "faces": []}, {"frame_number": 1883, "faces": []}, {"frame_number": 1884, "faces": []}, {"frame_number": 1885, "faces": []}, {"frame_number": 1886, "faces": []}, {"frame_number": 1887, "faces": []}, {"frame_number": 1888, "faces": []}, {"frame_number": 1889, "faces": []}, {"frame_number": 1890, "faces": []}, {"frame_number": 1891, "faces": []}, {"frame_number": 1892, "faces": []}, {"frame_number": 1893, "faces": []}, {"frame_number": 1894, "faces": []}, {"frame_number": 1895, "faces": []}, {"frame_number": 1896, "faces": []}, {"frame_number": 1897, "faces": []}, {"frame_number": 1898, "faces": []}, {"frame_number": 1899, "faces": []}, {"frame_number": 1900, "faces": []}, {"frame_number": 1901, "faces": []}, {"frame_number": 1902, "faces": []}, {"frame_number": 1903, "faces": []}, {"frame_number": 1904, "faces": []}, {"frame_number": 1905, "faces": []}, {"frame_number": 1906, "faces": []}, {"frame_number": 1907, "faces": []}, {"frame_number": 1908, "faces": []}, {"frame_number": 1909, "faces": []}, {"frame_number": 1910, "faces": []}, {"frame_number": 1911, "faces": []}, {"frame_number": 1912, "faces": []}, {"frame_number": 1913, "faces": []}, {"frame_number": 1914, "faces": []}, {"frame_number": 1915, "faces": []}, {"frame_number": 1916, "faces": []}, {"frame_number": 1917, "faces": []}, {"frame_number": 1918, "faces": []}, {"frame_number": 1919, "faces": []}, {"frame_number": 1920, "faces": []}, {"frame_number": 1921, "faces": []}, {"frame_number": 1922, "faces": []}, {"frame_number": 1923, "faces": []}, {"frame_number": 1924, "faces": []}, {"frame_number": 1925, "faces": []}, {"frame_number": 1926, "faces": []}, {"frame_number": 1927, "faces": []}, {"frame_number": 1928, "faces": []}, {"frame_number": 1929, "faces": []}, {"frame_number": 1930, "faces": []}, {"frame_number": 1931, "faces": []}, {"frame_number": 1932, "faces": []}, {"frame_number": 1933, "faces": []}, {"frame_number": 1934, "faces": []}, {"frame_number": 1935, "faces": []}, {"frame_number": 1936, "faces": []}, {"frame_number": 1937, "faces": []}, {"frame_number": 1938, "faces": []}, {"frame_number": 1939, "faces": []}, {"frame_number": 1940, "faces": []}, {"frame_number": 1941, "faces": []}, {"frame_number": 1942, "faces": []}, {"frame_number": 1943, "faces": []}, {"frame_number": 1944, "faces": []}, {"frame_number": 1945, "faces": []}, {"frame_number": 1946, "faces": []}, {"frame_number": 1947, "faces": []}, {"frame_number": 1948, "faces": []}, {"frame_number": 1949, "faces": []}, {"frame_number": 1950, "faces": []}, {"frame_number": 1951, "faces": []}, {"frame_number": 1952, "faces": []}, {"frame_number": 1953, "faces": []}, {"frame_number": 1954, "faces": []}, {"frame_number": 1955, "faces": []}, {"frame_number": 1956, "faces": []}, {"frame_number": 1957, "faces": []}, {"frame_number": 1958, "faces": []}, {"frame_number": 1959, "faces": []}, {"frame_number": 1959, "faces": [{"x1": 749, "y1": 77, "x2": 1026, "y2": 354, "speaking_score": 2.183333377043406, "active": true, "track_id": 12}]}, {"frame_number": 1960, "faces": [{"x1": 751, "y1": 77, "x2": 1029, "y2": 354, "speaking_score": 2.433333377043406, "active": true, "track_id": 12}]}, {"frame_number": 1961, "faces": [{"x1": 751, "y1": 77, "x2": 1029, "y2": 354, "speaking_score": 2.433333377043406, "active": true, "track_id": 12}]}, {"frame_number": 1962, "faces": [{"x1": 754, "y1": 77, "x2": 1031, "y2": 355, "speaking_score": 2.550000031789144, "active": true, "track_id": 12}]}, {"frame_number": 1963, "faces": [{"x1": 757, "y1": 78, "x2": 1035, "y2": 356, "speaking_score": 2.600000023841858, "active": true, "track_id": 12}]}, {"frame_number": 1964, "faces": [{"x1": 757, "y1": 78, "x2": 1035, "y2": 356, "speaking_score": 2.6666666666666665, "active": true, "track_id": 12}]}, {"frame_number": 1965, "faces": [{"x1": 760, "y1": 79, "x2": 1037, "y2": 356, "speaking_score": 2.716666658719381, "active": true, "track_id": 12}]}, {"frame_number": 1966, "faces": [{"x1": 761, "y1": 79, "x2": 1039, "y2": 357, "speaking_score": 2.716666658719381, "active": true, "track_id": 12}]}, {"frame_number": 1967, "faces": [{"x1": 761, "y1": 79, "x2": 1039, "y2": 357, "speaking_score": 2.716666658719381, "active": true, "track_id": 12}]}, {"frame_number": 1968, "faces": [{"x1": 763, "y1": 81, "x2": 1037, "y2": 355, "speaking_score": 2.7833333015441895, "active": true, "track_id": 12}]}, {"frame_number": 1969, "faces": [{"x1": 763, "y1": 81, "x2": 1037, "y2": 355, "speaking_score": 2.899999976158142, "active": true, "track_id": 12}]}, {"frame_number": 1970, "faces": [{"x1": 763, "y1": 81, "x2": 1037, "y2": 356, "speaking_score": 3.0166666507720947, "active": true, "track_id": 12}]}, {"frame_number": 1971, "faces": [{"x1": 763, "y1": 81, "x2": 1037, "y2": 356, "speaking_score": 3.1333333253860474, "active": true, "track_id": 12}]}, {"frame_number": 1972, "faces": [{"x1": 762, "y1": 80, "x2": 1038, "y2": 357, "speaking_score": 3.216666658719381, "active": true, "track_id": 12}]}, {"frame_number": 1973, "faces": [{"x1": 762, "y1": 80, "x2": 1038, "y2": 357, "speaking_score": 3.216666658719381, "active": true, "track_id": 12}]}, {"frame_number": 1974, "faces": [{"x1": 762, "y1": 80, "x2": 1038, "y2": 357, "speaking_score": 3.2666666507720947, "active": true, "track_id": 12}]}, {"frame_number": 1975, "faces": [{"x1": 762, "y1": 82, "x2": 1036, "y2": 356, "speaking_score": 3.2666666507720947, "active": true, "track_id": 12}]}, {"frame_number": 1976, "faces": [{"x1": 763, "y1": 83, "x2": 1036, "y2": 356, "speaking_score": 3.200000007947286, "active": true, "track_id": 12}]}, {"frame_number": 1977, "faces": [{"x1": 762, "y1": 83, "x2": 1036, "y2": 356, "speaking_score": 3.0666666428248086, "active": true, "track_id": 12}]}, {"frame_number": 1978, "faces": [{"x1": 762, "y1": 83, "x2": 1035, "y2": 356, "speaking_score": 2.9333333174387612, "active": true, "track_id": 12}]}, {"frame_number": 1979, "faces": [{"x1": 762, "y1": 83, "x2": 1035, "y2": 356, "speaking_score": 2.9333333174387612, "active": true, "track_id": 12}]}, {"frame_number": 1980, "faces": [{"x1": 761, "y1": 83, "x2": 1034, "y2": 356, "speaking_score": 2.8166666428248086, "active": true, "track_id": 12}]}, {"frame_number": 1981, "faces": [{"x1": 759, "y1": 83, "x2": 1033, "y2": 357, "speaking_score": 2.7666666507720947, "active": true, "track_id": 12}]}, {"frame_number": 1982, "faces": [{"x1": 758, "y1": 83, "x2": 1032, "y2": 357, "speaking_score": 2.6833333174387612, "active": true, "track_id": 12}]}, {"frame_number": 1983, "faces": [{"x1": 756, "y1": 83, "x2": 1030, "y2": 357, "speaking_score": 2.599999984105428, "active": true, "track_id": 12}]}, {"frame_number": 1984, "faces": [{"x1": 755, "y1": 82, "x2": 1029, "y2": 357, "speaking_score": 2.533333341280619, "active": true, "track_id": 12}]}, {"frame_number": 1985, "faces": [{"x1": 755, "y1": 82, "x2": 1029, "y2": 357, "speaking_score": 2.533333341280619, "active": true, "track_id": 12}]}, {"frame_number": 1986, "faces": [{"x1": 752, "y1": 81, "x2": 1027, "y2": 355, "speaking_score": 2.5, "active": true, "track_id": 12}]}, {"frame_number": 1987, "faces": [{"x1": 749, "y1": 81, "x2": 1021, "y2": 353, "speaking_score": 2.5166666905085244, "active": true, "track_id": 12}]}, {"frame_number": 1988, "faces": [{"x1": 745, "y1": 80, "x2": 1017, "y2": 352, "speaking_score": 2.5666666825612388, "active": true, "track_id": 12}]}, {"frame_number": 1989, "faces": [{"x1": 742, "y1": 79, "x2": 1014, "y2": 351, "speaking_score": 2.650000015894572, "active": true, "track_id": 12}]}, {"frame_number": 1990, "faces": [{"x1": 738, "y1": 78, "x2": 1010, "y2": 350, "speaking_score": 2.75, "active": true, "track_id": 12}]}, {"frame_number": 1991, "faces": [{"x1": 738, "y1": 78, "x2": 1010, "y2": 350, "speaking_score": 2.75, "active": true, "track_id": 12}]}, {"frame_number": 1992, "faces": [{"x1": 734, "y1": 78, "x2": 1006, "y2": 350, "speaking_score": 2.899999976158142, "active": true, "track_id": 12}]}, {"frame_number": 1993, "faces": [{"x1": 722, "y1": 77, "x2": 997, "y2": 351, "speaking_score": 2.9333333174387612, "active": true, "track_id": 12}]}, {"frame_number": 1994, "faces": [{"x1": 716, "y1": 76, "x2": 991, "y2": 352, "speaking_score": 2.916666626930237, "active": true, "track_id": 12}]}, {"frame_number": 1995, "faces": [{"x1": 708, "y1": 76, "x2": 984, "y2": 352, "speaking_score": 2.849999944368998, "active": true, "track_id": 12}]}, {"frame_number": 1996, "faces": [{"x1": 700, "y1": 76, "x2": 976, "y2": 352, "speaking_score": 2.7333333094914756, "active": true, "track_id": 12}]}, {"frame_number": 1997, "faces": [{"x1": 700, "y1": 76, "x2": 976, "y2": 352, "speaking_score": 2.7333333094914756, "active": true, "track_id": 12}]}, {"frame_number": 1998, "faces": [{"x1": 695, "y1": 74, "x2": 972, "y2": 351, "speaking_score": 2.599999984105428, "active": true, "track_id": 12}]}, {"frame_number": 1999, "faces": [{"x1": 682, "y1": 71, "x2": 958, "y2": 347, "speaking_score": 2.4333333174387612, "active": true, "track_id": 12}]}, {"frame_number": 2000, "faces": [{"x1": 674, "y1": 71, "x2": 951, "y2": 347, "speaking_score": 2.399999976158142, "active": true, "track_id": 12}]}, {"frame_number": 2001, "faces": [{"x1": 669, "y1": 71, "x2": 946, "y2": 347, "speaking_score": 2.4333333174387612, "active": true, "track_id": 12}]}, {"frame_number": 2002, "faces": [{"x1": 664, "y1": 71, "x2": 941, "y2": 348, "speaking_score": 2.466666658719381, "active": true, "track_id": 12}]}, {"frame_number": 2003, "faces": [{"x1": 664, "y1": 71, "x2": 941, "y2": 348, "speaking_score": 2.466666658719381, "active": true, "track_id": 12}]}, {"frame_number": 2004, "faces": [{"x1": 657, "y1": 70, "x2": 936, "y2": 349, "speaking_score": 2.5333333015441895, "active": true, "track_id": 12}]}, {"frame_number": 2005, "faces": [{"x1": 639, "y1": 70, "x2": 919, "y2": 349, "speaking_score": 2.599999944368998, "active": true, "track_id": 12}]}, {"frame_number": 2006, "faces": [{"x1": 629, "y1": 69, "x2": 910, "y2": 350, "speaking_score": 2.699999968210856, "active": true, "track_id": 12}]}, {"frame_number": 2007, "faces": [{"x1": 619, "y1": 68, "x2": 902, "y2": 350, "speaking_score": 2.7166666189829507, "active": true, "track_id": 12}]}, {"frame_number": 2008, "faces": [{"x1": 608, "y1": 68, "x2": 891, "y2": 350, "speaking_score": 2.6833332777023315, "active": true, "track_id": 12}]}, {"frame_number": 2009, "faces": [{"x1": 608, "y1": 68, "x2": 891, "y2": 350, "speaking_score": 2.6833332777023315, "active": true, "track_id": 12}]}, {"frame_number": 2010, "faces": [{"x1": 599, "y1": 68, "x2": 882, "y2": 350, "speaking_score": 2.6333332856496177, "active": true, "track_id": 12}]}, {"frame_number": 2011, "faces": [{"x1": 578, "y1": 68, "x2": 860, "y2": 350, "speaking_score": 2.5833332935969033, "active": true, "track_id": 12}]}, {"frame_number": 2012, "faces": [{"x1": 565, "y1": 65, "x2": 854, "y2": 353, "speaking_score": 2.5333333015441895, "active": true, "track_id": 12}]}, {"frame_number": 2013, "faces": [{"x1": 557, "y1": 64, "x2": 847, "y2": 354, "speaking_score": 2.4666666189829507, "active": true, "track_id": 12}]}, {"frame_number": 2014, "faces": [{"x1": 546, "y1": 63, "x2": 837, "y2": 354, "speaking_score": 2.4333333174387612, "active": true, "track_id": 12}]}, {"frame_number": 2015, "faces": [{"x1": 546, "y1": 63, "x2": 837, "y2": 354, "speaking_score": 2.4333333174387612, "active": true, "track_id": 12}]}, {"frame_number": 2016, "faces": [{"x1": 536, "y1": 63, "x2": 828, "y2": 355, "speaking_score": 2.400000015894572, "active": true, "track_id": 12}]}, {"frame_number": 2017, "faces": [{"x1": 517, "y1": 62, "x2": 810, "y2": 355, "speaking_score": 2.4333333571751914, "active": true, "track_id": 12}]}, {"frame_number": 2018, "faces": [{"x1": 508, "y1": 61, "x2": 802, "y2": 355, "speaking_score": 2.5000000397364297, "active": true, "track_id": 12}]}, {"frame_number": 2019, "faces": [{"x1": 497, "y1": 61, "x2": 791, "y2": 356, "speaking_score": 2.6000000635782876, "active": true, "track_id": 12}]}, {"frame_number": 2020, "faces": [{"x1": 485, "y1": 61, "x2": 780, "y2": 355, "speaking_score": 2.7000000874201455, "active": true, "track_id": 12}]}, {"frame_number": 2021, "faces": [{"x1": 485, "y1": 61, "x2": 780, "y2": 355, "speaking_score": 2.7000000874201455, "active": true, "track_id": 12}]}, {"frame_number": 2022, "faces": [{"x1": 476, "y1": 60, "x2": 771, "y2": 355, "speaking_score": 2.8000000715255737, "active": true, "track_id": 12}]}, {"frame_number": 2023, "faces": [{"x1": 457, "y1": 59, "x2": 754, "y2": 356, "speaking_score": 2.9166667064030967, "active": true, "track_id": 12}]}, {"frame_number": 2024, "faces": [{"x1": 449, "y1": 59, "x2": 746, "y2": 356, "speaking_score": 3.0333333810170493, "active": true, "track_id": 12}]}, {"frame_number": 2025, "faces": [{"x1": 442, "y1": 59, "x2": 739, "y2": 356, "speaking_score": 3.083333373069763, "active": true, "track_id": 12}]}, {"frame_number": 2026, "faces": [{"x1": 434, "y1": 59, "x2": 731, "y2": 355, "speaking_score": 3.1666667064030967, "active": true, "track_id": 12}]}, {"frame_number": 2027, "faces": [{"x1": 434, "y1": 59, "x2": 731, "y2": 355, "speaking_score": 3.1666667064030967, "active": true, "track_id": 12}]}, {"frame_number": 2028, "faces": [{"x1": 426, "y1": 59, "x2": 723, "y2": 355, "speaking_score": 3.1666667064030967, "active": true, "track_id": 12}]}, {"frame_number": 2029, "faces": [{"x1": 412, "y1": 59, "x2": 708, "y2": 355, "speaking_score": 3.133333365122477, "active": true, "track_id": 12}]}, {"frame_number": 2030, "faces": [{"x1": 406, "y1": 58, "x2": 703, "y2": 355, "speaking_score": 3.0166667302449546, "active": true, "track_id": 12}]}, {"frame_number": 2031, "faces": [{"x1": 396, "y1": 57, "x2": 694, "y2": 355, "speaking_score": 2.800000031789144, "active": true, "track_id": 12}]}, {"frame_number": 2032, "faces": [{"x1": 388, "y1": 57, "x2": 685, "y2": 354, "speaking_score": 2.6166666746139526, "active": true, "track_id": 12}]}, {"frame_number": 2033, "faces": [{"x1": 381, "y1": 56, "x2": 679, "y2": 353, "speaking_score": 2.4333333174387612, "active": true, "track_id": 12}]}, {"frame_number": 2034, "faces": [{"x1": 381, "y1": 56, "x2": 679, "y2": 353, "speaking_score": 2.4333333174387612, "active": true, "track_id": 12}]}, {"frame_number": 2035, "faces": [{"x1": 369, "y1": 57, "x2": 666, "y2": 354, "speaking_score": 2.366666634877523, "active": true, "track_id": 12}]}, {"frame_number": 2036, "faces": [{"x1": 363, "y1": 57, "x2": 659, "y2": 354, "speaking_score": 2.299999992052714, "active": true, "track_id": 12}]}, {"frame_number": 2037, "faces": [{"x1": 358, "y1": 57, "x2": 655, "y2": 354, "speaking_score": 2.2166666388511658, "active": true, "track_id": 12}]}, {"frame_number": 2038, "faces": [{"x1": 353, "y1": 57, "x2": 649, "y2": 354, "speaking_score": 2.166666646798452, "active": true, "track_id": 12}]}, {"frame_number": 2039, "faces": [{"x1": 350, "y1": 57, "x2": 646, "y2": 353, "speaking_score": 2.149999996026357, "active": true, "track_id": 12}]}, {"frame_number": 2040, "faces": [{"x1": 350, "y1": 57, "x2": 646, "y2": 353, "speaking_score": 2.149999996026357, "active": true, "track_id": 12}]}, {"frame_number": 2041, "faces": [{"x1": 345, "y1": 57, "x2": 642, "y2": 353, "speaking_score": 2.149999996026357, "active": true, "track_id": 12}]}, {"frame_number": 2042, "faces": [{"x1": 342, "y1": 57, "x2": 638, "y2": 353, "speaking_score": 2.0833333134651184, "active": true, "track_id": 12}]}, {"frame_number": 2043, "faces": [{"x1": 338, "y1": 57, "x2": 633, "y2": 352, "speaking_score": 2.099999964237213, "active": true, "track_id": 12}]}, {"frame_number": 2044, "faces": [{"x1": 334, "y1": 57, "x2": 629, "y2": 352, "speaking_score": 2.2333333094914756, "active": true, "track_id": 12}]}, {"frame_number": 2045, "faces": [{"x1": 330, "y1": 58, "x2": 624, "y2": 352, "speaking_score": 2.349999984105428, "active": true, "track_id": 12}]}, {"frame_number": 2046, "faces": [{"x1": 330, "y1": 58, "x2": 624, "y2": 352, "speaking_score": 2.349999984105428, "active": true, "track_id": 12}]}, {"frame_number": 2047, "faces": [{"x1": 325, "y1": 58, "x2": 616, "y2": 350, "speaking_score": 2.366666634877523, "active": true, "track_id": 12}]}, {"frame_number": 2048, "faces": [{"x1": 321, "y1": 59, "x2": 611, "y2": 349, "speaking_score": 2.2666666507720947, "active": true, "track_id": 12}]}, {"frame_number": 2049, "faces": [{"x1": 319, "y1": 59, "x2": 607, "y2": 346, "speaking_score": 2.149999996026357, "active": true, "track_id": 12}]}, {"frame_number": 2050, "faces": [{"x1": 317, "y1": 58, "x2": 604, "y2": 346, "speaking_score": 1.8833333253860474, "active": true, "track_id": 12}]}, {"frame_number": 2051, "faces": [{"x1": 316, "y1": 59, "x2": 602, "y2": 345, "speaking_score": 1.5666666527589161, "active": true, "track_id": 12}]}, {"frame_number": 2052, "faces": [{"x1": 316, "y1": 59, "x2": 602, "y2": 345, "speaking_score": 1.5666666527589161, "active": true, "track_id": 12}]}, {"frame_number": 2053, "faces": [{"x1": 312, "y1": 60, "x2": 597, "y2": 345, "speaking_score": 1.2333333194255829, "active": true, "track_id": 12}]}, {"frame_number": 2054, "faces": [{"x1": 310, "y1": 60, "x2": 594, "y2": 344, "speaking_score": 0.9333333373069763, "active": true, "track_id": 12}]}, {"frame_number": 2055, "faces": [{"x1": 309, "y1": 60, "x2": 593, "y2": 344, "speaking_score": 0.6833333298563957, "active": true, "track_id": 12}]}, {"frame_number": 2056, "faces": [{"x1": 307, "y1": 60, "x2": 591, "y2": 344, "speaking_score": 0.433333333581686, "active": true, "track_id": 12}]}, {"frame_number": 2057, "faces": [{"x1": 305, "y1": 60, "x2": 589, "y2": 344, "speaking_score": 0.133333341528972, "active": true, "track_id": 12}]}, {"frame_number": 2058, "faces": [{"x1": 305, "y1": 60, "x2": 589, "y2": 344, "speaking_score": 0.133333341528972, "active": true, "track_id": 12}]}, {"frame_number": 2059, "faces": [{"x1": 303, "y1": 60, "x2": 587, "y2": 344, "speaking_score": -0.2666666644314925, "active": false, "track_id": 12}]}, {"frame_number": 2060, "faces": [{"x1": 302, "y1": 61, "x2": 586, "y2": 345, "speaking_score": -0.6333333390454451, "active": false, "track_id": 12}]}, {"frame_number": 2061, "faces": [{"x1": 301, "y1": 61, "x2": 585, "y2": 346, "speaking_score": -0.9666666823128859, "active": false, "track_id": 12}]}, {"frame_number": 2062, "faces": [{"x1": 300, "y1": 62, "x2": 586, "y2": 347, "speaking_score": -1.3166666788359482, "active": false, "track_id": 12}]}, {"frame_number": 2063, "faces": [{"x1": 300, "y1": 63, "x2": 586, "y2": 348, "speaking_score": -1.649999996026357, "active": false, "track_id": 12}]}, {"frame_number": 2064, "faces": [{"x1": 300, "y1": 63, "x2": 586, "y2": 348, "speaking_score": -1.649999996026357, "active": false, "track_id": 12}]}, {"frame_number": 2065, "faces": [{"x1": 298, "y1": 62, "x2": 588, "y2": 351, "speaking_score": -1.8666666746139526, "active": false, "track_id": 12}]}, {"frame_number": 2066, "faces": [{"x1": 298, "y1": 62, "x2": 588, "y2": 353, "speaking_score": -1.9833333293596904, "active": false, "track_id": 12}]}, {"frame_number": 2067, "faces": [{"x1": 297, "y1": 62, "x2": 588, "y2": 353, "speaking_score": -2.0666666626930237, "active": false, "track_id": 12}]}, {"frame_number": 2068, "faces": [{"x1": 297, "y1": 63, "x2": 588, "y2": 354, "speaking_score": -2.099999984105428, "active": false, "track_id": 12}]}, {"frame_number": 2069, "faces": [{"x1": 297, "y1": 63, "x2": 589, "y2": 355, "speaking_score": -2.0833333134651184, "active": false, "track_id": 12}]}, {"frame_number": 2070, "faces": [{"x1": 297, "y1": 63, "x2": 589, "y2": 355, "speaking_score": -2.0833333134651184, "active": false, "track_id": 12}]}, {"frame_number": 2071, "faces": [{"x1": 296, "y1": 62, "x2": 590, "y2": 356, "speaking_score": -2.0666666626930237, "active": false, "track_id": 12}]}, {"frame_number": 2072, "faces": [{"x1": 296, "y1": 62, "x2": 590, "y2": 356, "speaking_score": -2.0666666626930237, "active": false, "track_id": 12}]}, {"frame_number": 2073, "faces": [{"x1": 296, "y1": 63, "x2": 590, "y2": 356, "speaking_score": -2.050000011920929, "active": false, "track_id": 12}]}, {"frame_number": 2074, "faces": [{"x1": 296, "y1": 64, "x2": 590, "y2": 358, "speaking_score": -2.0666666626930237, "active": false, "track_id": 12}]}, {"frame_number": 2075, "faces": [{"x1": 297, "y1": 64, "x2": 591, "y2": 358, "speaking_score": -2.1333333253860474, "active": false, "track_id": 12}]}, {"frame_number": 2076, "faces": [{"x1": 297, "y1": 64, "x2": 591, "y2": 358, "speaking_score": -2.1333333253860474, "active": false, "track_id": 12}]}, {"frame_number": 2077, "faces": [{"x1": 299, "y1": 68, "x2": 593, "y2": 362, "speaking_score": -2.216666658719381, "active": false, "track_id": 12}]}, {"frame_number": 2078, "faces": [{"x1": 301, "y1": 70, "x2": 593, "y2": 362, "speaking_score": -2.2666666507720947, "active": false, "track_id": 12}]}, {"frame_number": 2079, "faces": [{"x1": 304, "y1": 73, "x2": 595, "y2": 364, "speaking_score": -2.2833333015441895, "active": false, "track_id": 12}]}, {"frame_number": 2080, "faces": [{"x1": 307, "y1": 75, "x2": 598, "y2": 366, "speaking_score": -2.299999952316284, "active": false, "track_id": 12}]}, {"frame_number": 2081, "faces": [{"x1": 311, "y1": 79, "x2": 597, "y2": 366, "speaking_score": -2.2833333015441895, "active": false, "track_id": 12}]}, {"frame_number": 2082, "faces": [{"x1": 311, "y1": 79, "x2": 597, "y2": 366, "speaking_score": -2.2833333015441895, "active": false, "track_id": 12}]}, {"frame_number": 2083, "faces": [{"x1": 312, "y1": 83, "x2": 597, "y2": 367, "speaking_score": -2.2666666507720947, "active": false, "track_id": 12}]}, {"frame_number": 2084, "faces": [{"x1": 319, "y1": 85, "x2": 600, "y2": 365, "speaking_score": -2.283333341280619, "active": false, "track_id": 12}]}, {"frame_number": 2085, "faces": [{"x1": 319, "y1": 85, "x2": 600, "y2": 365, "speaking_score": -2.300000031789144, "active": false, "track_id": 12}]}, {"frame_number": 2086, "faces": [{"x1": 321, "y1": 85, "x2": 601, "y2": 365, "speaking_score": -2.350000023841858, "active": false, "track_id": 12}]}, {"frame_number": 2087, "faces": [{"x1": 321, "y1": 85, "x2": 601, "y2": 365, "speaking_score": -2.4166667064030967, "active": false, "track_id": 12}]}, {"frame_number": 2088, "faces": [{"x1": 321, "y1": 85, "x2": 601, "y2": 365, "speaking_score": -2.4166667064030967, "active": false, "track_id": 12}]}, {"frame_number": 2089, "faces": [{"x1": 321, "y1": 85, "x2": 601, "y2": 365, "speaking_score": -2.4333333571751914, "active": false, "track_id": 12}]}, {"frame_number": 2090, "faces": [{"x1": 321, "y1": 85, "x2": 601, "y2": 365, "speaking_score": -2.4800000190734863, "active": false, "track_id": 12}]}, {"frame_number": 2091, "faces": [{"x1": 322, "y1": 83, "x2": 600, "y2": 362, "speaking_score": -2.5, "active": false, "track_id": 12}]}, {"frame_number": 2092, "faces": [{"x1": 322, "y1": 82, "x2": 600, "y2": 361, "speaking_score": -2.5333333015441895, "active": false, "track_id": 12}]}, {"frame_number": 2093, "faces": [{"x1": 322, "y1": 81, "x2": 600, "y2": 358, "speaking_score": -2.5, "active": false, "track_id": 12}]}, {"frame_number": 2094, "faces": [{"x1": 322, "y1": 81, "x2": 600, "y2": 358, "speaking_score": -2.5, "active": false, "track_id": 12}]}, {"frame_number": 2095, "faces": [{"x1": 321, "y1": 85, "x2": 601, "y2": 365, "speaking_score": -2.4333333571751914, "active": false, "track_id": 12}]}, {"frame_number": 2096, "faces": [{"x1": 321, "y1": 85, "x2": 601, "y2": 365, "speaking_score": -2.4800000190734863, "active": false, "track_id": 12}]}, {"frame_number": 2097, "faces": [{"x1": 322, "y1": 83, "x2": 600, "y2": 362, "speaking_score": -2.5, "active": false, "track_id": 12}]}, {"frame_number": 2098, "faces": [{"x1": 322, "y1": 82, "x2": 600, "y2": 361, "speaking_score": -2.5333333015441895, "active": false, "track_id": 12}]}, {"frame_number": 2099, "faces": [{"x1": 322, "y1": 81, "x2": 600, "y2": 358, "speaking_score": -2.5, "active": false, "track_id": 12}]}], "video_info": {"fps": 30.0, "total_frames": 2106, "duration": 565.0, "resolution": {"width": 1280, "height": 720}}, "scenes": [{"scene_number": 1, "start_seconds": 0.0, "end_seconds": 4.9, "start_timecode": "00:00:00.000", "end_timecode": "00:00:04.900", "start_frame": 0, "end_frame": 147}, {"scene_number": 2, "start_seconds": 4.9, "end_seconds": 12.733333333333333, "start_timecode": "00:00:04.900", "end_timecode": "00:00:12.733", "start_frame": 147, "end_frame": 382}, {"scene_number": 3, "start_seconds": 12.733333333333333, "end_seconds": 17.666666666666668, "start_timecode": "00:00:12.733", "end_timecode": "00:00:17.667", "start_frame": 382, "end_frame": 530}, {"scene_number": 4, "start_seconds": 17.666666666666668, "end_seconds": 28.6, "start_timecode": "00:00:17.667", "end_timecode": "00:00:28.600", "start_frame": 530, "end_frame": 858}, {"scene_number": 5, "start_seconds": 28.6, "end_seconds": 35.43333333333333, "start_timecode": "00:00:28.600", "end_timecode": "00:00:35.433", "start_frame": 858, "end_frame": 1063}, {"scene_number": 6, "start_seconds": 35.43333333333333, "end_seconds": 43.13333333333333, "start_timecode": "00:00:35.433", "end_timecode": "00:00:43.133", "start_frame": 1063, "end_frame": 1294}, {"scene_number": 7, "start_seconds": 43.13333333333333, "end_seconds": 55.0, "start_timecode": "00:00:43.133", "end_timecode": "00:00:55.000", "start_frame": 1294, "end_frame": 1650}, {"scene_number": 8, "start_seconds": 55.0, "end_seconds": 59.733333333333334, "start_timecode": "00:00:55.000", "end_timecode": "00:00:59.733", "start_frame": 1650, "end_frame": 1792}, {"scene_number": 9, "start_seconds": 59.733333333333334, "end_seconds": 65.33333333333333, "start_timecode": "00:00:59.733", "end_timecode": "00:01:05.333", "start_frame": 1792, "end_frame": 1960}, {"scene_number": 10, "start_seconds": 65.33333333333333, "end_seconds": 70.03333333333333, "start_timecode": "00:01:05.333", "end_timecode": "00:01:10.033", "start_frame": 1960, "end_frame": 2101}]}, "video_info": {"fps": 30.0, "total_frames": 2106, "duration": 565.0, "resolution": {"width": 1280, "height": 720}}, "detection_count": 2106, "scenes_count": 10, "has_rendered_video": false}
    },
    ],
    "id": "cmder2g1k0003u3nw1bzhg65l",
    "jobId": "cmder2fiz0001u3nw4hm9i1zm",
    "sourceId": "-moW9jvvMr4",
    "videoLength": 565,
    "title": "A Simple Way to Break a Bad Habit | Judson Brewer | TED",
    "choosedDefinition": "720p",
    "status": "SUCCESS",
    "createdAt": new Date("2025-07-22T16:29:30.680Z")
  },
} as any